/*
TO REGENERATE THIS FILE, RUN THE 'TypescriptGenerator' CONSOLE APP IN THE MUELLER SOLUTION
*/

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.9.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum AccessToPropertyType {
    Undefined = "Undefined",
    AppointmentRequired = "AppointmentRequired",
    MobileLockbox = "MobileLockbox",
    PhysicalLockbox = "PhysicalLockbox",
}

/** Metadata for an account file */
export interface AccountFileDto {
    /** Account file table primary key */
    accountFileId: number;
    /** File type */
    accountFileType: string | undefined;
    /** Company code */
    companyCode: string | undefined;
    /** Customer number */
    customerNumber: number | undefined;
    /** Create date */
    createdDate: Date;
    /** File name */
    fileName: string | undefined;
    /** Modified date */
    modifiedDate: Date;
    /** File path */
    path: string | undefined;
}

/** Type of a account file */
export interface AccountFileTypeCodes {
}

/** Used to Update Billing Base Account invoice info */
export interface AccountInfoUpdateRequest {
    /** Control Number */
    controlIdNumber: number;
    /** Customer Number */
    customerNumber: number;
    /** Customer Name */
    customerName: string | undefined;
}

/** Model for adding additional contacts in the UW permission to close process */
export interface AddAdditionalContactDto {
    /** Role of contact */
    role: string;
    /** Phone number of contact */
    phoneNumber: string | undefined;
    /** Email address of contact */
    emailAddress: string | undefined;
    /** Instructions */
    contactInstructions: string | undefined;
}

/** Add case event request */
export interface AddCaseEventRequest {
    /** Case event molecule name */
    molecule: string;
    /** Case event name */
    eventType: string;
}

/** Add a new note */
export interface AddCaseNoteRequest {
    /** The note text */
    noteBody: string | undefined;
    /** Is external to customers, agents, etc.  Anyone outside of Mueller Employees */
    isExternal: boolean;
}

/** Add employee clocked time */
export interface AddClockedTimeRequest {
    /** Date Time of Clock in */
    clockInDateTime: Date;
    /** Date Time of Clock Out */
    clockOutDateTime: Date;
}

/** used to add a new user */
export interface AddInternetUserDto {
    /** Username  */
    username: string;
    /** Email address for forgot password */
    emailAddress: string;
    /** Primary role */
    primaryRole: string;
    /** Is login enabled */
    loginEnabled: boolean;
    /** array of user right names */
    enabledUserRightNames: string[] | undefined;
    /** array of disabled user right names */
    disabledUserRightNames: string[] | undefined;
    /** Users first name */
    firstName: string;
    /** Users last name */
    lastName: string;
    majorCompanyId: number;
}

/** Update User Dto */
export interface AddInternetUserRequest {
    username: string | undefined;
    emailAddress: string | undefined;
    primaryRole: string | undefined;
    loginEnabled: boolean;
    firstName: string | undefined;
    lastName: string | undefined;
    majorCompanyId: number;
}

/** used to add a new right to user */
export interface AddInternetUserRightDto {
    /** Internet User Id */
    internetUserId: number;
    /** Right Names to be added */
    rightNames: string[] | undefined;
}

/** Type safe enum pattern allows for enumerations that allow characters not allowed in a variable name. */
export interface TypeSafeEnum {
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfAdditionalAutomaticAppointment extends TypeSafeEnum {
}

/** Automatic Appointment Type */
export interface AdditionalAutomaticAppointment extends TypeSafeEnumOfAdditionalAutomaticAppointment {
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfAdditionalAutomaticAppointment2 extends TypeSafeEnum {
}

/** Automatic Appointment Type */
export interface AdditionalAutomaticAppointment2 extends TypeSafeEnumOfAdditionalAutomaticAppointment2 {
}

/** Structure to add a notification to a case */
export interface AddNotificationRequest {
    /** Case control number */
    controlIdNumber: number;
    /** Notification id (either set this or NotificationTypeCode) */
    notificationTypeId: number;
    /** Notification type string */
    notificationTypeCode: string | undefined;
    /** Effective date of the notification (optional) */
    sentDate: Date | undefined;
    /** Additional notes */
    notes: string | undefined;
}

export interface StreetAddress {
    /** address line 1 */
    address1: string | undefined;
    /** address line 1 */
    address2: string | undefined;
    /** address city */
    city: string | undefined;
    /** address state */
    state: string | undefined;
    /** address postal code */
    zip: string | undefined;
}

/** StreetAddress with a County */
export interface Address extends StreetAddress {
    /** County */
    county: string | undefined;
    /** Address to use if you want to display all together */
    displayAddress: string | undefined;
}

export interface AddressInfo {
    address1: string;
    address2: string | undefined;
    city: string;
    state: string;
    zipCode: string;
}

/** Request for adding a notification to a survey type */
export interface AddSurveyTypeNotificationRequest {
    /** Customer Number */
    customerNumber: number;
    /** Survey Type Code */
    surveyTypeCode: string | undefined;
    /** Notification */
    notification: SurveyTypeNotificationDto | undefined;
}

/** Customer Survey Type Notification model */
export interface SurveyTypeNotificationDto {
    /** Notification Type Code */
    notificationTypeCode: string | undefined;
    /** Number of days to wait since previous notification before sending this oen */
    daysFromPrevious: number;
    /** Previous Notification Code */
    previousNotificationCode: string | undefined;
    /** Notification Method Code */
    notificationMethodCode: string | undefined;
    /** Letter Code */
    letterCode: string | undefined;
}

/** Defines an account file request that can be matched to an existing database record */
export interface ExistingAccountFileRequest {
    /** File type */
    fileType: string;
    /** Company code (optional, either company code or customer number) */
    companyCode: string | undefined;
    /** Customer number (optional, either company code or customer number) */
    customerNumber: number | undefined;
    /** File name (optional, use to increase specificity, i.e. more than one account file of a type) */
    fileName: string | undefined;
}

/** Parameters used to add update an account file */
export interface AddUpdateAccountFileRequest extends ExistingAccountFileRequest {
    /** File data as a stream */
    fileStream: Stream | undefined;
    /** File data as a byte array */
    fileBytes: string | undefined;
    /** File name */
    fileName: string;
    /** Optional, use this if you want to explicitly set the file name */
    uploadFileId: string | undefined;
    /** Optional, use this if you want to explicitly set the folder name */
    uploadFolder: string | undefined;
}

export interface MarshalByRefObject {
}

export interface Stream extends MarshalByRefObject {
    canTimeout: boolean;
    readTimeout: number;
    writeTimeout: number;
}

/** add user right dto */
export interface AddUserRightDto {
    /** Right Name */
    rightName: string | undefined;
    /** Is Enabled */
    isEnabled: boolean;
}

export interface AdjustableFactor_1 {
    Factor: T | undefined;
    AdjustmentAmount: number | undefined;
}

export interface T {
}

/** list of agency codes */
export interface AgencyCodesDto {
    /** Agent code
             */
    agencyCode: string | undefined;
    /** Database Type */
    type: string | undefined;
}

/** Information regarding the ageny associated to a case */
export interface AgencyInfo extends Address {
    /** Agent name
             */
    agentName: string | undefined;
    /** Agent phone number
             */
    agentPhone: string | undefined;
    /** Agent ID
             */
    agentId: number | undefined;
    /** Agent email
             */
    email: string | undefined;
    /** Agency code
             */
    code: string | undefined;
}

/** Used When creating an Agent Record */
export interface AgentCreateRequest {
    /** Agent master code */
    masterCode: string | undefined;
    /** Associated underwriter code */
    underwriterCode: string | undefined;
    /** Agent address line 1 */
    addressLine1: string | undefined;
    /** Agent address line 2 */
    addressLine2: string | undefined;
    /** Agent address city */
    addressCity: string | undefined;
    /** Agent address state abbreviation */
    addressStateAbbreviation: string | undefined;
    /** Agent address postal code */
    addressPostalCode: string | undefined;
    /** Notes about agent. Typically change notes */
    comments: string | undefined;
    /** Major company this agent is associated with */
    majorCompanyCode: string | undefined;
    /** Agent code */
    agentCode: string | undefined;
    /** voice number */
    phoneNumber: string | undefined;
    /** Fax number */
    faxNumber: string | undefined;
    /** Email address */
    emailAddress: string | undefined;
    /** Agent / Agency name */
    agentName: string | undefined;
    /** Preferred notification method */
    notificationMethod: string | undefined;
}

/** Model for agent list */
export interface AgentListModel {
    /** The record id */
    id: number;
    /** Major company id */
    majorCompanyId: number | undefined;
    /** Major company display name */
    majorCompanyName: string | undefined;
    /** Major company code */
    majorCompanyCode: string | undefined;
    /** Agent code */
    agentCode: string | undefined;
    /** Agent / Agency name */
    agentName: string | undefined;
    /** voice number */
    phoneNumber: string | undefined;
    /** Fax number */
    faxNumber: string | undefined;
    /** Email address */
    emailAddress: string | undefined;
    /** Preferred notification method */
    notificationMethod: string | undefined;
}

/** Model for Agent Details */
export interface AgentDetailsViewModel extends AgentListModel {
    /** Agent master code */
    masterCode: string | undefined;
    /** Associated Underwriter Id */
    underwriterId: number | undefined;
    /** Associated underwriter code */
    underwriterCode: string | undefined;
    /** Agent address line 1 */
    addressLine1: string | undefined;
    /** Agent address line 2 */
    addressLine2: string | undefined;
    /** Agent address city */
    addressCity: string | undefined;
    /** Agent address state abbreviation */
    addressStateAbbreviation: string | undefined;
    /** Agent address postal code */
    addressPostalCode: string | undefined;
    /** Notes about agent. Typically change notes */
    comments: string | undefined;
    /** Users linked to this agency */
    users: UserInformationResponseDto[] | undefined;
}

/** used as a detailed user return */
export interface UserInformationResponseDto {
    id: number;
    username: string | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    lastFirstName: string | undefined;
    firstLastName: string | undefined;
    failedAttempts: number;
    roleName: string | undefined;
    mustChangePassword: boolean;
    receivesEmailConfirmations: boolean;
    companyName: string | undefined;
    passwordChangedLastDate: Date | undefined;
    passwordChangeDays: number | undefined;
    isDisabled: boolean;
    createDate: Date;
    modifyDate: Date;
    loginStatistics: InternetUserLoginStatisticsDto | undefined;
    canEditUser: boolean;
}

/** used to store login stats of a user */
export interface InternetUserLoginStatisticsDto {
    lastLoginDate: Date | undefined;
    lastLoginIPAddress: string | undefined;
    failedAttempts: number;
    countInLast7Days: number;
    countInLast14Days: number;
    countInLast30Days: number;
    countSunday: number;
    countMonday: number;
    countTuesday: number;
    countWednesday: number;
    countThursday: number;
    countFriday: number;
    countSaturday: number;
}

/** Web order Agent Info */
export interface AgentInfo {
    /** Agent Name */
    name: string | undefined;
    /** Agent Code */
    code: string | undefined;
    /** Agent Phone Number */
    phone: string | undefined;
    /** Agent Email Address */
    email: string | undefined;
    /** Agent mailing address */
    mailingAddress: AddressInfo | undefined;
}

/** agent list options */
export interface AgentSearchOptions {
    /** value to search for */
    searchTerm: string | undefined;
    /** if supplied then only agents linked to this major company will be returned */
    majorCompanyId: number | undefined;
}

/** Used as dto to update an agent */
export interface AgentUpdateRequest {
    /** primary key of agent */
    id: number;
    /** Agent master code */
    masterCode: string | undefined;
    /** Associated underwriter code */
    underwriterCode: string | undefined;
    /** Agent address line 1 */
    addressLine1: string | undefined;
    /** Agent address line 2 */
    addressLine2: string | undefined;
    /** Agent address city */
    addressCity: string | undefined;
    /** Agent address state abbreviation */
    addressStateAbbreviation: string | undefined;
    /** Agent address postal code */
    addressPostalCode: string | undefined;
    /** Notes about agent. Typically change notes */
    comments: string | undefined;
    /** Major company this agent is associated with */
    majorCompanyCode: string | undefined;
    /** Agent code */
    agentCode: string | undefined;
    /** voice number */
    phoneNumber: string | undefined;
    /** Fax number */
    faxNumber: string | undefined;
    /** Email address */
    emailAddress: string | undefined;
    /** Agent / Agency name */
    agentName: string | undefined;
    /** Preferred notification method */
    notificationMethod: string | undefined;
}

/** Amount by Day values for each day */
export interface AmountByDay_1 {
    /** The day of the week  */
    DayOfWeek: DayOfWeek;
    /** Actual date of the day */
    Date: Date;
    /** Amount for the day */
    Amount: T | undefined;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

/** API Key Credentials */
export interface ApiKeyCredentials {
    /** Matches with the UID property from an AppraisalPort order */
    appraisalPortUserId: string | undefined;
    /** The API Key */
    apiKey: string | undefined;
    /** The API Key Id
             */
    apiKeyId: string | undefined;
    /** The API Key Expiration Date */
    apiKeyExpiresDate: string | undefined;
}

/** Applicationdata */
export interface Applicationdata {
    /** photoLinkData */
    photoLinkData: Photolinkdata[] | undefined;
}

/** Photolinkdata */
export interface Photolinkdata {
    /** id */
    id: string;
    /** formId */
    formId: string;
    /** uuid */
    uuid: string;
    /** index */
    index: number;
    /** tags */
    tags: string[] | undefined;
    /** notTaken */
    notTaken: boolean;
    /** reason */
    reason: any | undefined;
    /** description */
    description: any | undefined;
    /** shared */
    shared: boolean;
    /** Photo export ID */
    exportId: string | undefined;
}

/** Applytags */
export interface Applytags {
    /** disabled */
    disabled: boolean;
}

/** Appointment Slot Candidate for case */
export interface AppointmentAssignmentCandidate {
    /** Inspector Primary key */
    inspectorId: number;
    /** Field Rep Number for the slot */
    fieldRepNumber: number;
    /** Appointment slot date and time */
    appointmentDateTime: Date;
    /** Driving miles to case */
    distanceToCase: number;
    /** Numerical rank of selection, 1 is best, 2 is second best */
    rank: number;
}

/** Result type for calculating appointment assignment candidates */
export interface AppointmentCandidateResponse {
    /** List of Candidates */
    candidates: AppointmentAssignmentCandidate[] | undefined;
    /** End of the date range being used in the evaulation for candidate selection */
    dateRangeEnd: Date;
}

/** Model for submitting an appointment based on appointment candidates */
export interface AppointmentCandidateSubmission {
    /** Field Rep Number for the slot */
    fieldRepNumber: number;
    /** Appointment slot date and time */
    appointmentDateTime: Date;
    /** List of phone numbers and/or email addresses to send confirmations to */
    confirmationMessageRecipients: string[] | undefined;
}

export interface CaseLocationRequest {
    stateCodeList: string[] | undefined;
    caseIdFilter: number[] | undefined;
}

/** Request object for getting a list of cases by state */
export interface AppointmentCaseLocationRequest extends CaseLocationRequest {
    /** Number of days forward to look for appointments */
    daysToLook: number | undefined;
}

/** Requested appointment details */
export interface AppointmentInfo {
    /** How is the property occupied  */
    occupancy: string | undefined;
    /** How can property be accessed */
    accessToProperty: AccessToPropertyType;
    /** Who to contact regarding property access */
    contact: WebOrderRoleContactInfo | undefined;
    /** Preferred appointment date */
    preferredAppointmentDate: string | undefined;
    /** Preferred appointment time window */
    preferredAppointmentWindow: string | undefined;
    /** Lockbox code to access property */
    lockboxCode: string | undefined;
}

/** Contact information for an individual */
export interface ContactInfo {
    /** First Name */
    firstName: string;
    /** Last Name */
    lastName: string;
    /** Primary Phone Number */
    phoneNumber1: string | undefined;
    /** Secondary Phone Number */
    phoneNumber2: string | undefined;
    /** Email Address */
    emailAddress: string | undefined;
}

/** Contact information for an order */
export interface WebOrderRoleContactInfo extends ContactInfo {
    /** Textual role */
    role: string | undefined;
    /** Contact address */
    address: AddressInfo | undefined;
}

export enum AppointmentTimeRangeEnum {
    Morning = 0,
    Afternoon = 1,
    Evening = 2,
    Saturday = 3,
    MorningExtended = 4,
    AfternoonExtended = 5,
    AllDay = 6,
    LateMorning = 7,
    EarlyAfternoon = 8,
}

/** More of a coded enum now */
export interface AppointmentTimeRangeEnumExtensions {
}

/** Appraisal Approval Email Data Transfer Object */
export interface AppraisalApprovalRequestEmailDto {
    /** User requesting approval */
    requestedByName: InternetUserNameInfoDto | undefined;
    /** Customer for case */
    customer: CustomerDto | undefined;
    /** Case control number */
    controlIdNumber: number;
    /** Case loan number */
    loanNumber: string | undefined;
    /** Case GSE */
    governmentSponsoredEnt: string | undefined;
    /** Appraiser requested */
    requestedAppraiser: AppraiserNameAndNumberDto | undefined;
    /** Additional comments from requestor */
    requestApprovalComments: string | undefined;
    /** Reasons why approval is required */
    requestApprovalReasons: string | undefined;
    /** Description of the requested appraiser */
    requestedAppraiserDescription: string | undefined;
    /** Description of all available appraisers */
    availableAppraisersDescription: string | undefined;
    /** Valuation Director contact info */
    valuationDirector: UserContactInfo | undefined;
}

/** login user email and name */
export interface InternetUserNameInfoDto {
    /** internet user id */
    id: number;
    /** Email Address */
    emailAddress: string | undefined;
    /** First Name */
    firstName: string | undefined;
    /** Last Name of User */
    lastName: string | undefined;
    /** Full name of user. Example "Jane Doe" */
    fullName: string | undefined;
}

/** Contains Customer Info */
export interface CustomerDto {
    accountNumber: number | undefined;
    customerName: string | undefined;
    type: string | undefined;
    majorCompanyId: number | undefined;
}

/** Appraiser full names and numbers */
export interface AppraiserNameAndNumberDto {
    /** Appraiser first and last name */
    fullName: string | undefined;
    /** Appraiser number */
    number: number;
}

/** Class for storing user contact information */
export interface UserContactInfo {
    nameNumberDto: NameNumberDto | undefined;
    /** User's work phone */
    workPhone: string | undefined;
    /** User's mobile phone */
    mobilePhone: string | undefined;
    /** User's home phone */
    homePhone: string | undefined;
    /** User's email address */
    email: string | undefined;
}

/** Generic Name and Number Model */
export interface NameNumberDto {
    /** First Name of Person */
    firstName: string | undefined;
    /** Last Name of Person */
    lastName: string | undefined;
    /** Reference Number of Person */
    number: string | undefined;
    /** calculated $"{FirstName} {LastName} ({Number})"; */
    firstLast: string | undefined;
    /** Calculated $"{LastName}, {FirstName} ({Number})"; */
    lastFirst: string | undefined;
    /** calculated $"{FirstName} {LastName}"; */
    firstLastNameOnly: string | undefined;
    /** Calculated $"{LastName}, {FirstName}"; */
    lastFirstNameOnly: string | undefined;
}

/** Appraisal assignment to appraiser approval decision */
export interface AppraisalAssignmentApprovalDecisionDto {
    /** The case control number for approval decision  */
    controlIdNumber: number;
    /** The unique id of this approval */
    appraisalAssignmentApprovalId: number;
    /** Date that the decision was made */
    decisionDateUtc: Date | undefined;
    /** Was a decision made */
    decisionMade: boolean;
    /** User that made the decision */
    decisionInternetUserId: number | undefined;
    /** Was the assignment approved */
    decisionApproved: boolean;
    /** Comments about decision */
    decisionComments: string;
}

/** AppraisalAssignmentApproval View Model Class */
export interface AppraisalAssignmentApprovalDto {
    /** Primary Key */
    id: number;
    /** Case control number */
    controlIdNumber: number;
    /** Date approval requested */
    requestedDateUtc: Date;
    /** User that requested the approval */
    requestedByInternetUserId: number;
    /** Reasons for approval */
    requestApprovalReasons: string | undefined;
    /** Approval request comments */
    requestApprovalComments: string | undefined;
    /** Appraiser requested */
    requestedAppraiserId: number;
    /** Description of the requested appraiser
             */
    requestedAppraiserDescription: string | undefined;
    /** Descriptions of available appraisers */
    availableAppraisersDescription: string | undefined;
    /** Decision has been made */
    decisionMade: boolean;
    /** Date that decision was made */
    decisionDateUtc: Date | undefined;
    /** User that made the decision */
    decisionInternetUserId: number | undefined;
    /** Decision approved */
    decisionApproved: boolean | undefined;
    /** Comments on the decision */
    decisionComments: string | undefined;
}

/** Model for results from AppraisalAssignmentApprovalResultProvider quicklist */
export interface AppraisalAssignmentApprovalResult {
    /** Case control number */
    controlIDNumber: number;
    /** Customer account name */
    customerName: string | undefined;
    /** Customer account number */
    customerNumber: number | undefined;
    /** Customer name number */
    customerNameNumber: string | undefined;
    /** Days since approval requested */
    daysSinceRequested: string | undefined;
    /** Days since approval decision */
    daysSinceDecided: string | undefined;
    /** Requested Appraiser name */
    appraiserName: string | undefined;
    /** Requested Appraiser city */
    appraiserCity: string | undefined;
    /** Requested Appraiser state */
    appraiserStateAbbreviation: string | undefined;
    /** Subject city */
    subjectCity: string | undefined;
    /** Subject county */
    subjectCounty: string | undefined;
    /** Appraiser status */
    appraiserStatus: string | undefined;
    /** Valuation coordinator name */
    valuationCoordinatorName: string | undefined;
    /** Valuation director name */
    valuationDirectorName: string | undefined;
    /** Days in appraisal status */
    daysInAppraisalStatus: string | undefined;
    /** Approval request date */
    requestedDateUtc: Date;
    /** Approval decision date */
    decisionDateUtc: Date | undefined;
    /** Days since approval request date  */
    daysSinceRequestedRaw: number | undefined;
    /** Days since approval decision date  */
    daysSinceDecidedRaw: number | undefined;
    /** Days in current appraisal status */
    daysInAppraisalStatusRaw: number | undefined;
    /** Subject state abbreviation */
    subjectState: string | undefined;
    /** Decision made */
    decided: boolean;
    /** Assignment approved */
    approved: boolean | undefined;
}

/** Case Issue DTO */
export interface AppraisalCaseIssueDto {
    /** Unique issue Id */
    id: number | undefined;
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** Report Group */
    reportGroup: string | undefined;
    /** Display Group */
    displayGroup: string | undefined;
    /** Date Created */
    dateCreated: Date;
    /** QA Response */
    qualityAssuranceResponse: string | undefined;
    /** Appraiser Response */
    appraiserResponse: string | undefined;
    /** Appraiser flagged as resolved */
    appraiserResolved: boolean;
    /** Indicates if the case issue is active */
    active: boolean;
}

/** DTO for listing Appraiser Case Issues */
export interface AppraisalCaseIssuesDto {
    controlIdNumber: number;
    commentDirection: string | undefined;
    caseIssues: AppraisalCaseIssueDto[] | undefined;
    policyHolderFirstName: string | undefined;
    policyHolderLastName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
}

/** File name and friendly name of appraisal files */
export interface AppraisalFileDefinition {
}

export interface AppraisalManagementResult {
    controlIDNumber: number;
    policyNumber: string | undefined;
    appraisalStatus: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    county: string | undefined;
    serviceRegion: string | undefined;
    policyholderName: string | undefined;
    customerNumber: number | undefined;
    customerName: string | undefined;
    customerNameNumber: string | undefined;
    dateEntered: Date | undefined;
    dateCompleted: Date | undefined;
    dateReceived: Date | undefined;
    dueDate: Date | undefined;
    appraiserDueDate: Date | undefined;
    inspectionType: string | undefined;
    frAssigned: string | undefined;
    appraiserAssigned: string | undefined;
    trackingNumber: string | undefined;
    appraisalId: number;
    webStatus: string | undefined;
    appraisalStatusCode: string | undefined;
    appraisalIsEditableByAppraiser: boolean;
    daysInStatus: string | undefined;
    daysInStatusRaw: number;
    resultGridRowType: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    appointmentDateTime: Date | undefined;
    daysInVS: string | undefined;
    daysInVSRaw: number;
    integerDaysInVS: number;
    appointmentDate: Date | undefined;
    lastNote: CellViewModelOfCaseNoteViewModel | undefined;
    timeUnassignedAppraiser: string | undefined;
    timeUnassignedFieldRep: string | undefined;
    timeAssignedWithNoContactEfforts: string | undefined;
    timeSinceScheduledAppointment: string | undefined;
    timeSinceScheduledAppointmentRaw: string | undefined;
    timeInQA2: string | undefined;
    timeInQA1: string | undefined;
    totalBrokerTime: string | undefined;
    totalBrokerTimeRaw: string | undefined;
    timeInFSQA: string | undefined;
    assignmentType: string | undefined;
    appraisalSupportRepresentative: string | undefined;
    fieldDirector: string | undefined;
    agencyName: string | undefined;
    appraiserEta: string | undefined;
    clientEta: string | undefined;
    isOnHold: boolean;
    surveyDate: Date | undefined;
    fieldLevelCoordinator: string | undefined;
    valuationDirector: string | undefined;
    lastContactEffort: string | undefined;
    lastContactResult: string | undefined;
    dateAssigned: Date | undefined;
    dateReturned: Date | undefined;
    lastContactDate: Date | undefined;
    /** Service Type - On Site  */
    serviceTypeIsOnSite: boolean;
    /** Service Type - Call Center */
    serviceTypeIsCallCenter: boolean;
    /** Service Type - Consumer Web */
    serviceTypeIsConsumerWeb: boolean;
    /** Service Type - Appraisal */
    serviceTypeIsAppraisalSurvey: boolean;
    /** Customer Type */
    customerTypeCode: string | undefined;
    /** Appraisal Appointment Date */
    appraisalAppointmentDate: Date | undefined;
    /** Loan Closing Date */
    loanClosingDate: Date | undefined;
    /** Lender logistics manager */
    lenderLogisticsManager: string | undefined;
    /** Appraisal Port Status if present */
    appraisalPortStatus: string | undefined;
    /** Case has an appraiser note type */
    hasAppraiserNote: boolean;
    /** Case has one or more linked cases */
    hasLinkedCase: boolean;
    /** Amount of days case is on hold */
    daysOnHold: number;
}

/** Data Structure for organizing data inside a grid cell */
export interface CellViewModelOfCaseNoteViewModel {
    /** ID of a cell */
    controlNumber: string | undefined;
    /** Value rendered in the grid */
    value: CaseNoteViewModel | undefined;
}

/** Data Structure for Case Notes Displayed within Tooltips in Result Grid */
export interface CaseNoteViewModel {
    /** The Time the note was created in UTC */
    createdDateUTC: Date | undefined;
    /** The meat of the Note */
    noteBody: string | undefined;
    /** Who wrote the Note */
    author: string | undefined;
}

/** AppraisalPort specific case attribute names */
export interface AppraisalPortCaseAttributeNames {
}

export interface Exception {
    Message: string | undefined;
    InnerException: Exception | undefined;
    StackTrace: string | undefined;
    Source: string | undefined;
}

export interface AppraisalPortUnexpectedServerResponseException extends Exception {
}

/** Class like AppraisalQaRejection, but optimized for transfer to the web client */
export interface AppraisalQaRejectionViewModel {
    /** The primary key id */
    id: number;
    /** The appraisal id */
    appraisalSurveyId: number;
    /** The date this rejection was created */
    createdDate: Date;
    /** The reason category key id */
    reasonCategoryId: number;
    /** The reason for this rejection */
    reasonNotes: string | undefined;
    /** The response to this rejection */
    responseNotes: string | undefined;
    /** The date this rejection was responded to */
    responseDate: Date | undefined;
    /** The last modified date of this rejection */
    modifiedDate: Date;
    /** The name of the reason category */
    reasonCategoryName: string | undefined;
    /** This is the appraiser Id of the case when it was rejected.
             */
    appraiserId: number;
}

/** Appraisal Survey Dto for case detail */
export interface AppraisalSurveyDetailDto {
    /** Control Number */
    controlIdNumber: number;
    /** GSE : Government Sponsor Enterprise */
    governmentSponsor: string | undefined;
    /** The appraiser assigned to this appraisal */
    assignedToAppraiserId: number | undefined;
}

/** Client side model for summary info about an appraisal */
export interface AppraisalSurveyInfo {
    /** The unique identifier for this appraisal id */
    id: number;
    /** The current workflow status display name */
    workflowStatusName: string | undefined;
    /** The current workflow status code */
    workflowStatusCode: string | undefined;
    /** True if the appraisal is assigned to an appraiser */
    isAssignedToAppraiser: boolean;
    /** The assigned appraiser number */
    assignedToAppraiserNumber: number | undefined;
    /** True if the appraisal has unresolved appraiser rejections */
    hasUnresolvedAppraiserRejection: boolean;
    /** The quantity of unresolved appraiser rejections */
    unresolvedAppraiserRejectionCount: number;
    /** The total quantity of appraiser rejections */
    appraiserRejectionCount: number;
    /** Is this case editable by Appraiser */
    isEditableByAppraiser: boolean;
    /** Can an appraiser add time log? */
    canAppraiserAddTimeLog: boolean;
    /** The amount of minutes to do an appraisal */
    appraiserLogMinutesExpected: number;
    /** The maximum amount of minutes that can be logged to an appraisal */
    appraiserLogMinutesMaximum: number;
    /** Total Appraiser minutes available to add */
    appraiserLogMinutesAvailable: number;
    /** Total Appraiser minutes logged */
    appraiserLogMinutesTotal: number;
    /** Can change the appraiser assigned to the case? */
    canChangeAppraiserAssignment: boolean;
    /** Estimated delivery date of appraisal */
    deliveryETA: Date | undefined;
    /** Client ETA */
    clientETA: Date | undefined;
    /** Government Sponsor Enterprise (GSE) */
    governmentSponsor: string | undefined;
    /** Appraisal appointment date */
    appraisalAppointmentDate: Date | undefined;
    /** Appraisal appointment note */
    appraisalAppointmentNote: string | undefined;
}

export interface ApplicationException extends Exception {
}

/** Mueller business logic exception */
export interface MuellerBusinessException extends ApplicationException {
}

/** Exception specific for when an appraisal has an invalid status transition */
export interface AppraisalSurveyInvalidStatusTransitionException extends MuellerBusinessException {
}

/** Fannie Mae / Freddie Mac Waiver Process Settings */
export interface AppraisalWaiverSettings {
    /** The case control number for these settings */
    controlNumber: number;
    /** Customer number on case */
    customerNumber: number;
    /** Case survey type code */
    surveyTypeCode: string | undefined;
    /** Customer has 1004 Hybrid configured */
    customerHasFannieMae1004Hybrid: boolean;
    /** Customer has Freddie Mac 70H configured */
    customerHasFreddieMac70H: boolean;
    /** Customer has Fannie Mae Integration Enabled */
    fannieMaeIntegrationEnabled: boolean;
    /** Customer has Freddie Mac Integration Enabled */
    freddieMacIntegrationEnabled: boolean;
    /** Case is currently a Fannie Mae 1004 Hybrid */
    caseIsFannieMae1004Hybrid: boolean;
    /** Case is currently a Freddie Mac 70H */
    caseIsFreddieMac70H: boolean;
    /** Case is currently a PropertyConditionReport */
    caseIsPropertyConditionReport: boolean;
    /** Case is currently a 1004 Hybrid / 70H Inspection */
    caseIs1004Hybrid70H: boolean;
    /** Case is a possibly eligible survey type  */
    caseIsPossiblyEligibleSurveyType: boolean;
    /** FNMA last submitted date */
    fannieMaeLastSubmitted: Date | undefined;
    /** FRE last submitted date */
    freddieMacLastSubmitted: Date | undefined;
    /** FNMA Integration has PCR set to True */
    fnmaHasPropertyConditionReportEnabled: boolean;
    /** FRE Integration has PCR set to True */
    freHasPropertyConditionReportEnabled: boolean;
    /** Fannie Mae Institution Id */
    fannieMaeInstitutionId: string | undefined;
    /** Freddie Mac Case File Id */
    freddieMacCaseFileId: string | undefined;
    /** True if case is a Fannie Mae 1004P survey type */
    caseIsFannieMae1004P: boolean;
    /** True if Fannie Mae integration applies to this case */
    fannieMaeIntegrationIsApplicable: boolean;
    /** True if Freddie Mac integration applies to this case */
    freddieMacIntegrationIsApplicable: boolean;
    /** True if the UPD integration applies to this case */
    updIntegrationIsApplicable: boolean;
    /** True if GSE indicates that Fannie Mae should be used */
    governmentSponsorCodeIndicatesFannnieMae: boolean;
    /** True if GSE indicates that Freddie Mac should be used */
    governmentSponsorCodeIndicatesFreddieMac: boolean;
    /** True if GSE indicates that Fannie Mae and Freddie Mac should be used */
    governmentSponsorCodeIndicatesFannieMaeAndFreddieMac: boolean;
    /** True if the GSE indicator is present */
    governmentSponsorCodeSupplied: boolean;
    /** True if Fannie Mae Waiver is set */
    integration_FannieMaeWaiver: boolean | undefined;
    /** True if Freddie Mac Waiver is set */
    integration_FreddieMacBACE: boolean | undefined;
    /** True if the Fannie Mae integration can be enabled on this case */
    fannieMaeIntegrationCanBeEnabled: boolean;
    /** True if the Freddie Mac integration can be enabled on this case */
    freddieMacIntegrationCanBeEnabled: boolean;
    /** True if the case was exported to Freddie Mac BACE API */
    wasSubmittedToFreddieMacBace: boolean;
    /** Loan_DesktopUnderwriterCasefileID supplied on case import */
    fannieMaeCaseFileId: string | undefined;
}

/** Summary of appraisal waver information */
export interface AppraisalWaiverSummaryResult {
    /** The applicable appraisal waiver settings */
    appraisalWaiverSettings: AppraisalWaiverSettings | undefined;
    /** True if there is a result from Fannie Mae */
    fannieMaePropertyDataResponseExists: boolean;
    /** True if the latest Fannie Mae result indicates a decision is required */
    fannieMaeRequiresDecision: boolean;
    /** True if there is a result from Freddie Mac */
    freddieMacInspectionResponseExists: boolean;
    /** True if the latest result from Freddie Mac indicates that a decision is required */
    freddieMacRequiresDecision: boolean;
    /** True if the latest AWAITING_ELIGIBILITY_DECISION status exists and is not marked for resend */
    fannieMaeWaiverDecisionEmailSent: boolean;
}

/** Static functions to help determine what status comes next and all that. */
export interface AppraisalWorkflowStatusHelper {
}

export interface AppraisalWorkflowStatusView {
    /** enum maps to this.
             */
    id: number;
    code: string | undefined;
    name: string | undefined;
    /** Turn on/off text comment Required.
             */
    commentRequired: boolean;
    /** Include the Validation summary in the confirm message.
             */
    showValidationStatus: boolean;
    /** Text for the action button.
             */
    buttonText: string | undefined;
    options: AppraisalWorkflowStatusView[] | undefined;
}

/** State with county level metrics */
export interface MetricsByStateCountyTabularOfAppraiserCoverageMetric {
    /** The related state id */
    stateId: number;
    /** The related county id */
    countyId: number;
    /** Metrics in this county */
    metrics: AppraiserCoverageMetric | undefined;
}

/** Count of active appraisers by state and county */
export interface AppraiserActiveCoverageByStateAndCountyDto extends MetricsByStateCountyTabularOfAppraiserCoverageMetric {
    /** The two letter state abbreviation */
    stateAbbreviation: string | undefined;
    /** The display name of the county */
    countyName: string | undefined;
}

/** Metric for Appraiser Count */
export interface AppraiserCoverageMetric {
    /** Are there any Appraisers */
    hasAppraiserCoverage: boolean;
    /** The quantity of appraisers present */
    appraiserCount: number;
    /** The list of appraisers present */
    appraisers: NameNumberDto[] | undefined;
}

/** Request to get appraiser appointments as calendar events */
export interface AppraiserAppointmentsCalendarRequest {
    /** Appraiser Number */
    appraiserNumber: number;
    /** Start Date of appointments */
    startDateTime: Date;
    /** End date of appointments */
    endDateTime: Date | undefined;
}

/** Abstraction for Result Provider objects */
export interface CaseResult {
    /** ControlNumber of each case */
    controlIdNumber: number;
    /** RowType for each case */
    rowType: string | undefined;
}

/** Appraiser Queue Case Result */
export interface AppraiserCaseResult extends CaseResult {
    loanNumber: string | undefined;
    fieldStatus: string | undefined;
    appraisalStatus: string | undefined;
    customerName: string | undefined;
    surveyType: string | undefined;
    customerDueDate: Date;
    dateEntered: Date;
    dateReceived: Date;
    appraiserETA: Date | undefined;
    lastNote: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
}

/** DTO that links an appraiser to the counties they work out of */
export interface AppraiserCountyDto {
    /** Primary key */
    id: number;
    /** Appraiser */
    appraiser: AppraiserListDto | undefined;
    /** County */
    county: CountyDto | undefined;
    /** Date created */
    createdDate: Date;
    /** Created by user */
    createdByInternetUser: InternetUserListDto | undefined;
}

/** Appraiser List Information */
export interface AppraiserListDto extends NameNumberDto {
    /** Primary key of appraiser */
    id: number;
}

/** County data transformation object */
export interface CountyDto {
    /** County Id */
    id: number;
    /** County FIPS Code */
    fips: string | undefined;
    /** County Name */
    name: string | undefined;
    /** State Abbreviation */
    state: string | undefined;
    /** Center of county Latitude */
    latitude: number | undefined;
    /** Center of county Longitude */
    longitude: number | undefined;
    /** Boundary JSON */
    boundary: string | undefined;
}

/** used is a return list of login users */
export interface InternetUserListDto {
    username: string | undefined;
    email: string | undefined;
    fullName: string | undefined;
    roleName: string | undefined;
    failedAttempts: number | undefined;
    mustChangePassword: boolean;
    isDisabled: boolean;
    internetUserId: number;
    isLockedOut: boolean;
}

/** Structure for data sent in the click tracking estimate email */
export interface AppraiserCoverageClickTrackingEmail {
    /** Customer name */
    submittedByName: string | undefined;
    /** Customer username  */
    submittedByUsername: string | undefined;
    /** Customer name and number */
    customerNameNumber: string | undefined;
    /** Submitted by date  */
    submittedOnDateUtc: Date;
}

/** Appraiser Designation list item. */
export interface AppraiserDesignationViewModel {
    id: number;
    appraiserId: number;
    appraiserDesignationTypeId: number;
    validFrom: Date | undefined;
    validTo: Date | undefined;
    appraiserDesignationType: DesignationViewModel | undefined;
    status: string | undefined;
    designationCode: string | undefined;
}

export interface DesignationViewModel {
    id: number;
    name: string | undefined;
    code: string | undefined;
    abbreviation: string | undefined;
    description: string | undefined;
    requiresRenewal: boolean;
    renewalIntervalDays: number | undefined;
}

/** Appraiser Exclusions Information */
export interface AppraiserExclusionDto {
    /** Customer Exclusion Primary Key */
    id: number;
    /** Appraiser Basic Information */
    appraiser: AppraiserListDto;
    /** Date Added to Exclusion List */
    createdDate: Date;
    /** Created by user display name */
    createdByUserEmail: string;
    /** Optional comments regarding exclusion */
    comments: string | undefined;
    /** Date removed from Exclusion List */
    removedDate: Date | undefined;
    /** Removed by user display name */
    removedByUserEmail: string | undefined;
}

/** A Customer List of Appraisers they cannot work form */
export interface AppraiserExclusionListDto {
    /** Appraiser Basic Information */
    appraisersExclusionList: AppraiserExclusionDto[] | undefined;
}

/** Match type found when searching for appraisers */
export enum AppraiserExclusionMatchTypeEnum {
    LastName = 0,
    FullName = 1,
    License = 2,
    LicenseAndLastName = 3,
    RemovedFromList = 4,
}

/** Results of an exclusion search */
export interface AppraiserExclusionSearchMatchListDto {
    /** List of appraiser matches */
    matches: AppraiserExlcusionSearchMatchDto[] | undefined;
}

/** Result of exclusion search for an appraiser */
export interface AppraiserExlcusionSearchMatchDto {
    /** The type of match found */
    matchType: AppraiserExclusionMatchTypeEnum;
    /** The matched appraiser */
    appraiser: AppraiserListDto | undefined;
    /** Action required based on the match and appraiser's current exclusion status */
    actionNeeded: ExclusionActionNeededEnum;
    /** Date of status change provided by the customer */
    customerStatusChangeDate: Date;
    /** Date exclusion was created by Mueller user */
    createdDate: Date | undefined;
}

/** Action needed to be taken on exclusion search match */
export enum ExclusionActionNeededEnum {
    None = 0,
    AddExclusion = 1,
    RemoveExclusion = 2,
    DeficiencyReview = 3,
}

/** Request to search for appraisers based on customer exclusion spreadsheet */
export interface AppraiserExclusionSearchRequestDto {
    /** Customer number to apply exclusions */
    customerNumber: number;
    /** Spreadsheet file data */
    fileData: string | undefined;
    /** The types of matches to find in the search */
    matchTypes: AppraiserExclusionMatchTypeEnum[] | undefined;
}

/** Details to use in search of an appraiser */
export interface AppraiserExclusionsSearchDto {
    /** Appraiser first name */
    firstName: string | undefined;
    /** Appraiser last name */
    lastName: string | undefined;
    /** State Id for state where the appraiser is licensed */
    licenseStateId: number;
    /** Appraiser's license number */
    licenseNumber: string | undefined;
    /** Customer number the search is being done for */
    customerId: number;
    /** Appraiser status */
    appraiserStatus: ExclusionAppraiserStatusEnum;
    /** Date of status change provided by the customer */
    statusChangeDate: Date;
}

/** Status of appraiser from customer exclusion list */
export enum ExclusionAppraiserStatusEnum {
    None = 0,
    Ineligible = 1,
    Deficient = 2,
}

/** used to add a new appraiser license */
export interface AppraiserLicenseAddRequest {
    /** Appraiser Id */
    appraiserNumber: number;
    /** State of License */
    stateAbbreviation: string;
    /** License Number */
    number: string;
    /** Certification Type Code */
    appraiserLicenseCertificateTypeCode: string;
    /** Effective Date of License */
    effectiveDate: Date;
    /** Expiration Date of License */
    expirationDate: Date;
    /** Status of license */
    status: string;
    /** Base64 Encoded License Image */
    licenseImage: string | undefined;
}

/** Appraiser License Certificate Codes */
export interface AppraiserLicenseCertificateCodes {
}

/** Constants of Appraiser License type ids */
export interface AppraiserLicenseCertificateConstants {
}

/** Get AppraiserLicenseCertificateTypes */
export interface AppraiserLicenseCertificateTypeDto {
    /** Primary Key */
    id: number;
    /** Name */
    name: string;
    /** Unique Code */
    code: string;
    /** Description */
    description: string | undefined;
    /** AppraisalSubcommitteeName */
    appraisalSubcommitteeName: string | undefined;
}

/** Used to get Appraiser License Info */
export interface AppraiserLicenseDto {
    /** Primary key */
    id: number;
    /** Appraiser Id */
    appraiserId: number;
    /** State  */
    licenseState: StateDto;
    /** License Number */
    licenseNumber: string;
    /** Appraiser Certification Type */
    licenseCertificateType: AppraiserLicenseCertificateTypeDto;
    /** License Effective Date */
    effectiveDate: Date;
    /** License Expiration Date */
    expirationDate: Date;
    /** License Status */
    licenseStatus: string;
    /** Do we have the license image  */
    hasLicenseImage: boolean;
    /** Url to get the image bytes */
    licenseImageUrl: string | undefined;
}

/** State Data transformation object */
export interface StateDto {
    /** State Id */
    id: number;
    /** State Abbreviation */
    abbreviation: string | undefined;
    /** State Name */
    name: string | undefined;
    /** State Abbreviation - Name */
    abbreviationAndName: string | undefined;
}

/** Model used to send daily email notifications to users about expiring appraiser licenses */
export interface AppraiserLicenseExpiredNotificationDto {
    /** Appraiser info */
    appraiser: AppraiserListDto | undefined;
    /** Appraiser Mueller Email */
    appraiserMuellerEmail: string | undefined;
    /** Appraiser Login Email */
    appraiserLoginEmail: string | undefined;
    /** Appraisers Supervisor Email */
    supervisorEmail: string | undefined;
    /** Appraisers Supervisors Supervisor Email (basically 2 levels up) */
    vpEmail: string | undefined;
    /** License number */
    licenseNumber: string | undefined;
    /** License State */
    licenseState: string | undefined;
    /** License Expired Date */
    licenseExpiredDate: Date;
    /** LicenseExpiredDate.Date minus DateTime.Today */
    dayFromExpiration: string;
}

/** Constants for Appraiser License Status */
export interface AppraiserLicenseStatuses {
}

/** Used to update an appraiser license */
export interface AppraiserLicenseUpdateRequest {
    /** Appraiser License Id */
    id: number;
    /** Appraiser License Id */
    appraiserNumber: number;
    /** State of License */
    stateAbbreviation: string;
    /** License Number */
    number: string;
    /** Certification Type Code */
    appraiserLicenseCertificateTypeCode: string;
    /** Effective Date of License */
    effectiveDate: Date;
    /** Expiration Date of License */
    expirationDate: Date;
    /** Status of license */
    status: string;
    /** Base64 Encoded License Image */
    licenseImage: string | undefined;
}

/** General Case Note */
export interface CaseNoteDto {
    /** Id from the database table this history type came from */
    id: number;
    /** Date the log was created */
    dateCreated: Date;
    /** Notes on the log */
    details: string | undefined;
    /** Who performed the action */
    performedBy: string | undefined;
}

export interface AppraiserNote extends CaseNoteDto {
    historyType: HistoryType;
}

/** Enum for the different Case History item types. */
export enum HistoryType {
    Touch = 1,
    CsNote = 2,
    Issue = 3,
    CallLog = 4,
    CaseEvent = 5,
    AppraisalEvents = 6,
    AppraisalLogs = 7,
    TimeLog = 8,
    Reconsideration = 9,
    InternalNote = 10,
    SystemTouch = 11,
    ExternalNote = 12,
    PreferredAppointment = 13,
    AppraiserNote = 14,
    AppointmentChange = 15,
}

/** Appraiser order requirements DTO */
export interface AppraiserOrderRequirementsRetrieveRequest {
    /** The survey type code */
    surveyTypeCode: string | undefined;
    /** The customer number */
    customerNumber: number;
}

/** Appraiser order requirements DTO */
export interface AppraiserOrderRequirementsDeleteRequest extends AppraiserOrderRequirementsRetrieveRequest {
}

/** Appraiser order requirements DTO */
export interface AppraiserOrderRequirementsRetrieveResult {
    /** The survey type code */
    pdfExists: boolean;
    /** The customer number */
    pdfUrl: string | undefined;
}

/** Appraiser order requirements save DTO */
export interface AppraiserOrderRequirementsUpdateStreamDto extends AppraiserOrderRequirementsRetrieveRequest {
    /** The stream to save to the file */
    orderRequirementsContentStream: Stream | undefined;
    /** The mime type of the content stream */
    orderRequirementsMimeType: string | undefined;
}

/** Case Detail of Appraiser Cases going to be paid */
export interface AppraiserPaymentCase {
    /** Control Number */
    controlIdNumber: number;
    /** Appraiser Number */
    appraiserNumber: number;
    /** Appraiser Name */
    appraiserName: string | undefined;
    /** Appraiser Payroll Id */
    payrollEmployeeId: string | undefined;
    /** Appraiser state they live in */
    appraiserState: string | undefined;
    /** Appraisers hourly rate (if salary, then hourly rate is calculated) */
    hourlyRate: number;
    /** If Employee is salary or hourly */
    salaryOrHourly: string | undefined;
    /** Case Cost Total (including Previous cost and current cost) */
    costTotal: number;
    /** Mueller Anticipated Cost (MAC) */
    mac: number;
    /** Mac Bonus */
    macBonus: number;
    /** Case Survey Type */
    surveyType: string | undefined;
    /** Date Time Case was submitted */
    submittedDateTime: Date | undefined;
    /** Administrative hours */
    administrativeHours: number;
    /** The cost(fees) associated with appraiser of this case in previous pay periods */
    costPrevious: number;
    /** The cost(fees) associated with appraiser of this case in current pay period */
    costCurrent: number;
    /** The current hours associated with appraiser in the current pay period */
    hoursCurrent: number;
}

export interface AppraiserPaymentCaseResponse {
    /** List of data */
    data: AppraiserPaymentCase[] | undefined;
    /** File Name */
    fileName: string | undefined;
    /** Column Definitions */
    columnDefinitions: MGridColumnDefinition[] | undefined;
}

export interface MGridColumnDefinition {
    /** Lets the grid know how to format the column */
    code: string | undefined;
    /** Tells the grid what key in the data this column applies to */
    dataSource: string | undefined;
    filterSource: string | undefined;
    name: string | undefined;
    visible: boolean | undefined;
    resizeable: boolean | undefined;
    sortable: boolean | undefined;
    dataType: string | undefined;
    filterType: string | undefined;
    width: number | undefined;
    key: string | undefined;
    headerTooltip: string | undefined;
}

/** Details for an individual case to be included in the pay summary */
export interface AppraiserPayrollCaseDto {
    /** Control number */
    controlIdNumber: number;
    /** The City the Survey was located in */
    surveyCity: string | undefined;
    /** Survey Type */
    surveyType: string | undefined;
    /** Base amount to be paid to the Appraiser (Mueller Anticipated Cost) */
    mac: number;
    /** Amount deducted from MacTotal for completed appraiser late */
    lateDeduction: number;
    /** Amount deducted from MacTotal for having an appraisal returned (rejected) */
    returnedDeduction: number;
    /** All costs already paid to the appraiser for the case */
    costPrevious: number;
    /** All cost in current payperiod NOT paid to the appraiser for the case. */
    costCurrent: number;
    /** All time that is allocated to this payperiod */
    hoursCurrent: number;
    /** Total amount paid for individual case (CostPrevious + CostCurrent) */
    costTotal: number;
    /** The calculated MacBonus on the case */
    macBonus: number;
    /** This is the available amount of remaining MAC bonus for the case */
    macRemaining: number;
}

/** View Model of each Case in an Appraisal Pay Period */
export interface AppraiserPayrollCaseViewModel {
    /** Control number */
    controlIdNumber: number;
    /** The City the Survey was located in */
    surveyCity: string | undefined;
    /** Survey Type */
    surveyType: string | undefined;
    /** Base amount to be paid to the Appraiser (Mueller Anticipated Cost) */
    mac: string | undefined;
    /** Amount deducted from MacTotal for completed appraiser late */
    lateDeduction: string | undefined;
    /** Amount deducted from MacTotal for having an appraisal returned (rejected) */
    returnedDeduction: string | undefined;
    /** All costs already paid to the appraiser for the case */
    costPrevious: string | undefined;
    /** All cost in current payperiod NOT paid to the appraiser for the case. */
    costCurrent: string | undefined;
    /** All time that is allocated to this payperiod */
    timeCurrent: number;
    /** Total amount paid for individual case (CostPrevious + CostCurrent) */
    costTotal: string | undefined;
    /** The calculated MacBonus on the case */
    macBonus: string | undefined;
    /** This is the available amount of remaining MAC bonus for the case */
    macRemaining: string | undefined;
}

/** Appraiser Payroll Summary */
export interface AppraiserPayrollSummary {
    /** appraiser info */
    appraiser: AppraiserListDto | undefined;
    /** Number of cases */
    casesCount: number;
    /** Hourly Rate at time of payroll run */
    hourlyRateAgreed: number;
    /** Hours worked for pay period */
    hoursWorked: number;
    /** Current Cost of those hours worked */
    costCurrent: number;
    /** Cost of cases previously */
    costPrevious: number;
    /** Total Case Cost */
    costTotal: number;
    /** Deductions for case being lat */
    lateDeduction: number;
    /** Deductions for case being returned  */
    returnedDeduction: number;
    /** Total Mac Amount of cases */
    macPay: number;
    /** Total Mac Bonus for the week */
    macBonusPay: number;
    /** If the users time card has been approved for the pay period */
    isApproved: boolean;
    /** Effective Hourly Rate: ((HoursWorked * HourlyRateAgreed) + MacBonusPay) / HoursWorked */
    effectiveHourlyRate: number;
    /** Cost Per Case: CostTotal / CasesCount */
    costPerCase: number;
    /** Supervisor to Appraiser */
    supervisor: NameNumberDto | undefined;
}

/** The full pay summary */
export interface AppraiserPayrollSummaryDto {
    /** List of cases that will generate the summary data */
    payPeriodCases: AppraiserPayrollCaseDto[] | undefined;
    /** Total amount payed for site time and web time based on InspectorPayRate */
    totalCaseCost: number;
    /** Total estimated amount to be paid to the appraiser (Average Rate x Estimated Minutes) */
    macTotal: number;
    /** Amount paid in excess of estimated (excluding MileagePay) */
    macBonus: number;
    /** Total MAC Bonus Remaining for payperiod */
    macRemaining: number;
    /** total hours */
    hoursTotal: number;
    /** Overtime Hours */
    hoursOvertime: number;
    /** Calculate overtime cost */
    overtimeCost: number;
    /** Is appraiser salaried */
    isSalaried: boolean;
    /** Weekly salary amount */
    weeklySalary: number;
}

/** View Model for the Appraiser Payroll Summary */
export interface AppraiserPayrollSummaryViewModel {
    /** List of cases that will generate the summary data */
    payPeriodCases: AppraiserPayrollCaseViewModel[] | undefined;
    /** Total amount payed for site time and web time based on InspectorPayRate */
    totalCaseCost: string | undefined;
    /** Total Amount of Returned Deduction */
    totalLateDeduction: string | undefined;
    /** Total Amount of Returned Deduction */
    totalReturnedDeduction: string | undefined;
    /** Total amount of cost previous */
    totalCostPrevious: string | undefined;
    /** Total amount of cost current */
    totalCostCurrent: string | undefined;
    /** Total estimated amount to be paid to the inspector (Mueller Adjusted Cost) (MacBase + MacIncentive) */
    macTotal: string | undefined;
    /** Amount paid in excess of estimated (excluding MileagePay) */
    macBonus: string | undefined;
    /** Total Amount paid in excess of estimated (excluding MileagePay) */
    macRemaining: string | undefined;
    /** total hours */
    hoursTotal: string | undefined;
    /** Overtime Hours */
    hoursOvertime: string | undefined;
    /** Calculate overtime cost */
    overtimeCost: string | undefined;
    /** Is appraiser salaried */
    isSalaried: boolean;
    /** Weekly salary amount */
    weeklySalary: string | undefined;
    /** The Defines what Columns to display on the Client's grid */
    columns: ColumnViewModel[] | undefined;
}

export interface ColumnViewModel {
    name: string | undefined;
    key: string | undefined;
    visible: boolean;
    formatter: string | undefined;
    /** ASC is True, DESC is False, Null for no preference
             */
    sort: boolean | undefined;
    /** Tells the client whether the column is editable */
    editable: boolean;
}

/** Appraiser Profile information */
export interface AppraiserProfile {
    /** Read-only list of licenses */
    licenseList: string[] | undefined;
    /** Appraisal Management Company if member */
    companyName: string | undefined;
    /** Direct phone number */
    phoneNumber: string | undefined;
    /** Flag to identify if this user has Appraisers reporting up to them for statistics. */
    isAppraisalManager: boolean;
    /** User Id of the manager */
    managerUserId: number;
}

export interface AppraiserQueueResult {
    controlIDNumber: number;
    policyNumber: string | undefined;
    appraisalStatus: string | undefined;
    name: string | undefined;
    webStatus: string | undefined;
    inspectionType: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    policyholderName: string | undefined;
    customerNumber: number;
    customerName: string | undefined;
    dateEntered: Date;
    appointmentDate: Date | undefined;
    dueDate: Date | undefined;
    dateCompleted: Date | undefined;
    daysInVS: string | undefined;
    appraiserEta: string | undefined;
    lastNote: string | undefined;
    appraisalSupportRepresentative: string | undefined;
    dateAssigned: Date | undefined;
    lastContactEffort: string | undefined;
    contactEffortResult: string | undefined;
    dateReturned: Date | undefined;
    appraisalAppointmentDate: Date | undefined;
}

/** Appraiser quicklist result */
export interface AppraiserQuickListResult {
    /** Appraiser name */
    appraiserName: string | undefined;
    /** Comma separated list of counties covered */
    countiesCovered: string | undefined;
    /** State of residence */
    state: string | undefined;
    /** Cases completed in the last 90 days */
    casesCompletedLast90: number;
    /** Appraiser ID */
    appraiserId: number;
    /** Internet user ID */
    internetUserId: number;
    /** Number of open(editable) cases assigned to Appraiser */
    casesAssigned: number;
}

/** Datamodel for an email indicating an Appraiser has been reassigned */
export interface AppraiserReassignmentEmailDto {
    /** Addresses Email will be sent */
    toAddress: MailAddress[] | undefined;
    /** Carbon Copy Addresses Email will be sent */
    ccAddress: MailAddress[] | undefined;
    /** Current Appraiser, Appraiser ID */
    currentAppraiser: string | undefined;
    /** Original Appraiser, Appraiser ID */
    originalAppraiser: string | undefined;
    /** Name of Case's Lender */
    lenderName: string | undefined;
    /** Case's Loan Number */
    loanNumber: string | undefined;
    /** Cases's Status */
    status: string | undefined;
    /** Cases's Survey Type */
    reportType: string | undefined;
    /** Case's Broker */
    orderedBy: string | undefined;
    /** Case's Borrower */
    borrowerName: string | undefined;
}

export interface MailAddress {
    displayName: string | undefined;
    user: string | undefined;
    host: string | undefined;
    address: string | undefined;
}

/** Used to add/update an appraiser signature */
export interface AppraiserSignatureAddRequest {
    /** Appraiser Number */
    appraiserNumber: number;
    /** Base64 Appraiser Signature */
    signatureImage: string | undefined;
}

/** Used when getting a list of appraisers than can be assigned to an appraisal */
export interface AppraisersToAssignToAppraisal {
    /** Do we need a reason for assigning an appraiser */
    assignmentReasonFeature: boolean;
    /** List of Appraisers than can be assigned */
    appraisersAvailable: AppraiserWithCounty[] | undefined;
    /** Do we need a comment when an appraiser is assigned to a appraisal more than 150 miles away */
    proximityCommentFeature: boolean;
    /** List of inactive appraisers that could otherwise be assigned the appraisal */
    appraisersIneligible: AppraiserWithCounty[] | undefined;
}

/** Appraiser who has appropriate license and county for the case */
export interface AppraiserWithCounty {
    /** Appraiser Id */
    id: number;
    /** Appraiser Number */
    appraiserNumber: number;
    /** Appraiser First Name */
    firstName: string | undefined;
    /** Appraiser Last Name */
    lastName: string | undefined;
    /** Appraiser Full Name */
    fullName: string | undefined;
    /** Appraiser County Id */
    countyId: number;
    /** Current Appraiser Performance Grade */
    performanceGrade: string | undefined;
    /** Distance in miles from appraiser to subject property */
    proximityToSubject: string | undefined;
    /** Numeric distance in miles from appraiser to subject property */
    proximityToSubjectMiles: number;
    /** Appraiser employee id */
    employeeId: number;
    /** Indicates that the Appraiser is on Salary */
    isSalary: boolean;
    /** Appraiser's license expiration date if expiring soon */
    licenseExpiringSoonDate: string | undefined;
}

/** A DTO supplying all available ASRs */
export interface AppraiserSupportEmployee {
    /** Identifier
             */
    id: number;
    /** Internet user id associated with the employee (shouldn't be really null, but the db allows it)
             */
    internetUserId: number | undefined;
    /** First name of ASR
             */
    firstName: string | undefined;
    /** Last name of ASR
             */
    lastName: string | undefined;
}

/** Map of available regions, by ZipCode */
export interface AppraiserSupportRegionViewModel {
    regionId: number;
    zipCode: string | undefined;
    county: string | undefined;
    state: string | undefined;
    assignedUserPayrollId: string | undefined;
}

export interface AppraiserSupportUserViewModel {
    payrollId: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    assignedRegion: AppraiserSupportRegionViewModel | undefined;
}

/** Use to add an Appraiser Survey Type Group fee */
export interface AppraiserSurveyTypeGroupAddRequest {
    /** Appraiser Id */
    appraiserId: number;
    /** Survey Type Group Id */
    surveyTypeGroupId: number;
    /** Mac Fee */
    fee: number;
    /** Created by Internet User Id */
    createdByInternetUserId: number;
}

/** Detail of an appraiser survey type group fee dto */
export interface AppraiserSurveyTypeGroupFeeDto {
    /** Primary key */
    id: number;
    /** Appraiser info */
    appraiser: AppraiserListDto | undefined;
    /** Survey Type Group info */
    surveyTypeGroup: SurveyTypeGroupDto | undefined;
    /** Overriding MAC Fee */
    fee: number;
    /** Created/Modified by user  */
    createdByUser: string | undefined;
    /** Date Time row was created */
    createdDate: Date;
    /** Date Time row was modified */
    modifiedDate: Date;
}

/** Survey Type Group Dto */
export interface SurveyTypeGroupDto {
    /** Primary key */
    id: number;
    /** Name */
    name: string | undefined;
}

/** Update request for Appraiser Survey Type Fee */
export interface AppraiserSurveyTypeGroupUpdateRequest {
    /** Primary key  */
    id: number;
    /** Mac Fee */
    fee: number;
    /** Updated by Internet User Id */
    updatedByInternetUserId: number;
}

/** All and Everything you need to know about the appraiser. */
export interface AppraiserViewModel {
    appraiserDesignationViewModels: AppraiserDesignationViewModel[] | undefined;
    appraiserId: number;
    appraiserNumber: number;
    appraiserManager: string | undefined;
    internetUserId: number;
    username: string | undefined;
    userEmail: string | undefined;
    companyName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    middleName: string | undefined;
    nameSuffix: string | undefined;
    fullName: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zipCode: string | undefined;
    homePhoneNumber: string | undefined;
    workPhoneNumber: string | undefined;
    mobilePhoneNumber: string | undefined;
    emailAddress: string | undefined;
    conformsToAQBCriteria: boolean;
    appraisalSubcommitteeDisciplinaryAction: string | undefined;
    appraisalSubcommitteeDisciplinaryActionEffectiveDate: Date;
    appraisalSubcommitteeDisciplinaryActionEndDate: Date;
    addressLatitude: number;
    addressLongitude: number;
    activeDate: Date;
    inactiveDate: Date;
    isEmployee: boolean;
    isFake: boolean;
    hourlyPayRate: number;
    /** Pay rate Type */
    payRateType: PayrateTypeEnum;
    hireDate: Date;
    terminatedDate: Date;
    createdDate: Date;
    modifiedDate: Date;
    payrollEmployeeId: string | undefined;
    managerInternetUserId: number;
    allowEditsEffectiveDate: Date;
    allowEditsEndDate: Date;
    /** Used to limit cases per customer feature of required experience to work cases. */
    experienceStartDate: Date;
    employeeId: number | undefined;
    weeklyCapacityHours: number | undefined;
}

/** Hourly or Salary rate type */
export enum PayrateTypeEnum {
    Unknown = 0,
    Salary = 1,
    Hourly = 2,
}

/** Used to approve time logs */
export interface ApprovalUserTimeLogsAddDto {
    /** Pay Period the time logs are approved for */
    payPeriodId: number;
    /** User the time logs are approved for (Employee) */
    internetUserId: number;
    /** User that is approving the time logs (Manager) */
    approverInternetUserId: number;
}

/** appSettings configuration name constants */
export interface AppSettingNames {
}

/** List of ASP.NET User Roles */
export interface AspNetUserRoles {
}

/** Message back from assigning a case */
export interface AssignCaseToAssigneeCaseResponse {
    /** The case control number */
    caseId: number;
    /** Textual message */
    message: string | undefined;
}

/** used to assign cases to an inspector */
export interface AssignCaseToAssigneeRequest {
    /** List of ControlNumbers */
    caseIds: number[] | undefined;
    /** Assignment notes */
    caseAssignmentDetails: AssignmentRequestDetail[] | undefined;
    /** Inspector Number to assign to cases */
    inspectorNumber: number;
    /** The user id of the person assigning the cases */
    assignedByUserId: number;
}

/** Used to provide additional assignment details */
export interface AssignmentRequestDetail {
    /** Case Control Number */
    caseId: number;
    /** Notes if assignment approval is required */
    approvalRequestComments: string | undefined;
    /** Notes to add to case notes */
    caseNoteBody: string | undefined;
}

/** Response to AssignCaseToAssigneeRequest */
export interface AssignCaseToAssigneeResponse {
    /** Case assignment details */
    caseAssignmentDetails: AssignCaseToAssigneeCaseResponse[] | undefined;
}

/** Information about an inspector assigned to a case for the assignment map */
export interface AssignedCaseInspectorInfo {
    /** The first name of the inspector */
    firstName: string | undefined;
    /** The last name of the inspector */
    lastName: string | undefined;
    /** Inspector Id */
    inspectorId: number;
    /** Inspector number */
    inspectorNumber: number;
}

/** Response for case location of assigned cases */
export interface AssignedCaseLocationListResponse {
    /** List of assigned case locations */
    caseLocations: AssignedCaseLocationResponse[] | undefined;
}

export interface CaseLocationResponse {
    caseId: number;
    latitude: number | undefined;
    longitude: number | undefined;
    pinGroupingConfigId: number;
    preferredAppointmentDate: Date | undefined;
    customerDueDate: Date | undefined;
    daysTillDue: number;
    age: number;
    frIncentivePercent: number | undefined;
    countyId: number | undefined;
    county: string | undefined;
    stateAbbreviation: string | undefined;
    isFilteredCase: boolean;
    wasAutomaticallyPulled: boolean;
    isAppraisal: boolean;
    /** Inspection ETA */
    inspectionEta: Date | undefined;
    /** Auto assignment ETA */
    autoAssignmentEta: Date | undefined;
    /** Appointment date */
    appointmentDate: Date | undefined;
}

/** Assigned case location */
export interface AssignedCaseLocationResponse extends CaseLocationResponse {
    /** Info for inspector. FirstName, LastName, InspectorId, InspectorNumber */
    inspectorInfo: AssignedCaseInspectorInfo | undefined;
}

export interface AssigneeLocationListResponse {
    inspectorLocations: InspectorLocationResponse[] | undefined;
}

export interface InspectorLocationResponse {
    id: number;
    inspectorNumber: number;
    isLiveLocation: boolean;
    isTravelLocation: boolean;
    lastLocationUpdate: Date | undefined;
    lastLocationUpdateFormatted: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    displayName: string | undefined;
    designations: string[] | undefined;
    email: string | undefined;
    workPhone: string | undefined;
    homePhone: string | undefined;
    cellPhone: string | undefined;
    county: string | undefined;
    stateAbbreviation: string | undefined;
    canBeAssignedCases: boolean;
    internetUserId: number;
    notes: string | undefined;
    performanceGrade: string | undefined;
    serviceBoundary: string | undefined;
    isTrainee: boolean;
    serviceRegions: InspectorServiceRegionResponse[] | undefined;
}

/** Web response for GetInspectorServiceRegions */
export interface InspectorServiceRegionResponse {
    /** Primary key */
    id: number;
    /** Service Region Name */
    name: string | undefined;
    /** State that the region resides in */
    stateAbbreviation: string | undefined;
    /** Date the service region was assigned to this inspector */
    createdDate: Date;
    /** The user that assigned the service region to this inspector */
    createdByUser: string | undefined;
    /** Link to county table id */
    countyId: number | undefined;
    /** Link to zip table id */
    postalId: number | undefined;
    /** Link to service region table id */
    serviceRegionId: number | undefined;
    /** Travel Rule Id if this region is made for a travel rule */
    travelRuleId: number | undefined;
}

export interface AssigneeLocationRequest {
    /** two character code (capital letters) for each state that the user does Cases for
if this is null Cases for every state will be returned */
    stateCodeList: string[] | undefined;
    /** Get Live FR Locations */
    useBreadcrumbs: boolean;
    /** Retrieves field rep service region data if true */
    includeServiceRegions: boolean;
}

export interface AssigneeResponse {
    /** primary key of User */
    id: number;
    inspectorLocation: InspectorLocationResponse | undefined;
    username: string | undefined;
    email: string | undefined;
    homePhone: string | undefined;
    cellPhone: string | undefined;
    fax: string | undefined;
    /** Experience Start Date */
    experienceStartDate: Date | undefined;
    /** Number of Years Experience */
    experienceYears: number;
    inspectorAddress: AssignmentAddress | undefined;
    notes: string | undefined;
    isSubcontractor: boolean;
    active: boolean;
    /** This is a fake account that most likely used for training.  Not a real inspector */
    isFake: boolean;
    countCases: number;
    countCasesAssignedToday: number;
    dollarsAssignedToday: number;
    countPastDueCases: number;
    countRejectedCases: number;
    /** Number of estimated hours on average the FR can do */
    workCapacityWeeklyHours: number;
    /** Number of cases submitted last 7 days */
    countCasesSubmittedLast7Days: number;
    errorPercent: number | undefined;
    interiorCompletionPercent: number | undefined;
    exteriorCompletionPercent: number | undefined;
    pastDuePercent: number | undefined;
    payrollEmployeeId: string | undefined;
    hireDate: Date | undefined;
    managerInternetUserId: number | undefined;
    managerName: string | undefined;
    teamLeader: TeamLeader | undefined;
    trainingCompletedDate: Date | undefined;
    terminatedDate: Date | undefined;
    backgroundCheckDate: Date | undefined;
    lastAuditDate: Date | undefined;
    hourlyPayRate: number | undefined;
    teamLeaderPayRate: number | undefined;
    isTeamLeader: boolean;
    canBeAssignedCases: boolean;
    employmentType: string | undefined;
    shouldShowOnlineForms: boolean;
    isMobileUser: boolean;
    usesAbbreviatedWebsite: boolean;
    clientCode: string | undefined;
    designationCodes: string[] | undefined;
    fieldDevelopmentEmployeeId: number | undefined;
    /** This the polygon boundary were the inspector will do work in general */
    serviceBoundary: string | undefined;
    /** Current Appraiser's Performance Grade */
    performanceGrade: string | undefined;
    /** List of account that the appraiser can't do work for */
    customerExclusionLists: CustomerExclusionListDto | undefined;
    /** Employee ID */
    employeeId: number | undefined;
    /** Employee Status from Ultimate  */
    employeeStatus: string | undefined;
    /** Is eligible for automatic assignment of cases */
    disableAutoAssign: boolean;
    /** Display name for MSA */
    serviceRegionDisplayName: string | undefined;
}

export interface AssignmentAddress {
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    stateAbbreviation: string | undefined;
    county: string | undefined;
    zip: string | undefined;
}

export interface TeamLeader {
    inspectorNumber: number;
    firstLastName: string | undefined;
}

/** An Appraiser's List of account they cannot do work for */
export interface CustomerExclusionListDto {
    /** List of Customers Exclusion  */
    customerExclusionLists: CustomerExclusionDto[] | undefined;
}

/** information to return for CustomerAppraiserExclusions */
export interface CustomerExclusionDto {
    /** Customer Exclusion Primary Key */
    id: number;
    /** Customer Basic Information */
    customers: CustomerListResponse;
    /** Date Added to Exclusion List */
    createdDate: Date;
    /** Created by user display name */
    createdByUserEmail: string;
    /** Optional comments regarding exclusion */
    comments: string | undefined;
    /** Date removed from Exclusion List */
    removedDate: Date | undefined;
    /** Removed by user display name */
    removedByUserEmail: string | undefined;
}

/** Account List model */
export interface CustomerListResponse {
    /** Primary Key */
    id: number;
    /** Account Name */
    name: string | undefined;
    /** Account Number */
    number: number;
    /** Display Value */
    displayLabel: string | undefined;
    /** Appraiser Minimum Years experience */
    appraiserMinimumYearExperience: number;
}

/** A DTO defining the needed information to assign employee to counties */
export interface AssignEmployeeCountyRequest {
    /** Employee Id to be assigned */
    employeeId: number;
    /** The assigned region */
    countyFIPSList: string[] | undefined;
}

/** A DTO defining the needed information to assign employee to states */
export interface AssignEmployeeStateRequest {
    /** Employee Id to be assigned */
    employeeId: number;
    /** The assigned region */
    stateAbbreviationList: string[] | undefined;
}

export enum AssignmentMode {
    Insurance = 0,
    Valuation = 1,
}

/** Result of call to inspector appointment assignment start */
export enum AssignmentNotificationStartResult {
    Unknown = 0,
    Success = 1,
    AlreadyStarted = 2,
    Ineligible = 3,
    InsufficientContactInfo = 4,
}

/** Appraisal assignment result */
export interface AssignToAppraiserResultDto {
    /** The appraisal survey */
    appraisalSurvey: AppraisalSurvey | undefined;
    /** assignment approval request */
    appraisalAssignmentApproval: AppraisalAssignmentApproval | undefined;
    /** The message to display to the user assigning */
    requestApprovalReasonUserDisplay: string | undefined;
}

export interface AppraisalSurvey {
    id: number;
    controlIdNumber: number;
    minimumAppraiserLicenseCertificateTypeId: number;
    appraisalWorkflowStatusId: number;
    assignedToAppraiserId: number | undefined;
    wasAssignedByManager: boolean;
    assignedToAppraiserDate: Date | undefined;
    appraiserManagerWhenAssignedId: number | undefined;
    rejectedToFieldRepDate: Date | undefined;
    wasRejectedToFieldRep: boolean;
    rejectedToAppraiserDate: Date | undefined;
    wasRejectedToAppraiser: boolean;
    appraisalSubmittedDate: Date | undefined;
    appraiserDueDate: Date | undefined;
    appraisalQaDueDate: Date | undefined;
    appraisalCompletedDate: Date | undefined;
    assignedToQaAgentId: number | undefined;
    assignedToQAAgentDate: Date | undefined;
    assignedToQaManagerId: number | undefined;
    assignedToQAManagerDate: Date | undefined;
    reviewedByQaAgentId: number | undefined;
    reviewedByQAAgentDate: Date | undefined;
    reviewedByQaManagerId: number | undefined;
    reviewedByQAManagerDate: Date | undefined;
    qaRejectionToAppraiserNotes: string | undefined;
    assignedToQAAgentTimeoutAtDate: Date | undefined;
    assignedToQAManagerTimeoutAtDate: Date | undefined;
    createdDate: Date | undefined;
    modifiedDate: Date;
    firstAvailableToAppraiserDate: Date | undefined;
    firstWorkflowTerminationDate: Date | undefined;
    appraiserMac: number;
    availableToCurrentAppraiserDate: Date | undefined;
    valuationServicesTimeServiceStartDate: Date | undefined;
    valuationServicesTimeServiceDueDate: Date | undefined;
    governmentSponsoredEnt: string | undefined;
    appraisalAssignmentDeclined: boolean;
    loanClosingDate: Date | undefined;
    appraisalCustomerRejections: AppraisalCustomerRejection[] | undefined;
    appraisalQaRejections: AppraisalQaRejection[] | undefined;
    appraisalReconsiderations: AppraisalReconsideration[] | undefined;
    appraisalSurveyDesignations: AppraisalSurveyDesignation[] | undefined;
    appraisalSurveyLogs: AppraisalSurveyLog[] | undefined;
    appraisalSurveyWorkflowStatusHistories: AppraisalSurveyWorkflowStatusHistory[] | undefined;
    appraisalWorkflowStatus: AppraisalWorkflowStatus | undefined;
    appraiser: Appraiser | undefined;
    appraiserLicenseCertificateType: AppraiserLicenseCertificateType | undefined;
    caseHeader: CaseHeader | undefined;
    collateralAnalyticsRiskProfilerResults: CollateralAnalyticsRiskProfilerResult[] | undefined;
    productConversionSourceAppraisalWorkflowStatusId: number | undefined;
    isInProductConversionProcess: boolean;
    productConversionSourceAppraisalWorkflowStatus: AppraisalWorkflowStatus | undefined;
    appraisalAssignmentApprovals: AppraisalAssignmentApproval[] | undefined;
    appraisalWorkflowStatusType: AppraisalWorkflowStatusType;
}

export interface AppraisalCustomerRejection {
    id: number;
    appraisalSurveyId: number;
    createdDate: Date;
    reasonCategoryId: number;
    reasonNotes: string | undefined;
    resolvedOnDate: Date | undefined;
    resolvedByInternetUserId: number | undefined;
    wasResolvedByAppraiser: boolean;
    wasResolvedByBusinessOps: boolean;
    resolutionNotes: string | undefined;
    modifiedDate: Date | undefined;
    appraisalReasonCategory: AppraisalReasonCategory | undefined;
    appraisalSurvey: AppraisalSurvey | undefined;
}

export interface AppraisalReasonCategory {
    id: number;
    reasonName: string | undefined;
    appraisalCustomerRejections: AppraisalCustomerRejection[] | undefined;
    appraisalQaRejections: AppraisalQaRejection[] | undefined;
    appraisalReconsiderations: AppraisalReconsideration[] | undefined;
}

export interface AppraisalQaRejection {
    id: number;
    appraisalSurveyId: number;
    createdDate: Date;
    reasonCategoryId: number;
    reasonNotes: string | undefined;
    responseNotes: string | undefined;
    responseDate: Date | undefined;
    modifiedDate: Date;
    appraiserId: number;
    rejectedByInternetUserId: number;
    appraisalReasonCategory: AppraisalReasonCategory | undefined;
    appraisalSurvey: AppraisalSurvey | undefined;
    appraiser: Appraiser | undefined;
    rejectedByInternetUser: InternetUser_Home | undefined;
}

export interface Appraiser {
    id: number;
    appraiserNumber: number;
    managerInternetUserId: number | undefined;
    internetUserId: number;
    companyName: string | undefined;
    firstName: string | undefined;
    middleName: string | undefined;
    lastName: string | undefined;
    nameSuffix: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    stateId: number;
    postalCodeId: number;
    homePhoneNumber: string | undefined;
    workPhoneNumber: string | undefined;
    mobilePhoneNumber: string | undefined;
    emailAddress: string | undefined;
    conformsToAqbCriteria: boolean;
    appraisalSubcommitteeDisciplinaryAction: string | undefined;
    appraisalSubcommitteeDisciplinaryActionEffectiveDate: Date | undefined;
    appraisalSubcommitteeDisciplinaryActionEndDate: Date | undefined;
    addressLatitude: number | undefined;
    addressLongitude: number | undefined;
    activeDate: Date;
    inactiveDate: Date | undefined;
    isEmployee: boolean;
    isFake: boolean;
    hourlyPayRate: number;
    hireDate: Date | undefined;
    terminatedDate: Date | undefined;
    createdDate: Date;
    modifiedDate: Date;
    allowEditsEffectiveDate: Date | undefined;
    allowEditsEndDate: Date | undefined;
    payrollEmployeeId: string | undefined;
    performanceGrade: string | undefined;
    signatureImagePath: string | undefined;
    experienceStartDate: Date | undefined;
    weeklyCapacityHours: number | undefined;
    appraisalSurveys: AppraisalSurvey[] | undefined;
    appraisalQARejections: AppraisalQaRejection[] | undefined;
    appraiserDesignations: AppraiserDesignation[] | undefined;
    appraiserLicenses: AppraiserLicense[] | undefined;
    appraiserCounties: AppraiserCounty[] | undefined;
    managerInternetUser: InternetUser_Home | undefined;
    postalCode: PostalCode | undefined;
    state: State | undefined;
    appraiserPayPeriodSummaries: AppraiserPayPeriodSummary[] | undefined;
    customerAppraiserExclusions: CustomerAppraiserExclusion[] | undefined;
    appraisalAssignmentApprovals: AppraisalAssignmentApproval[] | undefined;
    appraiserSurveyTypeGroupFees: AppraiserSurveyTypeGroupFee[] | undefined;
}

export interface AppraiserDesignation {
    id: number;
    appraiserId: number;
    appraiserDesignationTypeId: number;
    validFrom: Date | undefined;
    validTo: Date | undefined;
    appraiser: Appraiser | undefined;
    appraiserDesignationType: AppraiserDesignationType | undefined;
}

export interface AppraiserDesignationType {
    id: number;
    name: string | undefined;
    code: string | undefined;
    abbreviation: string | undefined;
    description: string | undefined;
    requiresRenewal: boolean;
    renewalIntervalDays: number | undefined;
    appraisalSurveyDesignations: AppraisalSurveyDesignation[] | undefined;
    appraiserDesignations: AppraiserDesignation[] | undefined;
}

export interface AppraisalSurveyDesignation {
    id: number;
    appraisalSurveyId: number;
    appraiserDesignationTypeId: number;
    designationOptional: boolean;
    appraisalSurvey: AppraisalSurvey | undefined;
    appraiserDesignationType: AppraiserDesignationType | undefined;
}

export interface AppraiserLicense {
    id: number;
    appraiserId: number;
    licenseStateId: number;
    licenseNumber: string | undefined;
    appraiserLicenseCertificateTypeId: number;
    licenseEffectiveDate: Date;
    licenseExpirationDate: Date;
    licenseStatus: string | undefined;
    licenseImagePath: string | undefined;
    appraiser: Appraiser | undefined;
    appraiserLicenseCertificateType: AppraiserLicenseCertificateType | undefined;
    state: State | undefined;
}

export interface AppraiserLicenseCertificateType {
    id: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    appraisalSubcommitteeName: string | undefined;
    appraisalSurveys: AppraisalSurvey[] | undefined;
    appraiserLicenses: AppraiserLicense[] | undefined;
}

export interface State {
    id: number;
    stateName: string | undefined;
    stateAbbreviation: string | undefined;
    costClass: number | undefined;
    counties: County[] | undefined;
    postalCodes: PostalCode[] | undefined;
    surveyCases: CaseHeader[] | undefined;
    mailingCases: CaseHeader[] | undefined;
    genericHazards: GenericFormHazardRule[] | undefined;
    standardFormHazardRules: StandardFormHazardRule[] | undefined;
    completeFormFees: CompleteFormFee[] | undefined;
    appraisers: Appraiser[] | undefined;
    appraiserLicenses: AppraiserLicense[] | undefined;
    featurePermissionStates: FeaturePermissionState[] | undefined;
    serviceRegions: ServiceRegion[] | undefined;
    customers: Customer[] | undefined;
}

export interface County {
    id: number;
    countyName: string | undefined;
    stateId: number;
    isActive: boolean;
    fipsCode: string | undefined;
    fieldRepEstimatedHourlyRate: number | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    boundary: string | undefined;
    appraiserEstimatedHourlyRate: number | undefined;
    boundaryGeometry: DbGeometry | undefined;
    state: State | undefined;
    postalCodes: PostalCode[] | undefined;
    genericHazards: GenericFormHazardRule[] | undefined;
    standardFormHazardRules: StandardFormHazardRule[] | undefined;
    appraiserCounty: AppraiserCounty[] | undefined;
    completeFormFees: CompleteFormFee[] | undefined;
    inspectorServiceRegions: InspectorServiceRegion[] | undefined;
    countyPostalCodes: CountyPostalCode[] | undefined;
}

/** Represents geometric shapes. */
export interface DbGeometry {
    /** Gets or sets a data contract serializable well known representation of this DbGeometry value.  */
    geometry: DbGeometryWellKnownValue | undefined;
}

/** A data contract serializable representation of a DbGeometry value. */
export interface DbGeometryWellKnownValue {
    /** Gets or sets the coordinate system identifier (SRID) of this value.  */
    coordinateSystemId: number;
    /** Gets or sets the well known text representation of this value.  */
    wellKnownText: string | undefined;
    /** Gets or sets the well known binary representation of this value.  */
    wellKnownBinary: string | undefined;
}

export interface PostalCode {
    id: number;
    zipCode: string | undefined;
    city: string | undefined;
    stateId: number;
    countyName: string | undefined;
    countyId: number | undefined;
    regionId: number;
    tier: string | undefined;
    centroidLatitude: number | undefined;
    centroidLongitude: number | undefined;
    timeZone: string | undefined;
    usesDaylightSavings: boolean | undefined;
    appraiserSupportEmployeeId: number | undefined;
    fieldCoordinatorEmployeeId: number | undefined;
    fieldDirectorEmployeeId: number | undefined;
    frIncentivePercent: number;
    inspectionServiceRegionId: number | undefined;
    lenderLogisticsManagerEmployeeId: number | undefined;
    isBarrierIsland: boolean;
    boundary: string | undefined;
    boundaryGeometry: DbGeometry | undefined;
    county: County | undefined;
    state: State | undefined;
    inspectorZips: InspectorZip[] | undefined;
    surveyCases: CaseHeader[] | undefined;
    mailingCases: CaseHeader[] | undefined;
    fieldCoordinatorEmployee: Employee | undefined;
    fieldDirectorEmployee: Employee | undefined;
    appraisalSupportEmployee: Employee | undefined;
    lenderLogisticsManagerEmployee: Employee | undefined;
    inspectionServiceRegion: ServiceRegion | undefined;
    appraisers: Appraiser[] | undefined;
    featurePermissionZips: FeaturePermissionZip[] | undefined;
    inspectorServiceRegions: InspectorServiceRegion[] | undefined;
    countyPostalCodes: CountyPostalCode[] | undefined;
}

export interface InspectorZip {
    id: number;
    internetUserId: number;
    postalCodeId: number;
    postalCode: PostalCode | undefined;
    inspectorZipFees: InspectorZipFee[] | undefined;
}

export interface InspectorZipFee {
    nInspectorZipFees_id: number;
    nInspectorZips_id: number;
    nInspectionType_id: number;
    nPercentOverFee: number;
    inspectionTypesT: SurveyType | undefined;
    inspectorZip: InspectorZip | undefined;
}

export interface SurveyType {
    id: number;
    name: string | undefined;
    inspectorDaysDue: number | undefined;
    code: string | undefined;
    description: string | undefined;
    isInterior: boolean;
    inspectorFee: number | undefined;
    qaFee: number | undefined;
    defaultPostcardNumber: string | undefined;
    siteTimeEstimatedMinutes: number;
    webTimeEstimatedMinutes: number;
    nQAExpectedMinutes: number;
    reportGroupName: string | undefined;
    inspectionTypeClass: string | undefined;
    appraisalExpectedMinutes: number;
    surveyTypeGroupId: number;
    qaFeePayRate: number;
    isCommercial: boolean;
    comparisonFields: ComparisonField[] | undefined;
    completeForms: CompleteForm[] | undefined;
    surveyTypePhotoTags: SurveyTypePhotoTag[] | undefined;
    customerSurveyTypePhotoTags: CustomerSurveyTypePhotoTag[] | undefined;
    demotionSourceMaps: SurveyTypeDemotionMap[] | undefined;
    demotionDestinationMaps: SurveyTypeDemotionMap[] | undefined;
    availFormPages: AvailFormPage[] | undefined;
    inspectorFees: InspectorFee[] | undefined;
    inspectorSurveyTypes: InspectorSurveyType[] | undefined;
    caseHeaders: CaseHeader[] | undefined;
    inspectorZipFees: InspectorZipFee[] | undefined;
    caseHeadersOriginalSurveyType: CaseHeader[] | undefined;
    surveyTypeGroup: SurveyTypeGroup | undefined;
    pdfRenderers: PdfRenderer[] | undefined;
    employeeCustomerSurveyTypes: EmployeeCustomerSurveyType[] | undefined;
    employeeCustomerSurveyTypeMaps: EmployeeCustomerSurveyTypeMap[] | undefined;
}

export interface ComparisonField {
    id: number;
    name: string;
    muellerKey: string;
    phoenixKey: string;
    availFormId: number;
    majorCompanyId: number;
    surveyTypeId: number | undefined;
    formatString: string | undefined;
    availForm: AvailForm | undefined;
    majorCompany: MajorCompany_Home | undefined;
    surveyType: SurveyType | undefined;
}

export interface AvailForm {
    id: number;
    formName: string | undefined;
    className: string | undefined;
    myriadName: string | undefined;
    displayOrder: number | undefined;
    fileName: string | undefined;
    customerId: number | undefined;
    lSuppWoodStove: boolean;
    lSuppEH: boolean;
    lSuppCanine: boolean;
    lSuppDayCare: boolean;
    lSuppAlcohol: boolean;
    lSuppDemoted: boolean;
    availFormTypeId: number | undefined;
    isGeneric: boolean;
    isOnline: boolean;
    isAlwaysOnline: boolean;
    isMajorForm: boolean;
    shouldUploadToMyriad: boolean;
    shouldBeSentBack: boolean;
    pdfSuffix: string | undefined;
    accessReportName: string | undefined;
    foreignKeyName: string | undefined;
    accessTableName: string | undefined;
    sqlProcedure: string | undefined;
    instanceCountMinimum: number;
    instanceCountMaximum: number | undefined;
    shouldHideEmptyAnswers: boolean;
    qaFee: number | undefined;
    createDate: Date | undefined;
    notes: string | undefined;
    supplementTypeId: number | undefined;
    code: string | undefined;
    inactiveDate: Date | undefined;
    phoenixFormId: string | undefined;
    expectedFieldMinutes: number | undefined;
    volume30: number;
    publishDate: Date | undefined;
    modifiedByInternetUserId: number | undefined;
    expectedCallCenterMinutes: number;
    expectedQaMinutes: number;
    availFormPages: AvailFormPage[] | undefined;
    availFormType: AvailFormType | undefined;
    customer: Customer | undefined;
    caseForms: CaseForm[] | undefined;
    comparisonFields: ComparisonField[] | undefined;
    deletedCaseForms: DeletedCaseForm[] | undefined;
    forms: Form[] | undefined;
    genericFormHazardRules: GenericFormHazardRule[] | undefined;
    genericQuestions: GenericQuestion[] | undefined;
    standardFormHazardRules: StandardFormHazardRule[] | undefined;
    rctMaterialFormOverrides: RCTMaterialFormOverride[] | undefined;
    availFormSupplementType: AvailFormSupplementType | undefined;
    pdfRenderers: PdfRenderer[] | undefined;
}

export interface AvailFormPage {
    id: number;
    availFormId: number;
    pageNumber: number;
    filename: string | undefined;
    inspectionTypeId: number | undefined;
    bitOptions: number | undefined;
    customerId: number | undefined;
    availForm: AvailForm | undefined;
    surveyType: SurveyType | undefined;
}

export interface AvailFormType {
    id: number;
    typeName: string | undefined;
    availForms: AvailForm[] | undefined;
}

export interface Customer {
    id: number;
    number: number | undefined;
    name: string | undefined;
    contact1: string | undefined;
    contact2: string | undefined;
    phoneNumber: string | undefined;
    phoneNumber2: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    stateId: number | undefined;
    zip: string | undefined;
    tier1Pricing: number | undefined;
    tier2Pricing: number | undefined;
    tier3Pricing: number | undefined;
    tier1InspectorFee: number | undefined;
    tier2InspectorFee: number | undefined;
    tier3InspectorFee: number | undefined;
    pricePerPhoto: number | undefined;
    pricePerPhoneCall: number | undefined;
    notes: string | undefined;
    agentsReqd: boolean | undefined;
    itvCoverPercent: number | undefined;
    preNoteReport: number | undefined;
    customerEmail: string | undefined;
    adobeDirectory: string | undefined;
    outputFileType: number | undefined;
    daysTillDue: number | undefined;
    teamName: string | undefined;
    revisionsEmail: string | undefined;
    qaPercentage: number | undefined;
    majorCompaniesId: number | undefined;
    emailFileNameOptionsId: number | undefined;
    minMinorHazardsToSendEmail: number | undefined;
    minMajorHazardsToSendEmail: number | undefined;
    itvBelowToSendEmail: number | undefined;
    itvAboveToSendEmail: number | undefined;
    createDate: Date;
    inactiveDate: Date | undefined;
    modifyDate: Date;
    emailFormatsId: number | undefined;
    sendMoleculeEventStartDate: Date | undefined;
    companyDisplayName: string | undefined;
    customEmailClass: string | undefined;
    emailCC: string | undefined;
    emailBCC: string | undefined;
    customerServiceTeamsId: number | undefined;
    customerTypeId: number | undefined;
    appraiserMinimumYearExperience: number;
    contractEndDate: Date | undefined;
    salesRepEmployeeId: number | undefined;
    auditPercentage: number;
    customerType: CustomerType | undefined;
    appraisalGaarRuleCustomerSeverities: AppraisalGaarRuleCustomerSeverity[] | undefined;
    completeForms: CompleteForm[] | undefined;
    customerSurveyTypePhotoTags: CustomerSurveyTypePhotoTag[] | undefined;
    inspectionTypeDemotionMaps: SurveyTypeDemotionMap[] | undefined;
    availForms: AvailForm[] | undefined;
    calculationsHeaderSettings: RCTCalculationSetting[] | undefined;
    salesRep: Employee | undefined;
    customerUnderwriterActions: CustomerUnderwriterAction[] | undefined;
    genericHazards: GenericFormHazardRule[] | undefined;
    cases: CaseHeader[] | undefined;
    standardFormHazardRules: StandardFormHazardRule[] | undefined;
    customer360ValueSettings: Customer360ValueSetting[] | undefined;
    caseBillingAdjustmentRuleCustomers: CaseBillingAdjustmentRuleCustomer[] | undefined;
    pdfRenderers: PdfRenderer[] | undefined;
    accountFiles: AccountFile[] | undefined;
    employeeCustomerSurveyTypes: EmployeeCustomerSurveyType[] | undefined;
    featurePermissionStates: FeaturePermissionState[] | undefined;
    featurePermissionZips: FeaturePermissionZip[] | undefined;
    customerAppraiserExclusions: CustomerAppraiserExclusion[] | undefined;
    customerInspectorExclusions: CustomerInspectorExclusion[] | undefined;
    majorCompany: MajorCompany_Home | undefined;
    state: State | undefined;
    emailFileNameOption: EmailFileNameOption | undefined;
    emailFormat: EmailFormat | undefined;
    stackCodeSettings: StackCodeSetting[] | undefined;
    pdfExportSettings: PDFExportSettings[] | undefined;
    employeeCustomerSurveyTypeMaps: EmployeeCustomerSurveyTypeMap[] | undefined;
    activeEmployeeSurveyTypeMaps: EmployeeCustomerSurveyTypeMap[] | undefined;
    customerOnboardings: CustomerOnboarding[] | undefined;
}

export interface CustomerType {
    customerTypeID: number;
    customerTypeCode: string | undefined;
    customers: Customer[] | undefined;
}

export interface AppraisalGaarRuleCustomerSeverity {
    id: number;
    customerId: number;
    ruleId: string | undefined;
    severityLevelId: number;
    customer: Customer | undefined;
    appraisalGaarRuleSeverityLevel: AppraisalGaarRuleSeverityLevel | undefined;
}

export interface AppraisalGaarRuleSeverityLevel {
    id: number;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    appraisalGaarRuleResults: AppraisalGaarRuleResult[] | undefined;
    appraisalGaarRuleCustomerSeverities: AppraisalGaarRuleCustomerSeverity[] | undefined;
}

export interface AppraisalGaarRuleResult {
    id: number;
    appraisalGaarHeaderId: number;
    ruleId: string | undefined;
    loopIndex: string | undefined;
    ruleMessage: string | undefined;
    severityLevelId: number | undefined;
    reviewedByInternetUserId: number | undefined;
    reviewedOnUtc: Date | undefined;
    reviewedComments: string | undefined;
    appraisalGaarHeader: AppraisalGaarHeader | undefined;
    appraisalGaarRuleSeverityLevel: AppraisalGaarRuleSeverityLevel | undefined;
    reviewedByInternetUser: InternetUser_Home | undefined;
}

export interface AppraisalGaarHeader {
    id: number;
    controlIdNumber: number;
    createdDateUtc: Date;
    gaarTransactionId: string | undefined;
    ruleFiringsCount: number | undefined;
    totalRulesCount: number | undefined;
    gaarResultJson: string | undefined;
    caseHeader: CaseHeader | undefined;
    appraisalGaarRuleResults: AppraisalGaarRuleResult[] | undefined;
}

export interface CaseHeader {
    percentITV: number | undefined;
    percentITV_Inverse: number | undefined;
    insurancePercentage: number | undefined;
    policyholderFullName: string | undefined;
    controlIDNumber: number;
    customerId: number | undefined;
    customerName: string | undefined;
    policyNumber: string | undefined;
    policyholderPhoneHome: string | undefined;
    policyholderPhoneWork: string | undefined;
    policyholderName1: string | undefined;
    policyholderName2: string | undefined;
    mailingAddress1: string | undefined;
    mailingAddress2: string | undefined;
    mailingCity: string | undefined;
    mailingStateId: number | undefined;
    mailingPostalCodeId: number | undefined;
    surveyCounty: string | undefined;
    muellerRegionId: string | undefined;
    surveyZipTier: string | undefined;
    department: string | undefined;
    alternateAddressToInspect: string | undefined;
    surveyAddress1: string | undefined;
    surveyAddress2: string | undefined;
    surveyCity: string | undefined;
    surveyStateId: number | undefined;
    surveyPostalCodeId: number | undefined;
    coverageAIn: number | undefined;
    coverageAOut: number | undefined;
    dateReceived: Date | undefined;
    dateAssigned: Date | undefined;
    dateCompleted: Date | undefined;
    alternateDateCompleted: Date | undefined;
    inspectorNumber: number | undefined;
    numberOfPhotos: number | undefined;
    numberOfPhoneCalls: number | undefined;
    reportFee: number | undefined;
    phoneCharge: number | undefined;
    photoCharge: number | undefined;
    miscCharge: number | undefined;
    billingNotes: string | undefined;
    directionsNeeded: boolean;
    directionsCompleted: boolean;
    directionsToSurveyAddress: string | undefined;
    appointmentRequired: boolean;
    appointmentSet: boolean;
    appointmentDate: Date | undefined;
    appointmentTime: string | undefined;
    effectiveDate: Date | undefined;
    appointmentNotes: string | undefined;
    agencyCode: string | undefined;
    agencyName: string | undefined;
    agencyPhoneNumber: string | undefined;
    privateNotes: string | undefined;
    surveyRemarks: string | undefined;
    webNotes: string | undefined;
    primaryStatus: string | undefined;
    directionsPostcard: Date | undefined;
    directionsPostcardSent: boolean;
    actionableReport: string | undefined;
    dueDate: Date | undefined;
    estimatedCompletionDate: Date | undefined;
    homeYearBuilt: string | undefined;
    inspectionTypeIn: string | undefined;
    agentId: number | undefined;
    constructionClassID: number | undefined;
    constructionClassReceivedID: number | undefined;
    businessType: BusinessType | undefined;
    call1Date: Date | undefined;
    call1Complete: boolean;
    call1DateComplete: Date | undefined;
    call1Outcome: string | undefined;
    call2Date: Date | undefined;
    call2Complete: boolean;
    call2DateComplete: Date | undefined;
    call2Outcome: string | undefined;
    call3Date: Date | undefined;
    call3Complete: boolean;
    call3DateComplete: Date | undefined;
    call3Outcome: string | undefined;
    preNoteReportType: number | undefined;
    locateLine1: string | undefined;
    locateLine2: string | undefined;
    locateLine3: string | undefined;
    hasHazard: boolean;
    hazardNotes: string | undefined;
    userInitials: string | undefined;
    appointmentYes: boolean;
    appointmentNo: boolean;
    canNotLocate: boolean;
    refusal: boolean;
    calcToolUsed: string | undefined;
    trackingNumber: number | undefined;
    adobeOutputDate: Date | undefined;
    dataEntryEmployeeId: number | undefined;
    assignedByEmployeeId: number | undefined;
    completedByEmloyeeId: number | undefined;
    billedByEmployeeId: number | undefined;
    nAllStateCat: number | undefined;
    lHasBeenSentElectronic: boolean;
    underwriterReviewedDate: Date | undefined;
    underwriterReviewedBy: string | undefined;
    underwriterReviewComments: string | undefined;
    requestedPhotoCount: number | undefined;
    clientReportType: string | undefined;
    clientReportCode: string | undefined;
    orderCodeOut: string | undefined;
    underwriterCode: string | undefined;
    inspectorQualityCheck: number | undefined;
    dateEntered: Date | undefined;
    hasWoodStoveSupplement: boolean;
    hasElectricalAndHeatingSupplement: boolean;
    hasCanineSupplement: boolean;
    hasDayCareSupplement: boolean;
    hasAlcoholSupplement: boolean;
    currentInspectionTypeId: number | undefined;
    isPrinted: boolean;
    delayType: number | undefined;
    delayEmp: number | undefined;
    directionsAction: number | undefined;
    directionsActionEmp: number | undefined;
    directionsCallEmp1: number | undefined;
    directionsCallEmp2: number | undefined;
    directionsCallEmp3: number | undefined;
    secondaryStatus: string | undefined;
    receivedFromStreetDate: Date | undefined;
    receivedAction: number | undefined;
    isRush: boolean;
    movedToQACalcDate: Date | undefined;
    orderCodeIn: string | undefined;
    isArchived: boolean;
    dateArchived: Date | undefined;
    majorRiskCount: number | undefined;
    minorRiskCount: number | undefined;
    addPoints: number | undefined;
    inspectorPaymentAmount: number | undefined;
    customerWebAction: number | undefined;
    isCompletedOnline: boolean;
    wasEverRejected: boolean;
    rejectionNotes: string | undefined;
    originalInspectionTypeId: number | undefined;
    hasDemotedSupplement: boolean;
    inspectorDaysExtension: number | undefined;
    reportYearBuilt: number | undefined;
    reportSquareFootage: number | undefined;
    stagedCaseId: number | undefined;
    calcToolFee: number | undefined;
    coverageAEndorsed: number | undefined;
    inspectorId: number | undefined;
    caseDataVerifications: CaseDataVerification[] | undefined;
    caseEvents: CaseEvent[] | undefined;
    caseForms: CaseForm[] | undefined;
    caseHazards: CaseHazard[] | undefined;
    caseIssueComments: CaseIssueComment[] | undefined;
    caseIssues: CaseIssue[] | undefined;
    appraisalCaseIssues: AppraisalCaseIssue[] | undefined;
    caseLinks: CaseLink[] | undefined;
    caseLinkSources: CaseLink[] | undefined;
    caseLogs: CaseLog[] | undefined;
    caseMailReturns: CaseMailReturn[] | undefined;
    casePayments: CasePayment[] | undefined;
    casePaymentsPending: CasePaymentsPending[] | undefined;
    caseRecommendations: CaseRecommendation[] | undefined;
    contactEfforts: ContactEffort[] | undefined;
    customer: Customer | undefined;
    inspectionDates: DateInspected[] | undefined;
    surveyPostalCode: PostalCode | undefined;
    mailingPostalCode: PostalCode | undefined;
    caseGeocode: CaseGeocode[] | undefined;
    surveyType: SurveyType | undefined;
    notifications: Notification[] | undefined;
    surveyState: State | undefined;
    mailingState: State | undefined;
    qaIssues: QAIssue[] | undefined;
    qaQueues: QAQueue[] | undefined;
    qaRemarks: QARemark[] | undefined;
    qaTouches: Touch[] | undefined;
    workItemsControlNumberCrossRef: WorkItemsControlNumberCrossRef[] | undefined;
    case360ValueCalcs: Case360ValueCalc[] | undefined;
    caseReturns: CaseReturn[] | undefined;
    caseAssignments: CaseAssignment[] | undefined;
    caseAttachments: CaseAttachment[] | undefined;
    caseAttributes: CaseAttribute[] | undefined;
    collateralAnalyticsRiskProfilerResults: CollateralAnalyticsRiskProfilerResult[] | undefined;
    telephoneSurveys: TelephoneSurvey[] | undefined;
    underwriterActionsAudits: UnderwriterActionsAudit[] | undefined;
    caseBillingItems: CaseBillingItem[] | undefined;
    buildingPermitHeaders: CaseBuildingPermitHeader[] | undefined;
    surveyTypeOriginal: SurveyType | undefined;
    caseCostEstimates: CaseCostEstimate[] | undefined;
    caseExportResults: CaseExportResult[] | undefined;
    automatedCallQueues: AutomatedCallQueue[] | undefined;
    caseTimeLogs: CaseTimeLog[] | undefined;
    caseNotes: CaseNote[] | undefined;
    caseRejections: CaseRejection[] | undefined;
    cubiCasaScans: CubiCasaScan[] | undefined;
    fnmaPropertyDataResponses: FnmaPropertyDataResponse[] | undefined;
    propertySearchData: PropertySearchData[] | undefined;
    phoenixIntegrationTracking: PhoenixIntegrationTracking | undefined;
    appraisalSurvey: AppraisalSurvey | undefined;
    appraisalGaarHeaders: AppraisalGaarHeader[] | undefined;
    caseCommunications: CaseCommunication[] | undefined;
    caseHeaderEncrypted: CaseHeaderEncrypted | undefined;
    caseHeaderAutoPolicyVerification: CaseHeaderMuellerAuto | undefined;
    caseFeedback: CaseFeedback[] | undefined;
    caseHolds: CaseHold[] | undefined;
    caseNationalFloodDataResults: CaseNationalFloodDataResult[] | undefined;
    appraisalAssignmentApprovals: AppraisalAssignmentApproval[] | undefined;
    inspector: Inspector | undefined;
    freddieMacBaceResponses: FreddieMacBaceResponse[] | undefined;
    caseAudits: CaseAudit[] | undefined;
    caseTimeLogFeedbacks: CaseTimeLogFeedback[] | undefined;
    caseAuditRiskScores: CaseAuditRiskScore[] | undefined;
    recommendationCounts: RecommendationCount[] | undefined;
    caseUserEventWatches: CaseUserEventWatch[] | undefined;
    caseETAs: CaseETAs[] | undefined;
    caseAppointments: CaseAppointment[] | undefined;
    qaCompletedCases: QACompletedCase[] | undefined;
    callCenterCompletedCases: CallCenterCompletedCase[] | undefined;
    caseUnderwriterActions: CaseUnderwriterAction[] | undefined;
    customerSatisfactionSurveyResponses: CustomerSatisfactionSurveyResponse[] | undefined;
    caseTravelLogs: CaseTravelLog[] | undefined;
    calculationHeaderHighValue: CalculationHeaderHighValue[] | undefined;
}

export enum BusinessType {
    New = 1,
    Renewal = 2,
}

export interface CaseDataVerification {
    id: number;
    controlIdNumber: number;
    observedValueDataVerificationCategoryCombinationId: number;
    observedValueDataVerificationCategoryCombination: DataVerificationCategoryCombination | undefined;
    observedValueAvailable: boolean;
    observedValueKey: string | undefined;
    observedValue: string | undefined;
    verificationDataVerificationCategoryCombinationId: number;
    verificationDataVerificationCategoryCombination: DataVerificationCategoryCombination | undefined;
    verificationValueAvailable: boolean;
    verificationValueKey: string | undefined;
    verificationValue: string | undefined;
    verificationDateUtc: Date;
    valuesAreConsideredEquivalent: boolean;
    caseHeader: CaseHeader | undefined;
}

export interface DataVerificationCategoryCombination {
    id: number;
    mainVerificationCategoryId: number;
    mainVerificationCategory: DataVerificationCategory | undefined;
    secondaryVerificationCategoryId: number;
    secondaryVerificationCategory: DataVerificationCategory | undefined;
    observedValueDataVerifications: CaseDataVerification[] | undefined;
    verificationDataVerifications: CaseDataVerification[] | undefined;
}

export interface DataVerificationCategory {
    id: number;
    code: string;
    name: string | undefined;
    mainVerificationCategoryCombinations: DataVerificationCategoryCombination[] | undefined;
    secondaryVerificationCategoryCombinations: DataVerificationCategoryCombination[] | undefined;
}

export interface CaseEvent {
    id: number;
    controlIDNumber: number;
    molecule: string | undefined;
    eventType: string | undefined;
    processDate: Date | undefined;
    createDate: Date;
    objectName: string | undefined;
    objectID: number | undefined;
    case: CaseHeader | undefined;
}

export interface CaseForm {
    id: number;
    controlIDNumber: number;
    availFormId: number;
    instanceNumber: number | undefined;
    isDeleted: boolean;
    parentCaseFormId: number | undefined;
    phoenixInstanceId: string | undefined;
    title: string | undefined;
    isPhoenixSupplement: boolean | undefined;
    hideFR: boolean;
    hideQA: boolean;
    hideCust: boolean;
    hideAppraiser: boolean;
    hideCER: boolean;
    availForm: AvailForm | undefined;
    case: CaseHeader | undefined;
    supplements: CaseForm[] | undefined;
    parent: CaseForm | undefined;
}

export interface CaseHazard {
    id: number;
    controlIDNumber: number;
    hazardCategoryId: number;
    majorCount: number | undefined;
    minorCount: number | undefined;
    hazardRuleID: number;
    hazardRuleObject: string | undefined;
    hazardLevel: string | undefined;
    hazardCategory: HazardCategory | undefined;
    case: CaseHeader | undefined;
}

export interface HazardCategory {
    id: number;
    categoryName: string | undefined;
    subcategoryName: string | undefined;
    caseHazards: CaseHazard[] | undefined;
    genericFormHazardRules: GenericFormHazardRule[] | undefined;
    standardFormHazardRules: StandardFormHazardRule[] | undefined;
}

export interface GenericFormHazardRule {
    id: number;
    availFormId: number;
    genericQuestionId: number;
    customerId: number | undefined;
    comparisonValue: string | undefined;
    isMajor: boolean | undefined;
    isMinor: boolean | undefined;
    comparisonType: string | undefined;
    hazardCategoryId: number;
    stateId: number | undefined;
    countyid: number | undefined;
    zipCodeLike: string | undefined;
    lRegionIsInverted: boolean | undefined;
    activeDate: Date;
    inactiveDate: Date | undefined;
    availForm: AvailForm | undefined;
    customer: Customer | undefined;
    genericQuestion: GenericQuestion | undefined;
    hazardCategory: HazardCategory | undefined;
    county: County | undefined;
    state: State | undefined;
}

export interface GenericQuestion {
    id: number;
    availFormId: number;
    questionName: string | undefined;
    question: string | undefined;
    type: string | undefined;
    values: string | undefined;
    isRequired: boolean;
    isNumeric: boolean;
    isYear: boolean;
    initialValue: string | undefined;
    parameters: string | undefined;
    header: string | undefined;
    displayOrder: number;
    isVisible: boolean;
    myriadName: string | undefined;
    groupName: string | undefined;
    availForm: AvailForm | undefined;
    genericFormHazardRules: GenericFormHazardRule[] | undefined;
}

export interface StandardFormHazardRule {
    id: number;
    availFormId: number;
    fieldName: string | undefined;
    majorValue: string | undefined;
    minorValue: string | undefined;
    comparisonType: string | undefined;
    hazardCategoryId: number;
    customerId: number | undefined;
    statesId: number | undefined;
    countyId: number | undefined;
    zipCodeLike: string | undefined;
    regionIsInverted: boolean;
    activeDate: Date;
    inactiveDate: Date | undefined;
    availForm: AvailForm | undefined;
    hazardCategory: HazardCategory | undefined;
    county: County | undefined;
    customer: Customer | undefined;
    state: State | undefined;
}

export interface CaseIssueComment {
    id: number;
    controlIDNumber: number;
    comments: string | undefined;
    createDate: Date;
    case: CaseHeader | undefined;
}

export interface CaseIssue {
    id: number;
    controlIDNumber: number;
    caseIssueTypeId: number;
    createDate: Date;
    caseIssueType: CaseIssueType | undefined;
    case: CaseHeader | undefined;
}

export interface CaseIssueType {
    id: number;
    customerId: number;
    code: string | undefined;
    name: string | undefined;
    reportGroup: string | undefined;
    displayGroup: string | undefined;
    createDate: Date;
    userTypeCode: string | undefined;
    caseIssues: CaseIssue[] | undefined;
    appraisalCaseIssues: AppraisalCaseIssue[] | undefined;
}

export interface AppraisalCaseIssue {
    id: number;
    controlIDNumber: number;
    caseIssueTypeId: number;
    appraiserResolved: Date | undefined;
    active: boolean;
    createdDate: Date;
    caseIssueType: CaseIssueType | undefined;
    case: CaseHeader | undefined;
    caseIssueComments: AppraisalCaseIssueComment[] | undefined;
}

export interface AppraisalCaseIssueComment {
    id: number;
    appraisalCaseIssueId: number;
    qualityAssuranceComments: string | undefined;
    appraiserResponse: string | undefined;
    createdDate: Date;
    appraisalCaseIssue: AppraisalCaseIssue | undefined;
}

export interface CaseLink {
    id: number;
    controlIdNumber: number;
    linkedControlIdNumber: number;
    dateLinked: Date;
    notes: string | undefined;
    internetUserId: number;
    caseHeader: CaseHeader | undefined;
    linkedCase: CaseHeader | undefined;
}

export interface CaseLog {
    id: number;
    controlIDNumber: number | undefined;
    milesDriven: number | undefined;
    previousCaseAddress: string | undefined;
    fieldMinutes: number | undefined;
    webMinutes: number | undefined;
    totalMinutes: number;
    travelMinutes: number;
    actualCost: number | undefined;
    milesEstimated: number | undefined;
    travelMinutesEstimated: number | undefined;
    previousControlNumber: number | undefined;
    case: CaseHeader | undefined;
    inspectorPaymentTemps: InspectorPaymentTemp[] | undefined;
    caseLogWayPoints: CaseLogWayPoint[] | undefined;
}

export interface InspectorPaymentTemp {
    id: number;
    inspectorNumber: number | undefined;
    internetUsersId: number | undefined;
    controlIdNumber: number | undefined;
    inspectorPayment: number | undefined;
    payPeriodFrom: Date | undefined;
    payPeriodTo: Date | undefined;
    milesDriven: number;
    totalMinutes: number;
    paymentTransactionTypesId: number | undefined;
    caseLogId: number | undefined;
    inspectedDate: Date | undefined;
    payPeriodId: number;
    inspectorId: number | undefined;
    inspector: Inspector | undefined;
    payPeriod: PayPeriod | undefined;
    caseHeader: CaseHeader | undefined;
    caseLog: CaseLog | undefined;
}

export interface Inspector {
    id: number;
    inspectorNumber: number;
    lastName: string | undefined;
    firstName: string | undefined;
    title: string | undefined;
    titleOfCourtesy: string | undefined;
    birthDate: Date | undefined;
    hiredByInternetUserId: number | undefined;
    hireDate: Date | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    region: string | undefined;
    postalCode: string | undefined;
    country: string | undefined;
    homePhone: string | undefined;
    extension: string | undefined;
    photo: string | undefined;
    notes: string | undefined;
    reportsTo: string | undefined;
    emergencyContactName: string | undefined;
    emergencyContactPhone: string | undefined;
    remarks: string | undefined;
    cellPhone: string | undefined;
    email: string | undefined;
    voiceMail: string | undefined;
    computerOSVersion: string | undefined;
    browserVersion: string | undefined;
    internetAccess: number | undefined;
    isActive: boolean;
    isFake: boolean;
    hasPrinter: boolean;
    shouldShowOnlineForms: boolean;
    managerInternetUserId: number | undefined;
    usesAbbreviatedWebsite: boolean;
    latitude: number | undefined;
    longitude: number | undefined;
    geocodeMatchLevel: string | undefined;
    interiorDaysTillPull: number | undefined;
    exteriorDaysTillPull: number | undefined;
    commercialDaysTillPull: number | undefined;
    isSubcontractor: boolean;
    trainingCompletedDate: Date | undefined;
    terminatedDate: Date | undefined;
    fax: string | undefined;
    teamLeaderId: number | undefined;
    backgroundCheckDate: Date | undefined;
    payrollEmployeeId: string | undefined;
    lastAuditDate: Date | undefined;
    isCertified: boolean;
    licenseTypeId: number | undefined;
    licenseNumber: string | undefined;
    licenseExpirationDate: Date | undefined;
    annualContinuingEducationDate: Date | undefined;
    clientCode: string | undefined;
    phoenixSketchUser: boolean | undefined;
    hourlyPayRate: number | undefined;
    teamLeaderPayRate: number | undefined;
    isTeamLeader: boolean;
    isPremiumQAOption: boolean;
    isMobileUser: boolean;
    canBeAssignedCases: boolean;
    serviceBoundary: string | undefined;
    serviceBoundaryGeometry: DbGeometry | undefined;
    workCapacityWeeklyMinutes: number;
    fieldDevelopmentEmployeeId: number | undefined;
    inspectorFees: InspectorFee[] | undefined;
    inspectorLicenseType: InspectorLicenseType | undefined;
    inspectorStatistic: InspectorStatistic | undefined;
    inspectorSurveyTypes: InspectorSurveyType[] | undefined;
    inspectorAdminWorkLog: InspectorAdminWorkLog[] | undefined;
    caseRejections: CaseRejection[] | undefined;
    inspectors: Inspector[] | undefined;
    teamLeader: Inspector | undefined;
    inspectorSurveyTypeGroups: InspectorSurveyTypeGroup[] | undefined;
    customerInspectorExclusions: CustomerInspectorExclusion[] | undefined;
    caseHeaders: CaseHeader[] | undefined;
    caseAutoAssignmentInspectors: CaseAutoAssignmentInspector[] | undefined;
    caseInspectorExtensions: CaseInspectorExtension[] | undefined;
    fieldDevelopmentEmployee: Employee | undefined;
    firstLastName: string | undefined;
    internetUserId: number | undefined;
    internetUser: InternetUser_Home | undefined;
    managerInternetUser: InternetUser_Home | undefined;
    locationGeometry: DbGeometry | undefined;
    costEfficiencyScoreLatest: number | undefined;
    disableAutoAssign: boolean;
    inspectorServiceRegions: InspectorServiceRegion[] | undefined;
    inspectorServiceTravelRules: InspectorServiceTravelRule[] | undefined;
    inspectorServiceTravelRuleDays: InspectorServiceTravelRuleDay[] | undefined;
    customerSatisfactionSurveyResponses: CustomerSatisfactionSurveyResponse[] | undefined;
    caseTravelLogs: CaseTravelLog[] | undefined;
    satisfactionSurvey_OnboardingResponses: SatisfactionSurvey_OnboardingResponse[] | undefined;
}

export interface InspectorFee {
    id: number;
    inspectorId: number;
    surveyTypeId: number;
    fee: number;
    surveyType: SurveyType | undefined;
    inspector: Inspector | undefined;
}

export interface InspectorLicenseType {
    id: number;
    description: string | undefined;
    code: string | undefined;
    inspectors: Inspector[] | undefined;
}

export interface InspectorStatistic {
    inspectorId: number;
    caseCount: number | undefined;
    errorPercentage: number | undefined;
    exteriorCompletionRate: number | undefined;
    interiorCompletionRate: number | undefined;
    pastDuePercentage: number | undefined;
    totalCaseCount: number | undefined;
    inspector: Inspector | undefined;
}

export interface InspectorSurveyType {
    id: number;
    inspectorId: number;
    inspectionTypeId: number;
    dateModified: Date;
    lastChangeUserId: number | undefined;
    inactiveDate: Date | undefined;
    surveyType: SurveyType | undefined;
    inspector: Inspector | undefined;
}

export interface InspectorAdminWorkLog {
    id: number;
    inspectorEmployeesId: number;
    inspectorAdminWorkTypesId: number;
    timeMinutes: number;
    milesDriven: number | undefined;
    workDate: Date;
    payPeriodsId: number | undefined;
    createdDate: Date;
    lastModifiedDate: Date;
    createdByInternetUserId: number | undefined;
    note: string | undefined;
    startDateTimeLocal: Date | undefined;
    endDateTimeLocal: Date | undefined;
    inspectorAdminWorkType: InspectorAdminWorkType | undefined;
    inspector: Inspector | undefined;
    payPeriod: PayPeriod | undefined;
}

export interface InspectorAdminWorkType {
    id: number;
    name: string | undefined;
    code: string | undefined;
    ultimatePayrollWorkTypeCode: string | undefined;
    displayOrder: number;
    earningCode: string | undefined;
    inspectorAdminWorkLog: InspectorAdminWorkLog[] | undefined;
}

export interface PayPeriod {
    id: number;
    fromDate: Date | undefined;
    toDate: Date | undefined;
    closedDate: Date | undefined;
    bonusWeekType: number;
    isClosed: boolean;
    casePayments: CasePayment[] | undefined;
    inspectorAdminWorkLogs: InspectorAdminWorkLog[] | undefined;
    employeeAdminTimeLogss: EmployeeAdminTimeLog[] | undefined;
    caseTimeLogs: CaseTimeLog[] | undefined;
    payPeriodUserApprovals: PayPeriodUserApproval[] | undefined;
    casePaymentsPending: CasePaymentsPending[] | undefined;
    appraiserPayPeriodSummaries: AppraiserPayPeriodSummary[] | undefined;
    qaCompletedCases: QACompletedCase[] | undefined;
    callCenterCompletedCases: CallCenterCompletedCase[] | undefined;
    caseTravelLogs: CaseTravelLog[] | undefined;
}

export interface CasePayment {
    id: number;
    controlIDNumber: number;
    internetUserId: number;
    inspectorNumber: number;
    payPeriodId: number;
    createDate: Date;
    paymentAmount: number;
    casePaymentTypeId: number;
    paymentTransactionTypesId: number;
    payPeriod: PayPeriod | undefined;
    case: CaseHeader | undefined;
    casePaymentType: CasePaymentType | undefined;
    paymentTransactionType: PaymentTransactionType | undefined;
}

export interface CasePaymentType {
    id: number;
    code: string | undefined;
    name: string | undefined;
    casePayments: CasePayment[] | undefined;
    casePaymentsPending: CasePaymentsPending[] | undefined;
}

export interface CasePaymentsPending {
    id: number;
    paymentTransactionTypesId: number;
    controlIDNumber: number;
    casePaymentTypeId: number;
    internetUserId: number;
    isPremiumQAOption: boolean;
    inspectorNumber: number;
    amount: number;
    payPeriodId: number;
    createDate: Date;
    modifiedDate: Date;
    qualifiedDate: Date;
    case: CaseHeader | undefined;
    casePaymentType: CasePaymentType | undefined;
    paymentTransactionType: PaymentTransactionType | undefined;
    payPeriod: PayPeriod | undefined;
}

export interface PaymentTransactionType {
    paymentTransactionTypesId: number;
    code: string | undefined;
    name: string | undefined;
    createdDate: Date;
    casePayments: CasePayment[] | undefined;
}

export interface EmployeeAdminTimeLog {
    id: number;
    employeeId: number;
    timeMinutes: number;
    workDate: Date;
    payPeriodId: number;
    employeeAdminTimeLogTypeId: number;
    createdDate: Date;
    approvedByInternetUserId: number | undefined;
    approvedDate: Date | undefined;
    note: string | undefined;
    employeeAdminTimeLogType: EmployeeAdminTimeLogType | undefined;
    payPeriod: PayPeriod | undefined;
    employee: Employee | undefined;
}

export interface EmployeeAdminTimeLogType {
    id: number;
    name: string;
    code: string;
    ultimatePayrollWorkTypeCode: string;
    employeeAdminTimeLogs: EmployeeAdminTimeLog[] | undefined;
}

export interface Employee {
    id: number;
    firstName: string | undefined;
    middleInitial: string | undefined;
    lastName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    homePhone: string | undefined;
    logInName: string | undefined;
    notes: string | undefined;
    emailAddress: string | undefined;
    title: string | undefined;
    internetUserId: number | undefined;
    payrollEmployeeId: string | undefined;
    hireDate: Date | undefined;
    employeeRoleId: number | undefined;
    status: string | undefined;
    supervisorEmployeeId: number | undefined;
    inactiveDate: Date | undefined;
    salary: number | undefined;
    salaryOrHourly: number;
    employmentType: string | undefined;
    trainingCompletedDate: Date | undefined;
    workPhone: string | undefined;
    macAdjustmentPercent: number;
    macAdjustmentDollar: number;
    extension: number | undefined;
    birthDate: string | undefined;
    startDate: Date | undefined;
    internetUser: InternetUser_Home | undefined;
    employees: Employee[] | undefined;
    employeeRole: EmployeeRole | undefined;
    supervisorEmployee: Employee | undefined;
    fieldCoordinatorPostalCodes: PostalCode[] | undefined;
    fieldDirectorPostalCodes: PostalCode[] | undefined;
    appraisalSupportPostalCodes: PostalCode[] | undefined;
    lenderLogisticsManagerPostalCodes: PostalCode[] | undefined;
    employeeNotes: EmployeeNote[] | undefined;
    employeeCustomerSurveyTypes: EmployeeCustomerSurveyType[] | undefined;
    customers: Customer[] | undefined;
    employeePtos: EmployeePto[] | undefined;
}

export interface InternetUser_Home {
    id: number;
    username: string | undefined;
    password: string | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    failedAttempts: number | undefined;
    roleId: number | undefined;
    mustChangePassword: boolean;
    receivesEmailConfirmations: boolean;
    majorCompanyId: number | undefined;
    passwordChanged: Date | undefined;
    passwordChangeDays: number | undefined;
    isDisabled: boolean;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    isValidEmail: boolean;
    localOffsetMinutes: number | undefined;
    qaQueues: QAQueue[] | undefined;
    internetRequests: InternetRequest[] | undefined;
    underwriters: Underwriter_Home[] | undefined;
    inspectorHiringForecastNotes: InspectorHiringForecastNote[] | undefined;
    quickListShares: QuickListShare[] | undefined;
    appraiserSurveyTypeGroupFees: AppraiserSurveyTypeGroupFee[] | undefined;
    caseTimeLogFeedbacks: CaseTimeLogFeedback[] | undefined;
    queueEntries: QueueEntry[] | undefined;
    qaUserAuditPercentages: QAUserAuditPercentage[] | undefined;
    internetUserRole: InternetUserRole | undefined;
    employees: Employee[] | undefined;
    caseInspectorExtensions: CaseInspectorExtension[] | undefined;
    webOrders: WebOrder[] | undefined;
    userEventWatches: UserEventWatch[] | undefined;
    caseUserEventWatches: CaseUserEventWatch[] | undefined;
    enteredEmployeeComplaints: EmployeeComplaint[] | undefined;
    customerInsightNotifications: CustomerInsightNotification[] | undefined;
    customerInsightNotificationAccounts: CustomerInsightNotificationAccount[] | undefined;
    employeeTimeClocks: EmployeeTimeClock[] | undefined;
    firstLastName: string | undefined;
    lastFirstName: string | undefined;
}

export interface QAQueue {
    id: number;
    internetUserId: number;
    controlIDNumber: number;
    startDate: Date;
    endDate: Date | undefined;
    isCompleted: boolean;
    isActive: boolean;
    resolution: string | undefined;
    activeDate: Date | undefined;
    secondsActive: number | undefined;
    notes: string | undefined;
    case: CaseHeader | undefined;
    internetUser: InternetUser_Home | undefined;
}

export interface InternetRequest {
    id: number;
    dateRequestSubmitted: Date | undefined;
    deleted: boolean | undefined;
    companyId: number | undefined;
    insuredName: string | undefined;
    inspectedAddress: string | undefined;
    inspectedCity: string | undefined;
    inspectedState: string | undefined;
    inspectedZip: string | undefined;
    mailingAddress: string | undefined;
    mailingCity: string | undefined;
    mailingState: string | undefined;
    mailingZip: string | undefined;
    policyPhoneNumber: string | undefined;
    policyNumber: string | undefined;
    effectiveDate: Date | undefined;
    businessType: number | undefined;
    agencyName: string | undefined;
    agencyCode: string | undefined;
    agencyPhone: string | undefined;
    coverageA: number | undefined;
    yearBuilt: number | undefined;
    squareFeet: number | undefined;
    inspectionType: number | undefined;
    suppWoodStove: boolean | undefined;
    suppElectricalHeating: boolean | undefined;
    suppCanine: boolean | undefined;
    suppDayCare: boolean | undefined;
    comments: string | undefined;
    underwriterCode: string | undefined;
    internetUserId: number | undefined;
    allstateLineCode: string | undefined;
    policyWorkNumber: string | undefined;
    availFormsIdList: string | undefined;
    controlIdNumber: number | undefined;
    policyPhoneNumber2: string | undefined;
    agencyEmail: string | undefined;
    policyEmail: string | undefined;
    internetUser: InternetUser_Home | undefined;
}

export interface Underwriter_Home {
    id: number;
    majorCompaniesId: number | undefined;
    internetUserId: number | undefined;
    code: string | undefined;
    techCode: string | undefined;
    internetUser: InternetUser_Home | undefined;
}

export interface InspectorHiringForecastNote {
    id: number;
    inspectorHiringForecastId: number;
    note: string;
    createdByUserId: number;
    createdDateUtc: Date;
    inspectorHiringForecast: InspectorHiringForecast | undefined;
    createdByUser: InternetUser_Home | undefined;
}

export interface InspectorHiringForecast {
    id: number;
    serviceRegionId: number;
    statusId: number;
    deficitCount: number;
    deficitCountLocal: number;
    traineeCount: number;
    deficitCountTrainee: number;
    orderingTrend: number;
    rateOfPay: number | undefined;
    inspectorUtilization: number;
    createdDateUtc: Date;
    modifiedDateUtc: Date;
    assignedToEmployeeId: number | undefined;
    inspectorHiringForecastNotes: InspectorHiringForecastNote[] | undefined;
    inspectorHiringForecastHistory: InspectorHiringForecastHistory[] | undefined;
    serviceRegion: ServiceRegion | undefined;
    assignedToEmployee: Employee | undefined;
}

export interface InspectorHiringForecastHistory {
    id: number;
    inspectorHiringForecastId: number;
    createdDateUtc: Date;
    deficitCount: number;
    deficitCountLocal: number;
    traineeCount: number;
    deficitCountTrainee: number;
    orderingTrend: number;
    inspectorUtilization: number;
    rateOfPay: number | undefined;
    inspectorHiringForecast: InspectorHiringForecast | undefined;
}

export interface ServiceRegion {
    id: number;
    type: number;
    name: string;
    createdDate: Date;
    stateId: number | undefined;
    inspectionServiceRegions: PostalCode[] | undefined;
    inspectorServiceRegions: InspectorServiceRegion[] | undefined;
    state: State | undefined;
}

export interface InspectorServiceRegion {
    id: number;
    inspectorId: number;
    serviceRegionId: number | undefined;
    createdDate: Date;
    createdByInternetUserId: number | undefined;
    countyId: number | undefined;
    postalCodeId: number | undefined;
    inspectorServiceTravelRuleId: number | undefined;
    inspector: Inspector | undefined;
    serviceRegion: ServiceRegion | undefined;
    postalCode: PostalCode | undefined;
    county: County | undefined;
    createdByInternetUser: InternetUser_Home | undefined;
    inspectorServiceTravelRule: InspectorServiceTravelRule | undefined;
}

export interface InspectorServiceTravelRule {
    id: number;
    inspectorId: number;
    name: string;
    startingLocationType: string;
    disableAutoAssign: boolean;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    startingLocationGeometry: DbGeometry | undefined;
    serviceBoundaryGeometry: DbGeometry | undefined;
    createdByUserId: number;
    createdDate: Date;
    startDate: Date;
    createdFromRuleId: number | undefined;
    daysMask: number | undefined;
    endDate: Date | undefined;
    repeatEveryUnit: string;
    repeatAmount: number | undefined;
    inspector: Inspector | undefined;
    createdByUser: InternetUser_Home | undefined;
    inspectorServiceTravelRuleDays: InspectorServiceTravelRuleDay[] | undefined;
    inspectorServiceRegions: InspectorServiceRegion[] | undefined;
    createdFromRule: InspectorServiceTravelRule | undefined;
}

export interface InspectorServiceTravelRuleDay {
    id: number;
    inspectorId: number;
    inspectorServiceTravelRuleId: number;
    travelDate: Date;
    inspector: Inspector | undefined;
    inspectorServiceTravelRule: InspectorServiceTravelRule | undefined;
}

export interface QuickListShare {
    id: number;
    createdDateUtc: Date | undefined;
    quickListId: number;
    rightId: number | undefined;
    sharedWithInternetUserId: number | undefined;
    groupCode: string | undefined;
    sortOrder: number | undefined;
    quickList: QuickListItem | undefined;
    sharedWithInternetUser: InternetUser_Home | undefined;
}

export interface QuickListItem {
    id: number;
    name: string | undefined;
    quickListCode: string | undefined;
    templateCode: string | undefined;
    description: string | undefined;
    filter: string | undefined;
    columnKeys: string | undefined;
    groupCode: string | undefined;
    sortOrder: number;
    isSimpleList: boolean;
    shareGuid: string | undefined;
    createdDateUtc: Date;
    createdByInternetUserId: number;
    lastModifiedDateUtc: Date | undefined;
    lastModifiedByInternetUserId: number | undefined;
    createdByInternetUser: InternetUser_Home | undefined;
    lastModifiedByInternetUser: InternetUser_Home | undefined;
    quickListShares: QuickListShare[] | undefined;
}

export interface AppraiserSurveyTypeGroupFee {
    id: number;
    appraiserId: number;
    surveyTypeGroupId: number;
    fee: number;
    createDate: Date;
    modifiedDate: Date;
    createdByInternetUserId: number;
    appraiser: Appraiser | undefined;
    surveyTypeGroup: SurveyTypeGroup | undefined;
    createdByInternetUser: InternetUser_Home | undefined;
}

export interface SurveyTypeGroup {
    id: number;
    order: number;
    name: string;
    pinImageUrl: string;
    code: string | undefined;
    showOnAssignmentTool: boolean;
    inspectorDesignationDefault: boolean;
    designationCode: string | undefined;
    inspectorSurveyTypeGroups: InspectorSurveyTypeGroup[] | undefined;
    surveyTypes: SurveyType[] | undefined;
    appraiserSurveyTypeGroupFees: AppraiserSurveyTypeGroupFee[] | undefined;
}

export interface InspectorSurveyTypeGroup {
    id: number;
    inspectorId: number;
    inspectorInspectionTypeGroupId: number;
    surveyTypeGroup: SurveyTypeGroup | undefined;
    inspector: Inspector | undefined;
}

export interface CaseTimeLogFeedback {
    id: number;
    controlIdNumber: number;
    comments: string | undefined;
    createDate: Date;
    internetUserId: number;
    case: CaseHeader | undefined;
    internetUser: InternetUser_Home | undefined;
    caseTimeLogFeedbackSelections: CaseTimeLogFeedbackSelection[] | undefined;
}

export interface CaseTimeLogFeedbackSelection {
    id: number;
    caseTimeLogFeedbackId: number;
    caseTimeLogFeedbackCategoriesId: number;
    caseTimeLogFeedback: CaseTimeLogFeedback | undefined;
    caseTimeLogFeedbackCategory: CaseTimeLogFeedbackCategory | undefined;
}

export interface CaseTimeLogFeedbackCategory {
    id: number;
    workTypeId: number;
    category: string | undefined;
    subCategory: string | undefined;
    code: string | undefined;
    toolTip: string | undefined;
    caseTimeLogWorkType: CaseTimeLogWorkType | undefined;
    caseTimeLogFeedbackSelections: CaseTimeLogFeedbackSelection[] | undefined;
}

export interface CaseTimeLogWorkType {
    id: number;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    caseTimeLogs: CaseTimeLog[] | undefined;
    caseTimeLogFeedbackCategories: CaseTimeLogFeedbackCategory[] | undefined;
}

export interface CaseTimeLog {
    id: number;
    controlIdNumber: number;
    internetUserId: number;
    workDate: Date;
    workTypeId: number;
    timeMinutes: number;
    createDate: Date;
    payPeriodId: number;
    resolutionTypeId: number | undefined;
    startDateTimeLocal: Date;
    endDateTimeLocal: Date;
    caseTimeLogWorkType: CaseTimeLogWorkType | undefined;
    case: CaseHeader | undefined;
    payPeriod: PayPeriod | undefined;
    internetUser: InternetUser_Home | undefined;
    resolutionType: CaseTimeLogResolutionType | undefined;
}

export interface CaseTimeLogResolutionType {
    id: number;
    code: string | undefined;
    name: string | undefined;
    isCompleteType: boolean;
    caseTimeLogs: CaseTimeLog[] | undefined;
}

export interface QueueEntry {
    id: number;
    queueTypeid: number;
    controlNumber: number;
    rank: number;
    internetUserTakenId: number;
    added: Date;
    taken: Date | undefined;
    fetchTimeMS: number | undefined;
    customerId: number | undefined;
    completeFormId: number | undefined;
    majorFormCount: number | undefined;
    rush: boolean;
    moveToTopDate: Date | undefined;
    queueType: QueueType | undefined;
    queueEntryUserMaps: QueueEntryUserMap[] | undefined;
    internetUserTaken: InternetUser_Home | undefined;
}

export interface QueueType {
    id: number;
    code: string | undefined;
    queueEntries: QueueEntry[] | undefined;
    employeeCustomerSurveyTypes: EmployeeCustomerSurveyType[] | undefined;
}

export interface EmployeeCustomerSurveyType {
    id: number;
    employeeId: number;
    customerId: number | undefined;
    inspectionTypeId: number | undefined;
    queueTypeId: number;
    isExcluded: boolean;
    customer: Customer | undefined;
    surveyType: SurveyType | undefined;
    queueType: QueueType | undefined;
    employee: Employee | undefined;
}

export interface QueueEntryUserMap {
    queueEntryId: number;
    internetUserId: number;
    queueEntry: QueueEntry | undefined;
    internetUser: InternetUser_Home | undefined;
}

export interface QAUserAuditPercentage {
    id: number;
    internetUserId: number;
    auditPercentage: number;
    rejectionAuditPercetage: number;
    auditLockDate: Date | undefined;
    internetUser: InternetUser_Home | undefined;
}

export interface InternetUserRole {
    id: number;
    name: string | undefined;
    defaultRole: boolean;
    inactiveDate: Date | undefined;
    internetUsers: InternetUser_Home[] | undefined;
    phoneSupportCalls: PhoneSupportCall[] | undefined;
}

export interface PhoneSupportCall {
    id: number;
    supportedForRoleId: number;
    supportedCallerName: string;
    supportedEmployeeId: number | undefined;
    supportUserId: number;
    phoneSupportCategoryId: number;
    startUtcDateTime: Date;
    completeUtcDateTime: Date | undefined;
    startLocalDateTime: Date | undefined;
    completeLocalDateTime: Date | undefined;
    notes: string | undefined;
    timeMinutes: number;
    payPeriodId: number;
    category: PhoneSupportCategory | undefined;
    supportedEmployee: Employee | undefined;
    supportedForRole: InternetUserRole | undefined;
    supportUser: InternetUser_Home | undefined;
    phoneSupportCallCases: PhoneSupportCallCase[] | undefined;
    supportLineResponses: SatisfactionSurvey_SupportLineResponse[] | undefined;
}

export interface PhoneSupportCategory {
    id: number;
    code: string;
    name: string;
    expectedMinutes: number;
    phoneSupportCalls: PhoneSupportCall[] | undefined;
}

export interface PhoneSupportCallCase {
    id: number;
    phoneSupportCallId: number;
    controlIdNumber: number;
    notes: string | undefined;
    phoneSupportCall: PhoneSupportCall | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface SatisfactionSurvey_SupportLineResponse {
    id: number;
    uId: string;
    supportCallId: number;
    supportSatisfactionScore: number | undefined;
    supportUnderstoodAndWorkedToResolveScore: number | undefined;
    postCallConfidenceScore: number | undefined;
    issueFullyResolvedScore: number | undefined;
    issueFullyResolvedComments: string | undefined;
    isThereAnythingSupportCouldHaveDoneBetter: string | undefined;
    additionaFeedbackOnCall: string | undefined;
    createdDateUtc: Date;
    completedDateUtc: Date | undefined;
    phoneSupportCall: PhoneSupportCall | undefined;
}

export interface CaseInspectorExtension {
    id: number;
    controlIdNumber: number;
    inspectorId: number;
    requestedDueDate: Date;
    extensionDays: number;
    reasonId: number;
    reasonDate: Date | undefined;
    createdDate: Date;
    responseActionId: number | undefined;
    responseExtensionDays: number | undefined;
    responseByInternetUserId: number | undefined;
    responseDate: Date | undefined;
    reason: CaseInspectorExtensionReason | undefined;
    inspector: Inspector | undefined;
    responseByInternetUser: InternetUser_Home | undefined;
}

export interface CaseInspectorExtensionReason {
    id: number;
    code: string;
    nameShort: string;
    nameLong: string;
    needReasonDate: boolean;
    isActive: boolean;
    caseInspectorExtensions: CaseInspectorExtension[] | undefined;
}

export interface WebOrder {
    webOrderID: number;
    internetUsersID: number;
    workItemsId: string;
    createDate: Date;
    payPeriodId: number | undefined;
    webOrderHistories: WebOrderHistory[] | undefined;
    webOrderAttributes: WebOrderAttribute[] | undefined;
    internetUser: InternetUser_Home | undefined;
    payPeriod: PayPeriod | undefined;
}

export interface WebOrderHistory {
    webOrderHistoryID: number;
    webOrderID: number;
    webOrderActionTypeID: number;
    timestamp: Date;
    value: string | undefined;
    amount: number;
    webOrder: WebOrder | undefined;
    webOrderActionType: WebOrderActionType | undefined;
    webOrderHistoryReceipts: WebOrderHistoryReceipt[] | undefined;
}

export interface WebOrderActionType {
    webOrderActionTypeID: number;
    code: string | undefined;
    webOrderHistories: WebOrderHistory[] | undefined;
}

export interface WebOrderHistoryReceipt {
    webOrderHistoryReceiptID: number;
    webOrderHistoryID: number;
    timestamp: Date;
    value: string | undefined;
    toAddress: string | undefined;
    webOrderHistory: WebOrderHistory | undefined;
}

export interface WebOrderAttribute {
    webOrderAttributeID: number;
    webOrderID: number;
    timestamp: Date;
    value: string | undefined;
    name: string | undefined;
    webOrder: WebOrder | undefined;
}

export interface UserEventWatch {
    id: number;
    internetUserId: number;
    caseEventTypeId: number;
    createdDate: Date;
    internetUser: InternetUser_Home | undefined;
    caseEventType: CaseEventType | undefined;
    caseUserEventWatches: CaseUserEventWatch[] | undefined;
}

export interface CaseEventType {
    id: number;
    name: string;
    code: string;
    isInspectionEvent: boolean;
    isAppraisalEvent: boolean;
    displayOrder: number;
    userEventWatches: UserEventWatch[] | undefined;
    caseUserEventWatches: CaseUserEventWatch[] | undefined;
}

export interface CaseUserEventWatch {
    id: number;
    controlIdNumber: number;
    internetUserId: number;
    caseEventTypeId: number;
    userEventWatchId: number | undefined;
    watchGroupIdentifier: string;
    createdDate: Date;
    caseHeader: CaseHeader | undefined;
    internetUser: InternetUser_Home | undefined;
    caseEventType: CaseEventType | undefined;
    userEventWatch: UserEventWatch | undefined;
}

export interface EmployeeComplaint {
    id: number;
    employeeId: number;
    employeeComplaintCategoryId: number;
    enteredByInternetUserId: number;
    dateCreated: Date | undefined;
    description: string | undefined;
    controlIdNumber: number | undefined;
    customerNumber: number | undefined;
    surveyScore: number | undefined;
    category: EmployeeComplaintCategory | undefined;
    enteredByInternetUser: InternetUser_Home | undefined;
    attachments: EmployeeComplaintAttachment[] | undefined;
}

export interface EmployeeComplaintCategory {
    id: number;
    name: string | undefined;
    code: string | undefined;
    employeeComplaints: EmployeeComplaint[] | undefined;
    employeeComplaintCategoryLinkedEmployeeRoles: EmployeeComplaintCategoryLinkedEmployeeRoles[] | undefined;
}

export interface EmployeeComplaintCategoryLinkedEmployeeRoles {
    id: number;
    employeeComplaintCategoryId: number;
    employeeRoleId: number;
    employeeComplaintCategory: EmployeeComplaintCategory;
}

export interface EmployeeComplaintAttachment {
    id: number;
    dateCreated: Date | undefined;
    lookupKey: string | undefined;
    employeeComplaintId: number | undefined;
    fileName: string | undefined;
    mimeType: string | undefined;
    complaint: EmployeeComplaint | undefined;
}

export interface CustomerInsightNotification {
    id: number;
    name: string;
    email: string;
    customerName: string;
    startDate: Date;
    disableDate: Date | undefined;
    createdDate: Date;
    createdByInternetUserId: number;
    customerInsightNotificationAccounts: CustomerInsightNotificationAccount[] | undefined;
    createdByInternetUser: InternetUser_Home | undefined;
    satisfactionSurvey_CustomerInsightsResponses: SatisfactionSurvey_CustomerInsightsResponse[] | undefined;
}

export interface CustomerInsightNotificationAccount {
    id: number;
    customerInsightNotificationId: number;
    majorCompanyId: number | undefined;
    customerId: number | undefined;
    createdDate: Date;
    createdByInternetUserId: number;
    customerInsightNotification: CustomerInsightNotification | undefined;
    createdByInternetUser: InternetUser_Home | undefined;
    majorCompany: MajorCompany_Home | undefined;
    customer: Customer | undefined;
}

export interface MajorCompany_Home {
    id: number;
    companyName: string | undefined;
    code: string | undefined;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    inactiveDate: Date | undefined;
    accountFiles: AccountFile[] | undefined;
    customers: Customer[] | undefined;
    companyPostalCodeTiers: CompanyPostalCodeTier[] | undefined;
    comparisonFields: ComparisonField[] | undefined;
    stackCodeSettings: StackCodeSetting[] | undefined;
}

export interface AccountFile {
    id: number;
    majorCompanyId: number;
    customerId: number | undefined;
    path: string;
    fileName: string;
    accountFileTypesId: number;
    createdDate: Date;
    modifiedDate: Date;
    accountFileType: AccountFileType | undefined;
    customer: Customer | undefined;
    majorCompany: MajorCompany_Home | undefined;
}

export interface AccountFileType {
    id: number;
    name: string;
    code: string;
    accountFiles: AccountFile[] | undefined;
}

export interface CompanyPostalCodeTier {
    id: number;
    majorCompaniesId: number;
    zipCode: string | undefined;
    tier: string | undefined;
    createdDate: Date;
    activeDate: Date;
    inactiveDate: Date | undefined;
    majorCompany: MajorCompany_Home | undefined;
}

export interface StackCodeSetting {
    id: number;
    majorCompaniesId: number;
    customersId: number | undefined;
    inspectionTypesId: number | undefined;
    value: string;
    name: string;
    activeDate: Date;
    inactiveDate: Date;
    version: number;
    majorCompany: MajorCompany_Home | undefined;
    customer: Customer | undefined;
}

export interface SatisfactionSurvey_CustomerInsightsResponse {
    id: number;
    uId: string;
    customerInsightNotificationId: number;
    timelinessScore: number;
    qualityScore: number;
    communicationScore: number;
    overallScore: number;
    additionalFeedback: string | undefined;
    createdDateUtc: Date;
    completedDateUtc: Date | undefined;
    customerInsightNotification: CustomerInsightNotification | undefined;
}

export interface EmployeeTimeClock {
    id: number;
    internetUserId: number;
    clockInDate: Date;
    clockOutDate: Date | undefined;
    payPeriodId: number;
    timeMinutes: number | undefined;
    ipAddressClockIn: string;
    ipAddressClockOut: string | undefined;
    timeZoneOffsetMinutes: number;
    clockInUtcDate: Date;
    clockOutUtcDate: Date | undefined;
    createByInternetUserId: number;
    createUtcDate: Date;
    modifyLastByInternetUserId: number;
    modifyLastUtcDate: Date;
    payPeriod: PayPeriod | undefined;
    internetUser: InternetUser_Home | undefined;
}

export interface EmployeeRole {
    id: number;
    code: string | undefined;
    name: string | undefined;
    employeeDepartmentId: number;
    employees: Employee[] | undefined;
    employeeDepartment: EmployeeDepartment | undefined;
}

export interface EmployeeDepartment {
    id: number;
    code: string;
    name: string;
    employeeRoles: EmployeeRole[] | undefined;
}

export interface EmployeeNote {
    id: number;
    employeeId: number;
    body: string | undefined;
    createdDateUtc: Date;
    createdByInternetUserId: number | undefined;
    employee: Employee | undefined;
    createdByUser: InternetUser_Home | undefined;
    editedDateUtc: Date | undefined;
}

export interface EmployeePto {
    id: number;
    employeeId: number;
    dateStart: Date;
    dateEnd: Date;
    notes: string | undefined;
    employee: Employee | undefined;
}

export interface PayPeriodUserApproval {
    id: number;
    payPeriodId: number;
    internetUserId: number;
    approvedDate: Date;
    approvedInternetUserId: number;
    payPeriod: PayPeriod | undefined;
    internetUser: InternetUser_Home | undefined;
    approvedInternetUser: InternetUser_Home | undefined;
}

export interface AppraiserPayPeriodSummary {
    id: number;
    employeeId: number | undefined;
    appraiserId: number;
    internetUserId: number;
    payPeriodId: number;
    casesCount: number;
    hourlyRateAgreed: number;
    hoursWorked: number;
    costCurrent: number;
    costPrevious: number;
    costTotal: number;
    lateDeduction: number;
    returnedDeduction: number;
    macPay: number;
    macBonusPay: number;
    payRateTypeCode: string | undefined;
    isApproved: boolean;
    appraiser: Appraiser | undefined;
    payPeriod: PayPeriod | undefined;
    employee: Employee | undefined;
}

export interface QACompletedCase {
    id: number;
    controlIDNumber: number;
    internetUserId: number;
    completedDateUtc: Date;
    localOffsetMinutes: number;
    localCreateDate: Date;
    payPeriodId: number;
    caseHeader: CaseHeader | undefined;
    payPeriodCompleted: PayPeriod | undefined;
}

export interface CallCenterCompletedCase {
    id: number;
    controlIdNumber: number;
    internetUserId: number;
    completedDateUtc: Date;
    localOffsetMinutes: number;
    localCompletedDate: Date | undefined;
    payPeriodId: number;
    completedTypeId: number;
    caseHeader: CaseHeader | undefined;
    payPeriodCompleted: PayPeriod | undefined;
    completedType: CallCenterCompletedType | undefined;
}

export interface CallCenterCompletedType {
    id: number;
    code: string;
    name: string;
}

export interface CaseTravelLog {
    id: number;
    controlIdNumber: number;
    inspectorId: number;
    startDateTimeLocal: Date;
    milesDriven: number;
    payPeriodId: number;
    pointFromLatitude: number;
    pointFromLongitude: number;
    pointFromType: number;
    backHome: boolean;
    caseHeader: CaseHeader | undefined;
    inspector: Inspector | undefined;
    payPeriod: PayPeriod | undefined;
}

export interface CaseRejection {
    id: number;
    controlIdNumber: number;
    inspectorNumber: number;
    qaInternetUserId: number;
    qaNotes: string | undefined;
    inspectorNotes: string | undefined;
    createdDate: Date;
    modifiedDate: Date;
    caseHeader: CaseHeader | undefined;
    inspector: Inspector | undefined;
}

export interface CustomerInspectorExclusion {
    id: number;
    customerId: number;
    inspectorId: number;
    createdDate: Date;
    customers: Customer | undefined;
    inspector: Inspector | undefined;
    comments: string | undefined;
    createdByInternetUserId: number;
    createdByInternetUser: InternetUser_Home | undefined;
}

export interface CaseAutoAssignmentInspector {
    id: number;
    caseAutoAssignmentId: number;
    inspectorId: number;
    milestoCase: number | undefined;
    minutesToCase: number | undefined;
    workCapacityWeeklyMinutes: number;
    currentCapacityMinutes: number;
    createDate: Date;
    hasCallLogIssue: boolean;
    caseAutoAssignmentInspectorCases: CaseAutoAssignmentInspectorCase[] | undefined;
    inspector: Inspector | undefined;
    caseAutoAssignment: CaseAutoAssignment | undefined;
}

export interface CaseAutoAssignmentInspectorCase {
    id: number;
    caseAutoAssignmentInspectorId: number;
    controlIdNumber: number;
    latitude: number;
    longitude: number;
    milesToCase: number | undefined;
    minutesToCase: number | undefined;
    createDate: Date;
    caseAutoAssignmentInspector: CaseAutoAssignmentInspector | undefined;
}

export interface CaseAutoAssignment {
    id: number;
    batchId: string;
    controlIdNumber: number;
    receivedDate: Date;
    dueDate: Date | undefined;
    expectedMinutes: number;
    latitude: number;
    longitude: number;
    inspectorIdAssigned: number | undefined;
    inspectorCount: number;
    createDate: Date;
    note: string | undefined;
    processedDate: Date | undefined;
    caseAutoAssignmentInspectors: CaseAutoAssignmentInspector[] | undefined;
}

export interface CustomerSatisfactionSurveyResponse {
    id: number;
    controlIdNumber: number;
    inspectorId: number;
    satisfactionWithSchedulingProcessScore: number;
    didInspectorArriveOnTimeScore: number;
    inspectorsProfessionalismAndCommunicationScore: number;
    overallSatisfactionScore: number;
    howCanWeImproveTheExperience: string | undefined;
    createdDateUtc: Date;
    caseHeader: CaseHeader | undefined;
    inspector: Inspector | undefined;
}

export interface SatisfactionSurvey_OnboardingResponse {
    id: number;
    uId: string;
    inspectorId: number;
    onboardingExperienceScore: number | undefined;
    didYouCompleteViitaCourse: boolean | undefined;
    wasViitaCourseHelpful: boolean | undefined;
    whatCouldBeImprovedAboutViitaCourse: string | undefined;
    recruiterOnboardingScore: number | undefined;
    wasRecruiterClearDuringScreeningCall: boolean | undefined;
    whatWasUnclearDuringScreeningCall: string | undefined;
    didRecruiterProvideHelpfulSupportDuringScreeningCall: boolean | undefined;
    whereDidSupportBreakDownDuringScreeningCall: string | undefined;
    didRecuiterResolveTechnicalIssuesPromptly: boolean | undefined;
    whatSupportWasNotProvided: string | undefined;
    didOnboardingPaperworkMakeFormCompletionEasy: boolean | undefined;
    whatWasConfusingWithOnboardingPaperwork: string | undefined;
    wereYouAbleToLogIntoSystemsWithoutIssue: boolean | undefined;
    whichSystemsCausedTrouble: string | undefined;
    managerOnboardingSupportScore: number | undefined;
    didYouMeetWithManagerWithinTwoDaysOfHire: boolean | undefined;
    whenDidYouFirstMeetWithManager: string | undefined;
    didOrientationClarifyExpectationsForFirstDay: boolean | undefined;
    whatCouldHaveImprovedOrientation: string | undefined;
    didTrainingMaterialsHelpPrepareForFirstInspection: boolean | undefined;
    whatCouldHaveBeenImprovedWithTrainingMaterials: string | undefined;
    wereYouProvidedNumberForFieldSupportHotline: boolean | undefined;
    didYouFeelSupportedByYourManagerDuringFirstTwoWeeks: boolean | undefined;
    whatSupportDidYouNotReceive: string | undefined;
    howLongAfterInitialMeetingDidYouCompleteAnInspection: number | undefined;
    whatCausedTheDelay: string | undefined;
    didYouFeelConfidentBeforeCompletingYourFirstInspection: boolean | undefined;
    whatMadeYouFeelUnprepared: string | undefined;
    didYouReceiveEnoughInspectionsInFirstTwoWeeks: boolean | undefined;
    didYouLetYourManagerKnowYouNeededMoreWork: string | undefined;
    doYouUnderstandYourJobResponsibilitiesToday: boolean | undefined;
    whatResponsibilitiesCouldBeClarified: string | undefined;
    doYouUnderstandHowYourPerformanceIsMeasured: boolean | undefined;
    whatIsUnclearAboutPerformanceExpectations: string | undefined;
    additionaFeedbackForOnboardingExperience: string | undefined;
    createdDateUtc: Date;
    smsDateUtc: Date | undefined;
    completedDateUtc: Date | undefined;
    inspector: Inspector | undefined;
}

export interface CaseLogWayPoint {
    caseLogId: number;
    id: number;
    order: number;
    addressLine1: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    controlIdNumber: number | undefined;
    wayPointTypeId: number;
    wayPointType: WayPointType | undefined;
    caseLog: CaseLog | undefined;
}

export interface WayPointType {
    id: number;
    description: string | undefined;
    code: string | undefined;
    caseLogWayPoints: CaseLogWayPoint[] | undefined;
}

export interface CaseMailReturn {
    id: number;
    controlIDNumber: number | undefined;
    dataEntryUserId: number | undefined;
    category: number | undefined;
    notes: string | undefined;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    returnDate: Date | undefined;
    case: CaseHeader | undefined;
}

export interface CaseRecommendation {
    id: number;
    controlIdNumber: number;
    recommendationId: number;
    userProvidedName: string | undefined;
    caseHeader: CaseHeader | undefined;
    recommendation: Recommendation | undefined;
}

export interface Recommendation {
    id: number;
    category: string | undefined;
    name: string | undefined;
    level: string | undefined;
    formDatafieldId: string | undefined;
    caseRecommendations: CaseRecommendation[] | undefined;
}

export interface ContactEffort {
    id: number;
    caseId: number;
    contactPersonTypeId: number;
    spokeWith: string | undefined;
    contactMadeOnDate: Date;
    contactMadeOnTimeRangeId: number;
    contactEffortResultTypeId: number;
    attemptedPhoneNumber: string | undefined;
    createdDate: Date;
    contactMadeOnDateTime: Date | undefined;
    phoenixId: string | undefined;
    contactMadeByInternetUserId: number | undefined;
    contactEffortResultType: ContactEffortResultType | undefined;
    contactPersonType: ContactPersonType | undefined;
    case: CaseHeader | undefined;
    timeRange: TimeRange | undefined;
    notes: string | undefined;
}

export interface ContactEffortResultType {
    id: number;
    name: string | undefined;
    code: string | undefined;
    contactTypeCode: string | undefined;
    sort: number;
    contactEfforts: ContactEffort[] | undefined;
}

export interface ContactPersonType {
    id: number;
    name: string | undefined;
    code: string | undefined;
    contactEfforts: ContactEffort[] | undefined;
}

export interface TimeRange {
    id: number;
    name: string | undefined;
    code: string | undefined;
    rangeStart: string | undefined;
    rangeEnd: string | undefined;
    contactEfforts: ContactEffort[] | undefined;
}

export interface DateInspected {
    id: number;
    controlIDNumber: number;
    inspectedDate: Date | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CaseGeocode {
    id: number;
    controlIDNumber: number;
    latitude: number | undefined;
    longitude: number | undefined;
    matchLevel: string | undefined;
    phone: string | undefined;
    notes: string | undefined;
    cNormalizedSurveyAddress1: string | undefined;
    geographyIsEmpty: boolean | undefined;
    case: CaseHeader | undefined;
}

export interface Notification {
    id: number;
    controlIDNumber: number;
    sentDate: Date;
    notificationTypeId: number | undefined;
    notes: string | undefined;
    isDeleted: boolean;
    case: CaseHeader | undefined;
    notificationType: NotificationType | undefined;
}

export interface NotificationType {
    id: number;
    code: string | undefined;
    name: string | undefined;
    createDate: Date;
    modifyDate: Date;
    isCall: boolean;
    notifications: Notification[] | undefined;
}

export interface QAIssue {
    id: number;
    controlIdNumber: number;
    qaIssueTypeId: number;
    notes: string | undefined;
    employeeLoginName: string | undefined;
    employeeFullName: string | undefined;
    createDate: Date;
    modifyDate: Date;
    case: CaseHeader | undefined;
    qaIssueType: QAIssueType | undefined;
}

export interface QAIssueType {
    id: number;
    name: string | undefined;
    code: string | undefined;
    isCompliment: boolean;
    createDate: Date;
    modifyDate: Date;
    qaIssues: QAIssue[] | undefined;
}

export interface QARemark {
    id: number;
    controlIDNumber: number;
    returnReason: string | undefined;
    complaintType: string | undefined;
    description: string | undefined;
    createDate: Date;
    case: CaseHeader | undefined;
}

export interface Touch {
    id: number;
    controlIDNumber: number;
    createDate: Date;
    touchTypeId: number;
    note: string | undefined;
    internetUserId: number | undefined;
    fullName: string | undefined;
    case: CaseHeader | undefined;
    touchType: TouchType | undefined;
}

export interface TouchType {
    id: number;
    description: string | undefined;
    code: string | undefined;
    touches: Touch[] | undefined;
}

export interface WorkItemsControlNumberCrossRef {
    id: string;
    controlIDNumber: number;
    caseHeader: CaseHeader | undefined;
    preferredAppointments: PreferredAppointment[] | undefined;
}

export interface PreferredAppointment {
    id: number | undefined;
    workItemsId: string;
    caseContactMethodsId: string;
    appointmentDate: Date;
    appointmentTimeRangesId: number;
    confirmationCode: string | undefined;
    createDate: Date;
    createUserName: string | undefined;
    createUserType: string | undefined;
    status: string | undefined;
    reminderSentDate: Date | undefined;
    hoPreferredAppointmentId: number;
    appointmentTimeRange: AppointmentTimeRange | undefined;
    caseContactMethod: CaseContactMethod | undefined;
    workItemsControlNumberCrossRef: WorkItemsControlNumberCrossRef | undefined;
}

export interface AppointmentTimeRange {
    id: number;
    code: string | undefined;
    value: string | undefined;
    rangeStart: string;
    rangeEnd: string;
    displayMonths: string | undefined;
    preferredAppointments: PreferredAppointment[] | undefined;
}

export interface CaseContactMethod {
    id: string;
    workItemsId: string;
    contactTypesId: number;
    value: string | undefined;
    createDate: Date;
    deleted: boolean;
    sortOrder: number | undefined;
    personName: string | undefined;
    contactType: ContactType | undefined;
    preferredAppointments: PreferredAppointment[] | undefined;
}

export interface ContactType {
    id: number;
    code: string | undefined;
    value: string | undefined;
    caseContactMethods: CaseContactMethod[] | undefined;
}

export interface Case360ValueCalc {
    id: number;
    controlIDNumber: number;
    valuationCode: string | undefined;
    calc360ValueTypesId: number;
    resultsXML: string | undefined;
    createDate: Date;
    modifyDate: Date;
    formNumber: number;
    inactiveDate: Date | undefined;
    calc360ValueTypes: Calc360ValueType | undefined;
    policyHolderDataT: CaseHeader | undefined;
}

export interface Calc360ValueType {
    id: number;
    code: string | undefined;
    name: string | undefined;
    case360ValueCalcs: Case360ValueCalc[] | undefined;
}

export interface CaseReturn {
    id: number;
    controlIDNumber: number;
    returnReasonId: number | undefined;
    attempt1Date: Date | undefined;
    attempt1Time: number | undefined;
    attempt1SpokeWith: string | undefined;
    attempt1Result: string | undefined;
    attempt2Date: Date | undefined;
    attempt2Time: number | undefined;
    attempt2SpokeWith: string | undefined;
    attempt2Result: string | undefined;
    attempt3Date: Date | undefined;
    attempt3Time: number | undefined;
    attempt3SpokeWith: string | undefined;
    attempt3Result: string | undefined;
    offeredAppt1Date: Date | undefined;
    offeredAppt1Result: number | undefined;
    offeredAppt2Date: Date | undefined;
    offeredAppt2Result: number | undefined;
    offeredAppt3Date: Date | undefined;
    offeredAppt3Result: number | undefined;
    onsiteDate: Date | undefined;
    onsiteTime: number | undefined;
    onsiteMetWith: string | undefined;
    onsiteResult: string | undefined;
    customerService1Date: Date | undefined;
    customerServiceTime: number | undefined;
    customerServiceSpokeWith: string | undefined;
    customerServiceResult: string | undefined;
    mapTool: string | undefined;
    mapToolResult: string | undefined;
    attempt4Date: Date | undefined;
    attempt4Time: number | undefined;
    attempt4SpokeWith: string | undefined;
    attempt4Result: string | undefined;
    attempt5Date: Date | undefined;
    attempt5Time: number | undefined;
    attempt5SpokeWith: string | undefined;
    attempt5Result: string | undefined;
    attempt6Date: Date | undefined;
    attempt6Time: number | undefined;
    attempt6SpokeWith: string | undefined;
    attempt6Result: string | undefined;
    customerService2Date: Date | undefined;
    customerService2Time: number | undefined;
    customerService2SpokeWith: string | undefined;
    customerService2Result: string | undefined;
    phoneNumberCalled1: string | undefined;
    phoneNumberCalled2: string | undefined;
    phoneNumberCalled4: string | undefined;
    phoneNumberCalled5: string | undefined;
    caseHeader: CaseHeader | undefined;
    returnReason: CloseOutReason | undefined;
}

export interface CloseOutReason {
    id: number;
    customerId: number | undefined;
    reasonName: string | undefined;
    notes: string | undefined;
    code: string | undefined;
    sortOrder: number | undefined;
    caseReturns: CaseReturn[] | undefined;
}

export interface CaseAssignment {
    id: number;
    inspectorNumber: number;
    controlNumber: number;
    inspectorDueDate: Date;
    dateCreated: Date;
    dateInactive: Date | undefined;
    extensionDays: number | undefined;
    datePulled: Date | undefined;
    dateWorked: Date | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CaseAttachment {
    caseAttachmentsID: number;
    controlIDNumber: number;
    name: string | undefined;
    path: string | undefined;
    sizeBytes: number;
    createdAtUtc: Date | undefined;
    lastModifiedUtc: Date | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CaseAttribute {
    id: number;
    controlIDNumber: number;
    name: string | undefined;
    value: string | undefined;
    createDate: Date;
    modifyDate: Date;
    userSaveID: number | undefined;
    caseHeader: CaseHeader | undefined;
    internetUserSave: InternetUser_Home | undefined;
}

export interface CollateralAnalyticsRiskProfilerResult {
    id: number;
    controlIdNumber: number;
    createdDateUtc: Date;
    responseId: string | undefined;
    resultsDateUtc: Date | undefined;
    resultsXml: string | undefined;
    riskLevelName: string | undefined;
    riskLevelScore: number | undefined;
    caseHeader: CaseHeader | undefined;
    appraisalSurvey: AppraisalSurvey | undefined;
    collateralAnalyticsRiskProfilerResultDetails: CollateralAnalyticsRiskProfilerResultDetail[] | undefined;
}

export interface CollateralAnalyticsRiskProfilerResultDetail {
    id: number;
    collateralAnalyticsRiskProfilerResultId: number;
    riskLevelName: string | undefined;
    ruleRiskId: number | undefined;
    ruleQuestion: string | undefined;
    ruleResult: string | undefined;
    collateralAnalyticsRiskProfilerResult: CollateralAnalyticsRiskProfilerResult | undefined;
}

export interface TelephoneSurvey {
    id: number;
    controlIDNumber: number;
    startDate: Date | undefined;
    webStatus: string | undefined;
    completeDate: Date | undefined;
    internetUsersCompletedById: number | undefined;
    createDate: Date;
    modifyDate: Date;
    userSaveId: string | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface UnderwriterActionsAudit {
    id: number;
    controlIDNumber: number;
    internetUsersId: number;
    createDate: Date;
    actionTaken: string | undefined;
    comments: string | undefined;
    policyHolderDataT: CaseHeader | undefined;
    internetUser: InternetUser_Home | undefined;
}

export interface CaseBillingItem {
    id: number;
    controlIdNumber: number;
    caseBillingItemTypesId: number;
    employeeName: string | undefined;
    note: string | undefined;
    amount: number;
    createdDate: Date | undefined;
    surveyTypeId: number | undefined;
    caseBillingItemType: CaseBillingItemType | undefined;
    caseHeader: CaseHeader | undefined;
    caseBillingAdjustmentRule: CaseBillingAdjustmentRule[] | undefined;
    surveyType: SurveyType | undefined;
}

export interface CaseBillingItemType {
    id: number;
    name: string | undefined;
    code: string | undefined;
    category: string | undefined;
    caseBillingItems: CaseBillingItem[] | undefined;
    caseBillingAdjustmentRules: CaseBillingAdjustmentRule[] | undefined;
    completeFormFees: CompleteFormFee[] | undefined;
}

export interface CaseBillingAdjustmentRule {
    id: number;
    name: string | undefined;
    description: string | undefined;
    filterRuleJson: string | undefined;
    caseBillingItemTypeId: number;
    amountValue: number;
    caseBillingAdjustmentAmountTypeId: number;
    activeDate: Date;
    inactiveDate: Date | undefined;
    caseBillingAdjustmentAmountType: CaseBillingAdjustmentAmountType | undefined;
    caseBillingAdjustmentRuleCustomers: CaseBillingAdjustmentRuleCustomer[] | undefined;
    caseBillingItemType: CaseBillingItemType | undefined;
    caseBillingItems: CaseBillingItem[] | undefined;
}

export interface CaseBillingAdjustmentAmountType {
    caseBillingAdjustmentAmountTypesId: number;
    name: string | undefined;
    enumName: string | undefined;
    description: string | undefined;
    caseBillingAdjustmentRules: CaseBillingAdjustmentRule[] | undefined;
}

export interface CaseBillingAdjustmentRuleCustomer {
    id: number;
    customerId: number;
    caseBillingAdjustmentRuleId: number;
    caseBillingAdjustmentRule: CaseBillingAdjustmentRule | undefined;
    customer: Customer | undefined;
}

export interface CompleteFormFee {
    id: number;
    completeFormId: number;
    stateId: number | undefined;
    countyId: number | undefined;
    postalCodeTier: string | undefined;
    caseBillingItemTypeId: number;
    amount: number;
    activeDate: Date;
    inactiveDate: Date | undefined;
    feeName: string | undefined;
    createdDate: Date;
    caseBillingItemType: CaseBillingItemType | undefined;
    completeForm: CompleteForm | undefined;
    state: State | undefined;
    county: County | undefined;
}

export interface CompleteForm {
    id: number;
    surveyTypeId: number;
    customerId: number;
    payScheduleCategoryId: number | undefined;
    customerFriendlyReportName: string | undefined;
    requiresPreNotification: boolean;
    canBeDemoted: boolean;
    qaCost: number | undefined;
    daysTillDue: number;
    photoRequirements: string | undefined;
    customerQANotations: string | undefined;
    daysHold: number;
    customerBillingAmount: number | undefined;
    email: string | undefined;
    bitOptions: number | undefined;
    qaPercentage: number | undefined;
    postcardOverrideNumber: string | undefined;
    isOnSite: boolean;
    isCallCenter: boolean;
    isConsumerWeb: boolean;
    isAppraisalSurvey: boolean;
    createDate: Date | undefined;
    inactiveDate: Date | undefined;
    myriadMaxPhotos: number | undefined;
    isAppointmentRequired: boolean;
    qaQueueReturnedRejectionTimeoutHours: number | undefined;
    pdfReportAssemblyClass: string | undefined;
    rejectionFee: number | undefined;
    qaExpectedMinutes: number;
    qaRuleItvCoverageAInMin: number | undefined;
    qaRuleItvMgrReviewMin: number | undefined;
    qaRuleItvMgrReviewMax: number | undefined;
    qaRuleItvWarningMin: number | undefined;
    qaRuleItvWarningMax: number | undefined;
    qaRuleRcPerSqftMin: number | undefined;
    qaRuleRcPerSqftMax: number | undefined;
    frExpectedSiteTime: number | undefined;
    frExpectedDeskTime: number | undefined;
    phonePreNotificationRequired: boolean;
    phonePreNotificationInstructions: string | undefined;
    phonePreNotificationCallScript: string | undefined;
    skipFieldServicesQa: boolean;
    skipAppraisalQa: boolean;
    skipFieldServices: boolean;
    appraisalExpectedMinutes: number | undefined;
    photoSortingLogicClassName: string | undefined;
    incentivePercent: number;
    appraiserHoursTillDue: number;
    valuationServicesTimeServiceDays: number;
    fieldServicesTimeServiceDays: number;
    fieldServicesBillingPercent: number;
    valuationServicesBillingPercent: number;
    supplementFreeCount: number;
    appraisalQAExpectedMinutes: number;
    enableFieldServicesAutoQa: boolean;
    fieldServiceAutoQaCaseDataVerificationsCheck: boolean;
    appraiserOrderRequirementsPath: string | undefined;
    customer: Customer | undefined;
    surveyType: SurveyType | undefined;
    completeFormNotifications: CompleteFormNotification[] | undefined;
    forms: Form[] | undefined;
    stamps: Stamp[] | undefined;
    completeFormFees: CompleteFormFee[] | undefined;
    completeFormNotificationBillingRules: CompleteFormNotificationBillingRule[] | undefined;
    fieldServiceAutoQaItvPercentRangeCheck: boolean;
    fieldServiceAutoQaStartDate: Date | undefined;
    fieldServiceAutoQaSketchCheck: string | undefined;
    isSchedulingQueueEligible: boolean;
    enableQaSummaryView: boolean;
    enableCaseEventMessages: boolean;
    enableCallCenterAutoQa: boolean;
}

export interface CompleteFormNotification {
    id: number;
    completeFormId: number;
    notificationTypeId: number;
    daysFromPrevious: number;
    previousNotificationId: number | undefined;
    deletedDate: Date | undefined;
    notificationMethodId: number | undefined;
    createDate: Date;
    letterCode: string | undefined;
    completeForm: CompleteForm | undefined;
    completeFormNotifications1: CompleteFormNotification[] | undefined;
    completeFormNotification1: CompleteFormNotification | undefined;
    notificationMethod: NotificationMethod | undefined;
    notificationType: NotificationType | undefined;
}

export interface NotificationMethod {
    id: number;
    code: string | undefined;
    name: string | undefined;
    storedProcedureName: string | undefined;
    createDate: Date;
    completeFormNotifications: CompleteFormNotification[] | undefined;
    notificationLetters: NotificationLetterCode[] | undefined;
}

export interface NotificationLetterCode {
    id: number;
    notificationMethodsId: number;
    code: string | undefined;
    name: string | undefined;
    inactiveDate: Date | undefined;
    letterPackage: boolean;
    postcard: boolean;
    additionalPages: number;
    documentArchiveRetrieval: number;
    click2MailDocumentId: number | undefined;
    click2MailMailingListId: number | undefined;
    notificationMethod: NotificationMethod | undefined;
}

export interface Form {
    id: number;
    completeFormId: number | undefined;
    availFormId: number | undefined;
    shouldPrint: boolean;
    customerDisplayOrder: number;
    isOptionalCustomerForm: boolean;
    customerFee: number | undefined;
    isOnSite: boolean;
    isCallCenter: boolean;
    isConsumerWeb: boolean;
    calcToolId: number | undefined;
    createDate: Date | undefined;
    parentFormId: number | undefined;
    isPhoenixSupplement: boolean;
    isFieldSupplement: boolean;
    hideFR: boolean;
    hideQA: boolean;
    hideCust: boolean;
    hideAppraiser: boolean;
    hideCER: boolean;
    availForm: AvailForm | undefined;
    completeForm: CompleteForm | undefined;
    supplementForms: Form[] | undefined;
    parentForm: Form | undefined;
    replacementCostTool: ReplacementCostTool | undefined;
}

export interface ReplacementCostTool {
    id: number;
    name: string | undefined;
    code: string | undefined;
    defaultFee: number | undefined;
    calcToolAccounts: ReplacementCostToolAccount[] | undefined;
    forms: Form[] | undefined;
}

export interface ReplacementCostToolAccount {
    id: number;
    customerNumber: number;
    calcToolId: number;
    licenseCode: string | undefined;
    userName: string | undefined;
    password: string | undefined;
    domain: string | undefined;
    webserviceURL: string | undefined;
    wcfEndpointName: string | undefined;
    referenceWebserviceURL: string | undefined;
    referenceWCFEndpointName: string | undefined;
    configWebserviceURL: string | undefined;
    configWCFEndpointName: string | undefined;
    webserviceVersion: string | undefined;
    calcTool: ReplacementCostTool | undefined;
}

export interface Stamp {
    id: number;
    completeFormId: number;
    text: string | undefined;
    sortOrder: number | undefined;
    completeForm: CompleteForm | undefined;
}

export interface CompleteFormNotificationBillingRule {
    id: number;
    completeFormId: number;
    notificationTypeId: number;
    amount: number;
    isPerNotification: boolean;
    activeDate: Date;
    inactiveDate: Date | undefined;
    completeForm: CompleteForm | undefined;
    notificationType: NotificationType | undefined;
}

export interface CaseBuildingPermitHeader {
    id: number;
    controlIdNumber: number;
    vendorId: string | undefined;
    property: CaseBuildingPermitProperty[] | undefined;
    buildingFound: boolean;
    caseHeader: CaseHeader | undefined;
}

export interface CaseBuildingPermitProperty {
    buildingPermits: CaseBuildingPermitDetail[] | undefined;
    id: number;
    caseBuildingPermitHeaderId: number;
    lotSize: string | undefined;
    buildingSize: string | undefined;
    bedroomCount: string | undefined;
    bathroomCount: string | undefined;
    propertyClass: string | undefined;
    propertyType: string | undefined;
    propertyLandUse: string | undefined;
    yearBuilt: number | undefined;
    dataVintage: string | undefined;
    vendorId: string | undefined;
    caseBuildingPermitHeader: CaseBuildingPermitHeader | undefined;
}

export interface CaseBuildingPermitDetail {
    id: number;
    caseBuildingPermitPropertyId: number;
    businessName: string | undefined;
    description: string | undefined;
    effectiveDate: Date | undefined;
    fees: number | undefined;
    homeOwnerName: string | undefined;
    jobValue: number | undefined;
    permitNumber: string | undefined;
    projectName: string | undefined;
    status: string | undefined;
    permitType: string | undefined;
    permitSubType: string | undefined;
    caseBuildingPermitProperty: CaseBuildingPermitProperty | undefined;
}

export interface CaseCostEstimate {
    id: number;
    controlIdNumber: number;
    updatedDate: Date;
    medianMiles: number;
    mileagePay: number;
    medianMinutes: number;
    driveTimePay: number;
    totalDrivePay: number | undefined;
    siteTime: number;
    siteTimePay: number;
    webTime: number;
    webTimePay: number;
    totalSitePay: number | undefined;
    totalPay: number | undefined;
    totalIncentivePercentage: number | undefined;
    customerIncentivePercentage: number;
    regionalIncentivePercentage: number;
    busOpsQAIncentivePercent: number;
    busOpsQAMac: number;
    busOpsEmployeeMacPercent: number;
    busOpsEmployeeMacDollar: number;
    frEmployeeMacPercent: number;
    frEmployeeMacDollar: number;
    appraiserEmployeeMacPercent: number;
    appraiserEmployeeMacDollar: number;
    reportFeeEstimated: number;
    busOpsExpectedMinutes: number;
    expectedFieldFormMinutes: number;
    callCenterExpectedMinutes: number;
    callCenterExpectedCost: number;
    caseHeader: CaseHeader | undefined;
}

export interface CaseExportResult {
    id: number;
    controlNumber: number;
    exportDefinitionId: number;
    initiatedByInternetUserId: number;
    exportProcessingSummary: string | undefined;
    exportResultsText: string | undefined;
    exportResultsLog: string | undefined;
    exportSuccessful: boolean;
    exportFirstRunAtUtc: Date;
    exportStartedAtUtc: Date;
    exportFinishedAtUtc: Date;
    exportAttemptsCount: number;
    exportDefinition: ExportDefinition | undefined;
    caseHeader: CaseHeader | undefined;
    initiatedByInternetUser: InternetUser_Home | undefined;
}

export interface ExportDefinition {
    id: number;
    name: string | undefined;
    assembly: string | undefined;
    namespaceClass: string | undefined;
    code: string;
    settingsFileName: string | undefined;
    caseExportResults: CaseExportResult[] | undefined;
}

export interface AutomatedCallQueue {
    id: number;
    automatedCallQueueGlobalId: string;
    controlIDNumber: number;
    notificationTypeId: number;
    fromPhoneNumber: string | undefined;
    toPhoneNumber: string | undefined;
    callCommandData: string | undefined;
    createdDateUtc: Date;
    whenToCallDate: Date;
    callWindowTimeZoneMinutes: number;
    callWindowTimeZoneId: number | undefined;
    callWindowBeginTime: string;
    callWindowEndTime: string;
    sentToCallSystemDateUtc: Date | undefined;
    callSystemResultDataRetrievedDateUtc: Date | undefined;
    callSystemCompletedDateUtc: Date | undefined;
    callSystemResultData: string | undefined;
    callStatus: string | undefined;
    callSystemResultAnsweredBy: string | undefined;
    callDurationSeconds: number | undefined;
    cost: number | undefined;
    callSystemId: string | undefined;
    transmitHangfireJobId: string | undefined;
    caseHeader: CaseHeader | undefined;
    notificationType: NotificationType | undefined;
    callWindowTimeZone: TimeZone | undefined;
}

export interface TimeZone {
    timeZonesId: number;
    timeZone_: string | undefined;
    timeZoneDescription: string | undefined;
    utcDifference: string | undefined;
    timeZoneInfoId: string | undefined;
    supportsDaylightSavingTime: boolean;
}

export interface CaseNote {
    id: number;
    controlIdNumber: number;
    createdByInternetUserId: number;
    createdDateUtc: Date;
    noteBody: string | undefined;
    noteSubject: string | undefined;
    lastModifiedDateUtc: Date | undefined;
    isDeleted: boolean;
    deletedByInternetUserId: number | undefined;
    deletedDateUtc: Date | undefined;
    caseNoteTypeId: number;
    isExternal: boolean;
    caseHeader: CaseHeader | undefined;
    createdByInternetUser: InternetUser_Home | undefined;
    deletedByInternetUser: InternetUser_Home | undefined;
    caseNoteType: CaseNoteType | undefined;
}

export interface CaseNoteType {
    id: number;
    code: string | undefined;
    caseNotes: CaseNote[] | undefined;
}

export interface CubiCasaScan {
    id: number;
    controlIDNumber: number;
    ticketId: string;
    fileId: string;
    modelId: string | undefined;
    status: string | undefined;
    priority: string | undefined;
    webHookRequest: string | undefined;
    source: string | undefined;
    createDate: Date;
    modifyDate: Date;
    caseHeader: CaseHeader | undefined;
}

export interface FnmaPropertyDataResponse {
    id: number;
    controlIdNumber: number;
    responseDate: Date;
    fnmaInspectionId: string | undefined;
    caseHeader: CaseHeader | undefined;
    fnmaPropertyDataAdditionalMessages: FnmaPropertyDataAdditionalMessage[] | undefined;
    fnmaPropertyDataMessages: FnmaPropertyDataMessage[] | undefined;
    fnmaPropertyDataPhotoMessages: FnmaPropertyDataPhotoMessage[] | undefined;
}

export interface FnmaPropertyDataAdditionalMessage {
    id: number;
    fnmaPropertyDataResponseId: number;
    fnmaPropertyDataMessageTypeId: number;
    fnmaPropertyDataResponse: FnmaPropertyDataResponse | undefined;
    fnmaPropertyDataMessageType: FnmaPropertyDataMessageType | undefined;
}

export interface FnmaPropertyDataMessageType {
    id: number;
    fnmaMessageCode: string | undefined;
    fnmaMessageDescription: string | undefined;
    fnmaPropertyDataAdditionalMessages: FnmaPropertyDataAdditionalMessage[] | undefined;
    fnmaPropertyDataMessages: FnmaPropertyDataMessage[] | undefined;
    fnmaPropertyDataPhotoMessages: FnmaPropertyDataPhotoMessage[] | undefined;
}

export interface FnmaPropertyDataMessage {
    id: number;
    fnmaPropertyDataResponseId: number;
    fnmaPropertyDataMessageTypeId: number;
    fnmaPropertyDataResponse: FnmaPropertyDataResponse | undefined;
    fnmaPropertyDataMessageType: FnmaPropertyDataMessageType | undefined;
}

export interface FnmaPropertyDataPhotoMessage {
    id: number;
    fnmaPropertyDataResponseId: number;
    fnmaPropertyDataMessageTypeId: number;
    photoId: string;
    fnmaPropertyDataPhotoPath: string | undefined;
    fnmaPropertyDataResponse: FnmaPropertyDataResponse | undefined;
    fnmaPropertyDataMessageType: FnmaPropertyDataMessageType | undefined;
}

export interface PropertySearchData {
    id: number;
    controlIdNumber: number;
    createDate: Date;
    sourceName: string | undefined;
    ac: string | undefined;
    apn: string | undefined;
    assessedLandValue: number | undefined;
    assessedValue: number | undefined;
    basement: string | undefined;
    baths: number | undefined;
    bedrooms: number | undefined;
    buildingArea: number | undefined;
    currentOwnerName: string | undefined;
    fireplace: string | undefined;
    foundation: string | undefined;
    garage: string | undefined;
    garageNumberOfCars: number | undefined;
    heating: string | undefined;
    lastBuyer: string | undefined;
    mailingAddress: string | undefined;
    mailingCity: string | undefined;
    mailingState: string | undefined;
    mailingUnit: string | undefined;
    mailingUnitType: string | undefined;
    mailingZip: string | undefined;
    mailingZip4: string | undefined;
    marketLandValue: number | undefined;
    marketValue: number | undefined;
    numberOfStories: string | undefined;
    numberOfUnits: number | undefined;
    pool: string | undefined;
    salePrice: number | undefined;
    siteAddress: string | undefined;
    siteCity: string | undefined;
    siteState: string | undefined;
    siteUnit: string | undefined;
    siteUnitType: string | undefined;
    siteZip: string | undefined;
    siteZip4: string | undefined;
    totalRooms: number | undefined;
    yearBuilt: string | undefined;
    totalComparables: number | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface PhoenixIntegrationTracking {
    controlIDNumber: number;
    fieldRepNumber: string | undefined;
    photos: boolean;
    sketch: boolean;
    data: boolean;
    sentToQA: boolean;
    canSendToQA: boolean;
    dataChangeCount: number;
    deviceName: string | undefined;
    deviceOSPlatform: string | undefined;
    deviceOSVersion: string | undefined;
    applicationVersion: string | undefined;
    fileSizeBytes: number | undefined;
    syncAction: string | undefined;
    syncDate: Date | undefined;
    photoCount: number | undefined;
    atHomeReady: boolean;
    atHomeCreated: boolean;
    atHomeCompleted: boolean;
    caseHeader: CaseHeader | undefined;
}

export interface CaseCommunication {
    id: number;
    controlIdNumber: number;
    parentCaseCommunicationId: number | undefined;
    fromInternetUsersId: number | undefined;
    fromName: string | undefined;
    fromAddress: string | undefined;
    toInternetUsersId: number | undefined;
    toAddress: string | undefined;
    transmissionMethod: string | undefined;
    messageSubject: string | undefined;
    messageBody: string | undefined;
    createdDate: Date | undefined;
    caseCommunications: CaseCommunication[] | undefined;
    parentCaseCommunication: CaseCommunication | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CaseHeaderEncrypted {
    controlIDNumber: number;
    policyholderName1: string | undefined;
    policyholderName2: string | undefined;
    surveyAddress1: string | undefined;
    surveyAddress2: string | undefined;
    mailingAddress1: string | undefined;
    mailingAddress2: string | undefined;
    policyholderPhoneHome: string | undefined;
    policyholderPhoneWork: string | undefined;
    webNotes: string | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CaseHeaderMuellerAuto {
    controlIDNumber: number;
    insuredIdNumber: number;
    caseHeader: CaseHeader | undefined;
}

export interface CaseFeedback {
    id: number;
    controlIDNumber: number;
    stars: number;
    comments: string | undefined;
    createDate: Date | undefined;
    caseFeedbackCategoryId: number;
    fromInternetUserId: number | undefined;
    aboutInternetUserId: number | undefined;
    deviceName: string | undefined;
    deviceOS: string | undefined;
    deviceOSVersion: string | undefined;
    application: string | undefined;
    applicationVersion: string | undefined;
    caseHeader: CaseHeader | undefined;
    caseFeedbackCategory: CaseFeedbackCategory | undefined;
}

export interface CaseFeedbackCategory {
    id: number;
    name: string | undefined;
    description: string | undefined;
    code: string | undefined;
    caseFeedbacks: CaseFeedback[] | undefined;
}

export interface CaseHold {
    id: number;
    controlIdNumber: number;
    startDateTime: Date;
    startInternetUserId: number;
    endDateTime: Date | undefined;
    endInternetUserId: number | undefined;
    daysOnHold: number;
    isActive: boolean;
    note: string | undefined;
    caseSecondaryStatus: string;
    caseHeader: CaseHeader | undefined;
    startInternetUser: InternetUser_Home | undefined;
    endInternetUser: InternetUser_Home | undefined;
}

export interface CaseNationalFloodDataResult {
    id: number;
    controlIdNumber: number;
    searchType: string | undefined;
    successful: boolean;
    resultId: string | undefined;
    resultDateUtc: Date;
    resultJson: string | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface AppraisalAssignmentApproval {
    id: number;
    controlIdNumber: number;
    requestedDateUtc: Date;
    requestedByInternetUserId: number;
    requestApprovalReasons: string | undefined;
    requestApprovalComments: string | undefined;
    requestedAppraiserId: number;
    requestedAppraiserDescription: string | undefined;
    availableAppraisersDescription: string | undefined;
    decisionMade: boolean;
    decisionDateUtc: Date | undefined;
    decisionInternetUserId: number | undefined;
    decisionApproved: boolean | undefined;
    decisionComments: string | undefined;
    caseHeader: CaseHeader | undefined;
    requestedAppraiser: Appraiser | undefined;
    appraisalSurvey: AppraisalSurvey | undefined;
    requestSuperseded: boolean;
}

export interface FreddieMacBaceResponse {
    id: number;
    controlNumber: number;
    apiVersion: string | undefined;
    propertyDataReportType: string | undefined;
    resultMessage: string | undefined;
    resultStatus: string | undefined;
    messagesJson: string | undefined;
    baceInspectionId: string | undefined;
    baceInspectionFileName: string | undefined;
    baceResultsFileName: string | undefined;
    resultsDateUtc: Date;
    caseHeader: CaseHeader | undefined;
}

export interface CaseAudit {
    id: number;
    controlIdNumber: number;
    auditDate: Date;
    auditorInternetUserId: number;
    auditeeInternetUserId: number;
    comments: string | undefined;
    isPassing: boolean;
    auditeeFeedbackDate: Date | undefined;
    auditeeAgree: boolean;
    auditeeTrainingRequested: boolean;
    auditeeFeedbackComments: string | undefined;
    auditDateUtc: Date;
    localOffsetMinutes: number;
    auditDateLocal: Date;
    payPeriodId: number;
    caseHeader: CaseHeader | undefined;
    caseAuditSelections: CaseAuditSelection[] | undefined;
    auditorInternetUser: InternetUser_Home | undefined;
    auditeeInternetUser: InternetUser_Home | undefined;
}

export interface CaseAuditSelection {
    id: number;
    caseAuditId: number;
    caseAuditSelectionTypeId: number;
    caseAudit: CaseAudit | undefined;
    caseAuditSelectionType: CaseAuditSelectionType | undefined;
}

export interface CaseAuditSelectionType {
    id: number;
    code: string | undefined;
    displayName: string | undefined;
    caseAuditSelections: CaseAuditSelection[] | undefined;
}

export interface CaseAuditRiskScore {
    id: number;
    controlIdNumber: number;
    score: number;
    caseHeader: CaseHeader | undefined;
}

export interface RecommendationCount {
    id: number;
    controlNumber: number;
    count: number | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CaseETAs {
    id: number;
    controlIdNumber: number;
    timeStamp: Date;
    eta: Date;
    internetUserId: number;
    active: boolean;
    caseETATypeId: number;
    caseETAType: CaseETAType | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CaseETAType {
    id: number;
    code: string | undefined;
    caseETAs: CaseETAs[] | undefined;
}

export interface CaseAppointment {
    id: number;
    controlIdNumber: number;
    appointmentTypeId: number;
    appointmentDate: Date;
    appointmentDurationMinutes: number;
    appointmentNote: string | undefined;
    createdDate: Date;
    createdByInternetUserId: number;
    removedDate: Date | undefined;
    removedByInternetUserId: number | undefined;
    caseAppointmentType: CaseAppointmentType | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CaseAppointmentType {
    id: number;
    code: string;
    caseAppointment: CaseAppointment[] | undefined;
}

export interface CaseUnderwriterAction {
    id: number;
    controlIdNumber: number;
    underwriterActionId: number;
    caseHeader: CaseHeader | undefined;
    underwriterAction: UnderwriterAction | undefined;
}

export interface UnderwriterAction {
    id: number;
    name: string | undefined;
    bit: number | undefined;
    bitMask: number | undefined;
    isDefault: boolean | undefined;
    code: string | undefined;
    customerUnderwriterActions: CustomerUnderwriterAction[] | undefined;
    caseUnderwriterActions: CaseUnderwriterAction[] | undefined;
}

export interface CustomerUnderwriterAction {
    id: number;
    customerId: number | undefined;
    underwriterActionId: number | undefined;
    displayOrder: number | undefined;
    isUserSelectable: boolean;
    customer: Customer | undefined;
    underwriterAction: UnderwriterAction | undefined;
}

export interface CalculationHeaderHighValue {
    id: number;
    controlIdNumber: number;
    calcIndex: number;
    rctXml: string | undefined;
    fitCommitDate: Date | undefined;
    caseHeader: CaseHeader | undefined;
}

export interface CustomerSurveyTypePhotoTag {
    id: number;
    tagName: string | undefined;
    tagNameDisplayOrder: number;
    activeDate: Date;
    inactiveDate: Date | undefined;
    isRequired: boolean;
    customerId: number;
    surveyTypeId: number;
    isHazard: boolean;
    tagLongName: string | undefined;
    customer: Customer | undefined;
    surveyType: SurveyType | undefined;
}

export interface SurveyTypeDemotionMap {
    id: number;
    customerId: number | undefined;
    currentSurveyTypeId: number;
    demotedSurveyTypeId: number;
    customer: Customer | undefined;
    currentSurveyType: SurveyType | undefined;
    demotedSurveyType: SurveyType | undefined;
}

export interface RCTCalculationSetting {
    id: number;
    customerId: number | undefined;
    enginePath: string | undefined;
    dataPath: string | undefined;
    constructionType: number | undefined;
    architectFeesFlag: string | undefined;
    architectFeesMultiplier: number | undefined;
    architectFeesMaximum: number | undefined;
    overheadFeesFlag: string | undefined;
    overheadFeesMultiplier: number | undefined;
    overheadFeesMaximum: number | undefined;
    profitFlag: string | undefined;
    profitMultipler: number | undefined;
    profitMaximum: number | undefined;
    debrisRemovalFlag: string | undefined;
    debrisRemovalMultiplier: number | undefined;
    debrisRemovalMaximum: number | undefined;
    debrisRemovalOnlyInStates: string | undefined;
    generalAdjustmentMultiplier: number | undefined;
    depreciationMultiplier: number | undefined;
    detachedDepreciationMultiplier: number | undefined;
    laborType: string | undefined;
    excavationFlag: string | undefined;
    builtStandard: string | undefined;
    valueType: number | undefined;
    fitProcessCompany: string | undefined;
    fitRoutingTargetSystem: string | undefined;
    maximumWings: number;
    usePierFoundationHeightSplit: boolean;
    useLocalizedCosts: boolean;
    fractionalStoryHeightEnabled: boolean;
    storyNumbers: string | undefined;
    customer: Customer | undefined;
}

export interface Customer360ValueSetting {
    id: number;
    customersId: number;
    agentGroupId: string | undefined;
    agentId: string | undefined;
    outputType: string | undefined;
    webserviceURL: string | undefined;
    customerT: Customer | undefined;
}

export interface PdfRenderer {
    id: number;
    name: string | undefined;
    pdfDisplayDefinitionId: string;
    availFormId: number;
    customerId: number | undefined;
    inspectionTypeId: number | undefined;
    availForm: AvailForm | undefined;
    customer: Customer | undefined;
    surveyType: SurveyType | undefined;
}

export interface FeaturePermissionState {
    id: number;
    customerId: number | undefined;
    stateId: number;
    featurePermissionTypeId: number;
    customer: Customer | undefined;
    state: State | undefined;
    featurePermissionType: FeaturePermissionType | undefined;
}

export interface FeaturePermissionType {
    id: number;
    name: string | undefined;
    code: string | undefined;
    featurePermissionStates: FeaturePermissionState[] | undefined;
    featurePermissionZips: FeaturePermissionZip[] | undefined;
}

export interface FeaturePermissionZip {
    id: number;
    customerId: number;
    zipCodeId: number;
    featurePermissionTypeId: number;
    customer: Customer | undefined;
    postalCode: PostalCode | undefined;
    featurePermissionType: FeaturePermissionType | undefined;
}

export interface CustomerAppraiserExclusion {
    id: number;
    customerId: number;
    appraiserId: number;
    createdDate: Date;
    comments: string | undefined;
    createdByInternetUserId: number;
    removedDate: Date | undefined;
    removedByInternetUserId: number | undefined;
    customers: Customer | undefined;
    appraisers: Appraiser | undefined;
    createdByInternetUser: InternetUser_Home | undefined;
    removedByInternetUser: InternetUser_Home | undefined;
}

export interface EmailFileNameOption {
    id: number;
    code: string | undefined;
    displayName: string | undefined;
    customers: Customer[] | undefined;
}

export interface EmailFormat {
    id: number;
    name: string | undefined;
    code: string | undefined;
    methodName: string | undefined;
    displayName: string | undefined;
    customers: Customer[] | undefined;
}

export interface PDFExportSettings {
    id: number;
    customersId: number;
    startDate: Date;
    inactiveDate: Date | undefined;
    localFolderEnabled: boolean;
    destinationPath: string | undefined;
    fileTemplateName: string | undefined;
    pgpEnabled: boolean;
    pgpEncryptSender: string | undefined;
    pgpEncryptSenderPassword: string | undefined;
    pgpEncryptRecipient: string | undefined;
    ftpEnabled: boolean;
    ftpUploadToServer: string | undefined;
    ftpUploadToPath: string | undefined;
    ftpUploadToUsername: string | undefined;
    ftpUploadToPassword: string | undefined;
    ftpUploadToUsePassive: boolean;
    ftpEnableSSL: boolean;
    customClass: string | undefined;
    customer: Customer | undefined;
}

export interface EmployeeCustomerSurveyTypeMap {
    id: number;
    employeeId: number;
    employeeRoleId: number;
    internetUserId: number;
    customerId: number;
    inspectionTypeId: number;
    queueTypeId: number;
    assignedRank: number;
    assignedLevel: string | undefined;
    employeeCustomerSurveyTypeId: number;
    employee: Employee | undefined;
    employeeRole: EmployeeRole | undefined;
    internetUser: InternetUser_Home | undefined;
    queueType: QueueType | undefined;
    customer: Customer | undefined;
    inspectionType: SurveyType | undefined;
}

export interface CustomerOnboarding {
    id: number;
    customerId: number;
    onboardDate: Date | undefined;
    firstOrderDate: Date | undefined;
    customer: Customer | undefined;
}

export interface DeletedCaseForm {
    caseFormsId: number;
    availFormsId: number;
    phoenixInstanceId: string | undefined;
    isPhoenixSupplement: boolean | undefined;
    availForm: AvailForm | undefined;
}

export interface RCTMaterialFormOverride {
    id: number;
    availFormId: number;
    materialId: number;
    isVisible: boolean;
    isOnShortList: boolean;
    availForm: AvailForm | undefined;
    rctMaterial: RCTMaterial | undefined;
}

export interface RCTMaterial {
    id: number;
    name: string | undefined;
    order: number | undefined;
    mmhOrder: number | undefined;
    s80: number | undefined;
    type: string | undefined;
    materialListsId: number | undefined;
    shortOrLong: string | undefined;
    unitOfMeasure: number | undefined;
    myriadValueField: string | undefined;
    fitCode: string | undefined;
    visible: boolean;
    rctMaterialFormOverrides: RCTMaterialFormOverride[] | undefined;
    calculationSelections: CalculationSelection[] | undefined;
    rctMaterialList: RCTMaterialList | undefined;
}

export interface CalculationSelection {
    id: number;
    calculationHeaderId: number;
    amount: number;
    rctMaterialId: number;
    isDefault: boolean | undefined;
    calculationsHeader: CalculationsHeaderT | undefined;
    rctMaterial: RCTMaterial | undefined;
}

export interface CalculationsHeaderT {
    id: number;
    controlIdNumber: number;
    numberOfStructures: number | undefined;
    debrisRemovalCost: number | undefined;
    subTotal: number | undefined;
    yearBuilt: string | undefined;
    squareFootage: string | undefined;
    squareFootageTotal: number | undefined;
    stories: string | undefined;
    numberOfFamilies: number | undefined;
    name: string | undefined;
    active: boolean;
    phoenixFormInstanceId: string | undefined;
    replacementCost: number | undefined;
    additionalStructureCost: number | undefined;
    actualCashValue: number | undefined;
    totalInsurableReplacementCost: number | undefined;
    styleWing1: number | undefined;
    percentSlabWing1: number | undefined;
    percentCrawlspaceWing1: number | undefined;
    percentBasementWing1: number | undefined;
    percentFinishedBasementWing1: number | undefined;
    percentPierWing1: number | undefined;
    percentHillsideWing1: number | undefined;
    basementTypeWing1: number | undefined;
    styleWing2: number | undefined;
    squareFeetWing2: string | undefined;
    storiesWing2: string | undefined;
    percentSlabWing2: number | undefined;
    percentCrawlspaceWing2: number | undefined;
    percentBasementWing2: number | undefined;
    percentPierWing2: number | undefined;
    percentHillsideWing2: number | undefined;
    percentFinishedBasementWing2: number | undefined;
    basementTypeWing2: number | undefined;
    styleWing3: number | undefined;
    squareFeetWing3: string | undefined;
    storiesWing3: string | undefined;
    percentSlabWing3: number | undefined;
    percentCrawlspaceWing3: number | undefined;
    percentBasementWing3: number | undefined;
    percentFinishedBasementWing3: number | undefined;
    percentPierWing3: number | undefined;
    percentHillsideWing3: number | undefined;
    basementTypeWing3: number | undefined;
    depreciationMultiplier: number | undefined;
    detachedDepreciationMultiplier: number | undefined;
    depreciationAmount: number | undefined;
    detachedDepreciationAmount: number | undefined;
    dateCalcRan: Date | undefined;
    dateFitCommit: Date | undefined;
    calculationSelections: CalculationSelection[] | undefined;
}

export interface RCTMaterialList {
    id: number;
    name: string | undefined;
    listType: string | undefined;
    rctMaterials: RCTMaterial[] | undefined;
}

export interface AvailFormSupplementType {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    hideFromOrderPage: boolean;
    availForms: AvailForm[] | undefined;
}

export interface SurveyTypePhotoTag {
    id: number;
    tagName: string | undefined;
    tagNameDisplayOrder: number;
    activeDate: Date;
    inactiveDate: Date | undefined;
    isRequired: boolean;
    surveyTypeId: number;
    isHazard: boolean;
    surveyType: SurveyType | undefined;
}

export interface CountyPostalCode {
    id: number;
    postalId: number;
    countyId: number;
    intersectionArea: number;
    postal: PostalCode | undefined;
    county: County | undefined;
}

export interface AppraiserCounty {
    id: number;
    appraiserId: number;
    countyId: number;
    createDate: Date;
    createdByInternetUserId: number | undefined;
    appraiser: Appraiser | undefined;
    county: County | undefined;
    createdByInternetUser: InternetUser_Home | undefined;
}

export interface AppraisalReconsideration {
    id: number;
    appraisalSurveyId: number;
    createdDate: Date;
    reasonCategoryId: number;
    customerReasonNotes: string | undefined;
    responseDate: Date | undefined;
    sentToField: boolean;
    sentToFieldDate: Date | undefined;
    muellerToFieldReasonNotes: string | undefined;
    fieldResponseNotes: string | undefined;
    returnedFromField: boolean;
    returnedFromFieldDate: Date | undefined;
    sentToAppraiser: boolean;
    sentToAppraiserDate: Date | undefined;
    muellerToAppraiserReasonNotes: string | undefined;
    returnedFromAppraiser: boolean;
    returnedFromAppraiserDate: Date | undefined;
    appraiserResponseNotes: string | undefined;
    appraiserUpdateAppraisal: boolean;
    modifiedDate: Date;
    appraisalReasonCategory: AppraisalReasonCategory | undefined;
    appraisalSurvey: AppraisalSurvey | undefined;
}

export interface AppraisalSurveyLog {
    id: number;
    appraisalSurveyId: number;
    internetUserId: number | undefined;
    activityStartDate: Date | undefined;
    activityEndDate: Date | undefined;
    totalActiveTimeSeconds: number | undefined;
    note: string | undefined;
    appraisalSurvey: AppraisalSurvey | undefined;
}

export interface AppraisalSurveyWorkflowStatusHistory {
    destinationAppraisalWorkflowStatusType: AppraisalWorkflowStatusType;
    incomingAppraisalWorkflowStatusType: AppraisalWorkflowStatusType;
    id: number;
    appraisalSurveyId: number;
    incomingAppraisalWorkflowStatusId: number;
    incomingDate: Date | undefined;
    destinationAppraisalWorkflowStatusId: number | undefined;
    outgoingDate: Date | undefined;
    appraisalSurvey: AppraisalSurvey | undefined;
    destinationAppraisalWorkflowStatus: AppraisalWorkflowStatus | undefined;
    incomingAppraisalWorkflowStatus: AppraisalWorkflowStatus | undefined;
}

export enum AppraisalWorkflowStatusType {
    ORDER_SUBMITTED = 0,
    UNASSIGNED = 1,
    AWAITING_FIELD_REPORT = 2,
    AVAILABLE_TO_APPRAISER = 3,
    REJECTED_TO_FIELD = 4,
    APPRAISAL_SUBMITTED = 5,
    PENDING_APPRAISAL_QA = 6,
    IN_APPRAISAL_QA = 7,
    ASSIGNED_TO_QA_MANAGER = 8,
    REJECTED_TO_APPRAISER = 9,
    COMPLETION_PENDING = 10,
    CUSTOMER_REJECTED = 11,
    COMPLETED = 12,
    RECONSIDERATION_PENDING = 13,
    FIELD_RECONSIDERING = 14,
    APPRAISER_RECONSIDERING = 15,
    CANCELLED_PRE_INSPECTION = 16,
    CLOSED_POST_INSPECTION = 17,
    CLOSED_PRE_APPRAISAL = 18,
    PENDING_APPRAISAL_ASSIGNMENT = 21,
    APPRAISAL_SUBMITTAL_VERIFICATION = 500,
    VEROS_PREVIEW_REQUESTED = 501,
    VEROS_PREVIEW_RESULT_ERROR = 502,
    VEROS_PREVIEW_RESULT_SUCCESS = 503,
    VEROS_PREVIEW_ERROR_APPRAISER = 504,
    GAAR_PREVIEW_REQUESTED = 511,
    GAAR_PREVIEW_RESULT_ERROR = 512,
    GAAR_PREVIEW_RESULT_SUCCESS = 513,
    GAAR_PREVIEW_ERROR_APPRAISER = 514,
    UCDP_SUBMITTED_PENDING_RESPONSE = 1000,
    UCDP_RESULT_RECEIVED_WITH_ERRORS = 1002,
    UCDP_RESULT_RECEIVED_NO_ERRORS = 1003,
    SUBMITTING_TO_CUSTOMER = 1004,
    AWAITING_ELIGIBILITY_DECISION = 2000,
    APPRAISAL_WAIVED = 2001,
    ORDER_PAYMENT_REQUIRED = 3001,
    ORDER_PAYMENT_PENDING = 3002,
    ORDER_PAYMENT_EXPIRED = 3003,
    ORDER_PAYMENT_DECLINED = 3004,
    REOPEN_CANCELLED_PRE_INSPECTION = 4001,
    REOPEN_CLOSED_POST_INSPECTION = 4002,
    APPRAISAL_PRODUCT_CONVERSION = 5000,
    CLOSED_PRE_INSPECTION = 5001,
    ACTION_01 = 9000,
    ACTION_02 = 9001,
}

export interface AppraisalWorkflowStatus {
    id: number;
    name: string | undefined;
    code: string | undefined;
    appraisalSurveys: AppraisalSurvey[] | undefined;
    productConversionSourceAppraisalSurveys: AppraisalSurvey[] | undefined;
    destinationAppraisalWorkflowStatus: AppraisalSurveyWorkflowStatusHistory[] | undefined;
    incomingAppraisalWorkflowStatus: AppraisalSurveyWorkflowStatusHistory[] | undefined;
    appraisalWorkflowStatusType: AppraisalWorkflowStatusType;
}

/** Attribute */
export interface Attribute {
    /** key */
    key: string | undefined;
    /** value */
    value: string | undefined;
}

/** Audio */
export interface Audio {
    /** disabled */
    disabled: boolean;
}

/** Amounts by day */
export interface DailyAmountOfDecimal {
    /** Amounts for the day */
    amountByDayList: AmountByDayOfDecimal[] | undefined;
}

/** Percentages per day */
export interface DailyPercent extends DailyAmountOfDecimal {
}

/** Audit Daily Percent */
export interface AuditDailyPercent extends DailyPercent {
    /** Audits passed count per day */
    passedCount: DailyAmountOfInteger | undefined;
    /** Total Audits per day */
    totalCount: DailyAmountOfInteger | undefined;
}

/** Amounts by day */
export interface DailyAmountOfInteger {
    /** Amounts for the day */
    amountByDayList: AmountByDayOfInteger[] | undefined;
}

/** Amount by Day values for each day */
export interface AmountByDayOfInteger {
    /** The day of the week  */
    dayOfWeek: DayOfWeek;
    /** Actual date of the day */
    date: Date;
    /** Amount for the day */
    amount: number;
}

/** Amount by Day values for each day */
export interface AmountByDayOfDecimal {
    /** The day of the week  */
    dayOfWeek: DayOfWeek;
    /** Actual date of the day */
    date: Date;
    /** Amount for the day */
    amount: number;
}

/** Audit Percent */
export interface AuditTotalPercent {
    /** Audits passed count */
    passedCount: number;
    /** Total Audits  */
    totalCount: number;
    /** Total Audit percent */
    amount: number;
}

/** Audit Total Percent Weighted By Expected Minutes */
export interface AuditTotalWeightedPercent extends AuditTotalPercent {
    /** Total Weighted Audit Passing Minutes Percent */
    weightedPassingPercent: number;
}

/** An exception that indicates the current user did not have the proper permissions to perform the requested action */
export interface AuthorizationFailedException extends Exception {
    /** The authorization result */
    authorizationResult: IAuthorizationResult | undefined;
}

/** Definition of the authorization result */
export interface IAuthorizationResult {
    /** True if the authorization was permitted */
    authorizationPassed: boolean;
    /** System errors */
    errors: string[] | undefined;
    /** User friendly errors */
    displayErrors: string[] | undefined;
}

/** Results of an authorization call */
export interface AuthorizationResult {
    /** Returns true if the authorization was successful
This is based on AuthorizationPassed being set to true and no Errors or DisplayErrors present */
    authorizationPassed: boolean;
    /** A list of system / IT errors */
    errors: string[] | undefined;
    /** A list of user friendly errors */
    displayErrors: string[] | undefined;
}

/** Dto used to get info of authorized customers from InternetUserDbAccess */
export interface AuthorizedCustomersDto {
    internetAuthorizedCompany: InternetAuthorizedCompany | undefined;
    customer: Customer2 | undefined;
}

export interface InternetAuthorizedCompany {
    id: number;
    internetUserId: number | undefined;
    customerId: number | undefined;
    databaseType: string | undefined;
    msrepl_tran_version: string;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
}

export interface Customer2 {
    id: number;
    customerNumber: number | undefined;
    customerName: string | undefined;
    insuranceCompanyName: string | undefined;
    insuranceCompanyAccountNumber: string | undefined;
    databaseType: string | undefined;
    teamEmail: string | undefined;
    msrepl_tran_version: string;
    majorCompanyId: number | undefined;
    inactiveDate: Date | undefined;
    originalDatabase: string | undefined;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    customerFeatures: CustomerFeature[] | undefined;
    majorCompany: MajorCompany | undefined;
}

export interface CustomerFeature {
    id: number;
    customerId: number;
    featureId: number;
    isEnabled: boolean;
    feature: Feature | undefined;
    customer: Customer2 | undefined;
    customerFeatureSettings: CustomerFeatureSetting[] | undefined;
}

export interface Feature {
    id: number;
    code: string | undefined;
    name: string | undefined;
    description: string | undefined;
    customerFeatures: CustomerFeature[] | undefined;
    featureSettings: FeatureSetting[] | undefined;
}

export interface FeatureSetting {
    featureSettingId: number;
    featureId: number;
    name: string | undefined;
    code: string | undefined;
    description: string | undefined;
    initialValue: string | undefined;
    displayOrder: number;
    inputType: string | undefined;
    customerFeatureSettings: CustomerFeatureSetting[] | undefined;
    feature: Feature | undefined;
}

export interface CustomerFeatureSetting {
    customerFeatureSettingId: number;
    customerFeatureId: number;
    featureSettingId: number;
    value: string | undefined;
    customerFeature: CustomerFeature | undefined;
    featureSetting: FeatureSetting | undefined;
}

export interface MajorCompany {
    id: number;
    companyName: string | undefined;
    code: string | undefined;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    inactiveDate: Date | undefined;
    agents: Agent[] | undefined;
    customers: Customer2[] | undefined;
    underwriters: Underwriter[] | undefined;
    internetUsers: InternetUser[] | undefined;
}

export interface Agent {
    id: number;
    majorCompanyId: number | undefined;
    code: string | undefined;
    name: string | undefined;
    address1: string | undefined;
    address2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    phone: string | undefined;
    fax: string | undefined;
    email: string | undefined;
    notifyMethod: string | undefined;
    reportingOffice: string | undefined;
    servOffice: string | undefined;
    masterName: string | undefined;
    comments: string | undefined;
    underwriterId: number | undefined;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    inactiveDate: Date | undefined;
    majorCompany: MajorCompany | undefined;
    underwriter: Underwriter | undefined;
}

export interface Underwriter {
    id: number;
    majorCompanyId: number | undefined;
    internetUserId: number | undefined;
    code: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    phone: string | undefined;
    extension: string | undefined;
    email: string | undefined;
    techCode: string | undefined;
    techEmail: string | undefined;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    agents: Agent[] | undefined;
    majorCompany: MajorCompany | undefined;
    underwriterAgents: UnderwriterAgent[] | undefined;
}

export interface UnderwriterAgent {
    id: number;
    underwriterId: number;
    agencyCode: string | undefined;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    underwriter: Underwriter | undefined;
}

export interface InternetUser {
    id: number;
    username: string | undefined;
    password: string | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    failedAttempts: number | undefined;
    roleId: number | undefined;
    inspectorId: number | undefined;
    mustChangePassword: boolean;
    receivesEmailConfirmations: boolean;
    majorCompanyId: number | undefined;
    shortReportPref: boolean;
    msrepl_tran_version: string;
    passwordChanged: Date | undefined;
    passwordChangeDays: number | undefined;
    isDisabled: boolean;
    createDate: Date | undefined;
    modifyDate: Date | undefined;
    isValidEmail: boolean;
    localOffsetMinutes: number | undefined;
    homeownerEmployee: HomeownerEmployee[] | undefined;
    majorCompany: MajorCompany | undefined;
    internetUsersAddressBooks: InternetUsersAddressBook[] | undefined;
    telephoneEmployee: TelephoneEmployee[] | undefined;
    userAgencyCodes: UserAgencyCode[] | undefined;
    role: Role | undefined;
    userRights: UserRight[] | undefined;
    userPreferences: UserPreference[] | undefined;
    loginEvents: LoginEvent[] | undefined;
    customerServiceIncidents: CustomerServiceIncident[] | undefined;
    customerServiceIncidentAttachments: CustomerServiceIncidentAttachment[] | undefined;
    customerServiceIncidentNotes: CustomerServiceIncidentNote[] | undefined;
}

export interface HomeownerEmployee {
    id: number;
    firstName: string | undefined;
    middleInitial: string | undefined;
    lastName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
    homePhone: string | undefined;
    logInName: string | undefined;
    notes: string | undefined;
    emailAddress: string | undefined;
    title: string | undefined;
    internetUserId: number | undefined;
    payrollEmployeeId: string | undefined;
    hireDate: Date | undefined;
    employeeRoleId: number | undefined;
    status: string | undefined;
    supervisorEmployeeId: number | undefined;
    salary: number | undefined;
    salaryOrHourly: number;
    macAdjustmentPercent: number;
    macAdjustmentDollar: number;
    extension: number | undefined;
    birthDate: string | undefined;
    startDate: Date | undefined;
    internetUser: InternetUser | undefined;
    telephoneTouches: TelephoneTouch[] | undefined;
    homeownerEmployees: HomeownerEmployee[] | undefined;
    supervisorEmployee: HomeownerEmployee | undefined;
    employeeRole: EmployeeRole2 | undefined;
}

export interface TelephoneTouch {
    id: number;
    controlIDNumber: number;
    employeeID: number;
    telephoneTouchTypeId: number;
    createDate: Date;
    databaseType: string | undefined;
    notes: string | undefined;
    telephoneTouchType: TelephoneTouchType | undefined;
    homeownerEmployeeT: HomeownerEmployee | undefined;
}

export interface TelephoneTouchType {
    id: number;
    description: string | undefined;
    touchValue: number | undefined;
    telephoneTouches: TelephoneTouch[] | undefined;
}

export interface EmployeeRole2 {
    id: number;
    code: string | undefined;
    name: string | undefined;
    employeeDepartmentId: number;
    homeownerEmployees: HomeownerEmployee[] | undefined;
    employeeDepartment: EmployeeDepartment2 | undefined;
}

export interface EmployeeDepartment2 {
    id: number;
    code: string;
    name: string;
    employeeRoles: EmployeeRole2[] | undefined;
    customerServiceIncidents: CustomerServiceIncident[] | undefined;
}

export interface CustomerServiceIncident {
    id: number;
    controlIDNumber: number;
    updatedLastDate: Date;
    databaseType: string;
    personId: number | undefined;
    reasonId: number | undefined;
    resultId: number | undefined;
    coverageABefore: number | undefined;
    coverageAAfter: number | undefined;
    note: string | undefined;
    statusId: number;
    createdDate: Date;
    errorOptionId: number | undefined;
    assignedToUserId: number | undefined;
    assignedToDeptId: number | undefined;
    payPeriodId: number | undefined;
    replyToName: string | undefined;
    replyToEmail: string | undefined;
    replyToPhone: string | undefined;
    createdByInternetUserId: number | undefined;
    reasons: CustomerServiceCallReason | undefined;
    errorOptions: CustomerServiceErrorOption | undefined;
    persons: CustomerServicePerson | undefined;
    status: CustomerServiceStatus | undefined;
    assignedToUser: InternetUser | undefined;
    createdByInternetUser: InternetUser | undefined;
    customerServiceIncidentAttachments: CustomerServiceIncidentAttachment[] | undefined;
    customerServiceIncidentNotes: CustomerServiceIncidentNote[] | undefined;
    assignedToDepartment: EmployeeDepartment2 | undefined;
}

export interface CustomerServiceCallReason {
    id: number;
    name: string;
    isIssue: boolean | undefined;
    activeDate: Date | undefined;
    inactiveDate: Date | undefined;
    code: string | undefined;
    description: string | undefined;
    customerServiceIncidents: CustomerServiceIncident[] | undefined;
}

export interface CustomerServiceErrorOption {
    id: number;
    name: string;
    sortOrder: number;
    isEnabled: boolean;
    code: string;
    customerServiceIncidents: CustomerServiceIncident[] | undefined;
}

export interface CustomerServicePerson {
    id: number;
    name: string;
    code: string;
    customerServiceIncidents: CustomerServiceIncident[] | undefined;
}

export interface CustomerServiceStatus {
    id: number;
    name: string;
    code: string;
    customerServiceIncidents: CustomerServiceIncident[] | undefined;
}

export interface CustomerServiceIncidentAttachment {
    id: number;
    customerServiceIncidentId: number | undefined;
    createDate: Date;
    createdByInternetUserId: number;
    fileDisplayName: string | undefined;
    blobPath: string | undefined;
    lookupKey: string | undefined;
    internetUser: InternetUser | undefined;
    customerServiceIncident: CustomerServiceIncident | undefined;
}

export interface CustomerServiceIncidentNote {
    id: number;
    customerServiceIncidentId: number;
    createDate: Date;
    createdByInternetUserId: number;
    note: string | undefined;
    internetUser: InternetUser | undefined;
    customerServiceIncident: CustomerServiceIncident | undefined;
}

export interface InternetUsersAddressBook {
    id: number;
    internetUserId: number | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    faxNumber: string | undefined;
    msrepl_tran_version: string;
    internetUser: InternetUser | undefined;
}

export interface TelephoneEmployee {
    id: number;
    firstName: string | undefined;
    middleInitial: string | undefined;
    lastName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    stateId: number | undefined;
    postalCode: string | undefined;
    homePhone: string | undefined;
    logInName: string | undefined;
    notes: string | undefined;
    salary: number | undefined;
    salaryOrHourly: number | undefined;
    emailAddress: string | undefined;
    title: string | undefined;
    qaType: number | undefined;
    internetUserId: number | undefined;
    internetUser: InternetUser | undefined;
}

export interface UserAgencyCode {
    id: number;
    internetUserId: number;
    agencyCode: string | undefined;
    databaseType: string | undefined;
    createdDate: Date | undefined;
    modifyDate: Date | undefined;
    internetUser: InternetUser | undefined;
}

export interface Role {
    id: number;
    name: string | undefined;
    defaultRole: boolean;
    inactiveDate: Date | undefined;
    internetUsers: InternetUser[] | undefined;
    roleRights: RoleRight[] | undefined;
}

export interface RoleRight {
    id: number;
    roleId: number;
    rightId: number;
    value: boolean;
    right: Right | undefined;
    role: Role | undefined;
}

export interface Right {
    id: number;
    name: string | undefined;
    description: string | undefined;
    defaultValue: boolean;
    roleRights: RoleRight[] | undefined;
    userRights: UserRight[] | undefined;
}

export interface UserRight {
    id: number;
    internetUserId: number;
    rightId: number;
    value: boolean;
    internetUser: InternetUser | undefined;
    right: Right | undefined;
}

export interface UserPreference {
    id: number;
    internetUserId: number | undefined;
    userPreferenceTypeId: number;
    value: string | undefined;
    modifiedDate: Date | undefined;
    type: UserPreferenceType | undefined;
    internetUser: InternetUser | undefined;
}

export interface UserPreferenceType {
    id: number;
    code: string | undefined;
    userPreferences: UserPreference[] | undefined;
}

export interface LoginEvent {
    id: number;
    loginAttemptDate: Date;
    internetUserId: number | undefined;
    ipAddress: string | undefined;
    loginSuccessful: boolean;
    usernamePasswordAllowed: boolean;
    userIpAddressAllowed: boolean;
    requestIpAddress: string | undefined;
    userSessionId: string | undefined;
    username: string | undefined;
    note: string | undefined;
    internetUser: InternetUser | undefined;
}

/** Payment information */
export interface AuthorizePaymentDto {
    /** Mueller work item id */
    workItemId: string;
    /** Payment info */
    billingInfo: CreditCardBillingInfo | undefined;
    /** Charge amount */
    chargeAmount: number;
    /** Charge description */
    description: string | undefined;
    /** Charge invoice number */
    invoiceNumber: string | undefined;
    /** Customer first name */
    customerFirstName: string | undefined;
    /** Customer last name */
    customerLastName: string | undefined;
    /** Customer email address */
    customerEmail: string | undefined;
    /** Customer id */
    customerId: string | undefined;
}

export interface CreditCardBillingInfo {
    cardNumber: string;
    expirationDate: string;
    ccv: string;
    cardHolder: string;
}

/** Automated phone call templates */
export interface AutomatedCallQueueCallTemplates {
}

/** Properties related to an AutomatedCallQueue entry */
export interface AutomatedCallQueueDto {
    /** The Id of this call queue entry */
    id: number;
    /** A unique identifier for this entry */
    automatedCallQueueGlobalId: string;
    /** The case control number */
    controlIDNumber: number;
    /** The notification type id */
    notificationTypeId: number;
    /** The notification type id */
    notificationTypeCode: string | undefined;
    /** The phone number to send from */
    fromPhoneNumber: string | undefined;
    /** The phone number to send to */
    toPhoneNumber: string | undefined;
    /** Call command text for Twilio */
    callCommandData: string | undefined;
    /** Date/time this entry was created */
    createdDateUtc: Date;
    /** Date to call on */
    whenToCallDate: Date;
    /** Time zone offset the call is going to  */
    callWindowTimeZoneMinutes: number;
    /** The Mueller time zone id */
    callWindowTimeZoneId: number | undefined;
    /** Earliest time in time zone local time that call can be placed */
    callWindowBeginTime: string;
    /** Latest time in time zone local time that call can be placed */
    callWindowEndTime: string;
    /** Date/time the call was sent to Twilio */
    sentToCallSystemDateUtc: Date | undefined;
    /** Date/time the latest command data was received */
    callSystemResultDataRetrievedDateUtc: Date | undefined;
    /** Date/time the call was completed */
    callSystemCompletedDateUtc: Date | undefined;
    /** The latest call results */
    callSystemResultData: string | undefined;
    /** The latest call status */
    callStatus: string | undefined;
    /** The system indication of how the call was completed (eg person, machine) */
    callSystemResultAnsweredBy: string | undefined;
    /** The call duration in seconds */
    callDurationSeconds: number | undefined;
    /** The call cost */
    cost: number | undefined;
    /** The unique identifier assigned by the calling system (eg Twilio) */
    callSystemId: string | undefined;
    /** The HangFire job id to transmit this request */
    transmitHangfireJobId: string | undefined;
    /** The time zone system id */
    callWindowTimeZoneInfoId: string | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfAutomaticAppointment extends TypeSafeEnum {
}

/** Automatic Appointment Type */
export interface AutomaticAppointment extends TypeSafeEnumOfAutomaticAppointment {
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfAutomaticAppointment2 extends TypeSafeEnum {
}

/** Automatic Appointment Type */
export interface AutomaticAppointment2 extends TypeSafeEnumOfAutomaticAppointment2 {
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfAutomaticAppointmentAssignment extends TypeSafeEnum {
}

/** Automatic Appointment Assignment Statuses */
export interface AutomaticAppointmentAssignment extends TypeSafeEnumOfAutomaticAppointmentAssignment {
}

/** AutomaticAppointmentAssignmentStartResult */
export enum AutomaticAppointmentAssignmentStartResult {
    Unknown = 0,
    Success = 1,
    AlreadyStarted = 2,
    Ineligible = 3,
}

/** Constants for AutomaticAppointment Campaign */
export interface AutomaticAppointmentCampaign {
}

/** Model for returning case information */
export interface AutomaticAppointmentDto {
    /** Case Information */
    appointmentInformation: AutomaticAppointmentInformation | undefined;
    /** Dates available for appointments */
    availableAppointmentDates: AutomaticAppointmentTimeSlot[] | undefined;
}

/** Model for returning case information */
export interface AutomaticAppointmentInformation {
    /** Policy Holder Name */
    policyHolderName: string | undefined;
    /** Address */
    address: string | undefined;
    /** Company */
    company: string | undefined;
    /** Url to the Logo that the company has
Not garaunteed to exist so you need to check on the front end */
    logoUrl: string | undefined;
    /** Agent */
    agent: string | undefined;
    /** Appointment Date */
    apptDate: string | undefined;
    /** Appointment Time Range Code */
    apptTimeCode: string | undefined;
    /** Status of the automatic appointment */
    appointmentStatus: string | undefined;
    /** True if the case is an appraisal */
    isAppraisal: boolean;
    /** True if call center is currently in business hours */
    isWithinCallCenterHours: boolean;
    /** CS phone number to display */
    muellerPhoneNumber: string | undefined;
    /** Is eligible for call center appointment efforts */
    isCallCenterEligible: boolean;
}

/** Represents a date and timerange for an Automatic Appointment */
export interface AutomaticAppointmentTimeSlot {
    /** Date in ISO-8601 (yyyy-MM-dd) format */
    date: string | undefined;
    /** Code from AppointmentTimeRanges table */
    appointmentTimeRangeCode: string | undefined;
}

/** Model for returning case information */
export interface AutomaticAppointmentDtoV2 {
    /** Case Information */
    appointmentInformation: AutomaticAppointmentInformation | undefined;
    /** Dates available for appointments */
    appointmentCandidates: AppointmentCandidateResponse | undefined;
}

/** Result of call to automatic appointment start */
export enum AutomaticAppointmentStartResult {
    Unknown = 0,
    Success = 1,
    AlreadyStarted = 2,
    Ineligible = 3,
    InsufficientContactInfo = 4,
    InvalidContactInfo = 5,
}

/** Webservice model for submitting appointment info */
export interface AutomaticAppointmentSubmit {
    /** No dates selected, user elected 'Call Me'. If this is set it will override any date selection */
    callMeRequested: boolean;
    /** Date Selected (ISO format) */
    dateSelected: string | undefined;
    /** Time range code from [MuellerHomeowner].[dbo].[AppointmentTimeRanges] */
    timeRangeCode: string | undefined;
}

/** Webservice model for submitting appointment info */
export interface AutomaticAppointmentSubmitV2 {
    /** No dates selected, user elected 'Call Me'. If this is set it will override any date selection */
    callMeRequested: boolean;
    /** Selected Assignment Candidate */
    candidate: AppointmentCandidateSubmission | undefined;
}

/** Internet Users for Automatic Processes */
export interface AutoProcessUsers {
}

/** Types of Auto QA rules that can be enabled */
export enum AutoQaRuleType {
    FieldServices = 0,
    CallCenter = 1,
}

/** Data object required to auto review a case */
export interface AutoReviewDto {
    /** Case control number */
    controlNumber: number;
    /** Optional - action code to set */
    actionCode: string | undefined;
    /** Optional - set to overwrite an existing underwriter action */
    overWriteAction: boolean;
    /** Identifies the user to be recorded in the audit table */
    internetUserId: number;
}

/** Available survey type conversions */
export interface AvailableConversionViewModel {
    /** Conversion / survey type code */
    code: string | undefined;
    /** Display description of the conversion that can be performed */
    description: string | undefined;
}

export interface AvailForm2 {
    availFormId: number;
    name: string | undefined;
    code: string | undefined;
    minInstanceCount: number;
    maxInstanceCount: number;
}

/** Avail form class names */
export interface AvailFormClassNames {
}

/** This is just a list of specific form codes that are used throughout the business logic. Not meant to be all forms. Order alphabetically please, to avoid merge conflicts */
export interface AvailFormCodes {
}

/** Avail Form Dto */
export interface AvailFormDto {
    /** Primary Key of Avail Form */
    id: number;
    /** Unique Form Code */
    code: string | undefined;
    /** Avail Form Name */
    name: string | undefined;
    /** Number of time this form can exist minimum.  Zero means it can be removed */
    instanceCountMinimum: number;
    /** Number of times this form can exists maximum.  blank means unlimited */
    instanceCountMaximum: number | undefined;
    /** Phoenix id */
    phoenixFormId: string | undefined;
    /** Is this form mobile ready */
    isMobileReady: boolean;
    /** The display name used to indicate it's mobile ready */
    displayName: string | undefined;
}

/** Avail form type names */
export interface AvailFormTypeNames {
}

export enum AwaitingDataReason {
    NoReason = 1,
    CubiCasa = 2,
    PhotoAnalysis = 4,
}

/** Awaiting Data reason result */
export interface AwaitingDataReasonResult {
    /** Is there a reason? */
    hasReason: boolean;
    /** Reason for awaiting data status */
    reason: AwaitingDataReason;
}

/** Azure blob base directory names */
export interface AzureBlobContainerNames {
}

export interface AzurePhoto {
    bucketUri: string | undefined;
    captureDate: Date;
    fileSizeBytes: number;
    geocode: GeocodeModel | undefined;
    id: string;
    imageDimensions: ImageDimensionsModel | undefined;
    lastModifiedDate: Date;
    lastViewedDate: Date;
    ownerUsername: string | undefined;
    photoAreas: any[] | undefined;
    sortOrder: number;
    tags: any[] | undefined;
    uploadedDate: Date;
    userDescription: string | undefined;
}

export interface GeocodeModel {
    altitudeMeters: number;
    datum: any | undefined;
    heading: any | undefined;
    latitude: number;
    longitude: number;
}

export interface ImageDimensionsModel {
    height: number;
    width: number;
}

/** Use this to make calls to the Azure Web Call Logic App Service End point Resource Handler Deamon service */
export interface AzureWebCallBody {
    body: any | undefined;
    failureRetryIntervalSeconds: number;
    failureRetryLoopTimeout: string | undefined;
    failureRetryMaximumAttempts: number;
    headers: any | undefined;
    initialDelaySeconds: number;
    method: string | undefined;
    successResponseStatusCode: string | undefined;
    url: string | undefined;
}

export interface BaseCaseForm extends AvailForm2 {
    caseFormId: number | undefined;
    title: string | undefined;
    isDeleted: boolean;
    isNew: boolean;
    currentUserCanDelete: boolean;
    localId: string | undefined;
}

export interface RootCaseForm extends BaseCaseForm {
    supplements: SupplementCaseForm[] | undefined;
}

export interface SupplementCaseForm extends BaseCaseForm {
    parentLocalId: string | undefined;
}

export interface BaseForm extends AvailForm2 {
    formId: number;
    isSupplement: boolean;
    parentFormId: number | undefined;
}

export interface RootForm extends BaseForm {
}

export interface SupplementForm extends BaseForm {
}

/** Billing Base */
export interface BillingBaseDto {
    /** Control Id Number */
    controlIdNumber: number;
    /** Policy Number */
    policyNumber: string | undefined;
    /** Policy holder First Name */
    policyholderName1: string | undefined;
    /** Policy holder last name */
    policyholderName2: string | undefined;
    /** Date case was set to start working */
    dateReceived: Date;
    /** Date case completed */
    dateCompleted: Date | undefined;
    /** Time service */
    timeService: number;
    /** Department */
    department: string | undefined;
    /** ReportFee */
    reportFee: number;
    /** Phone Charges */
    phoneCharge: number;
    /** Photo Charged */
    photoCharge: number;
    /** Misc Charges */
    miscCharge: number;
    /** Total Billing */
    totalBilling: number;
    /** Billing Notes */
    billingNotes: string | undefined;
    /** Account Number */
    customerNumber: number | undefined;
    /** Inspection type */
    inspectionType: string | undefined;
    /** Business Type (New or Renewal) */
    businessType: string | undefined;
    /** Business Type (New or Renewal) */
    businessTypeNewOrRenewal: string | undefined;
    /** Survey Street Address */
    surveyStreetAddress: string | undefined;
    /** Survey City */
    surveyCity: string | undefined;
    /** Survey County */
    surveyCounty: string | undefined;
    /** Survey State */
    surveyState: string | undefined;
    /** Survey Postal Code */
    surveyPostalCode: string | undefined;
    /** State Abbreviation */
    stateAbbreviation: string | undefined;
    /** Inspector Assigned */
    assignedToInspector: number;
    /** Underwriter code supplied on the case */
    underwriterCode: string | undefined;
    /** Customer Tracking Number */
    pbTrackingNumber: number | undefined;
    /** Is Rush */
    isRush: boolean;
    /** Reviewed by Customer Date */
    webReviewed: Date | undefined;
    /** Review by user */
    reviewedBy: string | undefined;
    /** Account Name */
    customerName: string | undefined;
    /** Inspection Type Legacy */
    inspectionTypeLegacy: string | undefined;
    /** Calc tool fee */
    calcToolFee: number;
    /** Mueller Region */
    region: string | undefined;
    /** Customer Supplied Order Code */
    orderCodeIn: string | undefined;
    /** Mueller Inspection Type Code */
    inspectionCode: string | undefined;
    /** Mueller Ordered Inspection type code */
    originalInspectionCode: string | undefined;
    /** Flow status */
    webStatus: string | undefined;
    /** Customer Supplied Agency Code */
    agencyCode: string | undefined;
    /** Account Director */
    directorName: string | undefined;
    /** Total Charges */
    totalCharges: number;
    /** Total Discounts */
    totalDiscounts: number;
    /** Timer Service Discount */
    timeServiceDiscount: number;
    /** Total Discount Percentage */
    totalDiscountPercentage: number;
    /** Time Service Discount Percentage */
    timeServiceDiscountPercentage: number;
}

/** Used to return data back to front end to create the file */
export interface BillingBaseFile {
    /** File Name */
    fileName: string | undefined;
    /** Data for Export */
    data: BillingBaseDto[] | undefined;
    /** Columns for Dollar File, keys are used on the front end to get the data off the object so we dont have to try to convert the data source to camel case */
    columnDefinitions: MGridColumnDefinition[] | undefined;
}

/** Container for billing related information */
export interface BillingInfo {
    /** Credit Card payment related information */
    creditCard: CreditCardBillingInfo | undefined;
}

/** Billing Request object for a Non Case */
export interface BillingItemsRequest {
    /** Account Number */
    customerNumber: number;
    /** Survey type Code */
    surveyTypeCode: string;
    /** Postal Code */
    postalCode: string;
    /** True if the case is a Rush */
    isRush: boolean;
    /** The billing date to use (defaults to the current date/time) */
    effectiveBillingDate: Date | undefined;
}

/** Bonus Types for pay periods */
export enum BonusWeekType {
    NoBonus = 0,
    Bonus4Week = 1,
    Bonus5Week = 2,
}

/** Response type for BookingSiteAppointmentCandidateCalculator submission */
export interface BookingSiteSubmitResponse {
    /** Submission was accepted and assigned */
    success: boolean;
    /** Front end should make a new call to get appointment candidates */
    needsRefresh: boolean;
    /** Slot was taken, hide it on the front end */
    invalidateSelectedOnly: boolean;
}

/** Request to send to the AppraisalPort ENV tool webservice */
export interface BpoToolClientRequest {
    username: string | undefined;
    password: string | undefined;
    bpoXmlFilePath: string | undefined;
    bpoXmlStream: Stream | undefined;
    invoiceXmlFilePath: string | undefined;
    fncBpoAddendumXmlFilePath: string | undefined;
    subjectFrontViewPhotoPath: string | undefined;
    subjectRearViewPhotoPath: string | undefined;
    subjectStreetViewPhotoPath: string | undefined;
    salesCompPhotoPaths: string[] | undefined;
    listingCompPhotoPaths: string[] | undefined;
    additionalPhotoPaths: string[] | undefined;
    genericPhotoPaths: string[] | undefined;
    locationMapFilePath: string | undefined;
    mapPhotoPaths: string[] | undefined;
}

export interface BpoToolClientResponse {
    success: boolean;
    envUrl: string | undefined;
    pdfUrl: string | undefined;
    failureReason: string | undefined;
}

export interface BpoToolClientResponseFailureReasons {
}

/** Breakdown Cost Int */
export interface BreakdownCostInt {
    /** Labor Cost */
    laborCost: number;
    /** Equipment Cost */
    equipmentCost: number;
    /** Material Cost */
    materialCost: number;
}

/** Case Header information */
export interface BrokerCaseHeaderViewModel {
    /** Wrappable Id - used by the Frontend to load the right React component */
    wrappableId: string | undefined;
    /** Policy (aka Appraisal) property information. */
    policyInfo: PolicyInfo | undefined;
    /** Top level case information like statuses. */
    caseInfo: CaseInfo | undefined;
}

/** Information regarding a case, such as Address/Contact information */
export interface PolicyInfo {
    /** Policyholder name, contact details
             */
    policyHolderInfo: PolicyHolderInfo | undefined;
    /** Inspection Address of the case
             */
    surveyAddress: Address | undefined;
    /** Survey Remarks text field
             */
    surveyRemarks: string | undefined;
    /** Mailing address of the policyholder
             */
    mailingAddress: Address | undefined;
    /** Contact info for the policyholder
             */
    caseContactMethods: CaseContactMethodViewModel[] | undefined;
    /** Contact details for the agent ordered with this case
             */
    caseAgentInfo: AgencyInfo | undefined;
    /** Contact details for the agency on this case (i.e. the agent record)
             */
    agencyInfo: AgencyInfo | undefined;
    /** Details of the customer this case is associated to
             */
    customerInfo: CustomerInfo | undefined;
    /** Geo code latitude and longitude
             */
    geoCode: Geocode | undefined;
    /** Case Attributes - web orders save good info in Case Attributes
             */
    caseAttributes: { [key: string]: string; } | undefined;
    /** Underwriter details for the underwriter code associated to the case
             */
    underwriterInfo: UnderwriterInfo | undefined;
    /** Order code out or stack code
             */
    orderCodeOut: string | undefined;
    /** Coverage A as provided by customer
             */
    coverageAIn: number | undefined;
    /** Coverage A as determined by inspection
             */
    coverageAOut: number | undefined;
    /** Percent ITV */
    percentITV: number | undefined;
    /** Order Code In */
    orderCodeIn: string | undefined;
    /** Stack Code */
    stackCode: string | undefined;
    /** Year Built */
    yearBuilt: number | undefined;
    /** Square Footage */
    squareFootage: number | undefined;
    /** Qa Queue Validation */
    qaQueueRules: QaQueueRules | undefined;
}

export interface PolicyHolderInfo {
    policyholderName: Name | undefined;
    policyNumber: string | undefined;
    policyholderPhoneHome: string | undefined;
    policyholderPhoneWork: string | undefined;
    policyholderEmail: string | undefined;
    additionalPhone1: string | undefined;
    additionalPhone2: string | undefined;
    additionalPhone3: string | undefined;
    additionalPhone4: string | undefined;
    designatedContactName: string | undefined;
    designatedContactPhone1: string | undefined;
    designatedContactPhone2: string | undefined;
    designatedContactEmail: string | undefined;
}

export interface Name {
    firstName: string | undefined;
    lastName: string | undefined;
    fullName: string | undefined;
}

/** View model for when returning the case contact methods */
export interface CaseContactMethodViewModel {
    /** Ex: email, phone, Facebook, Instagram, Myspace, Farmersonly.com, Tinder, Carboholics Anonymous */
    contactType: string | undefined;
    /** The contact type code
Mueller.Business.Models.ContactTypeCodes */
    contactTypeCode: string | undefined;
    /** Ex: 7163891946 Call Me */
    contactValue: string | undefined;
    /** The name of the person associated with the contact method */
    personName: string | undefined;
    /** Flag to indicate if this contact method is deleted */
    deleted: boolean;
    /** Display order for the contact method */
    sortOrder: number | undefined;
    /** When this contact method was created */
    createDate: Date | undefined;
}

export interface CustomerInfo {
    customerName: string | undefined;
    customerNumber: string | undefined;
    customerType: string | undefined;
    majorCompanyId: number | undefined;
}

export interface Geocode {
    latitude: string | undefined;
    longitude: string | undefined;
    match: string | undefined;
}

/** Information regarding the underwriter associated to the case */
export interface UnderwriterInfo {
    /** Underwriter code
             */
    code: string | undefined;
    /** Underwriter company name
             */
    companyName: string | undefined;
    /** Underwriter phone
             */
    phone: string | undefined;
    /** Underwriter email
             */
    email: string | undefined;
}

/** QA Queue Rules */
export interface QaQueueRules {
    /** Manager min
             */
    qaRuleItvMgrReviewMin: number | undefined;
    /** Manager max
             */
    qaRuleItvMgrReviewMax: number | undefined;
    /** Warning min
             */
    qaRuleItvWarningMin: number | undefined;
    /** Warning max
             */
    qaRuleItvWarningMax: number | undefined;
}

export interface CaseInfo {
    /** Date entered or created or imported
             */
    dateOrdered: Date | undefined;
    /** Date entered or created or imported
             */
    dateSurveyed: Date | undefined;
    /** Date Returned to Field */
    dateReturned: Date | undefined;
    /** Date survey was completed?
             */
    dateCompleted: Date | undefined;
    /** Customer Due Date for case
             */
    caseDueDate: Date | undefined;
    /** Loan Closing Date */
    loanClosingDate: Date | undefined;
    /** Remaining days until due to the customer
             */
    daysUntilDue: string | undefined;
    /** Who the case is assigned to
             */
    assignedTo: string | undefined;
    /** The FR Number for the inspector assigned to the case
             */
    inspectorNumber: string | undefined;
    /** When the case was assigned
             */
    dateAssigned: Date | undefined;
    /** The fee the inspector will be paid
             */
    inspectorFee: string | undefined;
    /** The primary status of the case (i.e. OPEN, COMPLETED)
             */
    primaryStatus: string | undefined;
    /** The secondary status of the case (i.e. PENDING, QA, COMPLETED, etc)
             */
    webStatus: string | undefined;
    originalInspectionType: SurveyTypeListDto | undefined;
    currentInspectionType: SurveyTypeListDto | undefined;
    /** The case control number
             */
    controlNumber: string | undefined;
    /** Case Tracking Number
             */
    trackingNumber: string | undefined;
    /** The Fannie Mae DU ID (Desktop Underwriter) */
    loanDesktopUnderwriterCaseFileId: string | undefined;
    /** Special Attention Notes */
    webNotes: string | undefined;
    /** True if the case has an appraisal survey component */
    hasAppraisalSurveyInfo: boolean;
    /** Appraisal related header information */
    appraisalSurveyInfo: AppraisalSurveyInfo | undefined;
    /** Appraiser assigned to the case
             */
    appraiserAssigned: string | undefined;
    /** Appraiser Id of assigned appraiser
             */
    appraiserId: number;
    /** Appraiser NUmber of assigned appraiser
             */
    appraiserNumber: number;
    /** Appraiser InternetUserId
             */
    appraiserInternetUserId: number;
    /** Appraiser Work Phone
             */
    appraiserWorkPhone: string | undefined;
    /** Appraiser Home Phone
             */
    appraiserHomePhone: string | undefined;
    /** Appraiser Mobile Phone
             */
    appraiserMobilePhone: string | undefined;
    /** Appraiser Email Address
             */
    appraiserEmailAddress: string | undefined;
    /** Appraiser Personal Email Address */
    appraiserPersonalEmailAddress: string | undefined;
    /** Whether or not the appraiser allows other users to edit their cases */
    appraiserAllowsEdits: boolean;
    /** Inspector Cell Phone Number
             */
    inspectorCellPhone: string | undefined;
    /** Inspector Home Phone Number
             */
    inspectorHomePhone: string | undefined;
    /** Inspector Email Address
             */
    inspectorEmailAddress: string | undefined;
    /** FR Due Date */
    inspectorDueDate: Date | undefined;
    /** Appointment Required
             */
    appointmentRequired: boolean;
    /** Appointment Date and Time
             */
    appointmentDateTime: Date | undefined;
    /** Appointment Time
             */
    appointmentTime: string | undefined;
    /** Appointment Notes */
    appointmentNotes: string | undefined;
    /** Appointment was changed */
    appointmentChanged: boolean;
    /** Broker on the case */
    broker: BrokerInfo | undefined;
    /** Lender Logistics Director on the case */
    lenderLogisticsDirector: UserContactInfo | undefined;
    /** Lender Logistics Manager on the case */
    lenderLogisticsManager: UserContactInfo | undefined;
    /** Field Survey Director on the case */
    fieldSurveyDirector: UserContactInfo | undefined;
    /** Field Survey Coordinator / manager on the case */
    fieldSurveyCoordinator: UserContactInfo | undefined;
    /** Valuation Coordinator / manager on the case */
    valuationCoordinator: UserContactInfo | undefined;
    /** Valuation Director on the case */
    valuationDirector: UserContactInfo | undefined;
    /** QA (Bus Ops) Director on case */
    qaDirector: UserContactInfo | undefined;
    qaManager: UserContactInfo | undefined;
    /** Effective Date */
    effectiveDate: Date | undefined;
    /** Received Date */
    dateReceived: Date | undefined;
    /** Rush Box */
    isRush: boolean;
    /** Year Built In */
    yearBuiltIn: string | undefined;
    /** Private Notes */
    privateNotes: string | undefined;
    /** Business Type */
    businessType: string | undefined;
    /** Has a recommendations form attached */
    hasRecommendations: boolean;
    /** Has a hazards form attached */
    hasHazards: boolean;
    /** Has comparison fields for chart */
    hasComparisonFields: boolean;
    /** Preferred appointment date + time range - null if no preferred appointment */
    preferredAppointmentDateAndTimeRange: string | undefined;
    /** Freddie Mac - LP ID */
    loanFreddieMacCaseFileId: string | undefined;
    /** Integration - Fannie Mae Waiver  */
    integrationFannieMaeWaiver: string | undefined;
    /** Integration - Freddie Mac BACE */
    integrationFreddieMacBace: string | undefined;
    /** Field Inspection ETA */
    fieldInspectionETA: Date | undefined;
    /** Client ETA */
    clientETA: Date | undefined;
    /** Link to stamp and photo requirements for the case */
    stampsAndPhotoRequirementsLink: LabelOnClick | undefined;
    /** Data related to if the case isnt set up properly and the UI needs to be limited */
    limitedView: LimitedViewData | undefined;
    /** Status of CubiCasa scan for case */
    cubiCasaStatus: string | undefined;
    /** Customer Experience Manager */
    customerExperienceManager: string | undefined;
    /** Customer Experience Director */
    customerExperienceDirector: string | undefined;
    /** Customer Experience Manager Email */
    customerExperienceManagerEmail: string | undefined;
    /** Customer Experience Director Email */
    customerExperienceDirectorEmail: string | undefined;
}

/** Survey Type List Dto. */
export interface SurveyTypeListDto {
    /** Survey Type Id */
    id: number;
    /** Survey Type Code to use */
    code: string | undefined;
    /** Display Name  */
    name: string | undefined;
    /** Inactive Date */
    inactiveDate: Date | undefined;
    /** Survey type has custom billing rules */
    hasBillingRules: boolean;
}

/** Container for all useful broker infomation */
export interface BrokerInfo {
    /** Broker's First and Last Name */
    fullName: string | undefined;
    /** The broker's first name */
    firstName: string | undefined;
    /** the broker's last name */
    lastName: string | undefined;
    /** the broker's email address */
    email: string | undefined;
    /** The Broker's phone number */
    phoneNumber: string | undefined;
}

/** Used by MCard Hyperlink data type */
export interface LabelOnClick {
    /** Displayed value
             */
    label: string | undefined;
    /** Onclick string to be used as href for link
             */
    onClick: string | undefined;
}

/** Object to hold data related to if and why a case is in limited view */
export interface LimitedViewData {
    /** If the case is in limited view */
    isLimitedView: boolean;
    /** Reason why we are in limited view */
    reason: string | undefined;
}

/** Case History and Status Information */
export interface BrokerCaseHistoryViewModel {
    /** Wrappable Id - used by the Frontend to load the right React component
             */
    wrappableId: string | undefined;
    /** Current Status
             */
    appraisalCurrentStatus: AppraisalWorkflowStatusView | undefined;
    /** Notes on how the Appointment went.
             */
    appointmentNotes: string | undefined;
    /** Date of the appointment.
             */
    appointmentDate: Date | undefined;
    /** Date of the appointment with time for display.
             */
    appointmentDateDisplay: string | undefined;
    /** List of History Note Items that are relevant to the Broker.
             */
    callHistoryList: CallHistory[] | undefined;
}

/** Call history */
export interface CallHistory {
    id: number;
    callDate: Date;
    callTime: string | undefined;
    who: string | undefined;
    spokeWith: string | undefined;
    attemptedNumber: string | undefined;
    result: string | undefined;
}

/** Result model from Customer Review QuickList query */
export interface BrokerFeedbackCaseResult {
    controlIDNumber: number;
    loanNumber: string | undefined;
    surveyType: string | undefined;
    dateOrdered: Date | undefined;
    dateCompleted: Date | undefined;
    surveyState: string | undefined;
    agentName: string | undefined;
    feedbackRating: string | undefined;
    feedbackComments: string | undefined;
    fieldRep: string | undefined;
    policyholderName: string | undefined;
    appraiserAssigned: string | undefined;
    appraisalSupportRep: string | undefined;
    customerNumber: number | undefined;
    fieldDirector: string | undefined;
    fieldDirectorId: number;
    fR_Assigned: string | undefined;
}

export interface BrokerOrderContactInfo extends WebOrderRoleContactInfo {
    /** Indicates that the borrower does not have a email address */
    noValidEmail: boolean;
    /** Borrower Address  */
    borrowerAddress: AddressInfo | undefined;
}

/** View Model representing a user registration request */
export interface BrokerRegisterModel {
    /** First Name */
    firstName: string | undefined;
    /** Last Name */
    lastName: string | undefined;
    /** Email */
    email: string | undefined;
    /** Company Name for Agency Record */
    companyName: string | undefined;
    /** Company Code for Agency Record */
    clientReferenceID: string | undefined;
    /** Company Address 1 */
    companyAddress1: string | undefined;
    /** Company Address 2 */
    companyAddress2: string | undefined;
    /** City */
    city: string | undefined;
    /** State */
    state: string | undefined;
    /** Zip */
    zip: string | undefined;
    /** Phone Number */
    phoneNumber: string | undefined;
    /** Mortgage Company */
    mortgageCompany: string | undefined;
    /** List of customer numbers with BrokerRegister numbers turned on  */
    companySelection: (number | undefined)[] | undefined;
    /** If broker is a Correspondent for mortgage company */
    brokerIsCorrespondent: string | undefined;
    /** Additional Instructions */
    additionalInstructionText: string | undefined;
}

/** Response to the user registration */
export interface BrokerRegisterResponse {
    /** Indicates success of the operation */
    success: boolean;
    /** Username for the newly registered user (usually email) */
    username: string | undefined;
}

/** Correspondent and Mortgage company settings */
export interface BrokerSettings {
    mortgageCompanyList: MortgageCompanies[] | undefined;
    /** List of customer numbers the broker selected to order from */
    selectedCompanies: number[] | undefined;
    /** If the broker is a correspondent  */
    isCorrespondent: boolean;
}

/** mortgage company */
export interface MortgageCompanies {
    /** Customer number */
    id: number;
    /** Customer name */
    name: string | undefined;
    /** Broker is authorized to place order with company */
    selectedCompany: boolean;
}

/** Data posted back from Waiver decision process. */
export interface BrokerWaiverDecisionModel {
    controlIdNumber: number;
    eligible: boolean;
}

/** View model for the Broker Waiver page. */
export interface BrokerWaiverViewModel {
    errorMessage: string | undefined;
    errorCode: ErrorCode;
    handled: boolean;
    successMessage: string | undefined;
    requestToken: string | undefined;
    controlIdNumber: number;
    loanNumber: string | undefined;
    duNumber: string | undefined;
    eligibleText: string | undefined;
    ineligibleText: string | undefined;
    address: string | undefined;
}

/** Error codes used by the api */
export enum ErrorCode {
    LoginFailed = 1,
    ItemNotFound = 2,
    NotAuthenticated = 3,
    NotAuthorized = 4,
    OperationFailed = 5,
    InvalidData = 6,
    PendingResult = 7,
}

/** Web Order payment checkout information */
export interface BrokerWebOrderCheckout {
    /** Encrypted url friendly token. */
    token: string | undefined;
    /** Decoded control number */
    controlNumber: number;
    lenderName: string | undefined;
    loanNumber: string | undefined;
    reportName: string | undefined;
    borrowerName: string | undefined;
    propertyAddress: string | undefined;
    propertyCity: string | undefined;
    propertyState: string | undefined;
    propertyZip: string | undefined;
    billingAmount: number;
    /** Container for standard properties and Error messages. */
    result: BrokerWebOrderResponse | undefined;
}

/** Base class for web order responses */
export interface WebOrderResponseBase {
    /** Has an error. */
    error: boolean;
    /** Collection of errors. */
    errorMessages: string[] | undefined;
    /** The actual import id. Will be null if the order was not entered into the import system. */
    importQueueId: number | undefined;
    /** Import queue alias id used to query for order status. Will be null if the order was not entered into the import system. */
    importQueueAliasId: string | undefined;
}

/** WebOrder response for single case orders. */
export interface WebOrderResponse extends WebOrderResponseBase {
    /** Web Order ID */
    webOrderID: number;
}

/** Broker web order response */
export interface BrokerWebOrderResponse extends WebOrderResponse {
    /** Loan number from the lender/broker. */
    loanNumber: string | undefined;
}

export interface BrokerWebOrderRequest {
    customerNumber: string;
    reportType: string;
    brokerAgent: string | undefined;
    loan: LoanInfo;
    transactionType: string;
    borrower: BrokerOrderContactInfo;
    inspectionAddress: AddressInfo;
    appointment: AppointmentInfo;
    paymentType: PaymentType;
    isCorrespondent: boolean;
    billing: CreditCardBillingInfo;
    attachments: string[] | undefined;
}

export interface LoanInfo {
    /** The lender name */
    lenderName: string;
    /** The loan number */
    loanNumber: string;
    /** Fannie Mae DU ID */
    desktopUnderwriterCasefileID: string | undefined;
    /** Freddie Mac case file id */
    freddieMacCaseFileId: string | undefined;
    /** Type of property */
    propertyType: string | undefined;
    /** Loan prospector id */
    loanProspectorId: string | undefined;
}

/** Type of Payment method available for a Web Order */
export enum PaymentType {
    PayNow = 1,
    DeferPayment = 2,
    MuellerInvoice = 3,
}

/** Web Order request for placing a second Order on the same Property. */
export interface BrokerWebReorderRequest {
    /** Billing stuff
             */
    billing: CreditCardBillingInfo | undefined;
    originalControlIdNumber: number;
    customerNumber: string | undefined;
    newReportTypeCode: string | undefined;
    paymentType: PaymentType;
}

/** Building system */
export enum BuildingSystem {
    Sitework = 0,
    Foundations = 1,
    SlabonGrade = 2,
    Framing = 3,
    Roofing = 4,
    ExteriorWalls = 5,
    Partitions = 6,
    WallFinishes = 7,
    FloorFinishes = 8,
    CeilingFinishes = 9,
    Equipment = 10,
    ConveyingSystems = 11,
    PlumbingSystems = 12,
    HVACSystems = 13,
    ElectricalSystems = 14,
    AttachedStructures = 15,
    DetachedStructure = 16,
    GeneralConditions = 17,
}

/** Building System Cost */
export interface BuildingSystemCost extends BreakdownCostInt {
    /** System */
    system: BuildingSystem;
    /** System Code */
    systemCode: string | undefined;
    /** Description */
    description: string | undefined;
}

/** Properties to populate a feedback request */
export interface CaseFeedbackRequest {
    /** Number of stars on case feedback */
    stars: number;
    /** Case feedback comments */
    comments: string | undefined;
}

/** Case Feedback request with category code */
export interface BulkCaseFeedbackRequest extends CaseFeedbackRequest {
    /** Category Code */
    categoryCode: string | undefined;
}

/** Enum used to identify which business unit the Case belongs with. */
export enum BusinessUnit {
    Insurance = 0,
    Valuation = 1,
}

/** Value from the cache */
export interface CachedValue_1 {
    /** Was the item found in the cache */
    HasValue: boolean;
    /** Value found in the cache */
    Value: T | undefined;
}

/** Setting names for updating calc header settings */
export interface CalcSettingsKey {
}

/** Calc tool codes (MuellerHomeowner.dbo.CalcTools) */
export interface CalcToolCodes {
}

/** Request parameters for calculating appointment candidates. */
export interface CalculateAppointmentCandidateRequest {
    /** Control Id Number */
    controlIdNumber: number;
    /** How many business days out from today to begin searching
Defaults to 3 */
    startBusinessDaysAway: number;
    /** How many business days out from today to end searching
Defaults to 10 */
    endBusinessDaysAway: number;
    /** Maximum number of candidates to return
Defaults to 5 */
    candidateCountToReturn: number;
    /** Eta types to include when checking for open spaces in appointment */
    caseEtaTypeCodeToInclude: CaseETATypeCode | undefined;
    /** Disables rounding of site and drive time
Defaults to false */
    disableTimeRounding: boolean;
    /** InpectorServiceTravelRules has a flag for if it should be included in exterior auto assign */
    considerExteriorAutoAssignFlag: boolean;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCaseETATypeCode extends TypeSafeEnum {
}

/** TypeSafeEnum for CaseETATypes */
export interface CaseETATypeCode extends TypeSafeEnumOfCaseETATypeCode {
}

export interface CalculateRctMainStreetInformationResponse {
    warnings: string[] | undefined;
    error: string | undefined;
    replacementCostEstimate: number | undefined;
    fitCommitDate: Date | undefined;
    debrisRemoval: number | undefined;
}

/** Employee Calendar Event Type */
export enum CalendarEventTypeEnum {
    Available = 1,
    Unavailable = 2,
    FieldInspectionAppointment = 3,
    AppraisalAppointment = 4,
    Break = 5,
}

/** Request needed to generate a CalendarReport */
export interface CalendarReportRequest {
    /** PayPeriod */
    payPeriodId: number;
    /** User who requested it (for notification when complete) */
    requestedInternetUserId: number;
}

/** Specifies the different ways to update a recurring calendar event */
export enum CalendarUpdateEnum {
    EntireEvent = 1,
    SingleDay = 2,
    SingleDayAndFuture = 3,
}

/** Used to add/update */
export interface CallCenterCompletedCaseUpdateRequest {
    /** Case Id */
    controlIdNumber: number;
    /** User who completed the case */
    internetUserId: number;
    /** Date case was completed in UTC time */
    completedDateUtc: Date | undefined;
    /** Type of Completion */
    completeType: CallCenterCompleteTypeEnum;
}

export enum CallCenterCompleteTypeEnum {
    Scheduled = 1,
    SubmittedToQa = 2,
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCallCenterScheduleAppointment extends TypeSafeEnum {
}

/** Call Center Scheduled Appointment Process */
export interface CallCenterScheduleAppointment extends TypeSafeEnumOfCallCenterScheduleAppointment {
}

/** Result of initiating Call Center workflow */
export enum CallCenterWorkflowResult {
    Unknown = 0,
    Success = 1,
    Ineligible = 2,
    Holding = 3,
}

/** Call log dto */
export interface CallLog {
    /** Id from the database table this history type came from */
    id: number;
    /** Enum for the type of history item */
    historyType: HistoryType;
    /** Date the log was created */
    dateCreated: Date;
    /** Result of contact and time range */
    details: string | undefined;
    /** Person that was contacted */
    contact: string | undefined;
    /** Person performing the contact */
    performedBy: string | undefined;
    /** Notes regarding contact */
    notes: string | undefined;
    /** Indicates if the entry is editable */
    editable: boolean;
}

/** Cancel case request */
export interface CancelRequest {
    /** ControlNumber of the case being canceled  */
    controlNumber: number;
    /** Appends to the Survey Remark notes */
    surveyRemarks: string | undefined;
    /** Appends to the Appointment notes */
    appointmentNotes: string | undefined;
}

/** Response indicating if a satisfaction survey can be completed */
export interface CanCompleteSatisfactionSurveyResponse {
    /** Indicates if a satisfaction survey can be completed */
    canCompleteSatisfactionSurvey: boolean;
}

/** 360 value */
export interface Case360Response {
    /** Uri to external calc tool */
    uri: string | undefined;
    /** Flag to indicate that 360 value */
    hasValue: boolean;
}

/** Case Alert Data Model */
export interface CaseAlert {
    /** Control Number of the case the alert occurred on */
    controlNumber: number;
    /** Customer Number of the Customer associated with the case the alert occurred on */
    customerNumber: number;
    /** Customer Name of the Customer associated with the case the alert occurred on */
    customerName: string | undefined;
    /** Message that will be displayed in the Notification for the QA */
    message: string | undefined;
    /** The Action that was taken that warrented a Case Alert */
    action: string | undefined;
    /** When the Action occurred */
    timeStamp: string | undefined;
    /** Id of the Case Alert */
    id: number;
    /** Queue id (1 for first qa/insurance qa, 2 for appraisal qa) */
    qaQueueTypeId: number;
}

/** DTO class for CaseAppointment */
export interface CaseAppointmentDto {
    id: number;
    controlIdNumber: number;
    appointmentTypeId: number;
    appointmentDate: Date;
    appointmentDurationMinutes: number;
    appointmentNote: string | undefined;
    createdDate: Date;
    createdByInternetUserId: number;
    removedDate: Date | undefined;
    removedByInternetUserId: number | undefined;
}

/** Request to add a new appointment */
export interface CaseAppointmentRequest {
    /** Control number of the case */
    controlIdNumber: number;
    /** Type of appointment */
    appointmentType: CaseAppointmentTypeCode | undefined;
    /** Date and time of appointment */
    appointmentDate: Date;
    /** Optional appointment note */
    appointmentNote: string | undefined;
}

/** TypeSafeEnum for CaseAppointmentTypes */
export interface CaseAppointmentTypeCode extends TypeSafeEnum {
}

/** Static CaseAttribute Name codes */
export interface CaseAttributeNames {
}

/** Constants for use with Case Attribute Values */
export interface CaseAttributePredefinedValue {
}

/** used to add a case attribute */
export interface CaseAttributesAddDto {
    controlIdNumber: number;
    name: string;
    value: string;
}

export interface CaseAttributesResponseDto {
    name: string | undefined;
    value: string | undefined;
}

/** Web Service Request for QaCaseAuditController.CreateFeedback */
export interface CaseAuditCreateFeedbackRequest {
    /** Auditee Agrees with findings */
    agreesWithAudit: boolean;
    /** Auditee Comments */
    comments: string | undefined;
    /** Auditee Requestes Training */
    trainingRequested: boolean;
}

/** Web Service Request for QaCaseAuditController.Create */
export interface CaseAuditCreateRequest {
    /** Selected CaseAuditSelectionType codes */
    selectedCodes: string[] | undefined;
    /** Auditor Comments */
    comments: string | undefined;
    /** Audit is a pass */
    isPassing: boolean;
    /** user local offset minutes from utc */
    localOffsetMinutes: number;
}

/** Routing workflows for audits */
export enum CaseAuditIncomingWorkflows {
    PRERELEASE = 0,
    REJECTED = 1,
}

/** Case Audit Selection Type Codes */
export interface CaseAuditSelectionTypeCodes {
}

/** Web Service Response for QaCaseAuditController.ListSelectionTypes */
export interface CaseAuditSelectionTypeResponse {
    /** Unique code for audit selection type */
    code: string | undefined;
    /** UI Display Name for audit selection */
    displayName: string | undefined;
}

/** Auto QA Rule Result */
export interface CaseAutoQaRuleResult {
    /** If true Auto QA is allowed */
    autoQaAllowed: boolean;
    /** Auto QA rule result notes */
    autoQaReasonNotes: string[] | undefined;
    /** Names of the rules that were run */
    autoQaRuleNames: string[] | undefined;
}

/** used to add a case billing item. */
export interface CaseBillingItemAdd {
    /** Control Number */
    controlIdNumber: number;
    /** Employee Name adding Items */
    employeeName: string;
    /** Amount to be billed or deducted */
    amount: number;
    /** Any note associated with the item */
    note: string | undefined;
    /** Billing Item Type code from CaseBillingItemTypeCodes static class */
    caseBillingItemTypeCode: string;
    /** If the billing item that is added is an adjustment / discount, the ruleId should apply */
    caseBillingAdjustmentRuleId: number;
}

/** Case Billing Item Type Code */
export interface CaseBillingItemTypeCodes {
}

/** DO NOT CHANGE VALUES WITHOUT UNDERSTANDING THE IMPLICATIONS.  We clear out the prior ledger items using these names. If it changes, then we won't clear out the old ledger items, and will just add new ones, likely doubling each billing group.  If you update this name, you'll have to create a SQL script to update ALL the ledger items with the prior name to the new name. */
export interface CaseBillingNameConstants {
}

/** Case billing result types */
export enum CaseBillingResult {
    Success = 0,
    NotInBillableStatus = 1,
    BaseFeeNotSet = 2,
}

export interface CaseBuildingPermitDetailDto {
    id: number;
    caseBuildingPermitPropertyId: number;
    businessName: string | undefined;
    description: string | undefined;
    effectiveDate: Date | undefined;
    fees: number | undefined;
    homeOwnerName: string | undefined;
    jobValue: number | undefined;
    permitNumber: string | undefined;
    projectName: string | undefined;
    status: string | undefined;
    permitType: string | undefined;
    permitSubType: string | undefined;
}

export interface CaseBuildingPermitHeaderDto {
    id: number;
    controlIdNumber: number;
    vendorId: string | undefined;
    property: CaseBuildingPermitPropertyDto[] | undefined;
    buildingFound: boolean;
}

export interface CaseBuildingPermitPropertyDto {
    buildingPermits: CaseBuildingPermitDetailDto[] | undefined;
    id: number;
    caseBuildingPermitHeaderId: number;
    lotSize: string | undefined;
    buildingSize: string | undefined;
    bedroomCount: string | undefined;
    bathroomCount: string | undefined;
    propertyClass: string | undefined;
    propertyType: string | undefined;
    propertyLandUse: string | undefined;
    yearBuilt: number | undefined;
    dataVintage: string | undefined;
    vendorId: string | undefined;
}

export interface CaseCancel {
    /** Comments on why it's being canceled. */
    cancelComments: string | undefined;
}

export interface Attribute2 {
    typeId: any | undefined;
}

/** Attribute used to generate CaseConfigurationsMetadata needed for the front end CaseConfigurations editor. */
export interface CaseConfigurationsEditorAttribute extends Attribute2 {
    /** Friendly name of configuration */
    name: string | undefined;
    /** Description of configuration */
    description: string | undefined;
    /** Front end control type to render */
    controlType: string | undefined;
    /** Sort order */
    order: number;
}

/** Metadata for the CaseConfigurations properties. */
export interface CaseConfigurationsMetadata {
    /** Property name on CaseConfigurationsProperties */
    key: string | undefined;
    /** Friendly name for UI */
    name: string | undefined;
    /** Long Description for UI */
    description: string | undefined;
    /** Control Type to Render */
    controlType: string | undefined;
    /** Options for "Select" control */
    options: string[] | undefined;
}

/** Front End Model for CaseConfigurations row. Make sure property names match exactly with names on MR1.Data.Home.CaseConfiguration */
export interface CaseConfigurationsProperties {
    /** PhoenixMobile appointment initial text message template */
    appointmentInitialTextTemplate: string | undefined;
    /** PhoenixMobile appointment reminder text message template */
    appointmentReminderTextTemplate: string | undefined;
    /** PhoenixMobile Initial Prenotification Text Message Template */
    preNoteInitialTextTemplate: string | undefined;
    /** Bus Ops QA Agent Incentive percentage rule for account / survey type */
    busOpsQAIncentivePercent: number | undefined;
    /** File name to attach to the document node on the MISMO - Defaults to Report.pdf
             */
    mismoEmbeddedPdfReportName: string | undefined;
    /** Flag to indicate Mueller@Home Interior inspections are Allowed */
    atHomeInteriorEnabled: boolean | undefined;
    /** Flag to indicate Mueller@Home Interior inspections are Required */
    atHomeInteriorRequired: boolean | undefined;
    /** Flag to indicate Mueller@Home Exterior inspections are Allowed */
    atHomeExteriorEnabled: boolean | undefined;
    /** Flag to indicate Mueller@Home Exterior inspections are Required */
    atHomeExteriorRequired: boolean | undefined;
    /** AppraiserFileIdentifier override for the MISMO file */
    mismoAppraiserFileIdentifierPilotIdOverride: string | undefined;
    /** Flag to initiate automatic appointment process on cases */
    autoAppointmentEnabled: boolean | undefined;
    /** Enables the automatic assignment of cases that had their appointment date selected by the 
automatic appointment process */
    autoAppointmentAssignmentEnabled: boolean | undefined;
    /** Use broker name for company name on communications */
    useBrokerForCompanyName: boolean | undefined;
    /** Call State Machine definition to assign to phoenix case */
    callWorkflowDefinitionKey: string | undefined;
    /** Call State Machine definition for scheduling workflow */
    schedulingWorkflowDefinitionKey: string | undefined;
    /** Phone number to display to end users where Mueller takes incoming calls */
    incomingCallPhoneNumber: string | undefined;
    /** Url for e2Value's Portico service estimator (refer to their service documentation - every calc type has its own url) */
    e2ValueCalcUrl: string | undefined;
    /** When true tells RCT to not validate interior material sections when the case is exterior */
    rctInteriorValidationDisabledWhenExterior: boolean | undefined;
    /** Template for appointment outreach (preferred appointment) email subject line */
    appointmentOutreachEmailSubject: string | undefined;
    /** Template for appointment outreach (preferred appointment) email body */
    appointmentOutreachEmailBody: string | undefined;
    /** Template for appointment outreach (preferred appointment) email body for designated contacts */
    appointmentOutreachEmailBodyDesignatedContact: string | undefined;
    /** Template for appointment outreach (preferred appointment) SMS message */
    appointmentOutreachSMSBody: string | undefined;
    /** Template for appointment outreach (preferred appointment) SMS message for designated contacts */
    appointmentOutreachSMSBodyDesignatedContact: string | undefined;
    /** Template for automatic assignment (full auto and top 5) email subject line */
    automaticAssignmentEmailSubject: string | undefined;
    /** Template for automatic assignment (full auto and top 5) email body */
    automaticAssignmentEmailBody: string | undefined;
    /** Template for automatic assignment (full auto and top 5) SMS message */
    automaticAssignmentSMSBody: string | undefined;
    /** Template for preassignment notification email subject */
    preassignmentNotificationEmailSubject: string | undefined;
    /** Template for preassignment notification email body */
    preassignmentNotificationEmailBody: string | undefined;
    /** Template for preassignment notification SMS message */
    preassignmentNotificationSMSBody: string | undefined;
    /** Customer Satisfaction Survey Enabled */
    customerSatisfactionSurveyEnabled: boolean | undefined;
    /** Enables Automatic Appointment Email Notifications */
    automaticAppointmentEmailEnabled: boolean | undefined;
    /** Enables Automatic Appointment SMS Notifications */
    automaticAppointmentSMSEnabled: boolean | undefined;
    /** Automatic Appointment Scheduling Link Enabled */
    automaticAppointmentSchedulingLinkEnabled: boolean | undefined;
    /** Prenotification Voice Call (robocall) Enabled */
    prenotificationVoiceCallEnabled: boolean | undefined;
    /** Template for Prenotification call */
    prenotificationVoiceCallTemplate: string | undefined;
    /** URL for prenotification audio file to play */
    prenotificationStaticAudioFileUrl: string | undefined;
    /** Enable sending invites for app-based Mueller@Home
             */
    atHomeAppEnabled: boolean | undefined;
    /** Enable sending invites for web-based Mueller@Home
             */
    atHomeWebEnabled: boolean | undefined;
    /** Enable Automated Call System Calls
             */
    automatedCallSystemEnabled: boolean | undefined;
    /** Enable the Case Data Verification feature on cases */
    caseDataVerificationEnabled: boolean | undefined;
    /** Require the Photo Analysis placeholder form on the case to enable photo analysis */
    photoAnalysis_RequireFormOnCase: boolean | undefined;
    /** Enable condition score */
    photoAnalysis_EnableConditionScore: boolean | undefined;
    /** Enable quality score */
    photoAnalysis_EnableQualityScore: boolean | undefined;
    /** Enable debris detection */
    photoAnalysis_EnableDebrisDetection: boolean | undefined;
    /** Enable object detection */
    photoAnalysis_EnableObjectDetection: boolean | undefined;
    /** Enable finish detection */
    photoAnalysis_EnableFinishDetection: boolean | undefined;
    /** Enable image quality score */
    photoAnalysis_EnableImageQualityScore: boolean | undefined;
    /** Score above which a photo is considered blurry */
    photoAnalysis_BlurryImageThresholdScore: number | undefined;
    /** Enable person detection */
    photoAnalysis_EnableComprehensivePersonDetection: boolean | undefined;
    /** Enable roof material classifier */
    photoAnalysis_EnableRoofMaterial: boolean | undefined;
    /** Enable dwelling style classifier */
    photoAnalysis_EnableDwellingStyle: boolean | undefined;
    /** Enable detached structure classifier */
    photoAnalysis_EnableDetachedStructure: boolean | undefined;
    /** Enable dwelling style classifier */
    photoAnalysis_EnableRoofStyle: boolean | undefined;
    /** Enable dwelling style classifier */
    photoAnalysis_EnableExteriorWalls: boolean | undefined;
}

/** Represents an option for converting a case */
export interface CaseConversionOption {
    /** Survey Type Code */
    code: string | undefined;
    /** Survey Type Name */
    name: string | undefined;
    /** Conversion Type */
    caseConversionType: CaseConversionType;
}

/** Types of conversions */
export enum CaseConversionType {
    FieldDemotion = 0,
    AppraisalConversion = 1,
}

/** Case Cost Estimates */
export interface CaseCostEstimatesDto {
    /** Site Time */
    siteTimeMinutes: number;
    /** Web Time  */
    webTimeMinutes: number;
    /** Form Time */
    formTimeMinutes: number;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCaseDataRevisionFriendlyName extends TypeSafeEnum {
}

/** Type safe enum for case data revision friendly names */
export interface CaseDataRevisionFriendlyName extends TypeSafeEnumOfCaseDataRevisionFriendlyName {
}

export interface CaseDataVendorOperationCreateRequest {
    /** Data vendor code See DataVendorCode class for constants */
    dataVendorCode: string | undefined;
    /** Data vendor operation type code */
    dataVendorOperationTypeCode: string | undefined;
    /** Case control number */
    controlIDNumber: number;
    /** Case form id */
    caseFormId: number;
    /** Data vendor reference id */
    dataVendorReferenceId: string | undefined;
    /** Date/Time the operation took place */
    operationDateTime: Date;
    /** Data vendor number of results returned */
    resultCount: number;
    /** Operation was successful */
    operationSuccessful: boolean;
    /** Operation is chargeable */
    operationChargeable: boolean;
}

/** Data Transfer Object for Case Data Verification. */
export interface CaseDataVerificationDto {
    /** Gets or sets the unique identifier for the case data verification. */
    id: number;
    /** Gets or sets the control ID number. */
    controlIdNumber: number;
    /** Gets or sets the date of verification. */
    verificationDateUtc: Date;
    /** Gets or sets a value indicating whether the observed value is available. */
    observedValueAvailable: boolean;
    /** Gets or sets the observed value. */
    observedValue: string | undefined;
    /** Gets or sets the key for the observed value. */
    observedValueKey: string | undefined;
    /** Gets or sets a value indicating whether the verification value is available. */
    verificationValueAvailable: boolean;
    /** Gets or sets the verification value. */
    verificationValue: string | undefined;
    /** Gets or sets the key for the verification value. */
    verificationValueKey: string | undefined;
    /** Gets or sets a value indicating whether the observed and verification values are considered equivalent. */
    valuesAreConsideredEquivalent: boolean;
    /** Gets or sets the observed category. */
    observedCategory: DataVerificationCategoryDto | undefined;
    /** Gets or sets the verification category. */
    verificationCategory: DataVerificationCategoryDto | undefined;
}

/** Data Transfer Object for Data Verification Category. */
export interface DataVerificationCategoryDto {
    /** Gets or sets the main category ID. */
    mainCategoryId: number;
    /** Gets or sets the main category code. */
    mainCategoryCode: string | undefined;
    /** Gets or sets the main category name. */
    mainCategoryName: string | undefined;
    /** Gets or sets the secondary category ID. */
    secondaryCategoryId: number;
    /** Gets or sets the secondary category code. */
    secondaryCategoryCode: string | undefined;
    /** Gets or sets the secondary category name. */
    secondaryCategoryName: string | undefined;
}

/** ETA List */
export interface CaseETAListDto {
    /** Type Code */
    type: string | undefined;
    /** Date */
    date: Date;
}

/** Used to update an ETA */
export interface CaseETARequest {
    /** New ETA (UTC) */
    eta: Date;
}

/** Case Event name definition */
export interface CaseEventConstant {
    /** Object name */
    objectName: string | undefined;
    /** Molecule name
             */
    molecule: string | undefined;
    /** Event type */
    eventType: string | undefined;
    /** ObjectEventName that is used in task processor Do not use to insert into case events */
    objectEventName: string | undefined;
    /** EventName that is used in task processor.  Do not use to insert into case events */
    eventName: string | undefined;
}

/** Case Event definitions */
export interface CaseEventConstants {
}

/** Case Event SignalR Hub Message model */
export interface CaseEventHubMessage {
    /** Case control number */
    controlNumber: number;
    /** Event date/time */
    createDate: Date;
    /** Event type */
    eventType: string | undefined;
    /** Molecule name */
    molecule: string | undefined;
    /** Object id */
    objectID: number | undefined;
    /** Object name */
    objectName: string | undefined;
}

export interface SystemException extends Exception {
}

export interface TimeoutException extends SystemException {
}

export interface CaseEventTimeoutException extends TimeoutException {
}

/** Case event type codes */
export interface CaseEventTypeCodes {
}

/** Watches for a user */
export interface CaseEventTypeDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** Case event type ID */
    id: number;
    /** Watch is for an inspection event */
    isInspectionWatch: boolean;
    /** Watch is for an appraisal event */
    isAppraisalWatch: boolean;
    /** Display Order */
    displayOrder: number;
}

/** Case Export SignalR Hub Message model */
export interface CaseExportProgressUpdateMessage {
    /** Case control number */
    controlNumber: number;
    /** Event date/time */
    createDateUtc: Date;
    /** Progress Percent */
    progressPercent: number;
    /** Molecule name */
    exportJobUuid: string | undefined;
    /** Object name */
    updateMessage: string | undefined;
    /** Export code */
    exportCode: string | undefined;
    /** True when the export is totally finished */
    exportFinished: boolean;
    /** True when the export is totally finished */
    exportSequenceFinished: boolean;
}

/** Return model for CaseExportQuicklistResult */
export interface CaseExportQuicklistResult {
    controlIDNumber: number;
    customerName: string | undefined;
    customerNumber: number;
    initiatedBy: string | undefined;
    exportResultText: string | undefined;
    exportResultLog: string | undefined;
    exportStartedAt: Date;
    exportFinishedAt: Date | undefined;
    exportSuccessful: boolean;
}

/** Results of a case export run */
export interface CaseExportResultDto {
    /** Primary key */
    caseExportResultId: number;
    /** Case control number */
    controlNumber: number;
    /** The export definition id */
    exportCode: string | undefined;
    /** The export name */
    exportName: string | undefined;
    /** Export initiated by internet user */
    initiatedByInternetUser: InternetUserNameInfoDto | undefined;
    /** One line summary for display */
    exportProcessingSummary: string | undefined;
    /** User friendly export results text */
    exportResultsText: string | undefined;
    /** Detailed export results log */
    exportResultsLog: string | undefined;
    /** True if the export was successful */
    exportSuccessful: boolean;
    /** Date the export started at */
    exportStartedAtUtc: Date;
    /** Date the export finished at */
    exportFinishedAtUtc: Date;
}

/** Return model for CaseExportWithApiQuicklistResult */
export interface CaseExportWithApiQuicklistResult extends CaseExportQuicklistResult {
    valuationCoordinator: string | undefined;
    valuationDirector: string | undefined;
    timeSinceFirstSubmission: string | undefined;
    timeSinceLastSubmission: string | undefined;
    apiRequirement: string | undefined;
    apiStatus: string | undefined;
    apiMessage: string | undefined;
    /** case field status */
    webStatus: string | undefined;
    /** case appraisal status */
    appraisalStatus: string | undefined;
    /** case date completed */
    dateCompleted: Date | undefined;
    /** case customer due date */
    dueDate: Date | undefined;
}

/** Result from CaseFeedbackResultProvider */
export interface CaseFeedbackResult {
    controlIDNumber: number;
    loanNumber: string | undefined;
    customerNumber: number | undefined;
    customerNameNumber: string | undefined;
    surveyType: string | undefined;
    dateEntered: Date | undefined;
    dateCompleted: Date | undefined;
    feedbackDate: Date | undefined;
    surveyState: string | undefined;
    feedbackRating: string | undefined;
    feedbackCategory: string | undefined;
    feedbackComments: string | undefined;
    fieldDirector: string | undefined;
    fieldManager: string | undefined;
    appraiserAssigned: string | undefined;
    deviceName: string | undefined;
    deviceOS: string | undefined;
    deviceOSVersion: string | undefined;
    application: string | undefined;
    applicationVersion: string | undefined;
}

/** Files on a case */
export interface CaseFileListing {
    /** Control id number for post back
             */
    controlIdNumber: number;
    /** Attached Files
             */
    attachedFiles: FileMetadata[] | undefined;
    /** Template that the client can call to render the old asp code in an Iframe.
             */
    iframeUrlTemplate: string | undefined;
}

/** Case File Information */
export interface FileMetadata {
    /** Name of the file */
    fileName: string | undefined;
    /** File Last Modified */
    lastModified: Date;
    /** Download location of file */
    downloadUrl: string | undefined;
    /** Inline location of file */
    viewUrl: string | undefined;
    /** File Size in bytes */
    fileSizeBytes: number;
    /** Type of File Storage */
    locationType: StorageLocationType;
    /** True if the file can be deleted */
    canDelete: boolean;
}

/** Type of file */
export enum StorageLocationType {
    File = 0,
    FileInternal = 1,
    CaseAttachment = 2,
}

export interface CaseFloodZoneDataTransferRequest {
    caseFloodZoneSearchResult: CaseFloodZoneSearchResult | undefined;
    controlIdNumber: number;
}

export interface CaseFloodZoneSearchResult {
    resultDateUtc: Date;
    resultJson: string | undefined;
    successful: boolean;
    searchType: string | undefined;
    resultId: string | undefined;
}

export interface CaseFloodZoneDataTransferResult {
    dataTransferred: boolean;
}

export interface CaseFloodZoneSearchRequest {
    controlIdNumber: number;
}

/** Case Follow up dto */
export interface CaseFollowUpDto {
    /** Primary Key */
    id: number;
    /** User Info */
    userInfo: NameNumberDto | undefined;
    /** Follow up Date */
    followUpDate: Date;
    /** Follow up note */
    note: string | undefined;
}

/** Get follow up by case and internet user id */
export interface CaseFollowUpGetRequest {
    /** Internet User Id */
    internetUserId: number;
    /** Control Id Number */
    controlIdNumber: number;
}

/** Case Follow up update request */
export interface CaseFollowUpInsertRequest {
    /** Internet User Id */
    internetUserId: number;
    /** ControlIdNumber */
    controlIdNumber: number;
    /** Follow up Date */
    followUpDate: Date;
    /** Follow up note */
    note: string | undefined;
}

/** Result from CaseFollowUpResultProvider */
export interface CaseFollowUpResult {
    /** Control number */
    controlIDNumber: number;
    /** Follow up date */
    followUpDateTime: Date;
    /** Policy number */
    policyNumber: string | undefined;
    /** Policyholder name */
    policyholderName: string | undefined;
    /** Survey address */
    surveyAddress: string | undefined;
    /** Last note */
    lastNote: CellViewModelOfCaseNoteViewModel | undefined;
    /** Customer name and number */
    customerNameNumber: string | undefined;
    /** Survey type */
    surveyType: string | undefined;
    /** Field status */
    fieldStatus: string | undefined;
    /** Date ordered */
    dateOrdered: Date | undefined;
    /** Customer due date */
    customerDueDate: Date | undefined;
    /** Agency name */
    agencyName: string | undefined;
    /** Effective date */
    effectiveDate: Date | undefined;
    /** Appointment date */
    appointmentDate: Date | undefined;
    /** Date last contacted */
    lastContactDate: Date | undefined;
    /** Last contact effort type */
    lastContactEffortType: string | undefined;
    /** Last contact result */
    lastContactResult: string | undefined;
    /** Field rep assigned */
    fieldRepAssigned: string | undefined;
    /** Underwriter code */
    underwriterCode: string | undefined;
    /** Client ETA */
    clientEta: Date | undefined;
    /** Follow Up Note */
    followUpNote: string | undefined;
}

/** Update Case Follow up Request */
export interface CaseFollowUpUpdateRequest {
    /** Primary Key */
    id: number;
    /** Follow up Date */
    followUpDate: Date;
    /** Follow up note */
    note: string | undefined;
}

/** Model used to add a form to a case */
export interface CaseFormAddRequest {
    /** Control Number */
    controlIdNumber: number;
    /** Form id to be added */
    availFormId: number;
    /** Title of Form */
    title: string | undefined;
}

/** Model used to request to delete a case form */
export interface CaseFormDeleteRequest {
    /** Case Form primary key */
    id: number;
    /** control Id number */
    controlIdNumber: number;
}

/** Case Form return model */
export interface CaseFormDto {
    /** Case Form Id */
    id: number;
    /** Current user can delete this for or not */
    currentUserCanDelete: boolean;
    /** Avail Form information */
    availForm: AvailFormDto | undefined;
    /** Is the form Deleted */
    isDeleted: boolean;
    /** Phoenix Instance Id */
    phoenixInstanceId: string | undefined;
    /** Form Title for this case */
    title: string | undefined;
    /** What Number of the form is on this case */
    instanceNumber: number | undefined;
    /** Is a phoenix supplement */
    isPhoenixSupplement: boolean;
}

/** Request model to get forms */
export interface CaseFormGetRequest {
    /** Case Id (controlIDNumber) */
    controlIdNumber: number;
}

export interface CaseFormStatus {
    dirty: boolean;
    validateFailed: boolean;
    saveSuccess: boolean;
}

/** Standard upadte model for any CaseForm */
export interface CaseFormUpdateModel {
    /** Control number to be updated
             */
    controlNumber: number;
    /** Wrappable Item type
             */
    wrappableItemType: string;
    /** Posted Form document - standard html form post
             */
    payload: any;
}

/** Model to update a Case Form */
export interface CaseFormUpdateRequest {
    /** Case Form Id */
    id: number;
    /** Case id (ControlIdNumber) */
    controlIdNumber: number;
    /** Title of the form if you want a different display to the customer than the form name */
    title: string | undefined;
}

/** Hazard that has triggered on a case */
export interface CaseHazardDto {
    /** Hazard id */
    id: number;
    /** Case control number */
    controlIDNumber: number;
    /** Count of instances of this hazard. */
    hazardCount: number;
    /** Type of hazard rule */
    hazardRuleObject: string | undefined;
    /** Textual hazard level */
    hazardLevel: string | undefined;
    /** Classification of hazard */
    hazardCategory: HazardCategoryDto | undefined;
    /** Additional notes set in the form logic (location, description, etc.) */
    details: string | undefined;
}

/** Dto for hazard classification */
export interface HazardCategoryDto {
    /** Main category name */
    categoryName: string | undefined;
    /** Subcategory name */
    subcategoryName: string | undefined;
}

/** Model for CaseHazard for frontend */
export interface CaseHazardViewModel {
    /** Hazard Category Name */
    categoryName: string | undefined;
    /** Hazard Subcategory Name */
    subCategoryName: string | undefined;
    /** How many majors the Hazard is worth */
    majorCount: number;
    /** How many minors the Hazard is worth */
    minorCount: number;
    /** Hazard ID */
    id: number;
}

/** Case Header DTO */
export interface CaseHeaderDto {
    /** Policy (aka Appraisal) property information. */
    policyInfo: PolicyInfo | undefined;
    /** Top level case information like statuses. */
    caseInfo: CaseInfo | undefined;
    /** Legacy case view link */
    legacyDataEntryPageLink: LabelOnClick | undefined;
    /** On Hold Status */
    onHold: boolean;
    /** On Hold Details */
    onHoldDetails: CaseHoldDetailDto | undefined;
    /** Appraisal Survey detail */
    appraisalSurveyDetail: AppraisalSurveyDetailDto | undefined;
    /** Mueller@Home Features */
    muellerAtHomeFeatures: MuellerAtHomeEnabledFeatures | undefined;
}

/** Case Hold Detail information */
export interface CaseHoldDetailDto {
    /** Control Number */
    controlIdNumber: number;
    /** Date Case was put on Hold */
    startDate: Date;
    /** Date the on hold is over */
    endDate: Date | undefined;
    /** Days on hold */
    daysOnHold: number;
    /** Workflow status of case when it was put on hold */
    caseSecondaryStatus: string | undefined;
    /** User that put the case on Hold */
    userPutOnHold: InternetUserNameInfoDto | undefined;
    /** Note associated with the case hold */
    note: string | undefined;
}

/** Enabled case features for mueller at home */
export interface MuellerAtHomeEnabledFeatures {
    /** InteriorEnabled */
    interiorEnabled: boolean;
    /** InteriorRequired */
    interiorRequired: boolean;
    /** ExteriorEnabled */
    exteriorEnabled: boolean;
    /** ExteriorRequired */
    exteriorRequired: boolean;
    /** InteriorEnabled or ExteriorEnabled */
    anyEnabled: boolean;
    /** Description of Interior Feature */
    interiorDescription: string | undefined;
    /** Description of Exterior Feature */
    exteriorDescription: string | undefined;
    /** App-based Mueller@Home enabled */
    appEnabled: boolean;
    /** Web-based Mueller@Home enabled */
    webEnabled: boolean;
}

/** Encrypted case header data */
export interface CaseHeaderEncryptedDto {
    /** Case control number */
    controlIDNumber: number;
    /** Policyholder first name  */
    policyholderName1: string | undefined;
    /** Policyholder last name */
    policyholderName2: string | undefined;
    /** Street address of service */
    surveyAddress1: string | undefined;
    /** Street address of service */
    surveyAddress2: string | undefined;
    /** Mailing address of policyholder */
    mailingAddress1: string | undefined;
    /** Mailing address of policyholder */
    mailingAddress2: string | undefined;
    /** Home or primary phone number of policyholder */
    policyholderPhoneHome: string | undefined;
    /** Work or alternate phone number of policyholder */
    policyholderPhoneWork: string | undefined;
    /** Special Attention Notes */
    webNotes: string | undefined;
}

/** Gives key path to the property in CaseHeaderDto It is used for updating case header, check view/edit rights */
export interface CaseHeaderPropertiesKeyPath {
}

export interface CaseHeaderView {
    cards: MCard[] | undefined;
    caseHeaderDto: CaseHeaderDto | undefined;
}

export interface MCard {
    key: string | undefined;
    title: string | undefined;
    fields: MField[] | undefined;
    isEditable: boolean;
    allowMultipleColumns: boolean;
    showOnLimitedView: boolean;
}

/** MField definition for front end */
export interface MField {
    /** Path to data */
    key: string | undefined;
    /** Label to display */
    label: string | undefined;
    /** Data type definition that controls formatting of value */
    dataType: string | undefined;
    /** Sub-fields that can edited individually */
    editFields: MField[] | undefined;
    /** Options for select controls */
    dataTypeOptions: DataTypeOptions | undefined;
    /** Is Editable */
    editable: boolean;
    /** Tooltip displayed on hover */
    tooltip: MCard | undefined;
    /** Field is a header label only (no value will be displayed) */
    isLabelOnly: boolean;
    /** Optional Classname for ME to apply styling */
    className: string | undefined;
}

export interface DataTypeOptions {
    numDigitsAfterDecimal: number;
    nullable: boolean;
    minDate: Date;
    maxDate: Date;
    isMultiSelect: boolean;
    options: LabelValuePair[] | undefined;
    wrapMultiLineText: boolean;
}

export interface LabelValuePair {
    label: string | undefined;
    value: string | undefined;
}

/** Case Issue */
export interface CaseIssue2 {
    /** Id from the database table this history type came from */
    id: number;
    /** Enum for the type of history item */
    historyType: HistoryType;
    /** Date the log was created */
    dateCreated: Date;
    /** Notes on the log */
    details: string | undefined;
}

/** Mapping of appraisal statuses to case issue comment direction */
export interface CaseIssueCommentDirection {
    /** Used to identify which comments should be available to the end user, and which should be read-only 
i.e. QA can edit their comments but not an appraisers

Side note: This may be better as a right, but unsure whether or not we want to leverage rights to lock down
specific fields on a form.  */
    commentDirectionMap: { [key: string]: string; } | undefined;
}

export interface CaseIssueCommentDto {
    controlIdNumber: number;
    caseIssueComment: string | undefined;
}

/** Case Issue DTO */
export interface CaseIssueDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** Report Group */
    reportGroup: string | undefined;
    /** Display Group */
    displayGroup: string | undefined;
    /** Date Created */
    dateCreated: Date;
}

/** DTO for listing Case Issues */
export interface CaseIssuesDto {
    controlIdNumber: number;
    caseIssues: CaseIssueDto[] | undefined;
    caseIssueComments: string | undefined;
    policyHolderFirstName: string | undefined;
    policyHolderLastName: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
}

/** Case Issue Type Codes */
export interface CaseIssueUserTypeCodes {
}

/** Add Case Link Model */
export interface CaseLinkAddRequest {
    /** User who is linking the case */
    internetUserId: number;
    /** Notes related to linked case */
    notes: string | undefined;
    /** Parent control number */
    controlIdNumber: number;
    /** Case that is linked to parent */
    linkedControlIdNumber: number;
}

/** Case Link Response */
export interface CaseLinkResponse {
    /** Primary key of CaseLink */
    id: number;
    /** Linked Case Control Number */
    linkedControlIdNumber: number;
    /** Policy number of linked case */
    policyNumber: string | undefined;
    /** Customer Related information to linked case */
    customer: CustomerListResponse | undefined;
    /** Appraiser Assigned (if applicable) */
    appraiserAssigned: AppraiserListDto | undefined;
    /** Field Rep Assigned (if applicable) */
    inspectorAssigned: NameNumberDto | undefined;
    /** survey type information related to linked case */
    surveyType: SurveyTypeListDto | undefined;
    /** Notes associated to linked case. */
    note: string | undefined;
    /** Date completed associated to linked case */
    dateCompleted: Date | undefined;
}

export interface CaseListRequest {
    caseIds: number[] | undefined;
}

export interface CaseListResponse {
    cases: CaseResponse[] | undefined;
}

export interface CaseResponse {
    caseLocation: CaseLocationResponse | undefined;
    dateOrdered: Date | undefined;
    dateAssigned: Date | undefined;
    dateEffective: Date | undefined;
    dateFieldRepDue: Date | undefined;
    dateFieldRepDueRaw: Date | undefined;
    inspectorDueDateExtensionDays: number | undefined;
    inspectionTypeId: number;
    inspectionType: string | undefined;
    supplementTypes: string[] | undefined;
    inspectionAddress: AssignmentAddress | undefined;
    mailingAddress: AssignmentAddress | undefined;
    webNotes: string | undefined;
    directionsNotes: string | undefined;
    privateNotes: string | undefined;
    rejectionNotes: string | undefined;
    total: number;
    mac: number;
    canineSupplement: boolean;
    woodStove: boolean;
    indicators: string | undefined;
    siteTime: number;
    webTime: number;
    insuredFirstName: string | undefined;
    insuredLastName: string | undefined;
    policyholderPhoneHome: string | undefined;
    policyholderPhoneWork: string | undefined;
    customerName: string | undefined;
    agencyName: string | undefined;
    agencyCode: string | undefined;
    agencyPhone: string | undefined;
    insuranceStatus: string | undefined;
    daysInStatus: number | undefined;
    /** Rule to limit appraiser who can be assigned based on experience */
    customer: CustomerListResponse | undefined;
    /** List of appraisers that can't work on this Customers cases */
    appraiserExclusionLists: AppraiserExclusionListDto | undefined;
    /** List of Inspectors that can't work on this Customers cases */
    inspectorExclusionLists: InspectorExclusionListDto | undefined;
    appraisalStatus: string | undefined;
    driveTime: number;
    /** Field inspection appointment date */
    fieldAppointmentDate: Date | undefined;
    /** Field inspection Inspected date */
    fieldInspectedDate: Date | undefined;
    /** Survey type group code */
    surveyTypeGroupCode: string | undefined;
}

/** An Inspector List of Exclusions */
export interface InspectorExclusionListDto {
    /** Inspector Basic Information */
    inspectorsExclusionList: InspectorExclusionDto[] | undefined;
}

/** Inspector Exclusions Information */
export interface InspectorExclusionDto {
    /** Customer Exclusion Primary Key */
    id: number;
    /** Inspector Basic Information */
    inspectors: InspectorListDto;
    /** Date Added to Exclusion List */
    createDate: Date;
    /** Created by user display name */
    createdByUserEmail: string;
    /** Optional comments regarding exclusion */
    comments: string | undefined;
}

/** Inspector List Information */
export interface InspectorListDto extends NameNumberDto {
    /** Primary key of Inspector */
    id: number;
}

export interface CaseLocationListResponse {
    caseLocations: CaseLocationResponse[] | undefined;
}

/** Case Log detail dto */
export interface CaseLogDto {
    /** Control Id Number */
    controlIdNumber: number;
    /** Miles actual driven to get to case */
    milesDriven: number | undefined;
    /** Total Travel Hours to get to case */
    travelHours: number | undefined;
    /** Total time on site doing inspection */
    fieldHours: number | undefined;
    /** Total Time to write up report on website  */
    webHours: number | undefined;
    /** Total Minutes */
    totalHours: number;
}

/** Detail of the stop point when filling out the FR case log mileage */
export interface CaseLogWayPointDto {
    /** Order of travel points */
    order: number;
    /** Full address of destination */
    fullAddress: string | undefined;
    /** Case They came from (if applicable) */
    controlIdNumberFrom: number | undefined;
    /** Description of Waypoint Type */
    wayPointTypeName: string | undefined;
}

/** Define a UI menu item. */
export interface CaseMenuItem {
    /** The unique Id of the menu item */
    id: string | undefined;
    /** Item name - not displayed */
    name: string | undefined;
    /** Optional Component - when set, this is the React Component to use. */
    component: string | undefined;
    /** Optional Path - when Component is not set, this is a local or remote path to a webpage.  User should redirect to the new url. */
    path: string | undefined;
    /** Item is Visible or Hidden */
    visible: boolean;
    /** Displayed Title or name for the item */
    title: string | undefined;
    /** Displayed icon for the menu item */
    icon: string | undefined;
    /** Status icon properties for this case menu item */
    statusIcons: CaseMenuStatusIcons | undefined;
    /** Status indicators for the case form */
    itemStatus: string | undefined;
    /** Indicator for whether or not item is shown */
    isShow: boolean;
    /** Sub menu for this menu */
    menuItems: CaseMenuItem[] | undefined;
}

export interface CaseMenuStatusIcons {
    dirty: { [key: string]: string; } | undefined;
    saving: { [key: string]: string; } | undefined;
    validateFailed: { [key: string]: string; } | undefined;
    saveError: { [key: string]: string; } | undefined;
    saveSuccessValidateFailed: { [key: string]: string; } | undefined;
    saveSuccess: { [key: string]: string; } | undefined;
    needsRefresh: { [key: string]: string; } | undefined;
    closedComps: { [key: string]: string; } | undefined;
    openedComps: { [key: string]: string; } | undefined;
}

export interface CaseMenuViewModel {
    /** Array of menu items. */
    menuItems: CaseMenuItem[] | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCaseNoteTypeCodes extends TypeSafeEnum {
}

/** Codes for the CaseNoteTypes table */
export interface CaseNoteTypeCodes extends TypeSafeEnumOfCaseNoteTypeCodes {
}

/** Flattened Case Notification model */
export interface CaseNotification {
    /** Id */
    notificationsId: number;
    /** Control Number */
    controlIdNumber: number;
    /** Date notification was sent */
    sentDate: Date;
    /** Notification type code */
    code: string | undefined;
    /** Details */
    notes: string | undefined;
    /** Indicates that this notification is flagged to be re-sent */
    isSending: boolean;
}

/** Take a case off hold request */
export interface CaseOffHoldRequest {
    /** Case to take off Hold */
    controlIdNumber: number;
    /** UserId of person removing hold */
    internetUserId: number;
}

/** Put a case on hold request */
export interface CaseOnHoldRequest {
    /** Case to put on Hold */
    controlIdNumber: number;
    /** UserId of person putting on hold */
    internetUserId: number;
    /** Specify the date for on hold */
    endDate: Date | undefined;
    /** Note for On Hold status */
    note: string | undefined;
}

/** Response from putting a case on/off hold */
export interface CaseOnHoldResponse {
    /** Case that was put on/off Hold */
    controlIdNumber: number;
    /** If the hold change was successful or not */
    success: boolean;
    /** Message */
    message: string | undefined;
}

/** Lits of Cases in the payroll the MAC */
export interface CasePaymentMAC {
    /** Control ID Number */
    controlIdNumber: number;
    /** Inspector Number */
    inspectorNumber: number;
    /** Mueller Anticipated Cost */
    mac: number;
    /** Survey City */
    surveyCity: string | undefined;
    /** Survey Class */
    surveyClass: string | undefined;
}

/** Case Payment Request Object */
export interface CasePaymentPendingRequest {
    /** ControlIDNumber */
    controlIdNumber: number;
    /** Logged in user id */
    internetUserId: number;
    /** Amount to be added */
    amount: number;
    /** Type of payment */
    casePaymentTypeCode: string | undefined;
    /** transaction type you want */
    paymentTransactionTypeCode: string | undefined;
}

/** Case Payment Types */
export interface CasePaymentTypeCode {
}

/** Case Payment Types */
export enum CasePaymentTypeEnum {
    FieldRep = 1,
    QualityAssurance = 2,
    Appraiser = 3,
}

/** Data transfer object representing the analysis results of a case photo. */
export interface CasePhotoAnalysisDto {
    /** unique identifier */
    id: number;
    /** Case control number */
    controlIdNumber: number;
    /** Photo Id */
    photoId: string;
    /** Photo analysis result type id */
    photoAnalysisResultTypeId: number;
    /** Result score */
    resultScore: number | undefined;
    /** Result boolean */
    resultBoolean: boolean | undefined;
    /** Analysis result type code */
    photoAnalysisResultTypeCode: string | undefined;
    /** Photo classifications */
    photoAnalysisClassifications: CasePhotoClassificationMainResultDto[] | undefined;
}

/** Data transfer object representing the main classification results of a case photo. */
export interface CasePhotoClassificationMainResultDto {
    /** unique identifier */
    id: number;
    /** result id */
    casePhotoAnalysisResultId: number;
    /** Classification id */
    photoAnalysisClassificationId: number;
    /** Score / confidence */
    score: number | undefined;
    /** Classification name */
    classification: string | undefined;
    /** Sub classifications */
    casePhotoClassificationSubResults: CasePhotoClassificationSubResultDto[] | undefined;
}

/** Data transfer object representing the sub-classification results of a case photo. */
export interface CasePhotoClassificationSubResultDto {
    /** unique identifier */
    id: number;
    /** main classification result id */
    casePhotoClassificationMainResultId: number;
    /** classification id */
    photoAnalysisClassificationId: number;
    /** Score / confidence */
    score: number | undefined;
    /** Classification name */
    classification: string | undefined;
}

/** Collection of Case Photos */
export interface CasePhotos {
    /** Wrappable Id - used by the Frontend to load the right React component
             */
    wrappableId: string | undefined;
    /** Control id number for post back
             */
    controlNumber: number;
    /** Private Notes text
             */
    isReadOnly: boolean;
    /** Template that the client can call to render the old asp code in an Iframe.
             */
    iframeUrlTemplate: string | undefined;
    /** Collection of deserialized Photo objects  */
    photoList: Photo[] | undefined;
    /** Indicates that this case has a completed Mueller@Home request. */
    atHomeCompleted: boolean;
}

export interface Photo {
    photoUrl: string | undefined;
    /** UUID from PNX Services */
    photoID: string | undefined;
    photoTags: string | undefined;
    photoTagList: string[] | undefined;
    photoDescription: string | undefined;
    latitude: number;
    longitude: number;
}

/** Results summary from post auto QA rules */
export interface CasePostAutoQaResult {
    /** List of notes */
    postAutoQaReasonNotes: string[] | undefined;
    /** Case status change already handled */
    caseStatusAlreadyChanged: boolean;
    /** Post Auto QA rule names that were run */
    postAutoQaRuleNames: string[] | undefined;
}

/** Post Auto QA result */
export interface CasePostAutoQaRuleResult {
    /** Informational messages */
    postAutoQaReasonNotes: string[] | undefined;
    /** If true tells the rule processor to not change the case status */
    caseStatusAlreadyChanged: boolean;
}

/** Strongly typed Codes for CaseProcessStatuses */
export interface CaseProcessStatus {
}

/** Strongly typed Codes for CaseProcessStatusTags */
export interface CaseProcessStatusTag {
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCaseProcessType extends TypeSafeEnum {
}

/** Strongly typed Codes for CaseProcessTypes */
export interface CaseProcessType extends TypeSafeEnumOfCaseProcessType {
}

/** Result of call to Queue a case */
export enum CaseQueueEligibility {
    Unknown = 0,
    Ineligible = 1,
    NoFieldCoverage = 2,
    Eligible = 3,
}

/** Result of call to Queue a case */
export enum CaseQueueResult {
    Unknown = 0,
    Success = 1,
    Failed = 2,
    AlreadyInQueue = 3,
}

/** Wrapper for the survey remarks */
export interface CaseRemarks {
    /** Survey remarks for the case
             */
    surveyRemarks: string | undefined;
    privateNotes: string | undefined;
    closeOutNotes: string | undefined;
    appointmentDirections: string | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCaseReturnType extends TypeSafeEnum {
}

/** Codes for CloseOutReasons table */
export interface CaseReturnType extends TypeSafeEnumOfCaseReturnType {
}

/** Data class for Cases_Get_PDFExportSettings */
export interface CasesGetPdfExportSettingsResult {
    /** ControlIdNumber */
    controlIDNumber: number;
    /** Account number associated with the export settings. */
    accountNumber: number;
    /** Code representing the notification types. */
    notificationTypesCode: string | undefined;
    /** State abbreviation. */
    stateAbbreviation: string | undefined;
    /** Policy number. */
    policyNumber: string | undefined;
    /** Tracking number for the case. */
    trackingNumber: string | undefined;
    /** Effective date of the export settings. */
    effectiveDate: Date | undefined;
    /** Agency code. */
    agencyCode: string | undefined;
    /** Stack code. */
    stackCode: string | undefined;
    /** Name of the file template. */
    fileTemplateName: string | undefined;
    /** Indicates whether local folder storage is enabled. */
    localFolderEnabled: boolean;
    /** Destination path for export. */
    destinationPath: string | undefined;
    /** Indicates whether PGP encryption is enabled. */
    pgpEnabled: boolean;
    /** PGP encryption sender. */
    pgpEncryptSender: string | undefined;
    /** PGP encryption recipient. */
    pgpEncryptRecipient: string | undefined;
    /** PGP encryption sender password. */
    pgpEncryptSenderPassword: string | undefined;
    /** Indicates whether FTP is enabled. */
    ftpEnabled: boolean;
    /** Indicates whether files should be uploaded to the FTP server. */
    ftpUploadToServer: boolean;
    /** Path for FTP uploads. */
    ftpUploadToPath: string | undefined;
    /** Username for FTP upload. */
    ftpUploadToUsername: string | undefined;
    /** Password for FTP upload. */
    ftpUploadToPassword: string | undefined;
    /** Indicates whether passive mode is used for FTP uploads. */
    ftpUploadToUsePassive: boolean;
    /** Indicates whether SSL is enabled for FTP connections. */
    ftpEnableSSL: boolean;
    /** Custom class associated with export settings. */
    customClass: string | undefined;
    /** Date when the export was received. */
    dateReceived: Date | undefined;
    /** Underwriter code. */
    uwCode: string | undefined;
    /** Date when the export was processed. */
    exportDate: Date;
}

/** Status defines for updating the case header Status fields (Primary and/or SecondaryStatus. */
export interface CaseStatusCodes {
}

/** DTO for Case Status Tracking - In support of Status Tracker display in Mueller Enterprise */
export interface CaseStatusTracker {
    /** Indicates whether or not the status tracker is enabled. Access is controlled 
through a customer feature.  */
    trackerFeatureEnabled: boolean;
    /** Maps rank to display-friendly status codes */
    availableStatuses: string[] | undefined;
    /** The highest status rank for the case */
    currentStatusRank: number | undefined;
    /** Indicator for whether or not the case is closed/cancelled */
    isClosed: boolean;
}

/** Used to add a new CaseTimeLog */
export interface CaseTimeLogAddDto {
    /** Control Number of the case */
    controlIdNumber: number;
    /** User assigned to time log */
    internetUserId: number;
    /** Date of Work */
    workDate: Date;
    /** Type of work */
    workTypeId: number;
    /** Log Minutes */
    timeMinutes: number;
    /** Resolution Code */
    resolutionCode: string | undefined;
}

/** Delete log dto */
export interface CaseTimeLogDeleteDto {
    /** Primary Key */
    caseTimeLogId: number;
}

/** Is the listing of case time logs */
export interface CaseTimeLogDto {
    /** Case Time Log Unique Id */
    id: number;
    /** ControlIdNumber */
    controlIdNumber: number;
    /** WorkTypeId */
    workTypeId: number;
    /** Date of Work */
    workDate: Date;
    /** Is this time log allowed to be edited */
    isEditable: boolean;
    /** Minutes logged */
    timeMinutes: number;
    /** User Id who logged the time */
    internetUserId: number;
    /** Pay period this time log was entered in */
    payPeriod: PayPeriodDto | undefined;
    /** Date log was created (Eastern Time) */
    createDate: Date;
    /** Users local time log started */
    startDateTimeLocal: Date;
    /** users local time log ended */
    endDateTimeLocal: Date;
    /** Time Log Work Type name */
    workTypeName: string | undefined;
    /** Case Survey Address */
    surveyAddress: string | undefined;
    /** Case Survey City */
    surveyCity: string | undefined;
    /** Case Survey State */
    surveyState: string | undefined;
    /** Case Survey Zip code */
    surveyZipCode: string | undefined;
    /** Case Survey Type */
    surveyTypeName: string | undefined;
    /** User who entered the time */
    userName: string | undefined;
    /** First + " " + Last Name */
    fullName: string | undefined;
    /** Appraisal Expected Minutes */
    appraisalExpectedMinutes: number | undefined;
    /** Total minutes of this worktype from previous time logs */
    workTypePreviousMinutes: number | undefined;
    /** Total minutes of this worktype from previous time logs for this user */
    workTypePreviousMinutesForUser: number | undefined;
    /** True if the case is completed */
    caseIsCompleted: boolean;
    /** True if the appraiser is completed with the appraiser (ie submitted to QA2 / not editable) */
    isAppraiserCompleted: boolean;
    /** Appraisal status */
    appraisalStatusName: string | undefined;
    /** True if QA is completed with the case */
    isQaCompleted: boolean;
    /** QA completed field review */
    isFieldReviewCompleted: boolean;
    /** QA Field Review Expected Minutes */
    fieldReviewExpectedMinutes: number;
    /** QA2 completed appraisal review */
    isAppraisalReviewCompleted: boolean;
    /** QA2 Appraisal review expected minutes */
    appraisalReviewExpectedMinutes: number;
    /** QA Field Review completed date */
    fieldReviewCompletedDate: Date | undefined;
    /** QA2 Appraisal completed date */
    appraisalReviewCompletedDate: Date | undefined;
    /** Pay rate that was applicable during the pay period */
    payRate: number | undefined;
}

/** Dto for a pay period */
export interface PayPeriodDto {
    /** primary key */
    payPeriodId: number;
    /** Beginning day of pay period */
    fromDate: Date;
    /** end day of pay period */
    toDate: Date;
    toDateStartOfNextDay: Date;
    /** Date time the pay period is closed */
    closedDateTime: Date | undefined;
    /** Bonus Week Type */
    bonusWeekType: BonusWeekType;
    /** display of pay period.  Ex: $"{FromDate:yyyy/MM/dd} to {ToDate:yyyy/MM/dd}" */
    fromToDisplay: string | undefined;
    /** Is pay period closed for editing */
    isClosed: boolean;
    /** The list of all the days in the pay period from date to end date */
    days: Date[] | undefined;
}

/** Used to get a list of CaseTimeLogFeedback Categories */
export interface CaseTimeLogFeedbackCategoriesDto {
    /** Category */
    category: string | undefined;
    /** SubCategories */
    subCategories: SubCategoryDto[] | undefined;
}

/** Grouping of subcategories */
export interface SubCategoryDto {
    /** SubCategory */
    subCategory: string | undefined;
    /** Code */
    code: string | undefined;
    /** Tooltip for the reason */
    tooltip: string | undefined;
}

/** Used to add a CaseTimeLog Feedback */
export interface CaseTimeLogFeedbackDto {
    /** Control Number of the case */
    controlIdNumber: number;
    /** User assigned to time log */
    internetUserId: number;
    /** Creation date of the feedback */
    createDate: Date;
    /** Feedback Reasons */
    reason: Reason;
}

/** CaseTimeLog Feedback Reasons */
export interface Reason {
    /** Category of Reason */
    reasonComments: string | undefined;
    /** Reason SubCategories */
    reasonCodes: string[] | undefined;
}

/** Used to update CaseTimeLog */
export interface CaseTimeLogUpdateDto {
    /** Primary Key of Row to update. */
    caseTimeLogId: number;
    /** Date of Work */
    workDate: Date;
    /** Type of work */
    workTypeId: number;
    /** Log Minutes */
    timeMinutes: number;
}

/** Client side model for Case Time Logs */
export interface CaseTimeLogViewModel {
    /** QA completed field review */
    isFieldReviewCompleted: boolean;
    /** QA Field Review Expected Minutes */
    fieldReviewExpectedMinutes: number;
    /** QA2 completed appraisal review */
    isAppraisalReviewCompleted: boolean;
    /** QA2 Appraisal review expected minutes */
    appraisalReviewExpectedMinutes: number;
    /** Current status of appraisal */
    appraisalStatusName: string | undefined;
    /** True if the primary case status is completed */
    caseIsCompleted: boolean;
    /** True if the appraisal is completed (ie not editable by the appraiser) */
    isAppraiserCompleted: boolean;
    /** Total minutes of this worktype for this user from previous time logs */
    workTypePreviousMinutesForUser: number | undefined;
    /** Total minutes of this worktype from previous time logs */
    workTypePreviousMinutes: number | undefined;
    /** Expected appraisal minutes */
    appraisalExpectedMinutes: number | undefined;
    /** User that logged the time. */
    userName: string | undefined;
    /** Case Time Log ID */
    id: number;
    /** Case Id */
    controlIdNumber: number;
    /** User ID */
    internetUserId: number;
    /** Work Date  */
    workDate: Date;
    /** Work Type */
    workTypeId: number;
    /** Work Type Description */
    workTypeName: string | undefined;
    /** Time Logged in Minutes */
    timeMinutes: number;
    /** Date entry was made (Eastern Time) */
    createDate: Date;
    /** Users local time log started */
    startDateTimeOffset: Date;
    /** users local time log ended */
    endDateTimeOffset: Date;
    /** Pay Period the time was applied to */
    payPeriod: PayPeriodDto | undefined;
    /** Time entry is editible or not. */
    isEditable: boolean;
    /** Survey Type Name */
    surveyTypeName: string | undefined;
    /** Survey Address */
    surveyAddress: string | undefined;
}

/** Work type for a CaseTimeLog */
export enum CaseTimeLogWorkTypeEnum {
    WRITE_UP = 1,
    ON_SITE = 2,
    DRIVE = 3,
    VALUATION_REVIEW = 4,
    VALUATION = 5,
    FIELD_REVIEW = 6,
    FS_SCHEDULING = 7,
    FS_REVIEW_AUDIT = 8,
    FS_REVIEW_AUDIT_FEEDBACK = 9,
}

/** Case Time Log Work Type lookup */
export interface CaseTimeLogWorkTypeViewModel {
    /** Work Type Id */
    id: number;
    /** Work Type Code */
    code: string | undefined;
    /** Work Type Name */
    name: string | undefined;
    /** Work Type Description */
    description: string | undefined;
}

/** Model for Case to Inspector Case Coordinates */
export interface CaseToInspectorCaseDto {
    /** Case to Be assigned location */
    caseToBeAssignedCoordinate: Coordinate | undefined;
    /** List of CaseAutoAssignmentInspectorCase to be updated */
    caseAutoAssignmentInspectorCases: CaseAutoAssignmentInspectorCase[] | undefined;
}

/** Lat / long point */
export interface Coordinate {
    /** Latitude  */
    latitude: number;
    /** Longitude  */
    longitude: number;
}

/** Model for Case to Inspector Coordinates */
export interface CaseToInspectorDto {
    /** Case to Be assigned location */
    caseToBeAssignedCoordinate: Coordinate | undefined;
    /** Inspector location */
    inspectorCoordinate: Coordinate | undefined;
    /** CaseAutoAssignmentInspector record for updating */
    caseAutoAssignmentInspector: CaseAutoAssignmentInspector | undefined;
}

/** Touch */
export interface CaseTouch {
    /** Id from the database table this history type came from */
    id: number;
    /** Enum for the type of history item */
    historyType: HistoryType;
    /** Date the log was created */
    dateCreated: Date | undefined;
    /** Type of Touch */
    touchType: string | undefined;
    /** Code for Touch Type */
    touchTypeCode: string | undefined;
    /** Notes on the log */
    details: string | undefined;
    /** Who performed the action */
    performedBy: string | undefined;
}

/** Model for Adding a case touch */
export interface CaseTouchAddRequest {
    /** Control ID Number */
    controlIdNumber: number;
    /** TouchType Code from Mueller.Business.Models.TouchTypes.TouchTypeCodes */
    touchTypeCode: string;
    /** Touch Note */
    note: string | undefined;
}

/** Travel Point base request */
export interface CaseTravelLogPointBaseRequest {
    /** Inspector that is saving the log */
    inspectorId: number;
    /** The start datetime local the inspector started driving */
    startDateTime: Date;
    /** Miles Driven */
    milesDriven: number;
    /** What type of place did they come from (home, other case, other address) */
    pointFromType: CaseTravelLogPointFromType;
    /** From Address is PointFromType = Other */
    fromAddress: Address | undefined;
    /** Case they came from if PointFromType = Other Case */
    fromControlIdNumber: number | undefined;
    /** Did they go back home from this case */
    backHome: boolean;
}

/** Case Travel Log add Request */
export interface CaseTravelLogAddRequest extends CaseTravelLogPointBaseRequest {
    /** Control Number the log is associated with */
    controlIdNumber: number;
}

/** Point "From".  Where did they come from to get to the case */
export enum CaseTravelLogPointFromType {
    AnotherCase = 1,
    Home = 2,
    Other = 3,
}

/** Case Travel Logs Get By Case Reponse */
export interface CaseTravelLogDto {
    /** Primary key of case travel log */
    id: number;
    /** case id */
    controlIdNumber: number;
    /** inspector */
    inspector: InspectorListDto | undefined;
    /** Miles Driven */
    milesDriven: number;
    /** Start Date Time Local */
    startDateTimeLocal: Date;
    /** "Point From" type */
    pointFromType: CaseTravelLogPointFromType;
    /** Pay Period info */
    payPeriod: PayPeriodDto | undefined;
}

/** Case travel log update request */
export interface CaseTravelLogUpdateRequest extends CaseTravelLogPointBaseRequest {
    /** Id of the row to be updated */
    id: number;
}

/** Case Types */
export enum CaseTypes {
    Insurance = 1,
    Valuation = 2,
}

/** Underwriter actions for a single case */
export interface CaseUnderwriterActionsDto {
    /** The case control ID number */
    controlNumber: number;
    /** The last date the an action was added */
    date: Date | undefined;
    /** Underwriter action comments */
    comments: string | undefined;
    /** Reviewer name */
    reviewerName: string | undefined;
    /** List of current actions */
    caseActions: UnderwriterActionDto[] | undefined;
    /** List of available actions */
    customerActions: UnderwriterActionDto[] | undefined;
}

/** Represents actions that an underwriter can take or has taken */
export interface UnderwriterActionDto {
    /** Underwriter action ID */
    id: number;
    /** Underwriter action name */
    name: string | undefined;
    /** Unique action code */
    code: string | undefined;
    /** Identifies Mueller default action */
    isDefault: boolean;
    /** Indicates if the action is user-selectable */
    isUserSelectable: boolean;
}

/** Case User timer request to start */
export interface CaseUserTimerStartRequest {
    /** User */
    internetUserId: number;
    /** Control Id Number */
    controlIdNumber: number;
}

/** A watch that has been applied to a case */
export interface CaseWatchDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** Case event type ID */
    caseEventTypeId: number;
    /** Internet user ID */
    internetUserId: number;
    /** Watch is enabled */
    enabled: boolean;
    /** Email address */
    emailAddress: string | undefined;
}

/** Case watch notification DTO */
export interface CaseWatchNotificationDto {
    /** Destination email addresses */
    to: string[] | undefined;
    /** Email body */
    body: string | undefined;
}

/** Data Structure for organizing data inside a grid cell */
export interface CellViewModel_1 {
    /** ID of a cell */
    ControlNumber: string | undefined;
    /** Value rendered in the grid */
    Value: T | undefined;
}

/** View Model for Changing the current user's password page */
export interface ChangePasswordViewModel {
    /** username */
    username: string;
    /** old password */
    oldPassword: string;
    /** new password */
    newPassword: string;
}

export enum ChangeType {
    Same = 0,
    Modified = 1,
    Added = 2,
    Removed = 3,
}

/** Form Data Change Type Constants */
export interface ChangeTypesNames {
}

export interface ChartImage {
    imageSrc: string | undefined;
    imageAlt: string | undefined;
}

/** Slim verion of CaseContactMethods_vw */
export interface CleanContactMethod {
    /** Contact method value, e.g. phone number or email address */
    value: string | undefined;
    /** Contact type code from Mueller.Business.Models.ContactMethods.ContactTypeCodes */
    contactTypeCode: string | undefined;
}

/** Options for Closing a case */
export enum CloseCaseNextStep {
    SendToQa = 0,
    SendToBilling = 1,
}

/** Close out case request information */
export interface CloseCaseRequest extends CancelRequest {
    /** The return type used on the close out form */
    returnType: CaseReturnType;
    /** What step to go to next */
    nextStep: CloseCaseNextStep;
}

/** Close Out Reason Codes */
export interface CloseOutReasonCodes {
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfClosingAppointmentEfforts extends TypeSafeEnum {
}

/** Closing appointment efforts process */
export interface ClosingAppointmentEfforts extends TypeSafeEnumOfClosingAppointmentEfforts {
}

/** Class to use for any Look up and Drop-downs to be display in the front end and to pass the code */
export interface CodeValuePair {
    /** Unique String Identifier for the Name */
    code: string | undefined;
    /** Name corresponding to the code */
    name: string | undefined;
}

/** SSO parameters */
export interface CollateralAnalyticsImportRequest {
    controlNumber: number;
    searchResultsDataXml: string | undefined;
}

/** SSO parameters */
export interface CollateralAnalyticsImportResult {
    comparableDataImportResults: ComparableDataImportResult[] | undefined;
}

export interface ComparableDataImportResult {
    dataProviderName: string | undefined;
    receiverName: string | undefined;
    /** Errors from the data provider */
    providerErrors: string[] | undefined;
    /** Errors from the data receiver */
    receiverErrors: string[] | undefined;
}

/** View model class for CollateralAnalyticsRiskProfilerResultDetail */
export interface CollateralAnalyticsRiskProfilerResultDetailDto {
    /** Primary key */
    id: number;
    /** Foreign key to CollateralAnalyticsRiskProfilerResult */
    collateralAnalyticsRiskProfilerResultId: number;
    /** The risk level of this question */
    riskLevelName: string | undefined;
    /** C/A rule / risk id */
    ruleRiskId: number | undefined;
    /** Rule question */
    ruleQuestion: string | undefined;
    /** Rule result */
    ruleResult: string | undefined;
}

/** View model class for CollateralAnalyticsRiskProfilerResult */
export interface CollateralAnalyticsRiskProfilerResultDto {
    /** primary key */
    id: number;
    /** Related case */
    controlIdNumber: number;
    /** Datetime the request was started */
    createdDateUtc: Date;
    /** The C/A response id */
    responseId: string | undefined;
    /** Datetime the results came back */
    resultsDateUtc: Date | undefined;
    /** Risk Level */
    riskLevelName: string | undefined;
    /** Grade / Score */
    riskLevelScore: number | undefined;
    /** The risk profiler result details */
    collateralAnalyticsRiskProfilerResultDetails: CollateralAnalyticsRiskProfilerResultDetailDto[] | undefined;
}

/** Structure for json in the COLLATERAL_ANALYTICS_RISK_PROFILER_RULESETS appsetting */
export interface CollateralAnalyticsRiskProfilerRuleset {
    /** Ruleset name */
    rulesetName: string | undefined;
    /** C/A username */
    username: string | undefined;
    /** C/A password */
    password: string | undefined;
}

/** SSO parameters */
export interface CollateralAnalyticsSsoDto {
    /** The Collateral Analytics SSO url to send the parameters to */
    ssoSignOnUrl: string | undefined;
    /** URL encoded query string parameters to send */
    ssoSignOnUrlQuerystring: string | undefined;
    /** The parameters to send to the SSO in case a form post is required */
    ssoSignOnParameters: CollateralAnalyticsSsoParametersDto | undefined;
}

/** Parameters to send to Collateral Analytics SSO link */
export interface CollateralAnalyticsSsoParametersDto {
    /** Encrypted authentication string */
    auth: string | undefined;
    /** Client ID */
    cid: string | undefined;
    /** Product ID */
    pid: string | undefined;
    /** Unique ID */
    uid: string | undefined;
    /** Account ID */
    aid: string | undefined;
    /** Loan number */
    loan: string | undefined;
    /** Subject street address */
    add: string | undefined;
    /** Subject unit number */
    unit: string | undefined;
    /** Subject city */
    cit: string | undefined;
    /** Subject state abbreviation */
    sta: string | undefined;
    /** Subject zip code */
    zip: string | undefined;
    /** True to block address changes */
    lockAddress: boolean;
}

/** Constants for the Collateral Analytics Product Types */
export interface CollateralAnalyticsSsoProductTypeNames {
}

/** SSO parameters */
export interface CollateralAnalyticsSsoRequest {
    /** The case control number */
    controlNumber: number;
    /** The Unique identifier sent to Collateral Analytics */
    uniqueIdentifier: string | undefined;
}

/** SSO parameters */
export interface CollateralAnalyticsSsoRequestWithType extends CollateralAnalyticsSsoRequest {
    /** The product type to send to Collateral Analytics */
    productType: string | undefined;
}

export interface Column {
    goalValue: number | undefined;
    id: string | undefined;
    troubleValue: number | undefined;
    formatString: string | undefined;
}

/** Attribute for setting properties of quicklist column definition */
export interface ColumnDefinitionAttribute extends Attribute2 {
    /** Name */
    name: string | undefined;
    /** Key */
    key: string | undefined;
    /** Data source */
    dataSource: string | undefined;
    /** Column code */
    columnCode: MGridColumnCode;
    /** Data type */
    dataType: MGridDataType;
    /** Column width */
    width: number;
    /** Is default column */
    isDefault: boolean;
}

export enum MGridColumnCode {
    COL_CODE_CONTROL_NUMBER = 0,
    COL_CODE_DAYS_IN_VS = 1,
    COL_CODE_DAYS_IN_STATUS = 2,
    COL_CODE_APPRAISAL_STATUS = 3,
    COL_CODE_FIELD_STATUS = 4,
    COL_CODE_LAST_NOTE = 5,
    COL_CODE_SURVEY_ADDRESS = 6,
    COL_CODE_CITY = 7,
    COL_CODE_STATE = 8,
    COL_CODE_APPRAISER_ASSIGNED = 9,
    COL_CODE_ORDERED_DATE = 10,
    COL_CODE_SCHEDULED_DATE = 11,
    COL_CODE_COMPLETED_DATE = 12,
    COL_CODE_DUE_DATE = 13,
    COL_CODE_INSPECTION_TYPE = 14,
    COL_CODE_CUSTOMER_NAME = 15,
    COL_CODE_CUSTOMER_NAME_NUMBER = 16,
    COL_CODE_POLICY_NUMBER = 17,
    COL_CODE_ZIP = 18,
    COL_CODE_POLICYHOLDER_NAME = 19,
    COL_CODE_FIELD_REP_ASSIGNED = 20,
    COL_CODE_CUSTOMER_NUMBER = 21,
    COL_CODE_LATITUDE = 22,
    COL_CODE_LONGITUDE = 23,
    COL_CODE_ADDRESS = 24,
    COL_CODE_FULL_NAME = 25,
    COL_CODE_SURVEY_TYPE = 26,
    COL_CODE_ORIGINAL_SURVEY_TYPE = 27,
    COL_CODE_RETURNED_DATE = 28,
}

/** Data types for MGrid component. See src\components\Shared\MGrid.js and src\typeConstants\dataTypes.js */
export enum MGridDataType {
    DATA_TYPE_NUMBER = 0,
    DATA_TYPE_NUMBER_RAW = 1,
    DATA_TYPE_NUMBER_UNFORMATTED = 2,
    DATA_TYPE_NUMBER_TENTHS = 3,
    DATA_TYPE_NUMBER_HUNDREDTHS = 4,
    DATA_TYPE_PERCENT_DECIMAL = 5,
    DATA_TYPE_MONEY = 6,
    DATA_TYPE_BOOLEAN = 7,
    DATA_TYPE_DATE = 8,
    DATA_TYPE_DATE_TIME = 9,
    DATA_TYPE_DATE_WITHDOW = 10,
    DATA_TYPE_DATETIME_WITHDOW = 11,
    DATA_TYPE_DAYS_ELAPSED = 12,
    DATA_TYPE_STRING = 13,
    DATA_TYPE_BUTTON = 14,
    DATA_TYPE_TEXT_BUTTON = 15,
    DATA_TYPE_NUMBER_NEGATIVE_OR_POSITIVE = 16,
}

/** Property details for Commercial web orders */
export interface CommercialPropertyInfo extends AddressInfo {
    /** Supplement codes */
    supplements: string[] | undefined;
    /** Year Built */
    yearBuilt: number | undefined;
    /** Building SqFt */
    sqFt: number | undefined;
    /** Construction Type Enumeration */
    constructionType: string | undefined;
}

/** Web order common details */
export interface WebOrderRequestBase {
    /** Customer Number */
    customerNumber: number;
    /** Inspection type code */
    surveyTypeCode: string;
    /** Order Code In */
    orderCodeIn: string | undefined;
    /** Case Mailing Address */
    mailingAddress: AddressInfo;
    /** Agent / Broker Info */
    agentInfo: AgentInfo | undefined;
    /** Comments */
    comments: string | undefined;
    /** Uploaded attachment Guids */
    attachments: string[] | undefined;
    /** Requested appointment details
  */
    appointment: AppointmentInfo | undefined;
    /** First day the case can be available for assignment */
    startDate: Date;
    /** How payment is being made */
    paymentType: PaymentType;
    /** Payment details */
    billing: BillingInfo | undefined;
    /** Order is a Rush */
    rush: boolean;
}

/** Web order details (Commerical Insurance) */
export interface CommercialWebOrderRequest extends WebOrderRequestBase {
    /** Name of the business */
    businessName: string;
    /** Business website */
    website: string | undefined;
    /** Business phone number */
    businessPhone: string | undefined;
    /** List of properties to inspect */
    inspections: CommercialPropertyInfo[] | undefined;
    /** Policy Number */
    policyNumber: string;
    /** Business Type:  N or R */
    businessType: string | undefined;
    /** Policy effective date */
    effectiveDate: Date | undefined;
    /** Underwriter code to assign this case to */
    underwriterCode: string | undefined;
    /** Coverage In */
    coverageIn: number | undefined;
}

/** Response for Commercial WebOrders (multi-property) */
export interface CommercialWebOrderResponse extends WebOrderResponseBase {
    /** Web Order Ids */
    webOrderIds: number[] | undefined;
}

export interface CommitDateViewModel {
    field: RCTFieldViewModel | undefined;
}

export interface RCTFieldViewModel {
    name: string | undefined;
    value: string | undefined;
    toolTipTitle: string | undefined;
    toolTipFields: RCTFieldViewModel[] | undefined;
}

export interface CommitRctMainStreetInformationResponse {
    error: string | undefined;
    warnings: string[] | undefined;
    replacementCostEstimate: number | undefined;
}

/** Broker mortgage company selection */
export interface CompanySettings {
    /** List of customer numbers the broker selected to order from */
    selectedCompanies: number[] | undefined;
}

export interface ComparableSearchForm {
    /** Wrappable Id - used by the Frontend to load the right React component */
    wrappableId: string | undefined;
    /** Control id number for post back */
    controlNumber: number;
    formName: string | undefined;
    comparablesURI: string | undefined;
    collateralURI: string | undefined;
    isReadOnly: boolean;
    displayNewComp: boolean;
    /** True if the Collateral Analytics comp search uses their SSO integration */
    collateralAnalyticsSsoEnabled: boolean;
    /** True if the Propmix integration is enabled */
    propMixEnabled: boolean;
}

/** Comparison chart response */
export interface ComparisonChartField {
    /** Field name */
    name: string | undefined;
    /** Expected value */
    expectedValue: string | undefined;
    /** Actual value */
    actualValues: string[] | undefined;
}

/** The comparables grid UI model */
export interface CompGrid {
    /** The subject property */
    subject: CompGridSubject | undefined;
    /** The comparable properties */
    comparables: CompGridComparable[] | undefined;
    /** History of the comparable properties that have been removed from the comps grid
Can be used to restore previously removed properties onto the comp grid */
    removedComparables: CompGridRemovedComparable[] | undefined;
    /** Adjustment settings */
    adjustmentFactorSettings: CompGridAdjustmentFactorSettings | undefined;
    /** Last saved date */
    lastSavedUtcDateTime: Date | undefined;
    /** Data Provider that provided this data */
    dataProvider: string | undefined;
}

export interface CompGridPropertyBase {
    /** A unique identifier for the property */
    muellerPropertyId: string | undefined;
    /** Old Id to replace in Phoenix if Id is changed by address change */
    oldId: string | undefined;
    /** Comparable type eg: Sold, List */
    comparableType: string | undefined;
    /** Address line 1 */
    addressLine1: string | undefined;
    /** Address  line 2 */
    addressLine2: string | undefined;
    /** City */
    addressCity: string | undefined;
    /** State */
    addressState: string | undefined;
    /** Postal code */
    addressPostalCode: string | undefined;
    /** The address location */
    geocodeLatitude: number | undefined;
    /** The address location */
    geocodeLongitude: number | undefined;
    /** Sale price */
    salePrice: number | undefined;
    /** Sale price */
    finalListPrice: number | undefined;
    /** Sale price per GLA */
    salePricePerGrossLivingArea: number | undefined;
    /** The data sources */
    dataSources: string | undefined;
    /** The verification sources */
    verificationSources: string | undefined;
    /** Comparison To Subject */
    comparisonToSubject: string | undefined;
    /** Comments */
    adjustmentComments: string | undefined;
    /** days on market */
    daysOnMarket: CompGridDaysOnMarket | undefined;
    /** section 1 */
    saleFinancingConcessions: CompGridSaleFinancingConcessions | undefined;
    /** section 2 */
    dateOfSaleTime: CompGridDateOfSaleTime | undefined;
    /** section 3 */
    location: CompGridLocation | undefined;
    /** section 4 */
    leasholdFeeSimple: CompGridLeaseholdFeeSimple | undefined;
    /** section 5 */
    site: CompGridSite | undefined;
    /** section 6 */
    view: CompGridView | undefined;
    /** section 7 */
    design: CompGridDesign | undefined;
    /** section 8 */
    quality: CompGridQuality | undefined;
    /** section 9 */
    actualAge: CompGridActualAge | undefined;
    /** section 10 */
    condition: CompGridCondition | undefined;
    /** section 11 */
    aboveGradeRooms: CompGridAboveGradeRooms | undefined;
    /** section 12 */
    grossLivingArea: CompGridGrossLivingArea | undefined;
    /** section 13 */
    belowGrade: CompGridBelowGrade | undefined;
    /** section 14 */
    belowGradeRooms: CompGridBelowGradeRooms | undefined;
    /** section 15 */
    functionalUtility: CompGridFunctionalUtility | undefined;
    /** section 16 */
    heatingCooling: CompGridHeatingCooling | undefined;
    /** section 17 */
    energyEfficientItems: CompGridEnergyEfficient | undefined;
    /** section 18 */
    garageCarport: CompGridGarageCarport | undefined;
    /** section 19 */
    porchPatioDeck: CompGridPorchPatioDeck | undefined;
    /** Pool */
    pool: CompGridPool | undefined;
    /** section 20 */
    fireplace: CompGridFireplace | undefined;
    /** section 21 */
    other: CompGridOther | undefined;
    /** section 22 */
    cdom: CompGridCDOM | undefined;
    /** section 23 */
    propertyType: CompGridPropertyType | undefined;
    /** section 24 */
    numOfUnits: CompGridNumOfUnits | undefined;
    /** section 25 */
    yearBuilt: CompGridYearBuilt | undefined;
    /** section 26 */
    numOfFloors: CompGridNumOfFloors | undefined;
    /** section 27 */
    floorLocation: CompGridFloorLocation | undefined;
    /** section 28 */
    monthlyRentalRate: CompGridMonthlyRentalRate | undefined;
    /** section 29 */
    belowGradeRoomCount: CompGridBelowGradeRoomCount | undefined;
    /** section 30 */
    unit1: CompGridAboveGradeRooms | undefined;
    /** section 31 */
    unit2: CompGridAboveGradeRooms | undefined;
    /** section 32 */
    unit3: CompGridAboveGradeRooms | undefined;
    /** section 33 */
    unit4: CompGridAboveGradeRooms | undefined;
    /** The primary photo for this comparable */
    primaryPhotoId: string | undefined;
}

export interface CompGridSubject extends CompGridPropertyBase {
}

export interface CompGridDaysOnMarket {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Days on market */
    daysOnMarket: string | undefined;
    /** Its adjustment */
    daysOnMarketAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
}

export interface CompGridSaleFinancingConcessions {
    /** The collapsed summary text line for sale type */
    summarySale: string | undefined;
    /** The summary sale adj amount */
    summarySaleAdjustmentAmount: number | undefined;
    /** The collapsed summary text line for financing */
    summaryFinancing: string | undefined;
    /** The summary financing adj amount */
    summaryFinancingAdjustmentAmount: number | undefined;
    /** sale type */
    saleType: string | undefined;
    /** Financing type */
    financingType: string | undefined;
    /** Financing Type Adjustment Amount */
    financingTypeAdjustmentAmount: number | undefined;
    /** The concession amount */
    concessionAmount: number | undefined;
    /** The other concession amount */
    concessionOtherAmount: number | undefined;
    /** adjustment amount */
    concessionAdjustmentAmount: number | undefined;
    /** adjustment amount */
    concessionOtherAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
}

export interface CompGridDateOfSaleTime {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Sale status */
    statusType: string | undefined;
    /** Date of sale */
    saleDate: Date | undefined;
    /** Date of contract */
    contractDate: Date | undefined;
    /** adjustment amount */
    saleDateAdjustmentAmount: number | undefined;
    /** adjustment amount */
    contractDateAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

export interface CompGridLocation {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The location rating */
    locationRating: string | undefined;
    /** The primary location type */
    locationType: string | undefined;
    /** The primary location description if other is selected as location type */
    locationType1Other: string | undefined;
    /** A secondary location type */
    locationType2: string | undefined;
    /** The primary location description if other is selected as location type */
    locationType2Other: string | undefined;
    /** adjustment amount */
    locationRatingAdjustmentAmount: number | undefined;
    /** adjustment amount */
    locationTypeAdjustmentAmount: number | undefined;
    /** The primary location adjustment if other is selected as location type */
    locationType1OtherAdjustmentAmount: number | undefined;
    /** adjustment amount */
    locationType2AdjustmentAmount: number | undefined;
    /** The primary location adjustment if other is selected as location type */
    locationType2OtherAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

export interface CompGridLeaseholdFeeSimple {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The type of leasehold */
    leaseholdFeeSimpleType: string | undefined;
    /** adjustment amount */
    leaseholdFeeSimpleTypeAdjustmentAmount: number | undefined;
}

export interface CompGridSite {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The land area in square feet */
    landAreaSquareFeet: number | undefined;
    /** The land area in acres */
    landAreaAcres: number | undefined;
    /** adjustment amount */
    landAreaSquareFeetAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

export interface CompGridView {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The view rating */
    viewRating: string | undefined;
    /** The type of view */
    viewType: string | undefined;
    /** The type of view */
    viewType2: string | undefined;
    /** adjustment amount */
    viewRatingAdjustmentAmount: number | undefined;
    /** adjustment amount */
    viewTypeAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
}

export interface CompGridDesign {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Attached Detached indicator */
    attachedDetached: string | undefined;
    /** Number of stories */
    stories: number | undefined;
    /** Design style */
    designStyle: string | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
}

export interface CompGridQuality {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** the quality rating */
    qualityRating: string | undefined;
    /** adjustment amount */
    qualityRatingAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

/** Actual age section */
export interface CompGridActualAge {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The structure age in years */
    ageYears: number | undefined;
    /** Is the age estimated */
    ageEstimated: boolean | undefined;
    /** Age adjustment */
    ageYearsAdjustmentAmount: number | undefined;
    /** Age estimated adjustment */
    ageEstimatedAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

export interface CompGridCondition {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Condition */
    conditionRating: string | undefined;
    /** adjustment amount */
    conditionAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

/** Above grade rooms section */
export interface CompGridAboveGradeRooms {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The collapsed summary adjustment amount */
    secondSummaryAdjustmentAmount: number | undefined;
    /** total room count */
    totalRoomCount: number | undefined;
    /** Bedroom count */
    bedroomCount: number | undefined;
    /** Bathroom count */
    fullBathroomCount: number | undefined;
    /** half bathroom count */
    halfBathroomCount: number | undefined;
    /** Total room adj amount */
    totalRoomCountAdjustmentAmount: number | undefined;
    /** Bedrooom count adj amount */
    bedroomCountAdjustmentAmount: number | undefined;
    /** Bathroom count adj amount */
    fullBathroomCountAdjustmentAmount: number | undefined;
    /** Half bathroom count adj amount */
    halfBathroomCountAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

export interface CompGridGrossLivingArea {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The gross living area */
    grossLivingArea: number | undefined;
    /** adjustment amount */
    grossLivingAreaAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

export interface CompGridBelowGrade {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Total square feet */
    totalSquareFeet: number | undefined;
    /** Finished square feet */
    finishedSquareFeet: number | undefined;
    /** exit type */
    basementExitType: string | undefined;
    /** adjustment amount */
    totalSquareFeetAdjustmentAmount: number | undefined;
    /** adjustment amount */
    finishedSquareFeetAdjustmentAmount: number | undefined;
    /** adjustment amount */
    basementExitTypeAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

export interface CompGridBelowGradeRooms {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Rec room count */
    recRoomCount: number | undefined;
    /** Bedroom count */
    bedroomCount: number | undefined;
    /** Full bathroom count */
    fullBathroomCount: number | undefined;
    /** Half bathroom count */
    halfBathroomCount: number | undefined;
    /** Other room count */
    otherRoomCount: number | undefined;
    /** adjustment amount */
    recRoomCountAdjustmentAmount: number | undefined;
    /** adjustment amount */
    bedroomCountAdjustmentAmount: number | undefined;
    /** adjustment amount */
    fullBathroomCountAdjustmentAmount: number | undefined;
    /** adjustment amount */
    halfBathroomCountAdjustmentAmount: number | undefined;
    /** adjustment amount */
    otherRoomCountAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
}

export interface CompGridFunctionalUtility {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The functional utility */
    functionalUtility: string | undefined;
    /** adjustment amount */
    functionalUtilityAdjustmentAmount: number | undefined;
}

export interface CompGridHeatingCooling {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Type of heating system */
    heatingType: string | undefined;
    /** Type of cooling system */
    coolingType: string | undefined;
    /** adjustment amount */
    heatingTypeAdjustmentAmount: number | undefined;
    /** adjustment amount */
    coolingTypeAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
}

export interface CompGridEnergyEfficient {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Energy efficient items */
    energyEfficientItems: string | undefined;
    /** adjustment amount */
    energyEfficientItemsAdjustmentAmount: number | undefined;
}

export interface CompGridGarageCarport {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Driveway type */
    drivewayType: string | undefined;
    /** Driveway capacity */
    drivewayCarCapacity: number | undefined;
    /** Garage type */
    carStorageType1: string | undefined;
    /** Garage attachment */
    carStorageAttachmentType1: string | undefined;
    /** Garage capacity */
    carStorageCarCapacity1: number | undefined;
    /** Garage type */
    carStorageType2: string | undefined;
    /** Garage attachment */
    carStorageAttachmentType2: string | undefined;
    /** Garage capacity */
    carStorageCarCapacity2: number | undefined;
    /** adjustment amount */
    drivewayTypeAdjustmentAmount: number | undefined;
    /** adjustment amount */
    drivewayCarCapacityAdjustmentAmount: number | undefined;
    /** adjustment amount */
    carStorageTypeAdjustmentAmount1: number | undefined;
    /** adjustment amount */
    carStorageAttachmentTypeAdjustmentAmount1: number | undefined;
    /** adjustment amount */
    carStorageCarCapacityAdjustmentAmount1: number | undefined;
    /** adjustment amount */
    carStorageTypeAdjustmentAmount2: number | undefined;
    /** adjustment amount */
    carStorageAttachmentTypeAdjustmentAmount2: number | undefined;
    /** adjustment amount */
    carStorageCarCapacityAdjustmentAmount2: number | undefined;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

export interface CompGridPorchPatioDeck {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** The type of porch */
    porchType: string | undefined;
    /** The type of patio deck */
    patioDeckType: string | undefined;
    /** adjustment amount */
    porchPatioDeckTypeAdjustmentAmount: number | undefined;
}

export interface CompGridPool {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Pool - Yes / No */
    pool: string | undefined;
    /** adjustment amount */
    poolAdjustmentAmount: number | undefined;
}

export interface CompGridFireplace {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** number of fireplaces */
    fireplaceCount: number | undefined;
    /** adjustment amount */
    fireplaceCountAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
}

export interface CompGridOther {
    /** Other desc */
    otherDesc: string | undefined;
    /** Other desc */
    other2Desc: string | undefined;
    /** Other desc */
    other3Desc: string | undefined;
    /** Misc adjustment */
    otherType: string | undefined;
    /** Another misc adjustment */
    other2Type: string | undefined;
    /** Another misc adjustment */
    other3Type: string | undefined;
    /** adjustment amount */
    otherTypeAdjustmentAmount: number | undefined;
    /** adjustment amount */
    other2TypeAdjustmentAmount: number | undefined;
    /** adjustment amount */
    other3TypeAdjustmentAmount: number | undefined;
    /** Adjustment string for BB&T cases */
    summaryAdjustmentDesc: string | undefined;
}

/** CDOM section */
export interface CompGridCDOM {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** CDOM field value (string coz can be 'Unk') */
    cdom: string | undefined;
}

/** Property Type section */
export interface CompGridPropertyType {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Property Type */
    propertyType: string | undefined;
    /** Property type adjustment amount */
    propertyTypeAdjustmentAmount: number | undefined;
}

/** num of units */
export interface CompGridNumOfUnits {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Num of Units */
    numOfUnits: number | undefined;
    /** Num of units adj amount */
    numOfUnitsAdjustmentAmount: number | undefined;
}

/** Year built section */
export interface CompGridYearBuilt {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Year built */
    yearBuilt: number | undefined;
    /** Year built adjustment amount */
    yearBuiltAdjustmentAmount: number | undefined;
}

/** Num of floors section */
export interface CompGridNumOfFloors {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Num of Floors */
    numOfFloors: number | undefined;
    /** Num of floors adj amount */
    numOfFloorsAdjustmentAmount: number | undefined;
}

/** Floor location section */
export interface CompGridFloorLocation {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Floor location */
    floorLocation: string | undefined;
    /** Floor Location adj amount */
    floorLocationAdjustmentAmount: number | undefined;
}

/** Monthly rental rate section */
export interface CompGridMonthlyRentalRate {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Monthly rental rate */
    monthlyRentalRate: number | undefined;
    /** Monthly Rental rate adj amount */
    monthlyRentalRateAdjustmentAmount: number | undefined;
}

/** Different than Below Grade and Below Grade Rooms (For FNMA) */
export interface CompGridBelowGradeRoomCount {
    /** The collapsed summary text line */
    summary: string | undefined;
    /** The collapsed summary adjustment amount */
    summaryAdjustmentAmount: number | undefined;
    /** Is the adjustment factor applied to this section */
    adjustmentFactorApplied: boolean;
    /** Below Grade Room Count */
    belowGradeRoomCount: number | undefined;
    /** Below Grade room count adj amount */
    belowGradeRoomCountAdjustmentAmount: number | undefined;
}

/** A comparable property */
export interface CompGridComparable extends CompGridPropertyBase {
    /** the distance to the subject */
    proximityToSubjectMiles: string | undefined;
    /** The direction of influence */
    influenceDirection: number;
    /** The total adjustment percentage */
    netAdjustmentsPercentage: number | undefined;
    /** The total adjustments */
    netAdjustmentsAmount: number | undefined;
    /** The gross adjustment percentage */
    grossAdjustmentsPercentage: number | undefined;
    /** The gross adjustment amount */
    grossAdjustmentsAmount: number | undefined;
    /** Images of the comp */
    imageURLs: string[] | undefined;
}

/** A comparable that has been removed */
export interface CompGridRemovedComparable extends CompGridComparable {
    /** The date the comparable was removed */
    removedDate: Date;
}

/** Adjustment factors */
export interface CompGridAdjustmentFactorSettings {
    /** adjustment factor */
    saleFinancingAdjustmentFactor: number | undefined;
    /** adjustment factor */
    saleDatePercentPerMonthAdjustmentFactor: number | undefined;
    /** adjustment factor */
    contractDatePercentPerMonth: number | undefined;
    /** adjustment factor */
    locationRatingAdjustmentFactor: number | undefined;
    /** adjustment factor */
    locationTypeAdjustmentFactor: number | undefined;
    /** adjustment factor */
    viewRatingAdjustmentFactor: number | undefined;
    /** adjustment factor */
    viewTypeAdjustmentFactor: number | undefined;
    /** adjustment factor */
    quality1AdjustmentFactor: number | undefined;
    /** adjustment factor */
    quality2AdjustmentFactor: number | undefined;
    /** adjustment factor */
    quality3AdjustmentFactor: number | undefined;
    /** adjustment factor */
    quality4AdjustmentFactor: number | undefined;
    /** adjustment factor */
    quality5AdjustmentFactor: number | undefined;
    /** adjustment factor */
    quality6AdjustmentFactor: number | undefined;
    /** adjustment factor */
    agePerYearAdjustmentFactor: number | undefined;
    /** adjustment factor */
    condition1AdjustmentFactor: number | undefined;
    /** adjustment factor */
    condition2AdjustmentFactor: number | undefined;
    /** adjustment factor */
    condition3AdjustmentFactor: number | undefined;
    /** adjustment factor */
    condition4AdjustmentFactor: number | undefined;
    /** adjustment factor */
    condition5AdjustmentFactor: number | undefined;
    /** adjustment factor */
    condition6AdjustmentFactor: number | undefined;
    /** adjustment factor */
    totalAdjustmentFactor: number | undefined;
    /** adjustment factor */
    bedroomAdjustmentFactor: number | undefined;
    /** adjustment factor */
    bathroomAdjustmentFactor: number | undefined;
    /** adjustment factor */
    halfBathroomAdjustmentFactor: number | undefined;
    /** adjustment factor */
    grossLivingAreaAdjustmentThreshold: number | undefined;
    /** adjustment factor */
    grossLivingAreaPerSquareFootAdjustmentFactor: number | undefined;
    /** adjustment factor */
    belowGradeTotalPerSquareFootAdjustmentFactor: number | undefined;
    /** adjustment factor */
    belowGradeFinishedPerSquareFootAdjustmentFactor: number | undefined;
    /** adjustment factor */
    belowGradeExitTypeAdjustmentFactor: number | undefined;
    /** adjustment factor */
    belowGradeRecRoomAdjustmentFactor: number | undefined;
    /** adjustment factor */
    belowGradeBedroomAdjustmentFactor: number | undefined;
    /** adjustment factor */
    belowGradeBathroomAdjustmentFactor: number | undefined;
    /** adjustment factor */
    belowGradeHalfBathroomAdjustmentFactor: number | undefined;
    /** adjustment factor */
    belowGradeOtherAdjustmentFactor: number | undefined;
    /** adjustment factor */
    heatingAdjustmentFactor: number | undefined;
    /** adjustment factor */
    coolingAdjustmentFactor: number | undefined;
    /** adjustment factor */
    fireplaceAdjustmentFactor: number | undefined;
}

/** A comp grid choice option */
export interface CompGridChoice {
    /** The display value for the select option */
    displayValue: string | undefined;
    /** The value to store for the select option */
    storedValue: string | undefined;
    /** The value to use in the summary item */
    summaryDisplayValue: string | undefined;
}

export interface CompGridFormCodes {
}

/** Container for comp grid and metadata */
export interface CompGridResponseDto {
    /** The comp grid model data */
    compGrid: CompGrid | undefined;
    /** The comp grid settings data */
    settings: CompGridSettings | undefined;
}

export interface CompGridSettings {
    /** Form code e.g 1004p or fannie mae ... */
    compGridFormCode: string | undefined;
    /** The minimum number of comps */
    minimumComparableCount: number;
    /** /The max number of comps */
    maximumComparableCount: number | undefined;
    /** The list of sections to hide */
    hiddenSections: string[] | undefined;
    /** Comparable type eg: Sold, List */
    comparableTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    saleTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    financingTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    statusTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    locationRatingChoices: CompGridChoice[] | undefined;
    /** Choice options */
    locationTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    leaseholdFeeSimpleTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    viewRatingChoices: CompGridChoice[] | undefined;
    /** Choice options */
    viewTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    attachedDetachedChoices: CompGridChoice[] | undefined;
    /** Is free form text allowed for the design */
    designChoiceFreeTextAllowed: boolean;
    /** Choice options */
    designChoices: CompGridChoice[] | undefined;
    /** Choice options */
    qualityChoices: CompGridChoice[] | undefined;
    /** Choice options */
    conditionChoices: CompGridChoice[] | undefined;
    /** Choice options */
    basementExitTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    functionalUtilityChoices: CompGridChoice[] | undefined;
    /** Choice options */
    heatingTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    coolingTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    carStorageChoices: CompGridChoice[] | undefined;
    /** Choice options */
    carStorageAttachmentTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    porchPatioDeckTypeChoices: CompGridChoice[] | undefined;
    /** Choice options */
    propertyTypeChoices: CompGridChoice[] | undefined;
    /** Pool */
    poolTypeChoices: CompGridChoice[] | undefined;
    /** Data Sources */
    dataSourceChoices: CompGridChoice[] | undefined;
    /** Adjustment dropdown for BBT */
    adjustmentTypeChoices: CompGridChoice[] | undefined;
}

/** Comp grid sections (rows in UI). Should be the same as UI (Sections.js) */
export interface CompGridSections {
}

export interface CompGridValidationError {
    key: string | undefined;
    compIndex: number;
    message: string | undefined;
}

export interface CompGridValidationFieldInfo {
    key: string | undefined;
    subject: SubjectValidate | undefined;
    comparable: CompValidate | undefined;
    adjustment: CompValidate | undefined;
}

export interface SubjectValidate {
    validate: FuncOfCompGridValidationFieldInfoAndCompGridAndStringAndListOfCompGridValidationError | undefined;
    value: string | undefined;
}

export interface Delegate {
    _target: any | undefined;
    _methodBase: any | undefined;
    _methodPtr: IntPtr;
    _methodPtrAux: IntPtr;
    Method: MethodInfo | undefined;
    Target: any | undefined;
}

export interface MulticastDelegate extends Delegate {
}

export interface FuncOfCompGridValidationFieldInfoAndCompGridAndStringAndListOfCompGridValidationError extends MulticastDelegate {
}

export interface IntPtr {
}

export interface MemberInfo {
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
    module: Module | undefined;
}

export interface MethodBase extends MemberInfo {
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    isGenericMethod: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    isPublic: boolean;
    isPrivate: boolean;
    isFamily: boolean;
    isAssembly: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isStatic: boolean;
    isFinal: boolean;
    isVirtual: boolean;
    isHideBySig: boolean;
    isAbstract: boolean;
    isSpecialName: boolean;
    isConstructor: boolean;
}

export interface MethodInfo extends MethodBase {
    memberType: MemberTypes;
    returnType: string | undefined;
    returnParameter: ParameterInfo | undefined;
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export interface ParameterInfo {
    parameterType: string | undefined;
    name: string | undefined;
    hasDefaultValue: boolean;
    defaultValue: any | undefined;
    rawDefaultValue: any | undefined;
    position: number;
    attributes: ParameterAttributes;
    member: MemberInfo | undefined;
    isIn: boolean;
    isOut: boolean;
    isLcid: boolean;
    isRetval: boolean;
    isOptional: boolean;
    metadataToken: number;
    customAttributes: CustomAttributeData[] | undefined;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export interface CustomAttributeData {
    attributeType: string | undefined;
    constructor: ConstructorInfo | undefined;
    constructorArguments: CustomAttributeTypedArgument[] | undefined;
    namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export interface ConstructorInfo extends MethodBase {
    memberType: MemberTypes;
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    Runtime = 3,
    CodeTypeMask = 3,
    Unmanaged = 4,
    ManagedMask = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    SecurityMitigations = 1024,
    InternalCall = 4096,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export interface CustomAttributeTypedArgument {
    argumentType: string | undefined;
    value: any | undefined;
}

export interface CustomAttributeNamedArgument {
    memberInfo: MemberInfo | undefined;
    typedValue: CustomAttributeTypedArgument;
    memberName: string | undefined;
    isField: boolean;
}

export interface Module {
    CustomAttributes: CustomAttributeData[] | undefined;
    MDStreamVersion: number;
    FullyQualifiedName: string | undefined;
    ModuleVersionId: string;
    MetadataToken: number;
    ScopeName: string | undefined;
    Name: string | undefined;
    Assembly: Assembly | undefined;
    ModuleHandle: ModuleHandle;
}

export interface Assembly {
    CodeBase: string | undefined;
    EscapedCodeBase: string | undefined;
    FullName: string | undefined;
    EntryPoint: MethodInfo | undefined;
    ExportedTypes: string[] | undefined;
    DefinedTypes: string[] | undefined;
    Evidence: any[] | undefined;
    PermissionSet: any[] | undefined;
    IsFullyTrusted: boolean;
    SecurityRuleSet: SecurityRuleSet;
    ManifestModule: Module | undefined;
    CustomAttributes: CustomAttributeData[] | undefined;
    ReflectionOnly: boolean;
    Modules: Module[] | undefined;
    Location: string | undefined;
    ImageRuntimeVersion: string | undefined;
    GlobalAssemblyCache: boolean;
    HostContext: number;
    IsDynamic: boolean;
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export interface ModuleHandle {
    mdStreamVersion: number;
}

export interface CompValidate {
    validate: FuncOfCompGridValidationFieldInfoAndCompGridAndStringAndListOfCompGridValidationError | undefined;
    values: string[] | undefined;
}

export interface CompilerFeatureRequiredAttribute extends Attribute2 {
}

/** Request to Complete the QA process of a case */
export interface CompleteCaseRequest {
    /** QA Queue Id */
    qaQueueId: number;
    /** Internet User Id of the QA Rep */
    internetUserId: number;
    /** Control number of the case */
    controlIdNumber: number;
    /** Time log working on a case */
    timeLog: CaseTimeLogAddDto | undefined;
    /** Indicates if the current user is a QA manager */
    isTeamLeader: boolean;
    /** Local UTC minutes offset for completing user */
    localOffsetMinutes: number;
}

/** Response for the Complete QA Case op */
export interface CompleteCaseResponse {
}

/** Setting Names related to vw_CompleteFormBitOptions table in MuellerHomeowner */
export interface CompleteFormBitOptions {
}

/** Request to Complete Scheduling Assistant Notification */
export interface CompleteSchedulingCaseRequest {
    /** Internet User Id */
    internetUserId: number;
    /** Control number of the case */
    controlIdNumber: number;
    /** Id of the next Notification Step, when present indicates
overriding the base workflow.  */
    overridenNotificationId: number | undefined;
    /** Time log working on a case */
    timeLog: CaseTimeLogAddDto | undefined;
}

/** Response for the Complete Scheduling Assistant op */
export interface CompleteSchedulingCaseResponse {
}

export interface ValidationResult {
    memberNames: string[] | undefined;
    errorMessage: string | undefined;
}

/** Class for aggregating nested validation results.  Required by ValidateObjectAttribute. */
export interface CompositeValidationResult extends ValidationResult {
    /** Validation results */
    results: ValidationResult[] | undefined;
}

export interface ConfigResponse {
    casePinGroupingConfigs: PinGroupingConfig[] | undefined;
    mileageRate: number;
    basePinURL: string | undefined;
}

/** Survey Type Group for Map Pins */
export interface PinGroupingConfig {
    /** Id */
    id: number;
    /** Sort Order */
    order: number;
    /** Survey Type Group Name */
    name: string | undefined;
    /** Survey Type Group Code */
    code: string | undefined;
    /** Pin Image Url */
    pinImageUrl: string | undefined;
}

/** Contact Effort Result Type */
export enum ContactEffortResultTypeEnum {
    OutOfService = 1,
    WrongNumber = 2,
    NoAnswer = 3,
    MessagePHMachine = 4,
    MessageUNKMachine = 5,
    MessagePH = 6,
    MessageADULT = 7,
    MessageOther = 8,
    PHDeclined = 9,
    NotEnglish = 10,
    DirectionsObtained = 11,
    PermissionGranted = 12,
    PreNoteMessageMachine = 13,
    PreNotePH = 14,
    PreNoteFailedNC = 15,
    PreNoteFailedNA = 16,
    ManagerAssistNeeded = 17,
    AgencyDirectionObtained = 18,
    AgencyInfoRequest = 19,
    AgencyMessageMachine = 20,
    AgencyMessageStaff = 21,
    AgencyNoAnswerNoMachine = 22,
    AgencyUnableAssist = 23,
    AgencyWrongNumber = 24,
    AgentMuellersBehalf = 25,
    AltNumberObtained = 26,
    CloseOutSurvey = 27,
    ConvertToExt = 28,
    PHAccepted = 29,
    PHInfoRequest = 30,
    PHNoAccess = 31,
    PHRefused = 32,
    TextMessageSent = 33,
    AppointmentTextSent = 34,
    PrenotificationTextSent = 35,
    ReminderTextSent = 36,
    MuellerAtHomeText = 37,
    MuellerAtHomeEmail = 38,
    MuellerAtHomeScheduled = 39,
    MuellerAtHomeRefused = 40,
    EmailSent = 41,
    AutomatedCallAttempt = 63,
}

export interface ContactEffortsContact {
    /** Name of contact */
    name: string | undefined;
    /** Contact value (i.e. phone number) */
    value: string | undefined;
    /** Type of Contact (i.e. insured, agent, etc.) */
    type: string | undefined;
    /** Contact is valid */
    isValid: boolean;
}

/** List of pnx contacts for a case */
export interface ContactEffortsContactsDto {
    /** List of contacts */
    contacts: ContactEffortsContact[] | undefined;
}

/** Model for adding or editing case contact efforts */
export interface ContactEffortsDto {
    /** Call log id */
    contactEffortsId: number | undefined;
    /** Case control number */
    controlIdNumber: number;
    /** Attempted phone number */
    phoneNumber: string;
    /** Date when contact was made */
    contactDate: Date;
    /** Time range when contact was made */
    contactTimeRangeId: number | undefined;
    /** Person who made contact */
    contactPersonTypeCode: string;
    /** Who was contacted */
    spokeWith: string;
    /** Result of contact */
    resultCode: string;
    /** Internet User Id of the person making contact */
    contactMadeById: number | undefined;
    /** Notes regarding contact */
    notes: string | undefined;
    /** PNX Call Log Entry Id */
    phoenixId: string | undefined;
}

/** Previous and next contact effort */
export interface ContactEffortsEditDueDate {
    controlNumber: number;
    currentDueDate: string | undefined;
    newDueDate: string | undefined;
}

/** Previous and next contact effort */
export interface ContactEffortsNextCall {
    previousNotificationName: string | undefined;
    previousNotificationDate: Date | undefined;
    nextNotificationName: string | undefined;
    nextNotificationDate: Date | undefined;
}

/** Call Log Settings */
export interface ContactEffortsSettingsDto {
    personTypes: PersonType[] | undefined;
    resultTypes: ResultType[] | undefined;
}

export interface PersonType {
    /** ID/Key of person type */
    key: string | undefined;
    /** Friendly name of person type */
    name: string | undefined;
    /** Available result keys on person type */
    possibleResultIDs: string[] | undefined;
}

export interface ResultType {
    /** ID/Key of call result */
    key: string | undefined;
    /** Friendly name of call result */
    name: string | undefined;
}

/** Contact person types in the MuellerHomeowner ContactPersonTypes table */
export enum ContactPersonTypes {
    INSURED = 1,
    AGENT = 2,
    MUELLER_CS = 3,
    MUELLER_MGR = 4,
    DESIGNATED = 5,
    UNDERWRITER = 6,
    AUTO = 7,
}

/** Contact Type Codes */
export interface ContactTypeCodes {
}

/** Base class for Dollar File Layouts */
export interface DollarFileDefinitionBase {
    /** Columns for Dollar File */
    columnDefinitions: MGridColumnDefinition[] | undefined;
}

/** Hourly Employee File layout */
export interface ContractorDollarFile extends DollarFileDefinitionBase {
    /** File name */
    fileName: string | undefined;
    /** Data for Export */
    data: UltimatePayrollDollarDto[] | undefined;
}

/** Payroll Dollar amounts */
export interface UltimatePayrollDollarDto {
    /** Payroll Id */
    cardNumber: string | undefined;
    /** earning code */
    earningCode: string | undefined;
    /** Dollar amount (bonus,reimbursement,etc) */
    amount: number;
}

/** Dto to hold distance between the case provided and the end case */
export interface ControlNumberDistancePair {
    /** Source Control Id Number */
    sourceControlIdNumber: number;
    /** Destination Control Id Number */
    destinationControlIdNumber: number;
    /** Distance between the two control id numbers */
    distance: number | undefined;
}

/** request data to convert a case to an appraisal */
export interface ConvertToAppraisalRequest {
    /** Case Id */
    controlIdNumber: number;
    /** Survey type to convert the case to (Use Survey */
    surveyTypeCodeConvertTo: string;
}

/** used copy a case. */
export interface CopyCaseRequest {
    /** Control Number */
    controlIDNumber: number;
    /** Customer Number the new case should be created on */
    customerNumber: number | undefined;
    /** Survey Type Code, if not provided defaults to the value of the case to be copied */
    surveyTypeCode: string | undefined;
    /** Date received, if not provided defaults to current date time */
    dateReceived: Date | undefined;
    /** Home phone number for policyholder, if not provided defaults to the value of the case to be copied */
    phoneHome: string | undefined;
    /** Work phone number for policyholder, if not provided defaults to the value of the case to be copied */
    phoneWork: string | undefined;
    /** Mailing Address line 1 */
    mailingAddress1: string | undefined;
    /** Mailing Address line 2 */
    mailingAddress2: string | undefined;
    /** Mailing Postal Code */
    mailingPostalCode: string | undefined;
    /** Survey Address line 1 */
    surveyAddress1: string | undefined;
    /** Survey Address line 1 */
    surveyAddress2: string | undefined;
    /** Survey Postal Code */
    surveyPostalCode: string | undefined;
    /** Special attention notes, if not provided defaults to the value of the case to be copied */
    webNotes: string | undefined;
    /** Set to true to assign to the same Field Rep as the case to be copied */
    assignOriginalInspector: boolean | undefined;
    /** Underwriter code associated to the case, if not provided defaults to the value of the case to be copied */
    underwriterCode: string | undefined;
    /** Due date for the new case, if not provided it will be set automatically. */
    useOriginalDueDate: boolean | undefined;
    /** Mark the copied case as a rush order */
    isRush: boolean | undefined;
}

/** Copy survey type dto */
export interface CopySurveyTypeDto {
    /** Customer number to copy survey type to */
    destinationCustomerNumber: number;
    /** Customer number to copy survey type from */
    sourceCustomerNumber: number;
    /** Survey type code to copy from */
    sourceSurveyTypeCodes: string[] | undefined;
}

/** Correspondent Settings */
export interface CorrespondentSettings {
    /** If the broker is a correspondent  */
    isCorrespondent: boolean;
}

/** Cost */
export interface Cost {
    /** Actual Cash Value */
    actualCashValue: number;
    /** Adjustment */
    adjustment: number;
    /** Depreciation */
    depreciation: number;
    /** Insurable Replacement Cost */
    insurableReplacementCost: number;
    /** Insured Value */
    insuredValue: number;
    /** Subtotal */
    subtotal: number;
}

export interface CostEstimateViewModel {
    fields: RCTFieldViewModel[] | undefined;
}

/** County data transformation object */
export interface CountyBoundaryDto {
    /** Stores the main county dto information */
    properties: CountyDto | undefined;
    /** JSON object containing the boundary info */
    boundaryJSON: string | undefined;
}

/** County Postal Code */
export interface CountyPostalDto {
    /** County Id */
    countyId: number;
    /** Postal Id */
    postalId: number;
    /** Area of Intersection */
    intersectionArea: number;
}

/** Course Add Request */
export interface CourseAddRequest {
    /** Name */
    name: string;
    /** URL */
    url: string;
    /** Frequency Months for repeating test */
    frequencyMonths: number | undefined;
    /** Course Group */
    courseGroupId: number;
    /** State Abbreviation */
    stateAbbreviation: string | undefined;
}

/** Course List Dto */
export interface CourseDto {
    /** Primary key */
    id: number;
    /** Name */
    name: string | undefined;
    /** Unique Code */
    code: string | undefined;
    /** URL to the course */
    url: string | undefined;
    /** Frequency of taking test */
    frequencyMonths: number | undefined;
    /** Disabled date */
    disabledDate: Date | undefined;
    /** Created Date */
    createdDate: Date;
    /** Course Group */
    courseGroup: CourseGroupDto | undefined;
    /** State the course could be assigned to */
    state: StateDto | undefined;
}

/** Course Group/Category */
export interface CourseGroupDto {
    /** Primary Key */
    id: number;
    /** Name */
    name: string | undefined;
    /** Number of days default till course is due when assigned */
    daysTillDue: number;
    /** Url for entire group of courses */
    url: string | undefined;
    /** Are notification enabled for these courses when assigned */
    notificationEnabled: boolean;
    /** Email Template type */
    emailTemplateType: CourseGroupEmailTemplateType;
}

/** Course Group Email Template Types */
export enum CourseGroupEmailTemplateType {
    HumanResourceTemplate = 1,
    TrainingTemplate = 2,
    TrainingRequirementTemplate = 3,
}

/** Course Group Add request */
export interface CourseGroupAddRequest {
    /** Name */
    name: string;
    /** URL if it has a main url */
    url: string | undefined;
    /** Days default till due when assigned of cases */
    daysTillDue: number;
    /** Are notification enabled for these courses when assigned */
    notificationEnabled: boolean;
    /** Email Template Type */
    emailTemplateType: CourseGroupEmailTemplateType;
}

/** Contains course group names */
export interface CourseGroupNames {
}

/** Update Course Group Request */
export interface CourseGroupUpdateRequest {
    /** Primary key */
    id: number;
    /** Name */
    name: string;
    /** URL if it has a main url */
    url: string | undefined;
    /** Days default till due when assigned of cases */
    daysTillDue: number;
    /** Are notification enabled for these courses when assigned */
    notificationEnabled: boolean;
    /** Email Template Type */
    emailTemplateType: CourseGroupEmailTemplateType;
}

/** Course Update Request */
export interface CourseUpdateRequest {
    /** Primary key */
    id: number;
    /** Name */
    name: string;
    /** URL */
    url: string;
    /** Frequency Months for repeating test */
    frequencyMonths: number | undefined;
    /** Date Disabled */
    disabledDate: Date | undefined;
    /** Course Group */
    courseGroupId: number;
    /** Can assign a state to a course */
    stateAbbreviation: string | undefined;
}

/** Export result for a case */
export interface CreateCaseExportResultDto {
    /** ExportDefinition Code */
    exportCode: string | undefined;
    /** Case control number */
    controlNumber: number;
    /** Who started this export */
    initiatedByInternetUserId: number;
    /** Export summary */
    exportProcessingSummary: string | undefined;
    /** User friendly export results text */
    exportResultsText: string | undefined;
    /** IT friendly full log text */
    exportResultsLog: string | undefined;
    /** True if the export was successful */
    exportSuccessful: boolean;
    /** When was the export started */
    exportStartedAtUtc: Date;
    /** When the export finished */
    exportFinishedAtUtc: Date;
}

/** Export definition */
export interface CreateExportDefinitionDto {
    /** Export name */
    name: string | undefined;
    /** Export assembly name */
    assembly: string | undefined;
    /** Export namespace qualified class name */
    namespaceClass: string | undefined;
    /** Unique Export Code */
    code: string;
    /** Export setting file name template */
    settingsFileName: string | undefined;
}

/** Request to create a new inspector */
export interface CreateInspectorRequest {
    /** Mueller email address / login */
    userEmail: string;
    /** The user's personal / recovery email address */
    personalEmail: string;
    /** First Name */
    firstName: string;
    /** Last Name */
    lastName: string;
    /** Street Address */
    address: string | undefined;
    /** City */
    city: string | undefined;
    /** State */
    state: string | undefined;
    /** Postal or zip code */
    postalCode: string | undefined;
    /** User's contact phone nu,ber */
    phoneNumber: string | undefined;
    /** Hire Date */
    hireDate: Date;
    /** Is the user full time */
    isFullTime: boolean;
    /** Team leader Id */
    teamLeaderInternetUserId: number | undefined;
    /** Manager Id */
    managerInternetUserId: number | undefined;
    /** Field Development Employee Id */
    fieldDevelopmentEmployeeId: number | undefined;
    /** Payroll Unique Id */
    payrollEmployeeId: string | undefined;
    /** Hourly Pay Rate */
    hourlyPayRate: number;
    /** Is this FR Fake */
    isFake: boolean;
}

/** Response from creating a new inspector */
export interface CreateInspectorResponse {
    /** Inspector Number of the created user */
    inspectorNumber: number;
    /** Internet user id of the created user */
    internetUserId: number;
}

/** Parameters to create a new appraiser */
export interface CreateNewAppraiserDto {
    /** Date they are hired on */
    hireDate: Date | undefined;
    /** Address: State */
    stateAbbreviation: string | undefined;
    /** Address: Postal code */
    postalCode: string | undefined;
    /** Their manager's internet user id */
    managerInternetUserId: number;
    /** Address: Address line 1 */
    address1: string | undefined;
    /** Address: Address line 1 */
    address2: string | undefined;
    /** Date they are going to be active */
    activeDate: Date;
    /** Date they are going to be inactive */
    inactiveDate: Date | undefined;
    /** Unique business assigned number for id */
    appraiserNumber: number;
    /** Geocoded address */
    addressLatitude: number | undefined;
    /** Geocoded address */
    addressLongitude: number | undefined;
    /** Action taken by AS */
    appraisalSubcommitteeDisciplinaryAction: string | undefined;
    /** Action taken by AS effective date */
    appraisalSubcommitteeDisciplinaryActionEffectiveDate: Date | undefined;
    /** Action taken by AS end date */
    appraisalSubcommitteeDisciplinaryActionEndDate: Date | undefined;
    /** Appraiser conforms to Appraiser Qualifications Board criteria */
    conformsToAqbCriteria: boolean;
    /** Appraiser company name */
    companyName: string | undefined;
    /** Appraiser email address */
    emailAddress: string | undefined;
    /** User Login information */
    userLoginInfoDto: AddInternetUserDto | undefined;
    /** Appraiser first name */
    firstName: string;
    /** Appraiser home phone */
    homePhoneNumber: string | undefined;
    /** Appraiser is a Mueller employee? */
    isEmployee: boolean;
    /** Appraiser hourly pay rate */
    hourlyPayRate: number;
    /** Is this a fake appraiser entry */
    isFake: boolean;
    /** Appraiser last name */
    lastName: string;
    /** Appraiser middle name */
    middleName: string | undefined;
    /** Appraiser cell phone number */
    mobilePhoneNumber: string | undefined;
    /** Appraiser name suffix (eg jr, sr ...) */
    nameSuffix: string | undefined;
    /** The employee id in the payroll system */
    payrollEmployeeId: string | undefined;
    /** Appraiser work phone number */
    workPhoneNumber: string | undefined;
    /** Address: City  */
    city: string | undefined;
    /** Appraiser internet user id */
    internetUserId: number;
    /** Beginning Date of Date Range When the Appraiser allows others to edit assigned cases */
    allowEditsEffectiveDate: Date | undefined;
    /** End Date of Date Range When the Appraiser allows others to edit assigned cases */
    allowEditsEndDate: Date | undefined;
    /** Used to limit cases per customer feature of required experience to work cases. */
    experienceStartDate: Date;
}

/** Body of fix request to CubiCasa */
export interface CubiCasaFixRequest {
    /** Description of fix request */
    text: string | undefined;
    /** Array of URIs for images to assist CubiCasa in making fix.  */
    image: string[] | undefined;
}

/** ViewModel for a CubiCasa form */
export interface CubiCasaForm {
    /** Sketch ViewModel for displaying CubiCasa images */
    sketchComp: Sketch | undefined;
    /** Quick Edit link */
    quickEditLink: string | undefined;
    /** Advanced Edit link */
    advancedEditLink: string | undefined;
}

export interface Sketch {
    /** True if the sketch is read-only */
    isReadOnly: boolean;
    /** Uri for the sketch editor */
    uri: string | undefined;
    /** List of the sketch image URIs */
    sketchImages: string[] | undefined;
    /** Name of sketch type */
    sketchName: string | undefined;
}

/** DTO for CubiCasa Scan */
export interface CubiCasaScanDto {
    /** Control Number for the case */
    controlIdNumber: number;
    /** CubiCasa Ticket Id for the scan */
    ticketId: string | undefined;
    /** CubiCasa Model Id for the scan result */
    modelId: string | undefined;
    /** Linked Phoenix File Id (external Id provided to CubiCasa) */
    fileId: string | undefined;
    /** Application Used to Create CubiCasa Scan */
    source: string | undefined;
    /** Priority of Scan Ticket */
    priority: string | undefined;
    /** Scan Status */
    status: string | undefined;
    /** WebHookRequest from CubiCasa */
    webHookRequest: string | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCubiCasaScanSourceCode extends TypeSafeEnum {
}

/** TypeSafeEnum for CubiCasa Scan Sources */
export interface CubiCasaScanSourceCode extends TypeSafeEnumOfCubiCasaScanSourceCode {
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCubiCasaScanStatus extends TypeSafeEnum {
}

/** TypeSafeEnum for CubiCasa Scan Status */
export interface CubiCasaScanStatus extends TypeSafeEnumOfCubiCasaScanStatus {
}

/** Customer 360 Value Settings Output Types */
export interface Customer360ValueOutputTypeCodes {
}

/** Customer 360 Value Settings Dto */
export interface Customer360ValueSettingsDto {
    /** Customer Number */
    customerNumber: number;
    /** Agent Group Id */
    agentGroupId: string | undefined;
    /** Agent Id */
    agentId: string | undefined;
    /** Output Type (see Customer360ValueOutputTypeCodes for options) */
    outputType: string | undefined;
    /** Webservice URL */
    webserviceURL: string | undefined;
}

export interface CustomerActionAuditViewModel {
    name: string | undefined;
    createDate: Date;
    actionTaken: string | undefined;
    comments: string | undefined;
    id: number;
}

/** Customer add request */
export interface CustomerAddRequest {
    /** Customer Number */
    customerNumber: number;
    /** Name */
    name: string;
    /** Major company id (if using existing) */
    companyId: number;
    /** Major company name (if adding new) */
    companyName: string | undefined;
    /** Customer Type Id */
    customerTypeId: CustomerTypeId;
    /** Address1 */
    address1: string;
    /** Address2 */
    address2: string | undefined;
    /** City */
    city: string;
    /** State */
    stateAbbreviation: string;
    /** Zip */
    zip: string;
    /** Contact name */
    contactName: string;
    /** Contact phone number */
    contactPhone: string;
    /** Customer Number to copy survey types from */
    copyFromCustomerNumber: number | undefined;
    /** List of survey type codes to copy */
    copySurveyTypeCodes: string[] | undefined;
    /** Sales Rep Employee Id */
    salesRepEmployeeId: number | undefined;
}

/** Values for CustomerTypeIds */
export enum CustomerTypeId {
    EXISTING_LENDER = 4,
    EXISTING_INSURANCE = 5,
    EXISTING_LOSS_DRAFT = 6,
    NEW_LENDER = 7,
    NEW_INSURANCE = 8,
    NEW_LOSS_DRAFT = 9,
}

/** Model class for CustomerAppraisalCaseResultProvider */
export interface CustomerAppraisalCaseResult {
    appraisalStatus: string | undefined;
    policyNumber: string | undefined;
    inspectionType: string | undefined;
    webStatus: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    county: string | undefined;
    appraiserAssigned: string | undefined;
    dateEntered: Date | undefined;
    dateReceived: Date | undefined;
    appointmentDate: Date | undefined;
    dateCompleted: Date | undefined;
    dueDate: Date | undefined;
    customerNameNumber: string | undefined;
    policyholderName: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    assignmentType: string | undefined;
    orderCodeIn: string | undefined;
    orderCodeOut: string | undefined;
    brokerName: string | undefined;
    daysInStatus: string | undefined;
    daysInVS: string | undefined;
    totalBrokerTime: string | undefined;
    controlIdNumber: number;
    controlIDNumber: number;
    controlNumber: number;
    trackingNumber: string | undefined;
    appraiserEta: string | undefined;
    /** Client ETA */
    clientEta: string | undefined;
    lastNote: string | undefined;
}

/** Dto to add a new Customer Appraiser Exclusion record */
export interface CustomerAppraiserExclusionAddRequest {
    /** Customer Id */
    customerNumber: number;
    /** Appraiser Id */
    appraiserNumber: number;
    /** Optional comments regarding exclusion */
    comments: string | undefined;
}

/** Customer Calc Account Setting */
export interface CustomerCalcAccountSettingsDto {
    /** Calc Tool Name */
    name: string | undefined;
    /** Calc Tool Code */
    code: string | undefined;
    /** 360 Value Account Settings */
    settings360Value: Customer360ValueSettingsDto | undefined;
    /** RCT Account Settings */
    settingsRCT: CustomerRCTAccountSettingsDto | undefined;
}

/** Customer RCT Account Settings Dto */
export interface CustomerRCTAccountSettingsDto {
    /** Customer Number */
    customerNumber: number;
    /**           Calc Tool Code
           */
    calcToolCode: string | undefined;
    /**           Calc Tool Name
           */
    calcToolName: string | undefined;
    /** License Code */
    licenseCode: string | undefined;
    /** User Name */
    userName: string | undefined;
    /** Password */
    password: string | undefined;
    /** Domain */
    domain: string | undefined;
    /** Webservice URL */
    webserviceURL: string | undefined;
    /** WCFEndpointName */
    wcfEndpointName: string | undefined;
    /** Reference Webservice URL */
    referenceWebserviceURL: string | undefined;
    /** Reference WCF Endpoint Name */
    referenceWCFEndpointName: string | undefined;
    /** Config Webservice URL */
    configWebserviceURL: string | undefined;
    /** Config WCF Endpoint Name */
    configWCFEndpointName: string | undefined;
    /** Webservice Version */
    webserviceVersion: string | undefined;
}

/** Combined Customer Calc Account and Calculation Settings */
export interface CustomerCalcSettingsDto {
    /** List of All Customer Calc Account Settings */
    accountSettings: CustomerCalcAccountSettingsDto[] | undefined;
    /** RCT Specific Settings for the Account */
    calculationSettings: CustomerRCTCalculationSettingsDto | undefined;
}

/** Customer Account RCT Calculation Settings */
export interface CustomerRCTCalculationSettingsDto {
    /** Engine Path */
    enginePath: string | undefined;
    /** Data Path */
    dataPath: string | undefined;
    /** Construction Type */
    constructionType: number | undefined;
    /** General Adjustment Multiplier */
    generalAdjustmentMultiplier: number | undefined;
    /** Depreciation Multiplier */
    depreciationMultiplier: number | undefined;
    /** Detached Depreciation Multiplier */
    detachedDepreciationMultiplier: number | undefined;
    /** Labor Type */
    laborType: string | undefined;
    /** Excavation Flag */
    excavationFlag: string | undefined;
    /** Built Standard */
    builtStandard: string | undefined;
    /** ValueType */
    valueType: number | undefined;
    /** Debris Removal flag */
    debrisRemovalFlag: string | undefined;
    /** Debris multiplier */
    debrisRemovalMultiplier: number | undefined;
    /** Debris max */
    debrisRemovalMaximum: number | undefined;
    /** Which states debris removal is applied in; null means all states */
    debrisRemovalOnlyInStates: string | undefined;
    /** FIT Process Company */
    fitProcessCompany: string | undefined;
    /** FIT Routing Target System */
    fitRoutingTargetSystem: string | undefined;
    /** Maximum Wings */
    maximumWings: number;
    /** Use Pier Foundation Height Split */
    usePierFoundationHeightSplit: boolean;
    /** Use Localized Costs */
    useLocalizedCosts: boolean;
    /** Fractional Story Height Enabled */
    fractionalStoryHeightEnabled: boolean;
    /** Story Numbers. This is intentionally not exposed in ME */
    storyNumbers: string | undefined;
}

export interface CustomerCaseInfo {
    /** Case Control Number */
    controlNumber: number;
    /** Case Primary Status */
    primaryStatus: string | undefined;
    /** Case Secondary Status */
    secondaryStatus: string | undefined;
    /** Customer Number of Case */
    customerNumber: number;
    /** Case Reviewer */
    reviewedBy: string | undefined;
    /** Date Case was Reviewed */
    dateReviewed: Date | undefined;
    /** Case Review Comments */
    reviewComments: string | undefined;
    /** Case Policy Number */
    policyNumber: string | undefined;
    /** Insured First Name */
    insuredFirstName: string | undefined;
    /** Insured Last Name */
    insuredLastName: string | undefined;
    /** Coverage A In */
    coverageAIn: number | undefined;
    /** Coverage A Out */
    coverageAOut: number | undefined;
    /** Coverage A Endorsed Amount */
    coverageAEndorsed: number | undefined;
    /** Hazards on the Case */
    hazards: CaseHazardViewModel[] | undefined;
    /** CASE_EMAIL_LINKS_DISABLED customer feature is enabled */
    isCaseLinksDisabled: boolean;
    /** CASE_DISPUTE_DISABLED customer feature is enabled */
    isCaseDisputeDisabled: boolean;
    /** HIDE_ReOrderLink customer feature is enabled */
    isHideReorderLink: boolean;
    /** CASE_MARK_REVIEWED_DISABLED customer feature is enabled */
    isMarkReviewDisabled: boolean;
    /** Available underwriter actions for case */
    availableUnderwriterActions: UnderwriterActionDto[] | undefined;
    /** Underwriter actions that have been selected */
    selectedUnderwriterActions: UnderwriterActionDto[] | undefined;
    /** History of underwriter actions taken on the case */
    underwriterActionsAudits: CustomerActionAuditViewModel[] | undefined;
}

export enum CustomerDecisionTypeEnum {
    DecisionRequired = 0,
    DecisionOnDataAndDoneOnly = 1,
    NoDecision = 2,
}

/** Customer details DTO */
export interface CustomerDetailsDto {
    /** Customer id */
    id: number;
    /** Customer number */
    number: number;
    /** Customer name */
    name: string | undefined;
    /** Customer display name */
    displayName: string | undefined;
    /** The mailing address */
    mailingAddress: StreetAddress | undefined;
    /** Customer email address */
    email: string | undefined;
    /** Customer phone number 1 */
    phoneNumber1: string | undefined;
    /** Customer phone number 2 */
    phoneNumber2: string | undefined;
    /** Customer Type Id */
    customerTypeId: CustomerTypeId | undefined;
    /** Pricing Contract End Date */
    contractEndDate: Date | undefined;
    /** Customer disabled on date */
    inactiveDate: Date | undefined;
    /** The major company */
    majorCompany: MajorCompanyDto | undefined;
    /** The survey types configured on this customer */
    configuredSurveyTypes: SurveyTypeListDto[] | undefined;
    /** The survey types configured on this customer */
    ccEmailAddress: string | undefined;
    /** The survey types configured on this customer */
    bccEmailAddress: string | undefined;
    /** File name option for case emails */
    pdfFileNameOption: EmailFileNameOptionDto | undefined;
    /** Email format for case emails */
    emailFormat: EmailFormatDto | undefined;
    /** Sales Rep */
    salesRep: EmployeeListDto | undefined;
    /** Customer Audit Percentage */
    auditPercentage: number;
}

/** Contains Customer Info */
export interface MajorCompanyDto {
    /** Major company Id */
    id: number;
    /** Major company code */
    code: string | undefined;
    /** Major company name */
    companyName: string | undefined;
}

/** File Name Options for Email */
export interface EmailFileNameOptionDto {
    /** Id */
    id: number;
    /** Code */
    code: string | undefined;
    /** Display name */
    displayName: string | undefined;
}

/** File Name Options for Email */
export interface EmailFormatDto {
    /** Id */
    id: number;
    /** Display name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** Display name */
    methodName: string | undefined;
    /** Display name */
    displayName: string | undefined;
}

/** Employee By Role */
export interface EmployeeListDto {
    /** EmployeeId */
    employeeId: number;
    /** InternetUserId */
    internetUserId: number | undefined;
    /** FirstName */
    firstName: string | undefined;
    /** LastName */
    lastName: string | undefined;
    /** Role Enum */
    roleId: EmployeeRoleEnum;
    /** Role Dro */
    role: RoleDto | undefined;
    /** FirstName LastName */
    firstLastName: string | undefined;
    /** LastName, FirstName */
    lastFirstName: string | undefined;
    /** Third party system for unique payroll id */
    payrollEmployeeId: string | undefined;
    /** Address of employee */
    address: Address | undefined;
    /** Supervisor name        
///  */
    supervisorName: string | undefined;
    /** Home Phone */
    phoneNumber: string | undefined;
    /** Email address */
    emailAddress: string | undefined;
    /** Extension */
    extension: number | undefined;
    /** Is employee active? */
    isActive: boolean;
}

/** List of Internet User Roles */
export enum EmployeeRoleEnum {
    ACCOUNTING_ASSOCIATE = 1,
    ACCOUNTING_MANAGER = 2,
    BUSOP_AGENT = 3,
    BUSOP_DIRECTOR = 4,
    BUSOP_MANAGER = 5,
    BUSOP_CUSTOMER_SERVICE_ASSOCIATE = 6,
    BUSOP_CUSTOMER_SERVICE_MANAGER = 7,
    CLERICAL_ASSOCIATE = 8,
    CLERICAL_MANAGER = 9,
    EXECUTIVE_ASSOCIATE = 10,
    EXECUTIVE_MANAGER = 11,
    EXECUTIVE_PRESIDENT = 12,
    EXECUTIVE_VICE_PRESIDENT = 13,
    FIELD_LOGISTIC_COORDINATOR = 14,
    FIELD_SERVICE_DIRECTOR = 15,
    FIELD_SERVICE_REP = 16,
    HUMAN_RESOURCE_ASSOCIATE = 17,
    HUMAN_RESOURCE_DIRECTOR = 18,
    IT_DIRECTOR = 19,
    IT_JUNIOR_SOFTWARE_DEVELOPER = 20,
    IT_MANAGER = 21,
    IT_PROJECT_MANAGER = 22,
    IT_SOFTWARE_DEVELOPER = 23,
    IT_TECHNICAL_SUPPORT = 24,
    IT_VICE_PRESIDENT = 25,
    LOSS_DRAFT_ASSOCIATE = 26,
    RECRUITING_ASSOCIATE = 27,
    RECRUITING_MANAGER = 28,
    SALES_INSURANCE_DIRECTOR = 29,
    SALES_INSURANCE_MANAGER = 30,
    SALES_INSURANCE_VICE_PRESIDENT = 31,
    SALES_VALUATION_DIRECTOR = 32,
    SALES_VALUATION_VICE_PRESIDENT = 33,
    TELEPHONE_AGENT = 34,
    TELEPHONE_DIRECTOR = 35,
    TELEPHONE_MANAGER = 36,
    TRAINING_ASSOCIATE = 37,
    VALUATION_CUSTOMER_SERVICE_ASSOCIATE = 38,
    VALUATION_CUSTOMER_SERVICE_MANAGER = 39,
    VALUATION_APPRAISER = 40,
    VALUATION_CHIEF_APPRAISER = 41,
    VALUATION_SUPPORT_REP = 42,
    VALUATION_QUALITY_ASSOCIATE = 43,
    VALUATION_QUALITY_MANAGER = 44,
    CLERICAL_DIRECTOR = 45,
    LOSS_DRAFT_DIRECTOR = 46,
    LOSS_DRAFT_MANAGER = 47,
    EXECUTIVE_DIRECTOR = 48,
    BUSINESSDEVELOPMENT_VP = 49,
    BUSINESSDEVELOPMENT_DIRECTOR = 50,
    BUSINESSDEVELOPMENT_MANAGER = 51,
    RECRUITING_DIRECTOR = 52,
    VALUATION_DIRECTOR = 53,
    VALUATION_VICE_PRESIDENT = 54,
    HUMAN_RESOURCE_MANAGER = 55,
    BUSOP_ASSISTANT_VP = 56,
    FIELD_SERVICE_ASSISTANT_VP = 57,
    VALUATION_ASSISTANT_VP = 58,
    VALUATION_CUSTOMER_SERVICE_DIRECTOR = 59,
    BROKER_ENGAGEMENT_REP = 60,
    FIELD_SERVICE_TRAINING_COORDINATOR = 61,
    CUSTOMER_SERVICE_ASSOCIATE = 62,
    CUSTOMER_SERVICE_MANAGER = 63,
    FIELD_OPERATIONS_MANAGER = 64,
    FIELD_OPERATIONS_DIRECTOR = 65,
    FIELD_OPERATIONS_AVP = 66,
    FIELD_OPERATIONS_VP = 67,
    FIELD_DEVELOPMENT_MANAGER = 68,
    CUSTOMER_EXPERIENCE_REP = 69,
    CUSTOMER_EXPERIENCE_MANAGER = 71,
    LENDER_LOGISTICS_MANAGER = 72,
    QUALITY_DEVELOPMENT_MANAGER = 73,
    CUSTOMER_EXPERIENCE_DIRECTOR = 74,
    UNKNOWN = -1,
}

/** Role DTO for use by the API BL */
export interface RoleDto {
    /** Name of Roles */
    name: string | undefined;
    /** Id of Role */
    id: number;
    /** Ids of all Enabled Rights this Role has */
    enabledRightIds: number[] | undefined;
    /** Ids of all Disabled Rights this Role has */
    disabledRightIds: number[] | undefined;
    /** Department Code Associated to Role */
    departmentCode: string | undefined;
}

/** A feature */
export interface Feature2 {
    /** The unique code for this feature */
    code: string | undefined;
    /** A description of this feature */
    description: string | undefined;
    /** The name of this features */
    name: string | undefined;
}

/** A customer feature */
export interface CustomerFeature2 extends Feature2 {
    /** The customer number */
    customerNumber: number;
    /** The customer name */
    customerName: string | undefined;
    /** Feature is enabled? True if it is enabled */
    isEnabled: boolean;
    /** Settings for the feature */
    featureSettings: FeatureSetting2[] | undefined;
}

/** Settings for a feature */
export interface FeatureSetting2 {
    /** A unique code for the feature setting */
    code: string | undefined;
    /** The description of the feature setting */
    description: string | undefined;
    /** The order to display this feature setting in */
    displayOrder: number;
    /** A default initial value for this feature setting */
    initialValue: string | undefined;
    /** The name of this feature */
    name: string | undefined;
    /** The value of this feature */
    value: string | undefined;
    /** What type of data input to use for the feature setting value */
    inputType: string | undefined;
}

export interface CustomerFeaturesDto {
    /** Feature Code */
    feature: string | undefined;
    /** Feature Settings */
    featureSettings: FeatureSettingsDto[] | undefined;
}

export interface FeatureSettingsDto {
    /** Feature Setting Code */
    code: string | undefined;
    /** Feature Setting Value */
    value: string | undefined;
}

/** Customer Insight Notification Account Add Request */
export interface CustomerInsightNotificationAccountAddRequest {
    /** Reference to Customer Insight Notification Id */
    customerInsightNotificationId: number;
    /** Major Company Id */
    majorCompanyId: number | undefined;
    /** CustomerId Id */
    customerId: number | undefined;
}

/** Customer Insight Notification Account Company Dto */
export interface CustomerInsightNotificationAccountCompanyDto extends MajorCompanyDto {
    /** Created by user */
    createdByUser: string | undefined;
}

/** Customer Insight Notification Account Customer Dto */
export interface CustomerInsightNotificationAccountCustomerDto extends CustomerInfo {
    /** Created by user */
    createdByUser: string | undefined;
}

/** Customer Insight Notification Account List Response */
export interface CustomerInsightNotificationAccountListResponse {
    /** Accounts associated */
    customer: CustomerInsightNotificationAccountCustomerDto[] | undefined;
    /** Major Companies associated */
    majorCompanyDto: CustomerInsightNotificationAccountCompanyDto[] | undefined;
}

/** Customer Insight Notification Add Request */
export interface CustomerInsightNotificationAddRequest {
    /** Salutation  */
    name: string | undefined;
    /** Email to send report to */
    email: string | undefined;
    /** Customer Name that gets displayed in the subject line of the email */
    customerName: string | undefined;
    /** Start sending emails */
    startDate: Date;
    /** Disable date to stop sending */
    disabledDate: Date | undefined;
}

/** Used to get the detail and list of Customer Insight Notifications */
export interface CustomerInsightNotificationDto {
    /** Name / Salutation */
    name: string | undefined;
    /** Major company (basically the first major company of any accounts it's assocaited with
             */
    majorCompany: MajorCompanyDto | undefined;
    /** Email address */
    email: string | undefined;
}

/** Search / List result */
export interface CustomerInsightNotificationResponse {
    /** Name / Saluation */
    name: string | undefined;
    /** Email Adderss */
    email: string | undefined;
    /** Major Company */
    majorCompany: string | undefined;
    /** Disabled date */
    disableDate: Date | undefined;
    /** Is Enabled */
    isEnabled: boolean;
    /** User who created or updated the latest set of data */
    createdByUser: InternetUserListDto | undefined;
}

/** Customer Insight Notification Update Request */
export interface CustomerInsightNotificationUpdateRequest {
    /** Id */
    id: number;
    /** Salutation  */
    name: string | undefined;
    /** Email to send report to */
    email: string | undefined;
    /** Start sending emails */
    startDate: Date;
    /** Disable date to stop sending */
    disabledDate: Date;
}

/** Satisfaction Survey Request */
export interface SatisfactionSurveyRequest {
}

/** Add Satisfaction Survey Request */
export interface CustomerInsightsSurveyAddRequest extends SatisfactionSurveyRequest {
    /** Customer insight notification identifier */
    customerInsightNotificationId: number;
}

/** Satisfaction Survey Response */
export interface SatisfactionSurveyResponse {
}

/** Customer Insights Satisfaction Survey Response */
export interface CustomerInsightsSurveyResponse extends SatisfactionSurveyResponse {
    /** Unique identifier */
    uId: string;
    /** Major Company Name */
    majorCompanyName: string | undefined;
    /** Customer Name */
    customerName: string | undefined;
    /** Customer user email */
    customerUserEmail: string | undefined;
    /** Customer user name */
    customerUserName: string | undefined;
    /** Timeliness score */
    timelinessScore: number;
    /** Quality score */
    qualityScore: number;
    /** Communication score */
    communicationScore: number;
    /** Overall score */
    overallScore: number;
    /** Additional feedback */
    additionalFeedback: string | undefined;
    /** Created date (UTC) */
    createdDateUtc: Date;
    /** Completed date (UTC) */
    completedDateUtc: Date | undefined;
}

/** Satisfaction Survey Update Request */
export interface CustomerInsightsSurveyUpdateRequest extends SatisfactionSurveyRequest {
    /** Unique identifier */
    uId: string;
    /** Timeliness score */
    timelinessScore: number;
    /** Quality score */
    qualityScore: number;
    /** Communication score */
    communicationScore: number;
    /** Overall score */
    overallScore: number;
    /** Additional feedback */
    additionalFeedback: string | undefined;
}

/** Dto to add a new Customer Inspector Exclusion record */
export interface CustomerInspectorExclusionAddRequest {
    /** Customer Account Number */
    customerNumber: number;
    /** Inspector Number */
    inspectorNumber: number;
    /** Optional comments regarding exclusion */
    comments: string | undefined;
}

/** Return model for CustomerInsuranceResultProvider */
export interface CustomerInsuranceResult {
    closeOutReason: string | undefined;
    businessType: string | undefined;
    orderCodeIn: string | undefined;
    orderCodeOut: string | undefined;
    coverageAEndorsed: number | undefined;
    reportSquareFootage: number | undefined;
    agencyCode: string | undefined;
    reviewedBy: string | undefined;
    reviewerComments: string | undefined;
    effectiveDate: Date | undefined;
    underwriterCode: string | undefined;
    underwriterName: string | undefined;
    coverageAIn: number | undefined;
    coverageAOut: number | undefined;
    percentToValue: string | undefined;
    hazards: string | undefined;
    caseProfileButtonIconName: string | undefined;
    caseProfileTipText: string | undefined;
    controlIDNumber: number;
    policyNumber: string | undefined;
    address: string | undefined;
    city: string | undefined;
    state: string | undefined;
    zip: string | undefined;
    county: string | undefined;
    policyholderName: string | undefined;
    customerNumber: number | undefined;
    customerName: string | undefined;
    customerNameNumber: string | undefined;
    dateEntered: Date | undefined;
    dateAssignedFr: Date | undefined;
    dateCompleted: Date | undefined;
    dateReceived: Date | undefined;
    reviewedDate: Date | undefined;
    dueDate: Date | undefined;
    appointmentDate: Date | undefined;
    inspectionType: string | undefined;
    inspectorDaysDue: number | undefined;
    fsDueDate: Date | undefined;
    frAssigned: string | undefined;
    frDueDate: Date | undefined;
    extensionDays: number | undefined;
    dateReturned: Date | undefined;
    trackingNumber: string | undefined;
    webStatus: string | undefined;
    resultGridRowType: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    appointmentDateTime: Date | undefined;
    contactMadeOnDate: Date | undefined;
    contactPerson: string | undefined;
    contactEffortResult: string | undefined;
    lastNote: CellViewModelOfCaseNoteViewModel | undefined;
    timeUnassignedFieldRep: string | undefined;
    timeAssignedWithNoContactEfforts: string | undefined;
    timeSinceScheduledAppointment: string | undefined;
    timeSinceScheduledAppointmentRaw: string | undefined;
    timeInQA1: string | undefined;
    timeInFSQA: string | undefined;
    agent: string | undefined;
    mac: number | undefined;
    reviewerAction: string | undefined;
    reviewerActions: string | undefined;
    clientEta: string | undefined;
    appointmentChanged: boolean;
    /** Count of Major Hazards */
    majorHazardCount: number;
    /** Count of Minor Hazards */
    minorHazardCount: number;
}

/** Customer search list DTO */
export interface CustomerListModel {
    /** Customer id */
    id: number;
    /** Customer number */
    number: number;
    /** Customer name */
    name: string | undefined;
    /** Customer display name */
    displayName: string | undefined;
    /** The customer mailing address */
    mailingAddress: StreetAddress | undefined;
    /** Customer email address */
    email: string | undefined;
    /** Customer phone number 1 */
    phoneNumber1: string | undefined;
    /** Customer phone number 2 */
    phoneNumber2: string | undefined;
    /** Major company */
    majorCompany: MajorCompanyDto | undefined;
    /** Inactive Date */
    inactiveDate: Date | undefined;
    /** Sales Rep Name */
    salesRepName: string | undefined;
    /** QA Director */
    qaDirector: NameNumberDto[] | undefined;
    /** Survey type codes that are active for the customer */
    activeSurveyTypeCodes: string[] | undefined;
    /** Customer Experience Director */
    customerExperienceDirector: NameNumberDto[] | undefined;
}

/** Result model from Customer Review QuickList query */
export interface CustomerReviewCaseResult {
    controlIDNumber: number;
    policyNumber: string | undefined;
    policyholderName: string | undefined;
    dateEntered: Date | undefined;
    dateCompleted: Date | undefined;
    effectiveDate: Date | undefined;
    orderCodeOut: string | undefined;
    underwriterCode: string | undefined;
    lastNote: CellViewModelOfCaseNoteViewModel | undefined;
}

/** Customer sales dto */
export interface CustomerSalesDto {
    /** Customer Number */
    customerNumber: number;
    /** Customer Type Id */
    customerTypeId: CustomerTypeId | undefined;
    /** Pricing Contract End Date */
    contractEndDate: Date | undefined;
    /** Sales rep Employee Id */
    salesRepEmployeeId: number | undefined;
    /** Sales Rep Name */
    salesRepName: string | undefined;
    /** Onboarding Date */
    customerOnboardingDate: Date | undefined;
    /** First Order Date */
    customerFirstOrderDate: Date | undefined;
}

/** Represents the results of a customer satisfaction survey for a QL response metadata. */
export interface CustomerSatisfactionResult {
    /** Control number for CSAT survey result */
    controlNumber: number;
    /** Date of feedback creation */
    feedbackDate: Date;
    /** Customer name associated with the survey */
    customerNameNumber: string | undefined;
    /** Survey type that was completed */
    surveyTypeCompleted: string | undefined;
    /** State code */
    stateCode: string | undefined;
    /** Appointment date for the survey */
    appointmentDate: Date | undefined;
    /** LM name */
    logisticsManagerName: string | undefined;
    /** LD name */
    logisticsDirectorName: string | undefined;
    /** Scheduling user name */
    schedulingUserName: string | undefined;
    /** Inspector name and number */
    inspectorNameAndNumber: string | undefined;
    /** Scheduling process satisfaction score */
    satisfactionWithSchedulingProcessScore: number;
    /** Inspector's punctuality score */
    didInspectorArriveOnTimeScore: number;
    /** Inspector's professionalism and communication score */
    inspectorsProfessionalismAndCommunicationScore: number;
    /** Overall satisfaction score */
    overallSatisfactionScore: number;
    /** Policy# associated with the survey */
    policyNumber: string | undefined;
    /** Case order date */
    orderDate: Date | undefined;
    /** Satisfaction survey notes */
    satisfactionSurveyNotes: string | undefined;
    /** Survey type ordered */
    surveyTypeOrdered: string | undefined;
    /** Date submitted to QA from the field */
    surveySubmitDate: Date;
    /** Customer type */
    customerType: string | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfCustomerSatisfactionSurvey extends TypeSafeEnum {
}

/** Customer Satisfaction Survey Process */
export interface CustomerSatisfactionSurvey extends TypeSafeEnumOfCustomerSatisfactionSurvey {
}

/** Customer Satisfaction Survey Request */
export interface CustomerSatisfactionSurveyRequest extends SatisfactionSurveyRequest {
    /** WorkItemId of the surveyed case */
    workItemId: string;
    /** Overall Satisfaction (1 - 5, 5 being best) of scheduling process */
    satisfactionWithSchedulingProcess: number;
    /** Overall Satisfaction (1 - 5, 5 being best) of inspector's timeliness */
    didInspectorArriveOnTime: number;
    /** Overall Satisfaction (1 - 5, 5 being best) with inspectors professionalism and communication */
    inspectorsProfessionalismAndCommunication: number;
    /** Overall Satisfaction (1 - 5, 5 being best) */
    overallSatisfaction: number;
    /** Survey text repsonse */
    howCanWeImproveTheExperience: string | undefined;
}

/** Satisfaction Survey Response */
export interface CustomerSatisfactionSurveyResponse2 extends SatisfactionSurveyResponse {
    /** Control Number of the surveyed case */
    controlNumber: number;
    /** Name of the Field Rep. at the time of survey */
    fieldRepName: string | undefined;
    /** Uniqueu Id of the Field Rep. at time of survey */
    fieldRepNumber: number;
    /** Overall Satisfaction (1 - 5, 5 being best) of scheduling process */
    satisfactionWithSchedulingProcess: number;
    /** Overall Satisfaction (1 - 5, 5 being best) of inspector's timeliness */
    didInspectorArriveOnTime: number;
    /** Overall Satisfaction (1 - 5, 5 being best) with inspectors professionalism and communication */
    inspectorsProfessionalismAndCommunication: number;
    /** Overall Satisfaction (1 - 5, 5 being best) */
    overallSatisfaction: number;
    /** Survey text repsonse */
    howCanWeImproveTheExperience: string | undefined;
    /** Local Creation Date of the Survey */
    dateCreated: Date;
}

export interface CustomerScorecardData {
    timeInFieldServicesScore: string | undefined;
    timeInFieldServicesActual: string | undefined;
    timeInQualityAssuranceScore: string | undefined;
    timeInQualityAssuranceActual: string | undefined;
    percentCompletedOnTimeScore: string | undefined;
    percentCompletedOnTimeActual: string | undefined;
    disputePercentScore: string | undefined;
    disputePercentActual: string | undefined;
    muellerRepProceduralViolationsScore: string | undefined;
    muellerRepProceduralViolationsActual: string | undefined;
}

/** Search options */
export interface CustomerSearchOptions {
    /** A customer number to filter for */
    customerNumber: number | undefined;
    /** A free text search */
    searchTerm: string | undefined;
}

/** Results of a customer search */
export interface CustomerSearchResult {
    /** Matching customers */
    searchResults: CustomerListModel[] | undefined;
}

/** User that can be assigned */
export interface CustomerServiceAssignToUser {
    /** Login Id */
    internetUserId: number;
    /** First Name */
    firstName: string | undefined;
    /** Last Name  */
    lastName: string | undefined;
    /** LastName, FirstName */
    lastFirstName: string | undefined;
    /** FirstName LastName */
    firstLastName: string | undefined;
    /** Employee Department Code */
    departmentCode: string | undefined;
}

/** Model for sending emails from Mueller Enterprise */
export interface EmailModel {
    /** Case this email is regarding */
    controlNumber: number;
    /** The email to send from */
    from: string | undefined;
    /** List of email addresses to send to */
    to: string[] | undefined;
    /** List of email addresses to cc */
    cc: string[] | undefined;
    /** List of email addresses to bcc */
    bcc: string[] | undefined;
    /** Subject of email */
    subject: string | undefined;
    /** Text to be added to email body */
    note: string | undefined;
    /** Attachment file names from case files */
    attachments: string[] | undefined;
    /** Guids for photos to include as attachments */
    photos: string[] | undefined;
}

/** Model for sending emails to customer service from Mueller Enterprise */
export interface CustomerServiceEmailModel extends EmailModel {
    /** The reason code for the email to customer service */
    reasonTypeCode: string | undefined;
}

/** Customer Service Error Option Enum */
export enum CustomerServiceErrorOptionEnum {
    CALL_CENTER_REP_ERROR = 1,
    FR_ERROR = 2,
    FR_CALL_CENTER_REP_QA_ERROR = 3,
    NONE = 4,
    QA_ERROR = 5,
    AP_ERROR = 6,
    AP_QA_ERROR = 7,
    FS_QA_ERROR_LENDER = 8,
}

/** used to add a customer service incident */
export interface CustomerServiceIncidentAdd {
    /** Control Number of Case */
    controlIdNumber: number;
    /** User submitting incident. */
    createdByUserId: number;
    /** User assigned the incident (not required). */
    assignedInternetUserId: number | undefined;
    /** Status of Incident */
    status: string | undefined;
    /** User group that the error occurred in. */
    errorOption: CustomerServiceErrorOptionEnum | undefined;
    /** Database type code (Use Static DatabaseTypeCodes class) */
    databaseTypeCode: string;
    /** Customer service person (use static CustomerServicePersonCodes class) */
    personTypeCode: string;
    /** Reason for Incident (use static CustomerServiceReasonCodes class) */
    reasonTypeCode: string;
    /** Notes regarding the actual incident */
    note: string | undefined;
    /** Assigned Department Code */
    assignedDepartment: string | undefined;
    /** Uploaded attachment to add to new Incident (by attachment lookup key) */
    attachments: string[] | undefined;
    /** The name of the customer UW that initiated the incident */
    replyToName: string | undefined;
    /** The reply email of the customer UW that initiated the incident */
    replyToEmail: string | undefined;
    /** The reply phone of the customer UW that initiated the incident */
    replyToPhone: string | undefined;
}

/** Used to add an appraiser rejection to QA customer service incident */
export interface CustomerServiceIncidentAddAppraiserRejection {
    /** Control Number of Case */
    controlIdNumber: number;
    /** Reason for rejection (use static CustomerServiceReasonCodes class) */
    reasonTypeCode: string;
    /** Notes regarding the rejection */
    note: string;
}

/** used to add a customer service incident */
export interface CustomerServiceIncidentAddFromCustomer {
    /** Control Number of Case */
    controlIdNumber: number;
    /** Reason for Incident (use static CustomerServiceReasonCodes class) */
    reasonTypeCode: string;
    /** Notes regarding the actual incident */
    note: string | undefined;
    /** Uploaded attachment to add to new Incident (by attachment lookup key) */
    attachments: string[] | undefined;
    /** CC address for the incident confirmation email */
    emailCc: string | undefined;
}

/** Represents attachments for an incident */
export interface CustomerServiceIncidentAttachmentMetadata {
    /** Lookup key/ID for queries (so we're not exposing primary key) */
    lookupKey: string;
    /** Name of file */
    fileDisplayName: string | undefined;
    /** Date attachment was uploaded */
    createDate: Date;
    /** Internet User that created the attachment */
    createdByUser: string | undefined;
}

export interface CustomerServiceIncidentDto {
    /** date the incident was made */
    dateCreated: Date;
    /** date the incident was last updated */
    dateUpdated: Date;
    /** Unique Id of Incident */
    id: number;
    /** Enum for the type of history item */
    historyType: HistoryType;
    /** Call Reason Code / Name */
    callReason: CodeValuePair | undefined;
    /** Dispute Notes */
    details: string | undefined;
    /** Person is was assigned to */
    assignedTo: string | undefined;
    /** Person is assigned to user id */
    assignedInternetUserId: number | undefined;
    /** User who created the incident */
    performedBy: string | undefined;
    /** User id who created the incident (user id) */
    performedByUserId: number;
    /** Case Id */
    controlIdNumber: number;
    /** The status of the incident */
    status: CustomerServiceStatusEnum | undefined;
    /** Human readable status */
    statusName: string | undefined;
    /** Error Option Code / Name */
    errorOption: CodeValuePair | undefined;
    /** Was this a QA Issue base on Error Option */
    isFieldServiceQAIssue: boolean;
    /** Person Type Code / Name */
    personType: CodeValuePair | undefined;
    /** Additional notes */
    notes: CustomerServiceIncidentNoteDto[] | undefined;
    /** Incident attachments */
    attachments: CustomerServiceIncidentAttachmentMetadata[] | undefined;
    /** Assigned Department */
    assignedDepartment: CodeValuePair | undefined;
    /** The name of the customer UW that initiated the incident */
    replyToName: string | undefined;
    /** The reply email of the customer UW that initiated the incident */
    replyToEmail: string | undefined;
    /** The reply phone of the customer UW that initiated the incident */
    replyToPhone: string | undefined;
}

export enum CustomerServiceStatusEnum {
    UNKNOWN = 0,
    OPEN = 1,
    CLOSED = 2,
}

/** DTO to add or modify an incident note */
export interface CustomerServiceIncidentNoteDto {
    /** Note Id */
    id: number;
    /** Text of the note */
    note: string | undefined;
    /** Date the note was added */
    createdDate: Date;
    /** Internet User that created the note */
    createdByUser: string | undefined;
}

/** DTO to add or modify an incident note */
export interface CustomerServiceIncidentNoteAdd {
    /** Text of the note */
    note: string | undefined;
}

/** Assign multiple incidents model */
export interface CustomerServiceIncidentsAssign {
    /** List of incident ids to assign */
    incidentIds: number[] | undefined;
    /** Internet User Id to assign incidents to */
    internetUserId: number;
}

/** Incident Status options */
export interface CustomerServiceIncidentStatusCodes {
}

/** Update incident model */
export interface CustomerServiceIncidentUpdate {
    /** Primary key of Incident */
    id: number;
    /** User the incident is assigned to */
    assignedInternetUserId: number | undefined;
    /** Status of Incident */
    status: string;
    /** User group that the error occurred in. */
    errorOption: CustomerServiceErrorOptionEnum | undefined;
    /** Customer service person (use static CustomerServicePersonCodes class) */
    personTypeCode: string;
    /** Reason for Incident (use static CustomerServiceReasonCodes class) */
    reasonTypeCode: string;
    /** Notes regarding the actual incident */
    note: string;
    /** Assigned Department Code */
    assignedDepartment: string | undefined;
    /** The name of the customer UW that initiated the incident */
    replyToName: string | undefined;
    /** The reply email of the customer UW that initiated the incident */
    replyToEmail: string | undefined;
    /** The reply phone of the customer UW that initiated the incident */
    replyToPhone: string | undefined;
}

/** Customer Service Person type */
export interface CustomerServicePersonCodes {
}

/** List of Customer Service Call Reason for an inquiry/Incident */
export interface CustomerServiceReasonCodes {
}

/** Customer survey type configuration options */
export interface CustomerSurveyTypeDto {
    /** Survey Type Name */
    surveyTypeName: string | undefined;
    /** Customer Id */
    customerId: number;
    /** The customer number */
    customerNumber: number;
    /** The customer name and number */
    customerName: string | undefined;
    /** The survey type id */
    surveyTypeId: number;
    /** Survey type code */
    surveyTypeCode: string | undefined;
    /** The customer friendly report name */
    customerFriendlyReportName: string | undefined;
    email: string | undefined;
    inactiveDate: Date | undefined;
    totalDaysUntilDue: number;
    pdfReportAssemblyClass: string | undefined;
    /** Not a real field, but if set true, it will update the class to the phoenix pdf generator */
    usePhoenixPdf: boolean;
    /** Can be converted to a different survey type */
    canBeDemoted: boolean;
    /** Default number of days to wait until starting cases used to populate CaseHeader.DateReceived on new cases */
    daysHold: number;
    isOnSite: boolean;
    isCallCenter: boolean;
    isConsumerWeb: boolean;
    isAppraisalSurvey: boolean;
    isSchedulingQueueEligible: boolean;
    qaDirector: string | undefined;
    qaManager: string | undefined;
    qaQueueReturnedRejectionTimeoutHours: number | undefined;
    qaExpectedMinutes: number;
    /** This skips the inspection and goes directly to QA (most virtual survey) */
    skipFieldServices: boolean;
    /** Load case in QA summary view if the account has the feature enabled */
    enableQaSummaryView: boolean;
    /** Subscribe this account survey type to SignalR case event message hub while reviewing cases */
    enableCaseEventMessages: boolean;
    qaRuleItvCoverageAInMin: number | undefined;
    qaRuleItvMgrReviewMin: number | undefined;
    qaRuleItvMgrReviewMax: number | undefined;
    qaRuleItvWarningMin: number | undefined;
    qaRuleItvWarningMax: number | undefined;
    qaRuleRcPerSqftMin: number | undefined;
    qaRuleRcPerSqftMax: number | undefined;
    isAppointmentRequired: boolean;
    frExpectedSiteTime: number | undefined;
    frExpectedDeskTime: number | undefined;
    rejectionFee: number | undefined;
    incentivePercent: number;
    fieldServicesTimeServiceDays: number;
    photoRequirements: string | undefined;
    phonePreNotificationRequired: boolean;
    phonePreNotificationInstructions: string | undefined;
    phonePreNotificationCallScript: string | undefined;
    frExpectedSiteTimeDefault: number;
    frExpectedDeskTimeDefault: number;
    skipFieldServicesQa: boolean;
    enableFieldServicesAutoQa: boolean;
    skipAppraisalQa: boolean;
    appraisalExpectedMinutes: number | undefined;
    appraiserHoursTillDue: number;
    valuationServicesTimeServiceDays: number;
    appraisalQaExpectedMinutes: number;
    fieldServiceAutoQaItvPercentRangeCheck: boolean;
    fieldServiceAutoQaStartDate: Date | undefined;
    fieldServiceAutoQaSketchCheck: string | undefined;
    fieldServiceAutoQaCaseDataVerificationsCheck: boolean;
    enableCallCenterAutoQa: boolean;
    supplementFreeCount: number;
    /** Url to the customer survey type billing rules website */
    customerSurveyTypeBillingConfigurationLink: MCardHyperlinkAddress | undefined;
    /** Url to the customer billing rules website */
    customerBillingRulesLink: MCardHyperlinkAddress | undefined;
    fieldServicesBillingPercent: number;
    valuationServicesBillingPercent: number;
    myriadMaxPhotos: number | undefined;
    appraisalExpectedMinutesDefault: number;
}

/** A hyperlink address for mCard */
export interface MCardHyperlinkAddress {
    /** The text to show for the link */
    label: string | undefined;
    /** The url that the link goes to  */
    onClick: string | undefined;
}

/** Customer survey type form */
export interface CustomerSurveyTypeFormDto {
    /** Form name */
    name: string | undefined;
    /** Form code (cCode from AvailForms) */
    formCode: string | undefined;
    /** Display order of form */
    displayOrder: number;
    /** Is an optional form for the survey type */
    isSupplement: boolean;
    /** Optional fee for this form */
    customerFee: number | undefined;
    /** Field Rep editable form */
    isOnSite: boolean;
    /** Call Center editable form */
    isCallCenter: boolean;
    /** Policyholder editable form */
    isConsumerWeb: boolean;
    /** Optional calc tool code associated to this form */
    calcToolCode: string | undefined;
    /** Optional form can be added by Field Reps */
    isFieldSupplement: boolean;
    /** Do not display form to Field Reps */
    isHiddenFromFR: boolean;
    /** Do not display form to QA */
    isHiddenFromQA: boolean;
    /** Do not display form to Customers */
    isHiddentFromCustomer: boolean;
    /** Do not display form to Appraisers */
    isHiddenFromAppraiser: boolean;
    /** Do not display form to Customer Experience Reps */
    isHiddenFromCER: boolean;
    /** Pnx form ID if it has one */
    phoenixFormId: string | undefined;
}

/** CompleteForm MCard field constants */
export interface CustomerSurveyTypePropertiesKeyPath {
}

/** Stamp DTO */
export interface CustomerSurveyTypeStampDto {
    /** Stamp Id */
    stampId: number | undefined;
    /** Complete Form Id) */
    completeFormId: number;
    /** Stamp Text */
    text: string | undefined;
    /** Sort Order */
    sortOrder: number | undefined;
}

/** Constants for CustomerType codes */
export interface CustomerTypeCodeConstants {
}

export enum CustomerTypeEnum {
    Insurance = 0,
    Lender = 1,
    Both = 2,
}

/** Customer update request */
export interface CustomerUpdateRequest {
    /** Customer Number */
    customerNumber: number;
    /** Name */
    name: string;
    /** Display Name */
    displayName: string;
    /** CompanyId */
    companyId: number;
    /** Address1 */
    address1: string;
    /** Address2 */
    address2: string | undefined;
    /** City */
    city: string;
    /** State */
    stateAbbreviation: string;
    /** Zip */
    zip: string;
    /** Email */
    email: string | undefined;
    /** PhoneNumber */
    phoneNumber1: string | undefined;
    /** PhoneNumber2 */
    phoneNumber2: string | undefined;
    /** InactiveDate */
    inactiveDate: Date | undefined;
    /** Email CC */
    emailCC: string | undefined;
    /** Email BCC */
    emailBCC: string | undefined;
    /** Email File Name Option Code */
    emailFileNameOptionCode: string | undefined;
    /** Email Format Code */
    emailFormatCode: string | undefined;
    /** Audit Percentage */
    auditPercentage: number;
}

/** An estimated ordering volume by county */
export interface CustomerVolumeEstimateByCountyDto {
    /** FIPS identifier for the county */
    countyId: number;
    /** Customer number */
    customerNumber: number;
    /** Estimated quantity of orders per month */
    estimatedOrdersMonthly: number | undefined;
}

/** Structure for data sent in the volume estimate email */
export interface CustomerVolumeEstimateByCountyEmail {
    /** Display name of the user submitting the estimate */
    submittedByName: string | undefined;
    /** Email address of the user submitting the estimate */
    submittedByEmailAddress: string | undefined;
    /** The date/time (UTC) this request was submitted */
    submittedOnDateUtc: Date;
    /** The submitted volume estimates */
    volumeEstimates: CustomerVolumeEstimateByCountyEmailDto[] | undefined;
    /** General comments from the estimate */
    comments: string | undefined;
}

/** Ordering volume estimate DTO */
export interface CustomerVolumeEstimateByCountyEmailDto extends CustomerVolumeEstimateByCountyDto {
    /** State display name */
    stateNameAbbreviation: string | undefined;
    /** Customer name and number */
    customerNameNumber: string | undefined;
    /** County display name */
    countyName: string | undefined;
    /** Count of available appraisers */
    appraisersAvailableCount: number;
}

/** Customer Volume Estimate */
export interface CustomerVolumeEstimateDto {
    /** The volume estimates */
    customerVolumeEstimateByCounty: CustomerVolumeEstimateByCountyDto[] | undefined;
    /** Additional notes supplied by the user */
    comments: string | undefined;
}

/** Amounts by day */
export interface DailyAmount_1 {
    /** Amounts for the day */
    AmountByDayList: T | undefined;
}

/** List of time by Day */
export interface DailyTime {
    /** List of Time By Day values */
    timeByDayList: TimeByDay[] | undefined;
}

/** Time by Day values for each day */
export interface TimeByDay {
    /** The day of the week  */
    dayOfWeek: DayOfWeek;
    /** Actual date of the day */
    date: Date;
    /** Hours for the day */
    hours: number;
}

/** Appraiser Dashboard page view model */
export interface DashboardModel {
    /** List of cases assigned to the currrent appraiser
             */
    appraiserCases: SearchResultViewModel | undefined;
    /** Profiel for the appraiser
             */
    appraiserViewModel: AppraiserViewModel | undefined;
    /** Statistics for the appraiser
             */
    appraiserStatistics: UserStatistics | undefined;
    /** Notifications sent to the current user
             */
    userNotifications: UserNotification[] | undefined;
}

export interface SearchResultViewModel {
    /** Generic options for the set of results. */
    options: SearchResultOptions | undefined;
    /** List of display columns to show with the results. */
    columns: ColumnViewModel[] | undefined;
    /** List of items to be retruned */
    rows: any[] | undefined;
    /** This should only be emitted in Debug/Test */
    sql: string | undefined;
    count: number;
}

export interface SearchResultOptions {
    rowType: string | undefined;
    title: string | undefined;
    description: string | undefined;
    warning: string | undefined;
}

export interface UserStatistics {
    /** Number of Cases calculated for a date range.
             */
    appraiserStatus: StatisticItem[] | undefined;
    /** Number of cases for current year
             */
    managerStatus: StatisticItem[] | undefined;
    /** Number of cases in the homeowner area.
             */
    homeownerStatus: StatisticItem[] | undefined;
    appraisalsThisMonth: number;
    appraisalsThisYear: number;
    openAppraisals: number;
}

export interface StatisticItem {
    name: string | undefined;
    code: string | undefined;
    count: number;
}

export interface UserNotification {
    id: number;
    notificationType: string | undefined;
    createDate: Date;
    createdByUserId: number;
    createdBy: string | undefined;
    message: string | undefined;
    controlIdNumber: number;
}

/** Extensions for DataAnnotations */
export interface DataAnnotationExtensions {
}

/** Database type codes used in MuellerGlobalData */
export interface DatabaseTypeCodes {
}

export interface DataContainer {
    smartGridData: SmartGridData | undefined;
}

export interface SmartGridData {
    rawData: RawData | undefined;
}

export interface RawData {
    dataStrings: number[][] | undefined;
    fields: Fields | undefined;
}

export interface Fields {
    data: Column[] | undefined;
}

/** Api result.  This should hold different tyles of Datw. */
export interface DataVendorApiResult {
    /** Status */
    status: DataVendorStatus | undefined;
    /** Return url.  This should be expanded upon. */
    data: DataVendorReturnUrl | undefined;
}

/** Api call back status */
export interface DataVendorStatus {
    /** Success */
    success: boolean;
    /** Http status code */
    code: number;
    /** Success of Failure message for the user */
    message: string | undefined;
    /** Longer message for the user. */
    userMessage: string | undefined;
}

/** Wrapper for a return url */
export interface DataVendorReturnUrl {
    /** Url to webpage that will interpret and display the result. */
    returnUrl: string | undefined;
}

/** Setup token url parameter for a Data Vendor callback operation. */
export interface DataVendorCallback {
    /** Case # */
    controlNumber: number;
    /** Data Vendor code name */
    vendorCode: string | undefined;
    /** Format Code name for a data vendor operation */
    formatCode: string | undefined;
    /** Date time stamp when we will NOT honor the response. */
    expires: Date;
    /** Data vendor operation id for this transaction. */
    operationId: number;
}

/** Case Data Vendor Codes */
export interface DataVendorCode {
}

/** Case Data Vendor Operation Type Codes */
export interface DataVendorOperationTypeCode {
}

/** Handle a response from an API */
export interface DataVendorResponse {
    /** Control case # */
    controlNumber: number;
    /** Success */
    success: boolean;
    /** Http Status code in leiu of a Human readable message for success or failure */
    statusCode: number;
    /** Result message stored in Case Attributes PropmixResultMessage record. */
    message: string | undefined;
}

/** Data Verification Category Ids */
export enum DataVerificationCategoryId {
    RCT = 10000,
    DWELLING_STYLE = 10001,
    ROOF_STYLE = 10002,
    EXTERIOR_WALL_MATERIAL = 10003,
    EXTERIOR_ROOF_MATERIAL = 10004,
    DETACHED_STRUCTURE = 10005,
    ATTACHED_STRUCTURE = 10006,
    FOUNDATION_TYPE = 10007,
    FOUNDATION_MATERIAL = 10008,
    AI = 20000,
    PHOTO_ANALYSIS = 20001,
    TAX_RECORD = 30000,
    YEAR_BUILT = 30001,
    NUMBER_OF_FAMILIES = 30002,
    LIVING_AREA = 30003,
    COVERAGE_A = 40000,
    ITV = 40001,
    SKETCH = 50000,
}

/** Constants for data verification category values. */
export interface DataVerificationCategoryValues {
}

/** Datetimestamp */
export interface Datetimestamp {
    /** forced */
    forced: boolean;
    /** disabled */
    disabled: boolean;
}

/** Data structure representing a Date and a time slot */
export interface DaySlot {
    day: Date;
    appointmentTimeSlotCode: AppointmentTimeRangeEnum;
}

/** Request to delete all case watches for a specific case event ID for a user */
export interface DeleteByEventRequest {
    /** Internet User ID */
    internetUserId: number;
    /** Case Event IDs */
    caseEventIds: number[] | undefined;
}

/** Department Dto */
export interface DepartmentDto {
    /** Primary key */
    id: number;
    /** Unique Code */
    code: string | undefined;
    /** Name */
    name: string | undefined;
}

/** Descriptions */
export interface Descriptions {
    /** disabled */
    disabled: boolean;
}

/** Detached Structure Cost */
export interface DetachedStructureCost extends Cost {
    /** Percent Of Primary Structure IRC Specified */
    percentOfPrimaryStructureIRCSpecified: boolean;
    /** Percent Of Primary Structure IRC */
    percentOfPrimaryStructureIRC: number;
}

/** Detached Structure Non Standardized Cost */
export interface DetachedStructureNonStandardizedCost extends DetachedStructureCost {
}

/** Detached Structure Standardized Cost */
export interface DetachedStructureStandardizedCost extends DetachedStructureCost {
    /** Debris Removal */
    debrisRemoval: number;
    /** Subtotal After Debris Removal */
    subtotalAfterDebrisRemoval: number;
}

/** Case history */
export interface DetailedCaseHistory {
    /** all history items combined */
    all: GenericHistory[] | undefined;
    /** call log collection */
    callLogs: CallLog[] | undefined;
    /** cs notes collection */
    csNotes: CustomerServiceIncidentDto[] | undefined;
    /** case issues */
    issues: CaseIssue2[] | undefined;
    /** internal notes */
    internalNotes: InternalNote[] | undefined;
    /** private notes field on the case */
    privateNotes: string | undefined;
    /** time logs */
    timeLogs: TimeLog[] | undefined;
    /** touches */
    touches: CaseTouch[] | undefined;
    /** system touches */
    systemTouches: SystemTouch[] | undefined;
    /** List of note that are external */
    externalNotes: ExternalNote[] | undefined;
    /** List of preferred appointments */
    preferredAppointments: PreferredAppointmentHistory[] | undefined;
    /** List of appraiser notes */
    appraiserNotes: AppraiserNote[] | undefined;
    /** Changes logged in DataChangesetItems */
    entityLogs: GenericHistory[] | undefined;
    /** Case events of appointment added */
    appointmentChanges: GenericHistory[] | undefined;
}

/** History item that will be used for the collection of all history items */
export interface GenericHistory {
    /** Date Created */
    dateCreated: Date | undefined;
    /** History Type */
    historyType: HistoryType;
    /** Details */
    details: string | undefined;
    /** Performed By */
    performedBy: string | undefined;
}

/** internal note */
export interface InternalNote extends CaseNoteDto {
    /** Enum for the type of history item */
    historyType: HistoryType;
}

/** Time Log */
export interface TimeLog {
    /** Id from the database table this history type came from */
    id: number;
    /** Enum for the type of history item */
    historyType: HistoryType;
    /** Date the log was created */
    dateCreated: Date;
    /** Notes on the log */
    details: string | undefined;
    /** Who performed the action */
    performedBy: string | undefined;
}

/** Touch */
export interface SystemTouch {
    /** Id from the database table this history type came from */
    id: number;
    /** Enum for the type of history item */
    historyType: HistoryType;
    /** Date the log was created */
    dateCreated: Date;
    /** Type of Touch */
    touchType: string | undefined;
    /** Notes on the log */
    details: string | undefined;
}

export interface ExternalNote extends CaseNoteDto {
    historyType: HistoryType;
}

/** Case history preferred appointment */
export interface PreferredAppointmentHistory {
    /** History tye */
    historyType: HistoryType;
    /** Date the appointment was set */
    dateCreated: Date;
    /** Created by user type */
    userType: string | undefined;
    /** Appointment date */
    appointmentDate: Date;
    /** Appointment time */
    appointmentTime: string | undefined;
    /** Contact type */
    contactType: string | undefined;
    /** Contact value */
    contactValue: string | undefined;
}

/** used to disable a user right */
export interface DisableInternetUserRightDto {
    internetUserId: number;
    rightNames: string[] | undefined;
}

/** Data Structure to streamline front-end referencing of caseheader fields */
export interface DisplayField {
    /** Field's ID, stays constant for a piece of data */
    id: string | undefined;
    /** The Field's Value */
    value: string | undefined;
}

/** enum for keeping track of what fields correspond to what IDs */
export enum DisplayFieldIds {
    PolicyHolder = 0,
    PolicyNumber = 1,
    FieldRepNumber = 2,
    SurveyAddress = 3,
    County = 4,
    GeoCode = 5,
    ReportType = 6,
    MuellerIDNumber = 7,
    CompanyName = 8,
    DateOrdered = 9,
    DateSurveyed = 10,
    DateCompleted = 11,
    PrimaryStatus = 12,
    WebStatus = 13,
    AppraisalStatus = 14,
    MailingAddress = 15,
    MailingCounty = 16,
    CustomerDueDate = 17,
    TrackingNumber = 18,
    SurveyState = 19,
}

/** Class that wraps an Image created from a stream so that both resources are disposed */
export interface DisposableImageResult {
    /** Image from backing stream */
    image: string | undefined;
}

/** Distance Matrix Request */
export interface DistanceMatrixPointRequest {
    /** List of destinations if multiple */
    destinationPoints: Coordinate[] | undefined;
    /** List of starting point if multiple */
    startPoints: Coordinate[] | undefined;
    /** Optionally specify a desired arrival time to run calculation with time of day / traffic functionality. */
    arrivalTime: Date | undefined;
    /** Optionally specify a desired departure time to run calculation with time of day / traffic functionality. */
    departureTime: Date | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfDistinguishedBrokerEmail extends TypeSafeEnum {
}

/** Distinguished broker email process */
export interface DistinguishedBrokerEmail extends TypeSafeEnumOfDistinguishedBrokerEmail {
}

/** Drawing */
export interface Drawing {
    /** disabled */
    disabled: boolean;
}

/** DTO for the 1004D Form Fields */
export interface DTO_1004D {
    muellerName: string | undefined;
    /** Lender/Customer Name */
    customerCompanyName: string | undefined;
    /** Lender/Customer Address */
    customerCompanyAddress: string | undefined;
    /** Date of Inspection */
    dateOfInspection: Date | undefined;
    /** Appraiser Name */
    appraiserName: string | undefined;
    /** License Certification Number */
    licenseCertificationNumber: string | undefined;
    /** State of License Certification */
    licenseState: string | undefined;
    /** License Expiration Date */
    licenseExpirationDate: Date | undefined;
}

/** DTO for the Completion Form Fields */
export interface DTO_CompletionForm {
    /** Original Lender/Customer Name */
    originalLenderClient: string | undefined;
    /** Original Lender/Customer Address */
    originalLenderAddress: string | undefined;
    /** Data Collector Name */
    propertyDataCollectorName: string | undefined;
    /** Lender/Customer Name */
    lenderClientCompanyName: string | undefined;
    /** Lender/Customer Address */
    lenderClientCompanyAddress: string | undefined;
}

/** Field Rep Due date extension request */
export interface DueDateExtensionRequest {
    /** ControlIdNumber */
    controlIdNumber: number;
    /** FieldRepNumber */
    fieldRepNumber: number;
    /** Requested Due Date */
    dueDate: Date;
    /** Details for email to manager */
    details: string | undefined;
}

/** Field Rep Due date extension response */
export interface DueDateExtensionResponse {
    /** Indicated whether the extension request was processed successfully */
    success: boolean;
    /** Indicates the extensions request was automatically approved */
    autoApproved: boolean;
    /** Response Message */
    message: string | undefined;
}

export interface DueDateType {
}

/** Dwelling Blocks Notes */
export interface DwellingBlockNoteRequest {
    /** Note to send */
    note: string | undefined;
    /** Does this message require attention */
    requiresAttention: boolean;
}

/** Response from call to connect to E2Value */
export interface E2ValueConnectResponse {
    /** Url to E2Value Calculator */
    url: string | undefined;
}

/** View Model for MultiFactor verification */
export interface EditMultiFactorRequestDto {
    multiFactorMethod: string;
    /** True to remove the MFA method */
    removeMethod: boolean;
    /** Settings to update MFA method to */
    settingsJson: string;
}

/** View Model for MultiFactor verification */
export interface EditMultiFactorVerifyRequestDto {
    /** MFA method */
    multiFactorMethod: string;
    verificationCode: string;
}

export interface RightsAttribute extends Attribute2 {
    rights: string[] | undefined;
}

export interface EditRightsAttribute extends RightsAttribute {
}

/** Allow assigning course group to employee. */
export interface EmployeCourseAddByGroupRequest {
    /** Course Group Id */
    courseGroupId: number;
    /** Employee that needs to be assigned */
    employeeId: number;
    /** Date employee needs to complete the course */
    dueDate: Date;
    /** Course Has notifications enabled or not */
    notificationEnabled: boolean;
}

/** Used to Add a new Employee */
export interface EmployeeAddRequest {
    /** unique Payroll Id associated to the employee from the HR system */
    payrollEmployeeId: string;
    /** Login User Id */
    internetUserId: number;
    /** Role of the employee */
    role: EmployeeRoleEnum;
    /** Employee First Name */
    firstName: string;
    /** Employee Last Name */
    lastName: string;
    /** work Phone */
    workPhone: string | undefined;
}

/** Employee Admin Time Log Add */
export interface EmployeeAdminTimeLogAddRequest {
    /** Employee Id Work Log is for */
    employeeId: number;
    /** The type of work that was performed (EmployeeAdminWorkTypes) */
    workTypeCode: string;
    /** Time spent in Minutes */
    timeMinutes: number;
    /** Date the work was performed (Needs to be in a pending pay period) */
    workDate: Date;
    /** Note associated to the work log */
    note: string;
}

/** Employee Admin Time Log Delete */
export interface EmployeeAdminTimeLogDeleteRequest {
    /** Primary key of Inspector Admin Work Log */
    id: number;
}

export interface EmployeeAdminTimeLogDto {
    /** Inspector Number Work Log is for */
    id: number;
    /** Inspector Number */
    employee: NameNumberDto | undefined;
    /** Pay Period information */
    payPeriod: PayPeriodDto | undefined;
    /** Time spent in Minutes */
    timeMinutes: number;
    /** Date the work was performed (Needs to be in a pending pay period) */
    workDate: Date;
    /** The type of work that was performed (InspectorAdminWorkTypeCode) */
    workType: EmployeeAdminTimeLogTypeDto | undefined;
    /** Note associated to the work log */
    note: string | undefined;
}

/** Employee Admin Time Log Type */
export interface EmployeeAdminTimeLogTypeDto {
    /** Primary key */
    id: number;
    /** Unique Code */
    code: string | undefined;
    /** Name */
    name: string | undefined;
}

/** Employee Admin Time log Update Request */
export interface EmployeeAdminTimeLogUpdateRequest {
    /** Primary key to update */
    id: number;
    /** The type of work that was performed (EmployeeAdminWorkTypeCode) */
    workTypeCode: string;
    /** Time spent in Minutes */
    timeMinutes: number;
    /** Date the work was performed (Needs to be in a pending pay period) */
    workDate: Date;
    /** Note associated to the work log */
    note: string;
}

/** Employee Calendar Add Request */
export interface EmployeeCalendarAddRequest {
    /** Employee Id that owns the Event */
    employeeId: number;
    /** Event type */
    calendarEventType: CalendarEventTypeEnum;
    /** Description of the calendar event */
    description: string | undefined;
    /** When the event starts date and time */
    startDateTime: Date;
    /** When the event ends time (date will be the same start date time) */
    endDateTime: Date;
    /** Timezone offset the user's browser was in when they made the event */
    timezoneOffsetHours: number;
    /** If the calendar event is recurring it will recur until this date
If the calendar event does not recur this will be null */
    recursUntilDate: Date | undefined;
    /** What days of the week the event recurs on */
    recursOn: EmployeeCalendarRecurDays | undefined;
    /** InternetUserId of user creating event */
    createdByInternetUserId: number;
}

/** Specify what days of the week something recurs on */
export interface EmployeeCalendarRecurDays {
    /** Wether or not this recurs on Sunday */
    sunday: boolean;
    /** Wether or not this recurs on Monday */
    monday: boolean;
    /** Wether or not this recurs on Tuesday */
    tuesday: boolean;
    /** Wether or not this recurs on Wednesday */
    wednesday: boolean;
    /** Wether or not this recurs on Thursday */
    thursday: boolean;
    /** Wether or not this recurs on Friday */
    friday: boolean;
    /** Wether or not this recurs on Saturday */
    saturday: boolean;
}

/** Employee Calendar Add Request */
export interface EmployeeCalendarDeleteRequest {
    /** Employee Id that owns the Event */
    employeeId: number;
    /** Id of the calendar update */
    id: number;
    /** Specifies what part of the event we are updating if it is a recurring event */
    updateType: CalendarUpdateEnum | undefined;
    /** What part of the recurring event to update if we are just updating one day, or this day and future events */
    dateToUpdate: Date | undefined;
}

/** Slim class for representing the basics of a calendar event */
export interface SimpleCalendarEvent {
    /** Event type */
    calendarEventType: CalendarEventTypeEnum;
    /** When the event starts date and time */
    startDateTime: Date;
    /** When the event ends time (date will be the same start date time) */
    endDateTime: Date;
}

/** Dto for Employee Calendar */
export interface EmployeeCalendarDto extends SimpleCalendarEvent {
    /** Id of the calendar update.

When this is returning from "IInspectorCaseOperations.GetCaseAppointments" (CalendarEventType of FieldInspectionAppointment),
this is the case ControlIdNumber. Not great to reuse fields in this manner. */
    id: number;
    /** Employee Id that this event is linked to */
    employeeId: number;
    /** Description of the calendar event */
    description: string | undefined;
    /** If the calendar event is recurring it will recur until this date
If the calendar event does not recur this will be null */
    recursUntilDate: Date | undefined;
    /** What days of the week the event recurs on */
    recursOn: EmployeeCalendarRecurDays | undefined;
}

/** Employee Calendar Event Request */
export interface EmployeeCalendarEventRequest {
    /** Start Date of appointments */
    startDateTime: Date;
    /** End date of appointments */
    endDateTime: Date | undefined;
}

/** Employee Calendar Add Request */
export interface EmployeeCalendarUpdateRequest {
    /** Employee Id that owns the Event */
    employeeId: number;
    /** Id of the calendar update */
    id: number;
    /** Specifies what part of the event we are updating if it is a recurring event */
    updateType: CalendarUpdateEnum | undefined;
    /** What part of the recurring event to update if we are just updating one day, or this day and future events */
    dateToUpdate: Date;
    /** Event type */
    calendarEventType: CalendarEventTypeEnum;
    /** Description of the calendar event */
    description: string | undefined;
    /** When the event starts date and time */
    startDateTime: Date;
    /** When the event ends time (date will be the same start date time) */
    endDateTime: Date;
    /** If the calendar event is recurring it will recur until this date
If the calendar event does not recur this will be null */
    recursUntilDate: Date | undefined;
    /** What days of the week the event recurs on */
    recursOn: EmployeeCalendarRecurDays | undefined;
}

/** DTO to add an employee complaint */
export interface EmployeeComplaintAddRequest {
    /** EmployeeId associated with the complaint */
    employeeId: number;
    /** Category code of the complaint */
    complaintCategoryCode: string | undefined;
    /** Complaint description */
    description: string | undefined;
    /** Optional ControlIdNumber related to complaint */
    controlIdNumber: number | undefined;
    /** Optional CustomerNumber related to complaint */
    customerNumber: number | undefined;
    /** Attachment LookupKeys related to complaint */
    attachments: string[] | undefined;
    /** Optional SurveyScore related to policyholder survey */
    surveyScore: number | undefined;
}

/** Client side class for viewing employee complaint attachments */
export interface EmployeeComplaintAttachmentResponse {
    /** Unique key of attachment */
    lookupKey: string;
    /** FileName for dsiplay on client */
    fileName: string | undefined;
    /** File mime type */
    mimeType: string | undefined;
}

/** Codes from EmployeeComplaintCategories */
export interface EmployeeComplaintCategoryCodes {
}

/** DTO for employee complaint categories */
export interface EmployeeComplaintCategoryDto {
    /** Id Primary Key */
    id: number;
    /** Category Name */
    name: string | undefined;
    /** Category Name */
    code: string | undefined;
}

/** Client side class for viewing employee complaints */
export interface EmployeeComplaintResponse {
    /** Date complaint was entered */
    dateCreated: Date;
    /** First + Last name of internet user that entered the complaint */
    enteredByUser: string | undefined;
    /** Display name of complaint category */
    categoryName: string | undefined;
    /** Description of the complaint */
    description: string | undefined;
    /** Control number associated with the complaint (optional) */
    controlIdNumber: number | undefined;
    /** Customer number associated with the complaint (optional) */
    customerNumber: number | undefined;
    /** Customer number and name used for display purposes */
    customerNameNumber: string | undefined;
    /** File attachments associated with the complaint */
    attachments: EmployeeComplaintAttachmentResponse[] | undefined;
    /** Survey score associated with the complaint (optional) */
    surveyScore: number | undefined;
}

/** Dto for Compliance information for an employee */
export interface EmployeeComplianceDto {
    /** True if the employee is full time */
    isFullTime: boolean;
    /** The minimum amount of hours they need to cover to be counted as in compliance */
    minExpectedAvailHours: number;
    /** Amount of hours that the FR is available for the given period */
    availableHours: number;
    /** Count of days for compliance range */
    dayCountForComplianceCheck: number;
    /** Start of the compliance range */
    startDate: Date;
    /** End of the compliance range */
    endDate: Date;
    /** Returns true if they have enough hours */
    isInCompliance: boolean;
    /** Gets or sets a value indicating whether the compliance message can be viewed. */
    canViewComplianceMessage: boolean;
    /** Error message for display of why they are out of compliance */
    outOfComplianceMessage: string | undefined;
    /** Error message for display of their next availability */
    nextDaysAvailabilityMessage: string | undefined;
}

/** Employee Course Add Class */
export interface EmployeeCourseAddRequest {
    /** Employee that needs to be assigned */
    employeeId: number;
    /** Course to be assigned */
    courseId: number;
    /** Date employee needs to complete the course */
    dueDate: Date;
    /** Date employee completed the course */
    completedDate: Date | undefined;
    /** Time it took in minutes for employee to complete course */
    durationMinutes: number | undefined;
    /** The score employee received on course */
    score: number | undefined;
    /** Course Has notifications enabled or not */
    notificationEnabled: boolean;
}

/** Employee Course Dto for gets' */
export interface EmployeeCourseDto {
    /** Primary Key of EmployeeCourses */
    id: number;
    /** Employee Id */
    employee: EmployeeListDto | undefined;
    /** Course */
    course: CourseDto | undefined;
    /** Date course was assigned to employee */
    createDate: Date;
    /** Date course is due to be completed */
    dueDate: Date;
    /** Date employee completed the course */
    completedDate: Date | undefined;
    /** Time it took in minutes for employee to completed case */
    durationMinutes: number | undefined;
    /** The score employee received on course */
    score: number | undefined;
    /** Location of test file  */
    fileName: string | undefined;
    /** Is this course still active for this employee or did they complete it. */
    isActive: boolean;
    /** Course Has notifications enabled or not */
    notificationEnabled: boolean;
}

/** Request to mark a notification sent. */
export interface EmployeeCourseMarkSentRequest {
    /** Employee Course Id */
    employeeCourseId: number;
    /** Notification type */
    notificationType: EmployeeCourseNotificationTypeEnum;
}

/** Employe Course Notification Type */
export enum EmployeeCourseNotificationTypeEnum {
    UNKNOWN = 0,
    _30DaysBeforeDue = 1,
    _21DaysBeforeDue = 2,
    _14DaysBeforeDue = 3,
    _7DaysBeforeDue = 4,
}

/** Model to add an employee course notification */
export interface EmployeeCourseNotificationAddRequest {
    /** Employee Course Id */
    employeeCourseId: number;
    /** Notification Type (1,2,3) */
    notificationType: EmployeeCourseNotificationTypeEnum;
}

/** Employee Course Notification */
export interface EmployeeCourseNotificationDto {
    /** Employee Course id */
    employeeCourseId: number;
    /** Notification Type */
    notificationType: EmployeeCourseNotificationTypeEnum;
    /** Date notification was sent */
    sentDate: Date;
}

/** Employee Course Update Class */
export interface EmployeeCourseUpdateRequest {
    /** Primary key */
    id: number;
    /** Date employee need to complete the course */
    dueDate: Date;
    /** Date employee completed the course */
    completedDate: Date | undefined;
    /** Time it took in minutes for employee to completed case */
    durationMinutes: number | undefined;
    /** The score employee received on course */
    score: number | undefined;
    /** Course Has notifications enabled or not */
    notificationEnabled: boolean;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfEmployeeCustomerSurveyTypeAssignedLevelCode extends TypeSafeEnum {
}

/** Employee Customer Survey Type Assigned at level code */
export interface EmployeeCustomerSurveyTypeAssignedLevelCode extends TypeSafeEnumOfEmployeeCustomerSurveyTypeAssignedLevelCode {
}

/** Queue and customer survey type mapping for an employee */
export interface EmployeeCustomerSurveyTypeDto {
    /** Employee Id */
    employeeId: number;
    /** Queue Type */
    queueTypeCode: string | undefined;
    /** Customer Number */
    customerNumber: number | undefined;
    /** Customer Name */
    customerName: string | undefined;
    /** Survey Type */
    surveyType: string | undefined;
    /** Survey Type Code */
    surveyTypeCode: string | undefined;
    /** Is Excluded */
    isExcluded: boolean;
}

/** Used as the response to get a mapping */
export interface EmployeeCustomerSurveyTypeGetResponse extends EmployeeCustomerSurveyTypeDto {
    /** Primary Key */
    id: number;
}

/** List of accounts and mappings */
export interface EmployeeCustomerSurveyTypeMapDto {
    /** Customer Id */
    customerId: number;
    /** Customer Number */
    customerNumber: number;
    /** Customer Name */
    customerName: string | undefined;
    /** SurveyType Id */
    surveyTypeId: number;
    /** Survey Type Name */
    surveyTypeName: string | undefined;
    /** QA Manager on the account/survey type */
    manager: string | undefined;
    /** Number of cases in Queue Entries */
    caseCountInQueue: number;
    /** Number of users in QueueEntryUserMaps for that account / survey type */
    usersMapped: number;
    /** Number of Active users in QueueEntryUserMaps for that account / survey type */
    usersActiveMapped: number;
}

/** Codes for the Employee Departments */
export interface EmployeeDepartmentCodes {
}

/** Employee Detail Model */
export interface EmployeeDetailDto {
    /** EmployeeId */
    employeeId: number;
    /** InternetUserId */
    internetUserId: number | undefined;
    /** First Name */
    firstName: string | undefined;
    /** Last Name */
    lastName: string | undefined;
    /** Last, First */
    lastFirstName: string | undefined;
    /** First Last Name */
    name: string | undefined;
    /** Role Enum */
    roleId: EmployeeRoleEnum | undefined;
    /** Street Address */
    address: string | undefined;
    /** City */
    city: string | undefined;
    /** State */
    state: string | undefined;
    /** Postal Code */
    postalCode: string | undefined;
    /** Mueller Email address */
    email: string | undefined;
    /** Payroll Id */
    payrollEmployeeId: string | undefined;
    /** Date employee was sent HR paperwork */
    hireDate: Date | undefined;
    /** Home Phone */
    homePhone: string | undefined;
    /** Hourly Pay Rate */
    salary: number | undefined;
    /** Payrate type */
    payRateType: PayrateTypeEnum;
    /** Date that employee graduated from training */
    trainingCompletedDate: Date | undefined;
    /** Work Phone */
    workPhone: string | undefined;
    /** Employee Percent added to Mac */
    macAdjustmentPercent: number;
    /** Employee Percent added to Mac */
    macAdjustmentDollar: number;
    /** HR Role information */
    role: RoleDto | undefined;
    /** Employee Id of the employee's manager */
    managerEmployeeId: number;
    /** Phone Extension */
    extension: number | undefined;
    /** DOB */
    birthDate: string | undefined;
    /** Is active employee */
    isActive: boolean;
    /** Number of people this employee supervises */
    supervisedEmployeesCount: number;
    /** Years, months, and days worked */
    tenure: string | undefined;
    /** Date employee started working */
    startDate: Date | undefined;
}

/** All queue and customer survey type mappings for an employee */
export interface EmployeeMappingsDto {
    /** Employee id */
    employeeId: number;
    /** Employee customer survey type mappings */
    customerSurveyTypes: EmployeeCustomerSurveyTypeDto[] | undefined;
}

export interface EmployeeNoteAddRequest {
    /** The internet user that created the note */
    createdByInternetUserId: number;
    /** The employee id the note is for */
    payrollEmployeeId: string | undefined;
    /** The note contents */
    body: string | undefined;
}

/** Contains constants for different categories of employee notes */
export interface EmployeeNoteCategories {
}

/** Employee note */
export interface EmployeeNoteDto {
    /** Unique id */
    id: number;
    /** Note contents */
    body: string | undefined;
    /** Employee this note is about */
    employeeId: number;
    /** Employee this note is about */
    payrollEmployeeId: string | undefined;
    /** Created date */
    createdDateUtc: Date;
    /** Created by user id */
    createdByUserInternetUserId: number | undefined;
    /** Created by user email */
    createdByUserEmail: string | undefined;
    /** Created by user display name */
    createdByUserDisplayName: string | undefined;
    /** Date this note was last modified */
    editedDateUtc: Date | undefined;
    /** To differentiate support calls vs. other notes */
    category: string | undefined;
}

export interface EmployeeNoteUpdateRequest {
    id: number;
    body: string | undefined;
}

export interface EmployeePtoDto {
    /** Id of PTO */
    id: number | undefined;
    /** Employee Id */
    employeeId: number;
    /** Start date of PTO */
    dateStart: Date;
    /** End date of PTO */
    dateEnd: Date;
    /** Notes */
    notes: string | undefined;
}

/** Add Employee Role Course Model */
export interface EmployeeRoleCourseAddRequest {
    /** Course Id */
    courseId: number;
    /** Employee Role Id */
    employeeRoleId: number;
}

/** Detail Employee Course Role Rule */
export interface EmployeeRoleCourseDto {
    /** Unique Id */
    id: number;
    /** Employee Role */
    employeeRole: EmployeeRoleDto | undefined;
    /** Course */
    course: CourseDto | undefined;
    /** Datetime stamp */
    createDate: Date;
}

/** Employee Role Department Dto */
export interface EmployeeRoleDto {
    /** Primary Key */
    id: number;
    /** Department */
    department: DepartmentDto | undefined;
    /** Unique Code
             */
    code: string | undefined;
    /** Name */
    name: string | undefined;
}

/** Employee Status Codes */
export interface EmployeeStatusCodes {
}

/** Time Clock on Request */
export interface EmployeeTimeClockActiveDto {
    /** User to be clocked in */
    internetUserId: number;
    /** Users offset minutes to UTC */
    timeZoneOffsetMinutes: number;
}

/** Model used to add a new employee time card */
export interface EmployeeTimeClockAddDto {
    /** User Time clock is for */
    internetUserId: number;
    /** User that is adding the time clock */
    createByInternetUserId: number;
    /** Date Time of Clock in */
    clockInDateTime: Date;
    /** Date Time of Clock Out */
    clockOutDateTime: Date;
    /** IP Address of user adding time */
    ipAddress: string;
}

/** Time Clock Dto */
export interface EmployeeTimeClockDto {
    /** Primary Key */
    id: number;
    /** Clock in Date time */
    clockInDate: Date;
    /** Clock Out Date time */
    clockOutDate: Date | undefined;
    /** Number of total Minutes between Clock in and Clock out date */
    timeMinutes: number | undefined;
    /** PayPeriod related to Clock In Date */
    payPeriodId: number;
    /** Indicator that the time clock was edited by someone other than the user */
    wasEdited: boolean;
}

/** Time Clock in and out Request */
export interface EmployeeTimeClockInOutDto {
    /** User to be clocked in */
    internetUserId: number;
    /** IP Address of user */
    ipAddress: string;
    /** Users offset minutes to UTC */
    timeZoneOffsetMinutes: number;
    /** Allow for overriding the clock-in/out time */
    clockInOutOverride: string | undefined;
}

/** Time Clock on Request */
export interface EmployeeTimeClockInOutRequest {
    /** Users offset minutes to GMT */
    timeZoneOffsetMinutes: number;
    /** Override the time for Clock-in/out */
    clockInOutOverride: string | undefined;
}

/** Update time clock request */
export interface EmployeeTimeClockUpdateDto {
    /** Primary key of time clock */
    id: number;
    /** User that is editing the time clock */
    modifyInternetUserId: number;
    /** Clients clock in date and time */
    clockInDateTime: Date;
    /** Clients clock out date and time */
    clockOutDateTime: Date;
    /** IP Address */
    clockOutIpAddress: string;
}

export interface EmployeeTimeClockUpdateRequest {
    /** Clients clock in date and time */
    clockInDateTime: Date;
    /** Clients clock out date and time */
    clockOutDateTime: Date;
}

/** Employee Type Codes */
export interface EmployeeTypeCodes {
}

/** Model for a list of enabled customer features */
export interface EnabledCustomerFeatures {
    /** List of enabled customer features for an account */
    features: CustomerFeaturesDto[] | undefined;
}

/** Wraps values needed to set the text for an entity change case history item */
export interface EntityChangeGroup {
    /** Display name */
    displayName: string | undefined;
    /** Property names in this group */
    propertyNames: string[] | undefined;
    /** Formatter used to display multiple fields */
    formatter: FuncOfStringOfAndIHomeRepositoryAndIGlobalRepositoryAndString | undefined;
}

export interface FuncOfStringOfAndIHomeRepositoryAndIGlobalRepositoryAndString extends MulticastDelegate {
}

export interface EnvComparablePhoto {
    comparableNumber: number;
    photo: PhotoWebserviceClientPhotoFile | undefined;
}

/** A file reference with associated photo properties */
export interface PhotoWebserviceClientPhotoFile {
    /** The photo metadata associated with the photo */
    photoProperties: PhotoProperties | undefined;
    /** The file containing the photo */
    photoFile: FileInfo | undefined;
    /** The byte contents of the photo file */
    fileContents: string | undefined;
    /** Creates an image object from the PhotoFile */
    photoImage: string | undefined;
}

export interface PhotoProperties {
    id: string;
    bucketUri: string | undefined;
    geocode: Geocode2 | undefined;
    tags: string[] | undefined;
    sortOrder: number;
    userDescription: string | undefined;
    captureDate: Date | undefined;
    ownerUsername: string | undefined;
    lastModifiedDate: Date;
    lastViewedDate: Date;
    photoAreas: PhotoArea[] | undefined;
    fileSizeBytes: number;
    imageDimensions: string;
    uploadedDate: Date;
    analysis: PhotoAnalysis | undefined;
}

export interface Geocode2 {
    latitude: number;
    longitude: number;
    altitudeMeters: number | undefined;
    datum: string | undefined;
    heading: number | undefined;
}

export interface PhotoArea {
    tags: string[] | undefined;
    userDescription: string | undefined;
    area: Rectangle | undefined;
}

export interface Rectangle {
    x: number;
    y: number;
    width: number;
    height: number;
}

export interface PhotoAnalysis {
    requestedAtUtc: Date;
    finishedAtUtc: Date;
    results: PhotoAnalysisResult[] | undefined;
}

export interface PhotoAnalysisResult {
    analysisCode: string | undefined;
    score: number;
    hasScore: boolean;
    resultBool: boolean;
    hasResultBool: boolean;
    classifications: PhotoAnalysisClassificationMain[] | undefined;
}

export interface PhotoAnalysisClassification {
    classification: string | undefined;
    score: number;
}

export interface PhotoAnalysisClassificationMain extends PhotoAnalysisClassification {
    subClassifications: PhotoAnalysisClassification[] | undefined;
}

export interface FileSystemInfo extends MarshalByRefObject {
    _data: WIN32_FILE_ATTRIBUTE_DATA;
    _dataInitialised: number;
    FullPath: string | undefined;
    OriginalPath: string | undefined;
    FullName: string | undefined;
    UnsafeGetFullName: string | undefined;
    Extension: string | undefined;
    Name: string | undefined;
    Exists: boolean;
    CreationTime: Date;
    CreationTimeUtc: Date;
    LastAccessTime: Date;
    LastAccessTimeUtc: Date;
    LastWriteTime: Date;
    LastWriteTimeUtc: Date;
    Attributes: FileAttributes;
    DisplayPath: string | undefined;
}

export interface FileInfo extends FileSystemInfo {
    Name: string | undefined;
    Length: number;
    DirectoryName: string | undefined;
    Directory: DirectoryInfo | undefined;
    IsReadOnly: boolean;
    Exists: boolean;
}

export interface DirectoryInfo extends FileSystemInfo {
    Name: string | undefined;
    FullName: string | undefined;
    UnsafeGetFullName: string | undefined;
    Parent: DirectoryInfo | undefined;
    Exists: boolean;
    Root: DirectoryInfo | undefined;
}

export interface WIN32_FILE_ATTRIBUTE_DATA {
}

export enum FileAttributes {
    ReadOnly = 1,
    Hidden = 2,
    System = 4,
    Directory = 16,
    Archive = 32,
    Device = 64,
    Normal = 128,
    Temporary = 256,
    SparseFile = 512,
    ReparsePoint = 1024,
    Compressed = 2048,
    Offline = 4096,
    NotContentIndexed = 8192,
    Encrypted = 16384,
    IntegrityStream = 32768,
    NoScrubData = 131072,
}

/** An Appraisal Port ENV creation request */
export interface EnvCreateRequest {
    /** Case control number */
    controlNumber: number;
    /** Case customer number */
    customerNumber: number;
    /** AI Ready Appraisal XML file */
    aiReadyBpoXmlFile: FileInfo | undefined;
    /** AI Ready Invoice XML */
    aiReadyInvoiceFile: FileInfo | undefined;
    /** Appraiser Signature */
    appraiserSignature: PhotoWebserviceClientPhotoFile | undefined;
    /** Field rep signature */
    fieldRepSignature: PhotoWebserviceClientPhotoFile | undefined;
    /** Subject front view */
    subjectFrontView: PhotoWebserviceClientPhotoFile | undefined;
    /** Subject rear view */
    subjectRearView: PhotoWebserviceClientPhotoFile | undefined;
    /** Subject street view */
    subjectStreetView: PhotoWebserviceClientPhotoFile | undefined;
    /** Additional Subject photos */
    subjectAdditionalPhotos: PhotoWebserviceClientPhotoFile[] | undefined;
    /** Comparable Sale photos */
    comparableSalePhotos: EnvComparablePhoto[] | undefined;
    /** Other photos */
    additionalPhotos: PhotoWebserviceClientPhotoFile[] | undefined;
    /** Comparable Listings photos */
    comparableListingPhotos: EnvComparablePhoto[] | undefined;
    /** Additional maps */
    additionalMapPhotos: EnvTitledPhoto[] | undefined;
    /** Floor plan (sketches) */
    floorPlanPhotos: EnvTitledPhoto[] | undefined;
    /** Parcel maps */
    platMapPhotos: EnvTitledPhoto[] | undefined;
    /** Location map images */
    locationMapPhotos: EnvTitledPhoto[] | undefined;
    /** Images of the rendered PDF pages from the Property Condition Inspection Report */
    propertyConditionReportPageImages: EnvTitledPhoto[] | undefined;
    /** Market trend chart images */
    marketTrendChartImages: EnvTitledPhoto[] | undefined;
    /** UAD AI Ready form XML */
    uadAddendumFile: FileInfo | undefined;
    /** Appraiser License Image */
    appraiserLicense: EnvTitledPhoto | undefined;
}

/** Photo with a name for ENV generation */
export interface EnvTitledPhoto {
    /** The photo title */
    name: string | undefined;
    /** The photo reference */
    photo: PhotoWebserviceClientPhotoFile | undefined;
}

/** Environment Name constants */
export interface EnvironmentNames {
}

/** List of distinct EventType codes from Case Events */
export interface EventCodes {
}

export enum EventTypeEnum {
    Unknown = 0,
    AppraisalCompleted = 1,
    AppraisalResubmitted = 2,
}

/** Export and Generate payroll file response */
export interface ExportAndGenerateFileResponse {
    /** List of files that were exported */
    payrollExportFiles: PayrollExportFile[] | undefined;
    /** Expiration date of URLs */
    expirationDate: Date;
}

/** Return values of when payroll is exported to be emailed */
export interface PayrollExportFile {
    /** Name of the file */
    name: string | undefined;
    /** Link to download the file */
    link: string | undefined;
}

/** ExportDefinition code constants */
export interface ExportDefinitionCodes {
}

/** Field Rep Extension Auto Approve Request */
export interface ExtensionAutoApproveRequest {
    /** Control Number */
    controlIdNumber: number;
    /** Case Due Date */
    dueDate: Date | undefined;
    /** Date Received */
    dateReceived: Date | undefined;
    /** Customer Type  */
    customerTypeCode: string | undefined;
    /** Survey type class */
    inspectionTypeClass: string | undefined;
    /** FR Manager Email */
    managerEmail: string | undefined;
    /** Inspector Email */
    inspectorEmail: string | undefined;
    /** Inspector Name info */
    inspectorNameNumber: NameNumberDto | undefined;
    /** Case Assignment */
    caseAssignment: CaseAssignment | undefined;
    /** Days Requested */
    daysRequested: number;
    /** Case Appointment Date */
    appointmentDate: Date | undefined;
    /** Case has contact efforts */
    hasContactEfforts: boolean;
}

/** FNMA appraisal decision as determined by the FNMA property data export response */
export interface FannieMaeAppraisalDecision {
    /** Text description of the status */
    description: string | undefined;
    /** Text that is applied to the decision email body */
    decisionEmailText: string | undefined;
    /** Fannie May decision status */
    status: StatusEnum;
    /** The date the response was received */
    responseDate: Date;
    /** The response codes from Fannie Mae */
    fannieMaeMessageCodes: string[] | undefined;
    /** Primary key */
    id: number;
}

/** Possible statuses resulting from the FNMA property data submission response */
export enum StatusEnum {
    DataAndDone = 0,
    DataAndAppraisal = 1,
    ActionRequired = 2,
    RetryExport = 3,
    DecisionPending = 4,
    NoDecisionResponse = 5,
}

export interface FannieMaeCaseModel {
    controlIdNumber: number;
    workItemId: string;
    fileVersion: number;
    notificationTypeCode: string | undefined;
    eventName: string | undefined;
    eventType: EventTypeEnum;
    subjectPropertyAddress: string | undefined;
    addressLine1: string | undefined;
    addressLine2: string | undefined;
    addressCityStateZip: string | undefined;
    addressCity: string | undefined;
    addressStateAbbreviated: string | undefined;
    addressZipCode: string | undefined;
    loanNumber: string | undefined;
    trackingNumber: string | undefined;
    borrowerFirstName: string | undefined;
    borrowerLastName: string | undefined;
    broker: InternetUser | undefined;
}

/** Feature Names related to Features table in MuellerGlobalData */
export interface FeatureCodes {
}

/** Feature permission codes */
export interface FeaturePermissionTypeCodes {
}

export interface Features {
    /** forms */
    forms: Forms | undefined;
    /** photos */
    photos: Photos | undefined;
    /** sketches */
    sketches: Sketches | undefined;
    /** notes */
    notes: Notes | undefined;
    /** order */
    order: Order | undefined;
    /** messaging */
    messaging: Messaging | undefined;
    /** remoteOperations */
    remoteOperations: Remoteoperations | undefined;
    /** integration */
    integration: Integration | undefined;
}

/** Forms */
export interface Forms {
    /** manageForms */
    manageForms: Manageforms | undefined;
    /** disabled */
    disabled: boolean;
    /** worksheet */
    worksheet: Worksheet | undefined;
    /** photoMultiLinking */
    photoMultiLinking: Photomultilinking | undefined;
}

/** Manageforms */
export interface Manageforms {
    /** disabled */
    disabled: boolean;
}

/** Worksheet */
export interface Worksheet {
    /** disabled */
    disabled: boolean;
}

/** Photomultilinking */
export interface Photomultilinking {
    /** disabled */
    disabled: boolean;
}

/** Photos */
export interface Photos {
    /** manageTags */
    manageTags: Managetags | undefined;
    /** disabled */
    disabled: boolean;
    /** multipleTags */
    multipleTags: Multipletags | undefined;
    /** tagSearching */
    tagSearching: Tagsearching | undefined;
    /** dateTimeStamp */
    dateTimeStamp: Datetimestamp | undefined;
    /** maximumSize */
    maximumSize: number;
    /** disableMaximumSize */
    disableMaximumSize: boolean;
    /** verify */
    verify: Verify | undefined;
    /** descriptions */
    descriptions: Descriptions | undefined;
    /** applyTags */
    applyTags: Applytags | undefined;
}

/** Managetags */
export interface Managetags {
    /** disabled */
    disabled: boolean;
}

/** Multipletags */
export interface Multipletags {
    /** disabled */
    disabled: boolean;
}

/** Tagsearching */
export interface Tagsearching {
    /** disabled */
    disabled: boolean;
}

/** Verify */
export interface Verify {
    /** level */
    level: any | undefined;
    /** disabled */
    disabled: boolean;
}

/** Sketches */
export interface Sketches {
    /** settings */
    settings: string | undefined;
    /** disabled */
    disabled: boolean;
}

/** Notes */
export interface Notes {
    /** text */
    text: Text | undefined;
    /** disabled */
    disabled: boolean;
    /** audio */
    audio: Audio | undefined;
    /** drawing */
    drawing: Drawing | undefined;
}

/** Text */
export interface Text {
    /** disabled */
    disabled: boolean;
}

/** Order */
export interface Order {
    /** manageAddress */
    manageAddress: Manageaddress | undefined;
    /** disabled */
    disabled: boolean;
    /** manageMetadata */
    manageMetadata: Managemetadata | undefined;
    /** meetings */
    meetings: Meetings | undefined;
    /** manageMeetings */
    manageMeetings: Managemeetings | undefined;
}

/** Manageaddress */
export interface Manageaddress {
    /** disabled */
    disabled: boolean;
}

/** Managemetadata */
export interface Managemetadata {
    /** disabled */
    disabled: boolean;
}

/** Meetings */
export interface Meetings {
    /** disabled */
    disabled: boolean;
}

/** Managemeetings */
export interface Managemeetings {
    /** disabled */
    disabled: boolean;
}

/** Messaging */
export interface Messaging {
    /** text */
    text: any | undefined;
    /** disabled */
    disabled: boolean;
}

/** Remoteoperations */
export interface Remoteoperations {
    /** endpointRootUri */
    endpointRootUri: string | undefined;
    /** disabled */
    disabled: boolean;
}

/** Integration */
export interface Integration {
    /** disabled */
    disabled: boolean;
    /** forms */
    forms: Form2[] | undefined;
    /** photoSharing */
    photoSharing: boolean;
}

/** Form */
export interface Form2 {
    /** id */
    id: string | undefined;
    /** type */
    type: string | undefined;
    /** key */
    key: string | undefined;
    /** attributes */
    attributes: Attribute[] | undefined;
}

/** List of feature codes */
export interface FeatureSettingCodes {
}

/** Field Level Coordinator */
export interface FieldLevelCoordinatorDto {
    /** EmployeeId */
    employeeId: number;
    /** InternetUserId */
    internetUserId: number | undefined;
    /** FirstName */
    firstName: string | undefined;
    /** LastName */
    lastName: string | undefined;
    /** Manager First Name */
    supervisorFirstName: string | undefined;
    /** Manager Last Name */
    supervisorLastName: string | undefined;
}

/** Filters to narrow down the field rep list */
export interface FieldRepListRequest {
    /** Search term to apply to query */
    searchTerm: string | undefined;
    /** Flag to include recently terminated inspectors */
    includeRecentlyTerminated: boolean;
}

/** Field rep full names and numbers */
export interface FieldRepNameAndNumberDto {
    /** Field rep first and last name */
    fullName: string | undefined;
    /** Field rep number */
    number: number;
}

/** Request for Auto QA Case Review */
export interface FieldServiceAutoQaReviewCaseRequest {
    /** Control Id Number */
    controlIdNumber: number;
    /** Case request is from Field Service Auto QA Queue and needs to be marked reviewed */
    markReviewedInQueue: boolean;
    /** Indicates if AutoQA is enabled for the request */
    autoQaRuleTypesEnabled: AutoQaRuleType[] | undefined;
}

/** Result model from FieldServicesCaseResultProvider */
export interface FieldServicesCaseResult {
    /** Case control number */
    controlIDNumber: number;
    /** Phoenix File Id */
    phoenixFileId: string;
    /** Policy Number */
    policyNumber: string | undefined;
    /** Survey address */
    address: string | undefined;
    /** Survey city */
    city: string | undefined;
    /** Survey state abbreviation */
    state: string | undefined;
    /** Survey Zip code */
    zip: string | undefined;
    /** Survey Count */
    county: string | undefined;
    /** Policyholder name */
    policyholderName: string | undefined;
    /** Customer Number */
    customerNumber: number | undefined;
    /** Customer Name */
    customerName: string | undefined;
    /** Customer Name and Number */
    customerNameNumber: string | undefined;
    /** Effective Date */
    effectiveDate: Date | undefined;
    /** Days Past Effective Date (Today's Date minus Effective Date) */
    daysPastEffectiveDate: number | undefined;
    /** Date received */
    dateReceived: Date | undefined;
    /** Date entered */
    dateEntered: Date | undefined;
    /** Date completed */
    dateCompleted: Date | undefined;
    /** Underwriter reviewed date */
    reviewedDate: Date | undefined;
    /** Due Date */
    dueDate: Date | undefined;
    /** Appointment Date */
    appointmentDate: Date | undefined;
    /** Inspection Type */
    inspectionType: string | undefined;
    /** Original Inspection Type */
    originalSurveyType: string | undefined;
    /** Inspector days till due */
    inspectorDaysDue: number | undefined;
    /** Field rep assigned */
    frAssigned: string | undefined;
    /** Field rep Due Date */
    frDueDate: Date | undefined;
    /** Field rep extension days */
    extensionDays: number | undefined;
    /** Date returned */
    dateReturned: Date | undefined;
    /** Field Work Present */
    fieldWorkPresent: string | undefined;
    /** Tracking Number */
    trackingNumber: string | undefined;
    /** Secondary Status / Web status */
    webStatus: string | undefined;
    /** Grid row type? */
    resultGridRowType: string | undefined;
    /** Geocode location latitude */
    latitude: number | undefined;
    /** Geocode location longitude */
    longitude: number | undefined;
    /** Appointment date / time */
    appointmentDateTime: Date | undefined;
    /** Appointment contact made date */
    contactMadeOnDate: Date | undefined;
    /** Appointment contact person */
    contactPerson: string | undefined;
    /** Appointment contact effort result */
    contactEffortResult: string | undefined;
    /** Last case note */
    lastNote: CellViewModelOfCaseNoteViewModel | undefined;
    /** Time spent unassigned */
    timeUnassignedFieldRep: string | undefined;
    /** Time spent with no contact efforts */
    timeAssignedWithNoContactEfforts: string | undefined;
    /** Time elapsed since appointment */
    timeSinceScheduledAppointment: string | undefined;
    /** Time elapsed since appointment */
    timeSinceScheduledAppointmentRaw: string | undefined;
    /** Time in Field QA  */
    timeInQA1: string | undefined;
    /** Time in Field QA again? */
    timeInFSQA: string | undefined;
    /** Agent name */
    agent: string | undefined;
    /** MAC value */
    mac: number | undefined;
    /** Field director */
    fieldDirector: string | undefined;
    /** Field level coordinator */
    fieldLevelCoordinator: string | undefined;
    /** Lender logistics manager */
    lenderLogisticsManager: string | undefined;
    /** Date assigned */
    dateAssigned: Date | undefined;
    /** Preferred appointment date */
    preferredAppointmentDate: Date | undefined;
    /** Mueller At Home survey created */
    atHomeCreated: string | undefined;
    /** Mueller At Home ready */
    atHomeReady: string | undefined;
    /** Mueller At Home completed */
    atHomeCompleted: string | undefined;
    /** Case is on hold */
    isOnHold: boolean;
    /** Case is rush */
    isRush: boolean;
    /** On-Site service type */
    serviceTypeIsOnSite: boolean;
    /** Call Center service type */
    serviceTypeIsCallCenter: boolean;
    /** Consumer Web service type */
    serviceTypeIsConsumerWeb: boolean;
    /** Appraisal Survey service type */
    serviceTypeIsAppraisalSurvey: boolean;
    /** Scheduling service type */
    serviceTypeIsScheduling: boolean;
    /** Customer Type Code */
    customerTypeCode: string | undefined;
    /** FR Email */
    frEmail: string | undefined;
    /** Field Services Inspection ETA */
    fieldInspectionETA: Date | undefined;
    /** Field Development Manager */
    fieldDevelopmentManager: string | undefined;
    /** Appointment required for this case's completeform */
    fieldAppointmentRequired: boolean;
    /** Indicator if assigned field rep is in trainee status */
    fieldRepIsTrainee: boolean;
    /** Due date of the next contact */
    nextContactDue: Date | undefined;
    /** Name of the next contact step */
    nextContactStep: string | undefined;
    /** Client ETA */
    clientETA: Date | undefined;
    /** Mueller Service Area */
    serviceRegion: string | undefined;
    /** Date when case was sent to website from Phoenixmobile workflow action */
    dateSentToWeb: Date | undefined;
    /** Indicator that case is in the permission to close workflow */
    isInPermissionToCloseWorkflow: boolean;
    /** Date permission to close workflow started */
    permissionToCloseStartDate: Date | undefined;
    /** Amount of time the case is in permision to close */
    timeInPermissionToClose: string | undefined;
    /** Status of CubiCasa scan for case */
    cubiCasaStatus: string | undefined;
    /** Amount of time that the CubiCasa scan has been in waiting status */
    timeInWaitingCubiCasaStatus: string | undefined;
    /** Amount of days case is on hold */
    daysOnHold: number;
    /** Did appointment change or was it removed */
    appointmentChanged: boolean;
    /** Customer experience manager from EmployeeCustomerSurveyTypes_vw */
    customerExperienceManager: string | undefined;
    /** Customer experience director from EmployeeCustomerSurveyTypes_vw */
    customerExperienceDirector: string | undefined;
    /** Date On Hold Started */
    onHoldDateStart: Date | undefined;
    /** Date On Hold Ended */
    onHoldDateEnd: Date | undefined;
    /** Note for On Hold status */
    onHoldNote: string | undefined;
    /** Date of Customer Onboarding */
    customerOnboardingDate: Date | undefined;
    /** Date of first customer order */
    customerFirstOrderDate: Date | undefined;
}

/** Model of employees that are field service directors */
export interface FieldSurveyDirectorDto {
    /** Employee id */
    employeeId: number;
    /** InternetUserId */
    internetUserId: number | undefined;
    /** FirstName */
    firstName: string | undefined;
    /** LastName */
    lastName: string | undefined;
}

export enum FileAction {
    MoveFile = 0,
    CopyFile = 1,
    NoAction = 2,
}

/** Used with the FileRetriever utility to define the file */
export interface FileDefinition {
    /** System file name */
    fileName: string | undefined;
    /** Source path of file is assumed to be in CaseFilePath unless FullPathOverride is set. Prefix with "/" to start in CaseFilePath */
    fullPathSourceOverride: string | undefined;
    /** Final path of file is assumed to be in CaseFilePath unless FullPathOverride is set. Prefix with "/" to start in CaseFilePath */
    fullPathDestinationOverride: string | undefined;
    /** Friendly file name sent to customers */
    friendlyName: string | undefined;
    /** If file alaready exists should a version be added */
    addFileVersion: boolean;
    /** Description of the file  */
    docDescription: string | undefined;
    /** The MIME type of the file attachment */
    mimeType: string | undefined;
    /** If true the control number is not used in the file name */
    excludeControlNumberInFileName: boolean;
}

/** Used with the FileRetriever utility to define the file */
export interface FileDefinitionEditable {
    /** System file name */
    fileName: string | undefined;
    /** Source path of file is assumed to be in CaseFilePath unless FullPathOverride is set. Prefix with "/" to start in CaseFilePath */
    fullPathSourceOverride: string | undefined;
    /** Final path of file is assumed to be in CaseFilePath unless FullPathOverride is set. Prefix with "/" to start in CaseFilePath */
    fullPathDestinationOverride: string | undefined;
    /** Friendly file name sent to customers */
    friendlyName: string | undefined;
    /** If file alaready exists should a version be added */
    addFileVersion: boolean;
    /** Description of the file  */
    docDescription: string | undefined;
    /** The MIME type of the file attachment */
    mimeType: string | undefined;
    /** If true the control number is not used in the file name */
    excludeControlNumberInFileName: boolean;
}

/** File path details */
export interface FileDetails {
    /** Final friendly name  */
    finalFileName: string | undefined;
    /** Final path of file */
    finalDestinationPath: string | undefined;
    /** Combines FinalDestinationPath and FinalFileName */
    finalFullPath: string | undefined;
    /** Source file name */
    sourceFileName: string | undefined;
    /** Current path of file */
    sourcePath: string | undefined;
    /** Combines SourcePath and SourceFileName */
    sourceFullPath: string | undefined;
    /** Description of file */
    docDescription: string | undefined;
}

export interface FileOperationException extends MuellerBusinessException {
}

/** File response */
export interface FileResponse {
    /** File path details */
    fileDetail: FileDetails | undefined;
    /** False if there was an error handling the file */
    success: boolean;
    /** Error detail if success is false  */
    message: string | undefined;
}

/** File Revision info */
export interface FileRevision {
    /** Date data was modified in Phoenix */
    dataModifiedByDate: Date;
    /** Date data was modified in Phoenix */
    modifiedByDate: Date;
    /** Date data was last synchronized in Phoenix */
    syncDate: Date;
    /** Phoenix revision number */
    revision: number;
    /** An identifier for this Revision */
    revisionId: string | undefined;
    /** Date this revision was generated on */
    generatedOnDate: Date;
    /** Name of revision to display in user interfaces */
    friendlyName: string | undefined;
}

export enum FilterAppointmentStatus {
    NoAppointmentScheduled = 0,
    AppointmentScheduled = 1,
    AllAppointmentStatuses = 2,
    AppointmentInPast = 3,
}

export enum FilterAppraiser {
    MyAppraisers = 0,
    AllAppraisers = 1,
    Appraiser = 2,
}

export enum FilterContactEfforts {
    NoContactEfforts = 0,
    AnyContactEfforts = 1,
    AllContactEfforts = 2,
}

export enum FilterCreated {
    Today = 0,
    Last7Days = 1,
    Last30Days = 2,
    Last60Days = 3,
    Last90Days = 4,
    Whenever = 5,
}

export enum FilterCustomer {
    Uwm = 1547,
}

export interface FilterDetails {
    valuePath: string | undefined;
    valueType: string | undefined;
}

export interface FilterFactoryDto_1 {
    BaseQueryable: T | undefined;
    Filters: { [key: string]: FilterDetails; } | undefined;
}

export enum FilterFieldStatus {
    Unassigned = 0,
    Received = 1,
    Qa = 2,
    CompletionPending = 3,
}

/** Used for Quick List Filter Key Items that will match up to front end programming */
export interface FilterKeys {
}

/** Filter Operators */
export interface FilterOperators {
}

/** Filter type defines what filter control and values are displayed on the front end */
export interface FilterTypes {
}

export enum FilterValuationStatus {
    Unassigned = 0,
    Assigned = 1,
    Inreview = 2,
    InternalRejection = 3,
    CustomerRejection = 4,
    Completed = 5,
    Closed = 6,
    Cancelled = 7,
    Open = 8,
    InAppraisalQa = 9,
    AvailableToAppraiser = 10,
    AwaitingFieldReport = 11,
    FieldReconsidering = 12,
    RejectedToField = 13,
    AwaitingEligibilityDecision = 14,
}

/** Dto for FnmaPropertyDataMessage */
export interface FnmaPropertyDataMessageDto {
    /** Primary key */
    id: number;
    /** Message code */
    fnmaMessageCode: string | undefined;
    /** Message description */
    fnmaMessageDescription: string | undefined;
}

/** Dto for FnmaPropertyDataPhotoMessage */
export interface FnmaPropertyDataPhotoMessageDto {
    /** Primary key id */
    id: number;
    /** Photo Id */
    photoId: string;
    /** Photo path in Fannie Mae Json */
    fnmaPropertyDataPhotoPath: string | undefined;
    /** Message code */
    fnmaMessageCode: string | undefined;
    /** Message description */
    fnmaMessageDescription: string | undefined;
}

/** Dto for FnmaPropertyDataResponse */
export interface FnmaPropertyDataResponseDto {
    /** Primary key */
    id: number;
    /** Case control number */
    controlIdNumber: number;
    /** Response Date time */
    responseDate: Date;
    /** Fannie Mae inspection identifier */
    fnmaInspectionId: string | undefined;
    /** Appriasal Decision */
    appraisalDecision: FannieMaeAppraisalDecision | undefined;
    /** Property Data messages */
    propertyDataMessages: FnmaPropertyDataMessageDto[] | undefined;
    /** Property Data photo messages */
    propertyDataPhotoMessages: FnmaPropertyDataPhotoMessageDto[] | undefined;
}

/** Form data comparison info */
export interface FormDataRevisionComparison {
    /** The file revision compared from */
    fileRevisionFrom: FileRevision | undefined;
    /** The file revision compared to */
    fileRevisionTo: FileRevision | undefined;
    /** The Form data comparison */
    forms: FormInstanceComparison[] | undefined;
}

/** A form comparison */
export interface FormInstanceComparison {
    /** The type of change enumeration */
    changeType: ChangeType;
    /** The form instance id */
    formInstanceId: string | undefined;
    /** Info about the Phoenix form */
    formMetadata: PhoenixFormMetadata | undefined;
    /** A comparison of the questions and answers */
    questionAnswerSummary: FormQuestionAnswerComparison[] | undefined;
    /** The change type display name */
    changeTypeName: string | undefined;
}

/** A base class of IHashedObject */
export interface HashedValueBase {
    /** The value stored in the hash */
    hashValue: string | undefined;
}

/** Form metadata about a Phoenix form */
export interface PhoenixFormMetadata extends HashedValueBase {
    /** The phoenix row key */
    rowKey: string | undefined;
    /** The phoenix partition key */
    partitionKey: string | undefined;
    /** The containing namespace */
    rootNamespace: string | undefined;
    /** Any required namespaces */
    requiredNamespace: string[] | undefined;
    /** The form category */
    category: string | undefined;
    /** The form display name */
    name: string | undefined;
    /** A description about the form */
    description: string | undefined;
    /** Date/time the form defintion was last modified */
    modifiedDate: Date;
    /** Timestamp the form defintion was last modified */
    timestamp: Date;
}

/** Comparison of a FormQuestionAnswer */
export interface FormQuestionAnswerComparison {
    /** The type of change */
    changeType: ChangeType;
    /** The type of change name that happened on this question */
    changeTypeName: string | undefined;
    /** The before state of this question */
    before: FormQuestionAnswer | undefined;
    /** The after state of this question */
    after: FormQuestionAnswer | undefined;
    /** A comparison of any children question answers */
    children: FormQuestionAnswerComparison[] | undefined;
}

/** The question and answer on a form */
export interface FormQuestionAnswer extends HashedValueBase {
    /** The unique id of the control */
    controlId: string | undefined;
    /** The page index */
    pageIndex: number;
    /** The type of data or control rendered */
    controlType: string | undefined;
    /** Questions that rely on this question */
    children: FormQuestionAnswer[] | undefined;
    /** Indicator of whether this question is relevant */
    relevant: boolean;
    /** The question label text associated with this answer */
    label: string | undefined;
    /** The section name associated with this question */
    sectionName: string | undefined;
    /** The section index for this question */
    sectionIndex: number;
    /** The answer for the question */
    questionAnswer: string | undefined;
}

/** Revision info for a case */
export interface FormDataRevisionInstance extends HashedValueBase {
    /** The revision info */
    fileRevision: FileRevision | undefined;
    /** The form data for this revision */
    forms: FormInstance[] | undefined;
}

/** A form instance */
export interface FormInstance extends HashedValueBase {
    /** The form instance id */
    formInstanceId: string | undefined;
    /** Phoenix form metadata */
    formMetadata: PhoenixFormMetadata | undefined;
    /** Question and answer summary */
    questionAnswerSummary: QuestionAnswerSummary | undefined;
}

/** A Question Answer summary */
export interface QuestionAnswerSummary extends HashedValueBase {
    /** The render mode of the model */
    modelMode: string | undefined;
    /** The question answers associated with the form */
    formData: FormQuestionAnswer[] | undefined;
}

/** Formmetadata */
export interface Formmetadata {
    /** RowKey */
    rowKey: string | undefined;
    /** PartitionKey */
    partitionKey: string | undefined;
    /** rootNamespace */
    rootNamespace: any | undefined;
    /** requiredNamespace */
    requiredNamespace: any | undefined;
    /** minimumPhoenixVersion */
    minimumPhoenixVersion: string | undefined;
    /** maximumPhoenixVersion */
    maximumPhoenixVersion: any | undefined;
    /** webPurchaseUrl */
    webPurchaseUrl: any | undefined;
    /** category */
    category: string | undefined;
    /** name */
    name: string | undefined;
    /** description */
    description: string | undefined;
    /** modifiedDate */
    modifiedDate: Date;
    /** questionLibraryKey */
    questionLibraryKey: any | undefined;
    /** Timestamp */
    timestamp: Date;
}

/** Form Option for Selecting Forms */
export interface FormOptionDto {
    /** Form name */
    name: string | undefined;
    /** Form code (cCode from AvailForms) */
    formCode: string | undefined;
}

/** Provides attribute driven value mapping */
export interface FormQuestionAnswerAttribute extends Attribute2 {
    /** The question label text */
    questionLabel: string | undefined;
    /** A callback function used to map a value to a string */
    mapQuestionAnswerFunc: FuncOfObjectAndString | undefined;
}

export interface FuncOfObjectAndString extends MulticastDelegate {
}

export interface FormsOnCase {
    controlNumber: number;
    forms: RootCaseForm[] | undefined;
}

/** Customer/Survey type detail for form use */
export interface FormUsageDetail {
    /** Customer Number */
    customerNumber: number;
    /** Customer Name */
    customerName: string | undefined;
    /** Survey type name */
    surveyType: string | undefined;
    /** Customer Inactive Date */
    customerInactiveDate: Date | undefined;
    /** Survey (CompleteForm) inactive date */
    surveyInactiveDate: Date | undefined;
    /** Form volume over the last 30 days */
    volume: number;
}

export interface FormValidationResult {
    messages: string[] | undefined;
    formName: string | undefined;
    formId: string | undefined;
}

/** Freddie Mac Message category */
export interface FreddieMacAppraisalDecisionMessageCategory {
    /** Message category */
    category: string | undefined;
    /** Messages */
    messages: any[] | undefined;
}

/** Freddie Mac BACE version values */
export interface FreddieMacBaceApiVersions {
}

/** Freddie Mac BACE Property Data Report Type values */
export interface FreddieMacBacePropertyDataReportTypes {
}

/** DTO class mirroring FreddieMacBaceResponse entity class without navigation properties */
export interface FreddieMacBaceResponseDto {
    /** Primary key */
    id: number;
    /** Case control number */
    controlNumber: number;
    /** The BACE API version */
    apiVersion: string | undefined;
    /** PDR Type */
    propertyDataReportType: string | undefined;
    /** Freddie Mac result summary message */
    resultMessage: string | undefined;
    /** Freddie Mac result status */
    resultStatus: string | undefined;
    /** Json data of messages from Freddie Mac */
    messagesJson: string | undefined;
    /** The BACE API Inspection Id */
    baceInspectionId: string | undefined;
    /** Inspection data send to Freddie Mac */
    baceInspectionFileName: string | undefined;
    /** Results data returned from Freddie Mac */
    baceResultsFileName: string | undefined;
    /** UTC date of the results */
    resultsDateUtc: Date;
}

/** Freddie Mac BACE calculated result status */
export enum FreddieMacBaceResultStatus {
    Unsuccessful = 0,
    Successful = 1,
    SuccessfulWithWarning = 2,
    FailedWithCriticalErrors = 3,
    IneligibleFor70H = 4,
    UpgradeRequired = 5,
}

/** Settings use to run BACE transform and export */
export interface FreddieMacBaceSettings {
    /** AMC ID */
    amcId: string | undefined;
    /** Customer is an AMC */
    customerIsAmc: boolean;
    /** Lender Address */
    lenderAddress: string | undefined;
    /** Lender ID */
    lenderId: string | undefined;
    /** Lender Name */
    lenderName: string | undefined;
    /** LPA Key */
    lpaKey: string | undefined;
    /** Substitution value for the AppraiserFileIdentifier in MISMO and BACE submissions */
    appraiserFileIdentifierSubstitutionValue: string | undefined;
}

/** GAAR results */
export interface GaarResult {
    /** The case control number */
    controlNumber: number;
    /** GAAR provider unique identifier */
    transactionId: string | undefined;
    /** The total rules that triggered */
    totalRulesCount: number;
    /** The rules that triggered */
    ruleFirings: GaarRuleFiring[] | undefined;
}

/** GAAR rule firing result */
export interface GaarRuleFiring {
    /** identifier of the rule */
    ruleId: string | undefined;
    /** loop index? */
    loopIndex: string | undefined;
    /** rule message */
    message: string | undefined;
}

/** GAAR model tailored for front-end use */
export interface GaarResultDto {
    /** Associated case control number */
    controlIdNumber: number;
    /** Date created */
    createdDateUtc: Date;
    /** Vendor transaction id */
    gaarTransactionId: string | undefined;
    /** Count of the rules triggered */
    ruleFiringsCount: number | undefined;
    /** Total number of rules applied */
    totalRulesCount: number | undefined;
    /** Related rule results */
    ruleFirings: GaarRuleFiringDto[] | undefined;
    /** True if there are any rule firings that need review */
    hasRuleFiringsRequiringReview: boolean;
}

/** GAAR rule firing result view model */
export interface GaarRuleFiringDto {
    /** Unique id of record */
    id: number;
    /** GAAR rule id */
    ruleId: string | undefined;
    /** GAAR loop index */
    loopIndex: string | undefined;
    /** GAAR rule message */
    ruleMessage: string | undefined;
    /** Severity level */
    severityLevel: GaarRuleSeverityDto | undefined;
    /** InternetUser that reviewed this rule result */
    reviewedByInternetUser: InternetUserNameInfoDto | undefined;
    /** UTC date/time reviewed */
    reviewedOnUtc: Date | undefined;
    /** Review comments */
    reviewedComments: string | undefined;
}

/** Generally Accepted Appraisal Rules (GAAR) severities */
export interface GaarRuleSeverityDto {
    /** Unique id of record */
    id: number;
    /** Code name of severity */
    code: string | undefined;
    /** Severity display name */
    name: string | undefined;
    /** Severity description */
    description: string | undefined;
}

/** The response wrapper from GAAR */
export interface GaarResultResponse {
    /** The GAAR results
             */
    gaarResult: GaarResult | undefined;
    /** GAAR provider unique identifier */
    transactionId: string | undefined;
    /** GAAR provider successful */
    success: boolean;
}

/** Request to mark a rule firing as reviewed */
export interface GaarRuleFiringReviewRequestDto {
    /** Case being reviewed */
    controlNumber: number;
    /** Unique id of rule firing record */
    id: number;
    /** User marking reviewed */
    reviewedByInternetUserId: number;
    /** Review comments */
    reviewedComments: string | undefined;
}

/** Request to see if GAAR submittal is required on a case */
export interface GaarSubmittalIsRequiredRequestDto {
    /** The case control number */
    controlNumber: number;
}

/** Results of determining if GAAR submittal is required */
export interface GaarSubmittalIsRequiredResponseDto {
    /** Submittal is required */
    submittalRequired: boolean;
    /** Submittal is available */
    submittalAvailable: boolean;
    /** Last date time GAAR was submitted */
    lastSubmittalDate: Date | undefined;
    /** Last Phoenix form data modified date */
    formDataModifiedDate: Date | undefined;
}

/** Setting Names related to GeneralSettings table in MuellerHomeowner */
export interface GeneralSettingNameConstants {
}

/** A request for generating an error report for phoenix forms */
export interface GenerateErrorReportRequest {
    /** Form ID to generate the error report for */
    phoenixFormId: string;
    /** Date to start the error report period */
    startDate: Date;
    /** Date to end the error report period (inclusive) */
    endDate: Date;
}

export interface GeoCoordsResponse {
    geoCoords: GeoCoordsViewModel | undefined;
    distanceFromAddress: string | undefined;
}

export interface GeoCoordsViewModel {
    latitude: number;
    longitude: number;
}

/** Parameters used to get an account file list */
export interface GetAccountFileListRequest extends ExistingAccountFileRequest {
    /** File type (optional) */
    fileType: string | undefined;
}

/** Exports available to QA */
export interface GetAvailableQAExportsResult {
    /** Export codes available */
    availableExportCodes: string[] | undefined;
    exportCodesNeedingValidation: string[] | undefined;
}

/** A data transfer object from case forms */
export interface GetCaseFormsDto {
    /** The forms on this case */
    caseForms: Wrappable[] | undefined;
    /** Is the appraiser set of forms being displayed to this user */
    displayAppraiserForms: boolean;
    /** Are the appraisal forms being displayed as editable for this user */
    displayAppraiserFormsAsEditable: boolean;
}

/** View Model for a Wrappable component. */
export interface Wrappable {
    /** Collection Unique Index used to order the list of components and is an easy way to reference it in React.
             */
    id: string | undefined;
    /** The enum value of the Id */
    wrappableItemType: WrappableItemType;
    /** Component name is the React component name to be rendered
             */
    componentName: string | undefined;
    /** Displayable Title for the component
             */
    title: string | undefined;
    /** Flag for a Read only component like the Case Header.
             */
    isReadOnly: boolean;
    /** json data is attached.
             */
    hasPayload: boolean;
    /** Original version of the Payload
             */
    originalPayload: string | undefined;
    /** Default Status for the form, redux maintains changes */
    formStatus: string | undefined;
    isExpanded: boolean;
    isHidden: boolean;
    /** Flag for a Phoenix Form embedded on the case.
             */
    isPhoenixForm: boolean;
    /** Indicate whether or not this is a form we should save */
    shouldSaveForm: boolean;
    /** Options allow the server to pass configuration settings down to client. */
    options: string | undefined;
    /** Provide a src for loading within iframe */
    src: string | undefined;
    pnxForm: PhoenixCaseForm | undefined;
    compSearchForm: ComparableSearchForm | undefined;
    /** Fashionable charts. */
    trendCharts: ChartImage[] | undefined;
    /** From Code (cCode) */
    formCode: string | undefined;
}

export enum WrappableItemType {
    Header = 1,
    History = 2,
    Files = 3,
    PrivateNotes = 4,
    Phoenix = 5,
    Photos = 6,
    CompSearch = 7,
    TrendCharts = 8,
    Sketch = 9,
    Validation = 10,
    BrokerCaseHeader = 11,
    BrokerCaseHistory = 12,
    PublicPropertyRecord = 13,
    CaseAttributes = 14,
    CaseReview = 15,
    UcdpSubmittal = 16,
    AppraiserOrderRequirements = 17,
    CubiCasa = 18,
    Exports = 19,
    RCT = 20,
    QACaseAudit = 21,
    BuildingPermits = 22,
    BuildingPermitsRoof = 23,
}

export interface PhoenixCaseForm {
    /** Wrappable Id - used by the Frontend to load the right React component */
    wrappableId: string | undefined;
    /** Control id number for post back */
    controlNumber: number;
    formName: string | undefined;
    formId: string | undefined;
    /** Rulesets to run after saving */
    formWarningsRulesetIds: string[] | undefined;
    /** RCT data - null if form is not an RCT */
    rct: PhoenixRctCaseForm | undefined;
    recommendations: PhoenixRecommendationsCaseForm | undefined;
}

/** Phoenix RCT case form details for ME */
export interface PhoenixRctCaseForm {
    /** Backfill endpoint URL */
    backfillUrl: string | undefined;
    /** Calculate endpoint URL */
    calculateUrl: string | undefined;
    /** Commit endpoint URL (null for non-FIT calcs) */
    commitUrl: string | undefined;
    /** Is an RCT No Calc form. This indicates to the front end that backfill should happen immediately after save.
For calcs, backfill happens prior to calc or commit. */
    isNoCalc: boolean;
}

export interface PhoenixRecommendationsCaseForm {
    updateRecommendationsUrl: string | undefined;
}

/** Request for additional data about the current case */
export interface GetCaseInfoRequest {
    /** The control number of the case */
    controlNumber: number;
    /** Internet User Id of the QA Rep */
    internetUserId: number;
    /** The SSO Token of the currently authenticated user */
    token: string | undefined;
}

/** Response for my data about the case */
export interface GetCaseInfoResponse {
    /** Case Header for the next case */
    caseInfo: QualityAssuranceCaseHeader | undefined;
    /** Summary Info for the next case */
    summaryInfo: QualityAssuranceSummaryInfo | undefined;
}

/** Case Header for a QA case */
export interface QualityAssuranceCaseHeader {
    /** The primary status of the case (i.e. open, completed) */
    primaryStatus: string | undefined;
    /** The secondary status of the case (i.e. unassigned, QA, completed) */
    secondaryStatus: string | undefined;
    /** Customer number for the account associated to the case */
    customerNumber: string | undefined;
    /** Customer name for the account associated to the case */
    customerName: string | undefined;
    /** The original inspection type of the case */
    originalInspectionType: string | undefined;
    /** The current inspection type of the case */
    inspectionType: string | undefined;
    /** A list of all available managers that the QA rep can escalate a case to */
    managers: QualityAssuranceUserManager[] | undefined;
    /** The Special Attention Notes associated with this case */
    specialAttentionNotes: string | undefined;
    /** The FR Inspection Comments associated with this case */
    inspectionComments: string | undefined;
    /** Policyholder of case */
    policyholder: UserContactInfo | undefined;
    /** Field Rep assigned to case */
    fieldRep: UserContactInfo | undefined;
    /** Address of subject property */
    surveyAddress: string | undefined;
    /** County of subject property */
    surveyCounty: string | undefined;
    /** State of subject property */
    surveyState: string | undefined;
    /** Geocode of subject property */
    surveyGeocode: string | undefined;
    /** Distance from GPS Location tag to Mueller Geocode */
    distanceFromGeocode: number;
    /** Date case Ordered */
    orderedDate: string | undefined;
    /** Date subject Surveyed */
    surveyDate: string | undefined;
    /** Date case Completed */
    completedDate: string | undefined;
    /** Dialogue between QA and manager */
    qaTouches: QualityAssuranceTouches[] | undefined;
    /** QA case Rejections */
    caseReturns: QualityAssuranceRejectionNotes[] | undefined;
    /** Case Policy Number */
    policyNumber: string | undefined;
    /** Case Tracking Number */
    trackingNumber: string | undefined;
    /** Customer due date */
    customerDueDate: string | undefined;
    /** Agent information */
    agent: UserContactInfo | undefined;
    /** List of hazards associated to the case */
    hazards: Hazard[] | undefined;
    /** Appraisal Status for appraisal QA */
    appraisalWorkflowStatusType: AppraisalWorkflowStatusType | undefined;
    /** Mueller@Home status */
    atHomeStatus: MuellerAtHomeStatus | undefined;
    /** Type of Case */
    caseType: string | undefined;
    /** Displayed as Assignment Type */
    transactionType: string | undefined;
    /** Appraisal Workflow Status */
    appraisalWorkflowStatus: string | undefined;
    /** Field Survey Director on the case */
    fieldSurveyDirector: UserContactInfo | undefined;
    /** Field Survey Coordinator / manager on the case */
    fieldSurveyCoordinator: UserContactInfo | undefined;
    /** Valuation Coordinator / manager on the case */
    valuationCoordinator: UserContactInfo | undefined;
    /** Valuation Director on the case */
    valuationDirector: UserContactInfo | undefined;
    /** Appraiser assigned to case */
    appraiser: UserContactInfo | undefined;
    /** Coverage A Out */
    coverageAOut: number | undefined;
    /** Coverage A In */
    coverageAIn: number | undefined;
    /** Percent ITV */
    percentITV: number | undefined;
    /** Channel (Loan officer org name) */
    channel: string | undefined;
    /** Link to stamp and photo requirements for the case */
    stampsAndPhotoRequirementsLink: LabelOnClick | undefined;
    /** Dwelling depreciation multiplier */
    depreciationMultiplier: number;
    /** GSE value from appraisal survey or case attributes */
    governmentSponsorCode: string | undefined;
    /** Status of CubiCasa scan for case */
    cubiCasaStatus: string | undefined;
    /** Should the Case Attributes Card be visible to QA user? */
    showCaseAttributes: boolean;
    /** Is Summary View enabled for the case? */
    summaryViewEnabled: boolean;
    /** Case has comparison fields */
    hasComparisonFields: boolean;
    /** Internet user id of assigned QA agent */
    qaAgentInternetUserId: number;
    /** Queue type Id */
    queueTypeId: number;
}

/** Class representing a QA reps manager */
export interface QualityAssuranceUserManager {
    /** The manager's internet user id */
    internetUserId: number;
    /** The name of the manager */
    nameNumberDto: NameNumberDto | undefined;
}

export interface QualityAssuranceTouches {
    /** ID of Note */
    id: number;
    /** Action accompanying Note */
    resolution: string | undefined;
    /** Note Body */
    body: string | undefined;
    /** Time QA Touch Started */
    start: Date | undefined;
    /** Time QA Touch Ended */
    end: Date | undefined;
    /** Writer of Note */
    author: string | undefined;
    /** Shows if touch is active */
    isActive: boolean;
}

export interface QualityAssuranceRejectionNotes {
    /** ID of Note */
    id: number;
    /** Note Body */
    body: string | undefined;
    /** Time Note Created */
    created: Date | undefined;
    /** Writer of Note */
    author: string | undefined;
}

/** Represents a hazard associated to a case */
export interface Hazard {
    /** Hazard name */
    hazardName: string | undefined;
    /** Count of the hazard  */
    hazardCount: number;
    /** The hazard level, some customers like to call 
their hazards something beside major/minor */
    hazardLevel: string | undefined;
    /** Specific category/sub-category of the hazard.  */
    hazardCategories: string[] | undefined;
}

/** Mueller@Home status info for a case */
export interface MuellerAtHomeStatus {
    /** Mueller@Home is available for this case */
    ready: boolean;
    /** Mueller@Home inspection has been created for this case */
    created: boolean;
    /** Mueller@Home inspection has been completed for this case */
    completed: boolean;
}

/** Summary Info for a QA case */
export interface QualityAssuranceSummaryInfo {
    /** Number of Photos */
    numOfPhotos: number;
    /** Number of Major Hazards */
    numOfMajorHazards: number;
    /** Number of Minor Hazards */
    numOfMinorHazards: number;
    /** Total Living Area */
    totalLivingArea: number;
    /** Coverage A Out */
    coverageAOut: number;
    /** Has Special Attn Notes */
    hasSpecialAttnNotes: boolean;
}

export interface GetCasePhotosRequest {
    /** Control Number for the requested case */
    controlNumber: number;
    /** Current user's token, authorizing the request */
    token: string | undefined;
    /** Internet User ID for the current user */
    internetUserId: number;
}

export interface GetCasePhotosResponse {
    /** The photo src url and tags for a case */
    photos: CasePhotos | undefined;
    photoTags: string[] | undefined;
}

export interface GetCaseRCTRequest {
    /** Control Number for the requested case */
    controlNumber: number;
    /** Current user's token, authorizing the request */
    token: string | undefined;
    /** Internet User ID for the current user */
    internetUserId: number;
}

export interface GetCaseRCTResponse {
    /** The Calculation Header for a case */
    rctViewModel: RCTViewModel | undefined;
}

export interface RCTViewModel {
    propertyDescriptionViewModel: PropertyDescriptionViewModel | undefined;
    homeFeaturesViewModel: HomeFeaturesViewModel | undefined;
    costEstimateViewModel: CostEstimateViewModel | undefined;
    commitDateViewModel: CommitDateViewModel | undefined;
}

export interface PropertyDescriptionViewModel {
    fields: RCTFieldViewModel[] | undefined;
}

export interface HomeFeaturesViewModel {
    sections: RCTMaterialSectionViewModel[] | undefined;
}

export interface RCTMaterialSectionViewModel {
    name: string | undefined;
    materials: RCTMaterialViewModel[] | undefined;
}

export interface RCTMaterialViewModel {
    name: string | undefined;
    value: string | undefined;
}

export interface GetCaseSketchRequest {
    /** Control Number for the requested case */
    controlNumber: number;
    /** Current user's token, authorizing the request */
    token: string | undefined;
    /** Internet User ID for the current user */
    internetUserId: number;
}

export interface GetCaseSketchResponse {
    /** The photo src url and tags for a case */
    sketch: Sketch | undefined;
}

/** The most recent export results for a given case */
export interface GetCurrentExportResultsByCaseResult {
    /** The available export results */
    caseExportResults: CaseExportResultDto[] | undefined;
}

/** response of getting eta's */
export interface GetEtaByInspectorResponse {
    /** Case */
    controlIdNumber: number;
    /** Start Date time of ETA */
    startDateTime: Date;
    /** End Date Time of ETA */
    endDateTime: Date;
}

/** Get next QA case request */
export interface GetNextCaseRequest {
    /** Internet User Id of the QA Rep */
    internetUserId: number;
    /** Flag indicating whether or not the current rep is a team leader */
    isTeamLeader: boolean;
    /** The SSO Token of the currently authenticated user */
    token: string | undefined;
    /** Whether or not the user is approved for Valuation Type Case (Could be inspection review or appraisal) */
    isValuationReview: boolean;
    /** Flag indicating whether or not the user has access to the summary view */
    isSummaryViewRightEnabled: boolean;
    /** Control number passed from client */
    controlNumber: number | undefined;
}

/** The response for a request from a QA rep to get their next case. */
export interface GetNextCaseResponse {
    /** Control Number of the next case. */
    controlIdNumber: number | undefined;
    /** QA Queue Id of the next case.  */
    qaQueueId: number | undefined;
    /** QA Queue Type Id of the next case.  */
    qaQueueTypeId: number;
    /** Days till Customer Due */
    daysTillCustomerDue: number | undefined;
    /** Placeholder for the subsequent call */
    caseInfo: QualityAssuranceCaseHeader | undefined;
    /** Placeholder for the subsequent call */
    summaryInfo: QualityAssuranceSummaryInfo | undefined;
    /** Indicate whether or not the summary view is enabled for this case */
    summaryViewEnabled: boolean;
    /** Indicate whether or not the feature setting for editing depreciation is enabled */
    editDepreciationEnabled: boolean;
    /** Indicate whether or not this case requires a Case Audit to complete.  */
    caseAuditRequired: boolean;
    /** Date QA Case Audit was conducted */
    caseAuditCompleted: boolean;
    /** Date QA Case Audit Feedback was conducted */
    caseAuditFeedbackCompleted: boolean;
    /** Indicate if this case requires receiving SignalR message from CaseEventsHub */
    subscribeToCaseEventMessages: boolean;
}

/** Get next Scheduling Assistant case request */
export interface GetNextSchedulingCaseRequest {
    /** Internet User Id */
    internetUserId: number;
    /** The SSO Token of the currently authenticated user */
    token: string | undefined;
    /** Control number passed from client */
    controlNumber: number | undefined;
}

/** The response for a request from a scheduling assistant to get their next case. */
export interface GetNextSchedulingCaseResponse {
    /** Control Number of the next case. */
    controlIdNumber: number | undefined;
}

/** Get next Scheduling Assistant Notification request */
export interface GetNextSchedulingNotificationRequest {
    /** Control Number of the case. */
    controlNumber: number;
}

/** The response for a request from a scheduling assistant to get the next notification */
export interface GetNextSchedulingNotificationResponse {
    previousNotificationName: string | undefined;
    previousNotificationTypeId: number | undefined;
    previousNotificationDate: Date | undefined;
    previousNotificationDateFormatted: string | undefined;
    nextNotificationName: string | undefined;
    nextNotificationTypeId: number | undefined;
    nextNotificationDate: Date | undefined;
    nextNotificationDateFormatted: string | undefined;
}

/** Get Scheduling Assistant Notification List request */
export interface GetSchedulingNotificationListRequest {
    /** Control Number of the case. */
    controlNumber: number;
}

/** The response for a request from a scheduling assistant to get the notification list */
export interface GetSchedulingNotificationListResponse {
    /** List of notifications for this case */
    schedulingNotificationList: SchedulingNotification[] | undefined;
}

export interface SchedulingNotification {
    /** Notification Type Id */
    notificationTypeId: number;
    /** Notification Name */
    notificationTypeName: string | undefined;
    /** Is currently the next notification */
    isNextNotification: boolean;
}

/** Parameters for identifying what customer/client/loan a UCDP Veros operation is for */
export interface SendVerosUCDPIdentificationDto {
    /** The Fannie Mae institution Id to send as */
    fnmaInstitutionId: string | undefined;
    /** The Fannie Mae seller number to send */
    fnmSellerNumber: string | undefined;
    /** The FreddieMac identification number to send */
    freIdentificationNumber: string | undefined;
    /** The Business Unit Number to send */
    businessUnitNumber: string | undefined;
}

/** Parameters for checking / getting a UCDP submission response */
export interface GetUCDPSubmissionResponseDto extends SendVerosUCDPIdentificationDto {
    /** The case control number */
    controlNumber: number;
    /** The Veros pathway Guid */
    pathwayGuid: string | undefined;
}

/** Request for GetUsersByAccountSurveyType */
export interface GetUsersByAccountSurveyTypeRequest {
    /** customer Id */
    customerId: number;
    /** Inspection type */
    inspectionTypeId: number;
    /** Queue Type */
    queueType: QueueTypeEnum;
}

/** Queue Types */
export enum QueueTypeEnum {
    HomeownersQa = 1,
    AppraisalQa = 2,
    FieldAppointment = 3,
    PreferredAppointment = 4,
    AuditQa = 5,
}

/** Employee Info and is Clocked in status */
export interface GetUsersByAccountSurveyTypeResponse extends NameNumberDto {
    /** Employee Id */
    employeeId: number;
    /** Is currently clocked in */
    isClockedIn: boolean;
}

/** Government sponsor codes stored on AppraisalSurveys */
export interface GovernmentSponsorCodes {
}

/** Hazard level constants */
export interface HazardLevelNames {
}

/** Constant values for Hazard rule object names */
export interface HazardRuleObjectNames {
}

/** Case Header information */
export interface Header {
    /** Wrappable Id - used by the Frontend to load the right React component */
    wrappableId: string | undefined;
    /** Policy (aka Appraisal) property information. */
    policyInfo: PolicyInfo | undefined;
    /** Top level case information like statuses. */
    caseInfo: CaseInfo | undefined;
    /** An additional data structure that reorganizes the data in the caseinfo and policy info into one simple datastructure */
    displayFields: DisplayField[] | undefined;
    /** can user edit case header */
    canUserEdit: boolean;
    /** can user add time log */
    canUserAddTimeLog: boolean;
    /** can user review the case profile */
    canViewCaseProfile: boolean;
    /** can user cancel case */
    canCancelCase: boolean;
    /** Legacy case view link */
    legacyDataEntryPageLink: string | undefined;
    /** User can view assignment approvals  */
    canViewAppraisalAssignmentApprovals: boolean;
    /** Case has Appraisal Assignment Approvals */
    appraisalAssignmentApprovalsExists: boolean;
}

export interface HireAppraiserDto {
    appraiserId: number;
    hireDate: Date;
}

/** Case History and Status Information */
export interface History {
    /** Wrappable Id - used by the Frontend to load the right React component
             */
    wrappableId: string | undefined;
    /** Current Status
             */
    appraisalCurrentStatus: AppraisalWorkflowStatusView | undefined;
    /** List of possible Next Appraisal Workflow Statuses
             */
    lenderNextActions: AppraisalWorkflowStatusView[] | undefined;
    /** Current Status
             */
    fieldSurveyCurrentStatus: WorkflowStatus | undefined;
    /** Next Status
             */
    fieldSurveyNextStatus: WorkflowStatus | undefined;
    isReadOnly: boolean;
}

/** Appraisal Workflow Status */
export interface WorkflowStatus {
    /** Status keeper.
             */
    appraisalWorkflowStatusType: AppraisalWorkflowStatusType;
    /** Appraisal Status as of this very instant.
             */
    appraisalWorkflowStatusId: number;
    /** Name of the status to display.
             */
    displayName: string | undefined;
    /** Enum value for the Appraisal Status
             */
    appraisalWorkflowStatusCode: string | undefined;
    /** Use this for identifying the Status */
    code: WorkflowStatusCode;
    /** Use this to Display the status */
    name: string | undefined;
    /** Indicate that the operation has not finished, yet.
             */
    isPolling: boolean;
    /** Display this message on the UX.  If IsPolling == false then
this is the completikon message.
             */
    message: string | undefined;
}

/** Status codes for the Homeowner database. */
export enum WorkflowStatusCode {
    NotSet = 0,
    Calc = 1,
    Cancelled = 2,
    Closed = 3,
    Completed = 4,
    Open = 5,
    Pending = 6,
    QA = 7,
    Received = 8,
    Unassigned = 9,
    OrderPaymentRequired = 10,
    OrderPaymentDeclines = 11,
    OrderPaymentExpired = 12,
    OrderSubmitted = 13,
}

/** Case History Note */
export interface HistoryNote {
    /** Unique Id for client */
    id: string | undefined;
    /** Enum for the type of history item
             */
    historyType: HistoryType;
    /** DateCreated */
    dateCreated: Date | undefined;
    /** Description */
    description: string | undefined;
    /** Note */
    note: string | undefined;
}

/** Dto for a Holiday */
export interface HolidayDto {
    /** Primary key */
    id: number;
    /** Name of the holiday */
    name: string | undefined;
    /** Date the holiday falls on */
    date: Date;
}

export interface HomesiteStackCodes {
}

/** Hourly Employee File layout */
export interface HourlyDollarFile extends DollarFileDefinitionBase {
    /** File name */
    fileName: string | undefined;
    /** Data for Export */
    data: UltimatePayrollDollarDto[] | undefined;
}

/** File Definition interface */
export interface IFileDefinition {
    /** System file name */
    fileName: string | undefined;
    /** Source path of file is assumed to be in CaseFilePath unless FullPathOverride is set. Prefix with "/" to start in CaseFilePath */
    fullPathSourceOverride: string | undefined;
    /** Final path of file is assumed to be in CaseFilePath unless FullPathOverride is set. Prefix with "/" to start in CaseFilePath */
    fullPathDestinationOverride: string | undefined;
    /** Friendly file name sent to customers */
    friendlyName: string | undefined;
    /** If file already exists should a version be added */
    addFileVersion: boolean;
    /** Description of the file  */
    docDescription: string | undefined;
    /** The MIME type of the file attachment */
    mimeType: string | undefined;
    /** If true the control number is not used in the file name */
    excludeControlNumberInFileName: boolean;
}

/** A class that stores a hash value for comparison */
export interface IHashedObject {
    /** The hash value */
    hashValue: string | undefined;
}

/** Template keys for a recommendation letter */
export interface ILetterTemplateKeys {
    /** Current date */
    date: string | undefined;
    /** Insured Name */
    insuredName: string | undefined;
    /** Contact Name */
    contactName: string | undefined;
    /** Contact Phone */
    contactPhone: string | undefined;
    /** Contact Email */
    contactEmail: string | undefined;
    /** Mailing Address1 */
    mailingAddress1: string | undefined;
    /** Mailing City State Zip */
    mailingCityStateZip: string | undefined;
    /** Policy Number */
    policyNumber: string | undefined;
    /** Recommendations */
    recommendations: string | undefined;
    /** Recommendations Table */
    recommendationsTable: string | undefined;
    /** Survey Address 1 */
    surveyAddress1: string | undefined;
    /** Survey City State Zip */
    surveyCityStateZip: string | undefined;
    /** Survey Date Unformatted */
    surveyDateUnformatted: string | undefined;
    /** Survey Date Formatted */
    surveyDateFormatted: string | undefined;
    /** Agency Name */
    agencyName: string | undefined;
    /** Agency Phone Number */
    agencyPhoneNumber: string | undefined;
    /** Agency Email */
    agencyEmail: string | undefined;
    /** Agency Code */
    agencyCode: string | undefined;
    /** Agents Address */
    agentsAddress: string | undefined;
    /** Agents City */
    agentsCity: string | undefined;
    /** Agents State */
    agentsState: string | undefined;
    /** Agents City State Zip */
    agentsCityStateZip: string | undefined;
    /** Location Building */
    locationBuilding: string | undefined;
    /** Underwriter Name */
    underwriterName: string | undefined;
    /** Underwriter Code */
    underwriterCode: string | undefined;
    /** Insured Home Phone */
    insuredHomePhone: string | undefined;
    /** Insured Email */
    insuredEmail: string | undefined;
    /** Control Number */
    controlNumber: string | undefined;
    /** Inspector Name */
    inspectorName: string | undefined;
    /** Tracking Number */
    trackingNumber: string | undefined;
    /** Order Code In */
    orderCodeIn: string | undefined;
    /** Year the inspection was completed */
    yearInspected: string | undefined;
    /** Month the inspection was completed */
    monthInspected: string | undefined;
    /** Day the inspection was completed */
    dayInspected: string | undefined;
    /** Recommendation number */
    recommendationNumber: string | undefined;
    /** Recommendation level */
    recommendationLevel: string | undefined;
    /** Recommendation name */
    recommendationName: string | undefined;
    /** Recommendation text */
    recommendationText: string | undefined;
    /** An HTML block that defines a set of recommendations grouped by level */
    levelGroupTemplate: string | undefined;
    /** An HTML block that defines a single recommendation */
    recommendationTemplate: string | undefined;
    /** Completed Date Formatted */
    completedDateFormatted: string | undefined;
}

/** Import Codes */
export interface ImportCodes {
}

/** Result response from adding new inspectors from a list of employee inspector records */
export interface ImportEmployeeInspectorResponse {
    /** Unique Employee Id */
    payrollEmployeeId: string | undefined;
    /** Employee Full Name */
    employeeName: string | undefined;
    /** Inspector Number */
    inspectorNumber: number;
    /** Email Address */
    email: string | undefined;
    /** Any issue importing this employee */
    issue: string | undefined;
    /** Easy boolean if it was created or not */
    wasCreated: boolean;
}

/** Response from ImportOperation business logic */
export interface ImportQueueResponse {
    /** Indicator if the request has errors */
    error: boolean;
    /** Error Messages */
    errorMessages: string[] | undefined;
}

/** Import status codes from [MR2Staging].[dbo].[vw_ImportQueueStatus] */
export interface ImportQueueStatusCodes {
}

/** Import setting names (default settings) */
export interface ImportSettingNames {
}

/** Response from IImportOperations.GetImportStatus */
export interface ImportStatusResponse {
    /** True if the import is not running */
    finished: boolean;
    /** True if not running and in a failed status code */
    failed: boolean;
    /** Summary of import errors and scrubs */
    messages: string[] | undefined;
    /** Total number of records */
    records: number;
    /** Count of records with errors */
    recordErrors: number | undefined;
    /** Count of records with scrubs */
    recordScrubs: number | undefined;
    /** Count of records successfully imported */
    recordUploads: number | undefined;
    /** Batch Id of import */
    batchId: string | undefined;
}

export interface InactivateAppraiserDto {
    /** Appraiser id */
    appraiserId: number;
    /** Date they are inactive */
    inactiveDate: Date;
    /** Date they are active again */
    activeDate: Date;
}

/** Display Mapping for HowLongAfterInitialMeetingDidYouCompleteAnInspection */
export interface InitialInspectionTimeRange {
}

/** Request to start an export for a case */
export interface InitiateRealtimeExportRequest {
    /** Export Code to run */
    exportCode: string | undefined;
    /** The case control number to run the export for */
    controlNumber: number;
    /** Internet user id of the user initiating this export */
    initiatedByInternetUserId: number;
    /** URL to pass status updates back to */
    progressUpdatesUrl: string | undefined;
    /** A guid for the export jobs */
    exportJobUuid: string | undefined;
}

/** Starts an export request */
export interface StartExportRequest {
    /** The export code to run */
    exportCode: string | undefined;
    /** The case control number to run */
    controlNumber: number;
    /** Internet user id of the user initiating this export */
    initiatedByInternetUserId: number;
    /** URL to pass status updates back to */
    progressUpdatesUrl: string | undefined;
    /** Guid id for export job */
    exportJobUuid: string | undefined;
    /** Id returned from the export job scheduler (Hangfire) */
    exportJobRunnerId: string | undefined;
}

/** Result of starting an export */
export interface InitiateRealtimeExportResult extends StartExportRequest {
}

/** A chained sequence of exports to run */
export interface InitiateRealtimeExportSequenceRequest {
    /** The sequence of export requests to execute */
    exportSequence: InitiateRealtimeExportRequest[] | undefined;
    /** A guid for the export jobs */
    exportJobUuid: string | undefined;
}

/** The result of starting a sequence of exports */
export interface InitiateRealtimeExportSequenceResult {
    initiateRealtimeExportResults: InitiateRealtimeExportResult[] | undefined;
    /** The SignalR hub name */
    signalrHubName: string | undefined;
    /** The SignalR group used to subscribe to the SignalR messages */
    signalrGroupName: string | undefined;
    /** The export job unique identifier */
    exportJobUuid: string | undefined;
    /** Id returned from the export job scheduler (Hangfire) */
    exportJobRunnerId: string | undefined;
}

/** Data model for an email indicating a new Appointment has been scheduled for an appraisal case */
export interface InspectionRescheduledEmailDto {
    /** Addresses Email will be sent */
    toAddress: MailAddress[] | undefined;
    /** Carbon Copy Addresses Email will be sent */
    ccAddress: MailAddress[] | undefined;
    /** Name of Case's Lender */
    lenderName: string | undefined;
    /** Case's Loan Number */
    loanNumber: string | undefined;
    /** Cases's Status */
    status: string | undefined;
    /** Cases's Survey Type */
    reportType: string | undefined;
    /** Case's Broker */
    orderedBy: string | undefined;
    /** Case's Borrower */
    borrowerName: string | undefined;
    /** Cases's assigned Inspector */
    inspectorName: string | undefined;
    /** Date of Case's Appointment */
    appointmentDate: string | undefined;
    /** Time of Case's Appointment */
    appointmentTime: string | undefined;
}

/** Data model for an email indicating intial Appointment has been scheduled for an appraisal case */
export interface InspectionScheduledEmailDto {
    /** Addresses Email will be sent */
    toAddress: MailAddress[] | undefined;
    /** Carbon Copy Addresses Email will be sent */
    ccAddress: MailAddress[] | undefined;
    /** Name of Case's Lender */
    lenderName: string | undefined;
    /** Case's Loan Number */
    loanNumber: string | undefined;
    /** Cases's Status */
    status: string | undefined;
    /** Cases's Survey Type */
    reportType: string | undefined;
    /** Case's Broker */
    orderedBy: string | undefined;
    /** Case's Borrower */
    borrowerName: string | undefined;
    /** Cases's assigned Inspector */
    inspectorName: string | undefined;
    /** Date of Case's Appointment */
    appointmentDate: string | undefined;
    /** Time of Case's Appointment */
    appointmentTime: string | undefined;
}

/** A DTO defining the needed information to assign a service region to counties */
export interface InspectionServiceRegionRequest {
    /** Service Region Id to be assigned */
    serviceRegionId: number;
    /** The assigned list of counties */
    countyFIPSList: string[] | undefined;
}

/** Model to add a new Inspector Admin Work Log */
export interface InspectorAdminWorkLogAdd {
    /** Inspector Number Work Log is for */
    inspectorNumber: number;
    /** The type of work that was performed (InspectorAdminWorkTypeCode) */
    workTypeCode: string;
    /** Time spent in Minutes */
    timeMinutes: number;
    /** Miles Driven (optional) */
    milesDriven: number | undefined;
    /** Actual users time they started working the admin log */
    startDateTimeLocal: Date;
    /** Note associated to the work log */
    note: string;
}

/** Delete model for Inspector Admin Work Log */
export interface InspectorAdminWorkLogDelete {
    /** Primary key of Inspector Admin Work Log */
    id: number;
}

/** Used to get list or a detail of Admin Work Log for an Inspector */
export interface InspectorAdminWorkLogDto {
    /** Inspector Number Work Log is for */
    id: number;
    /** Inspector Number */
    inspectorNumber: number;
    /** Pay Period information */
    payPeriod: PayPeriodDto | undefined;
    /** Time spent in Minutes */
    timeMinutes: number;
    /** Miles Driven (optional) */
    milesDriven: number | undefined;
    /** The type of work that was performed (InspectorAdminWorkTypeCode) */
    workType: InspectorAdminWorkTypeDto | undefined;
    /** Note associated to the work log */
    note: string | undefined;
    /** Internet user name that added the entry */
    createdByUser: string | undefined;
    /** FR's local time log started */
    startDateTimeLocal: Date | undefined;
    /** FR's local time log ended */
    endDateTimeLocal: Date | undefined;
}

/** Work Types to be displayed */
export interface InspectorAdminWorkTypeDto {
    /** Primary key */
    id: number;
    /** Unique Code */
    code: string | undefined;
    /** Name */
    name: string | undefined;
    /** Sort order to be displayed */
    displayOrder: number;
}

/** Model to add a new Inspector Admin Work Log */
export interface InspectorAdminWorkLogUpdate {
    /** Inspector Number Work Log is for */
    id: number;
    /** The type of work that was performed (InspectorAdminWorkTypeCode) */
    workTypeCode: string;
    /** Time spent in Minutes */
    timeMinutes: number;
    /** Miles Driven (optional) */
    milesDriven: number | undefined;
    /** Note associated to the work log */
    note: string;
    /** Actual users time they started working the admin log */
    startDateTimeLocal: Date;
}

/** Inspector Administrative Work Type Codes uses for Types of Hours added that are not case production */
export interface InspectorAdminWorkTypeCodes {
}

/** Data model for an email indicating initial inspector has been assigned to an Appraisal case */
export interface InspectorAssignmentEmailDto {
    /** Addresses Email will be sent */
    toAddress: MailAddress[] | undefined;
    /** Carbon Copy Addresses Email will be sent */
    ccAddress: MailAddress[] | undefined;
    /** Name of Case's Lender */
    lenderName: string | undefined;
    /** Case's Loan Number */
    loanNumber: string | undefined;
    /** Cases's Status */
    status: string | undefined;
    /** Cases's Survey Type */
    reportType: string | undefined;
    /** Case's Broker */
    orderedBy: string | undefined;
    /** Case's Borrower */
    borrowerName: string | undefined;
    /** Cases's assigned Inspector */
    inspectorName: string | undefined;
    /** Date of Case's Appointment */
    appointmentDate: string | undefined;
    /** Time of Case's Appointment */
    appointmentTime: string | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfInspectorAssignmentNotification extends TypeSafeEnum {
}

/** Customer Satisfaction Survey Process */
export interface InspectorAssignmentNotification extends TypeSafeEnumOfInspectorAssignmentNotification {
}

/** Inspector Calendar Event */
export interface InspectorCalendarEventLog {
    /** Inspector Info */
    inspectorInfo: UserInfo | undefined;
    /** Start Event Name */
    startDateTime: Date;
    /** End Event Time */
    endDateTime: Date;
    /** Case Number */
    controlIdNumber: number;
}

/** user information */
export interface UserInfo extends NameNumberDto {
    /** State of where the user lives */
    state: string | undefined;
}

/** This will store capacity in memory to be updated as each case is assigned */
export interface InspectorCapacityDto {
    /** Inspector Id */
    inspectorId: number;
    /** Inspector Number */
    inspectorNumber: number;
    /** Maximum amount of minutes that can be assigned at any given time */
    maxCapacityMinutes: number;
    /** Minutes Assigned (to be updated) */
    currentCapacityMinutes: number;
    /** Calculation of MaxCapacityMinutes - CurrentCapacityMinutes */
    availableMinutes: number;
    /** Does the Inspector have a call log issue */
    hasCallLogIssue: boolean;
}

/** Inspector Case Appointment Request */
export interface InspectorCaseAppointmentRequest {
    /** Inspector Id */
    inspectorId: number;
    /** Start Date of appointments */
    startDateTime: Date;
    /** End date of appointments (If blank it will go out 6 months in the future).

This is treated as a 'Date' field (i.e. not DateTime) and is INCLUSIVE: 
If you have 1/1/2024 12:00AM here, it will get all appointments on 1/1/2024 */
    endDateTime: Date | undefined;
}

/** List of cases for inspectors */
export interface InspectorCaseLogDetail {
    /** Employee Info */
    employee: NameNumberDto | undefined;
    /** Case Log information */
    caseLog: CaseLogDto | undefined;
    /** Inspected Date of case */
    inspectedDate: Date | undefined;
}

/** Case Mileage Details */
export interface InspectorCaseMileageDto {
    /** Case Id */
    controlIdNumber: number;
    /** Date the case was inspected */
    inspectedDate: Date | undefined;
    /** Previous Case or Address they came from. */
    previousCaseOrAddress: string | undefined;
    /** Mileage Estimated to get to the case. */
    mileageEstimated: number;
    /** Miles Inspector entered to get to the case */
    mileageActual: number;
    /** The detail points that made up the Mileage Actual amount */
    mileagePointDetails: CaseLogWayPointDto[] | undefined;
    /** Percentage efficient Expected and Actual (MinutesExpected / MinutesActual) */
    efficiencyPercent: number | undefined;
    /** Name of the Survey Type for this case */
    surveyTypeName: string | undefined;
    /** Indicates this customer/survey type was an appointment case */
    isAppointment: boolean;
}

/** Model for Estimate and Actual Minutes detail */
export interface InspectorCaseTimeDetailDto {
    /** Drive Time Minutes */
    driveTimeMinutes: number;
    /** Site Time Minutes */
    siteTimeMinutes: number;
    /** Web write up Minutes */
    webTimeMinutes: number;
    /** Total Minutes of data above */
    totalMinutes: number;
}

/** Inspector Case Time Log */
export interface InspectorCaseTimeDto {
    /** Case Id */
    controlIdNumber: number;
    /** Survey Type */
    surveyTypeName: string | undefined;
    /** Detail of Actual minutes spent */
    minutesActualDetail: InspectorCaseTimeDetailDto | undefined;
    /** Detail of Expected minutes to spend */
    minutesExpectedDetail: InspectorCaseTimeDetailDto | undefined;
    /** Percentage efficient Expected and Actual (MinutesExpected / MinutesActual) */
    efficiencyPercent: number | undefined;
}

/** Inspector Contractor */
export interface InspectorContractorsPayrollSummary {
    /** Inspector */
    inspector: NameNumberDto | undefined;
    /** inspector state */
    state: string | undefined;
    /** Payroll Id */
    payrollEmployeeId: string | undefined;
    /** Contractors Pay */
    mac: number;
    /** If payroll has been approved for the user */
    isApproved: boolean;
    /** Supervisor to employee */
    supervisor: NameNumberDto | undefined;
}

/** Inspector Detail Dto */
export interface InspectorDetailDto extends InspectorListDto {
    /** Email */
    email: string | undefined;
    /** Phone Number */
    phone: string | undefined;
}

/** Match type found when searching for inspectors */
export enum InspectorExclusionMatchTypeEnum {
    LastName = 0,
    FullName = 1,
}

/** Results of an exclusion search */
export interface InspectorExclusionSearchMatchListDto {
    /** List of inspector matches */
    matches: InspectorExlcusionSearchMatchDto[] | undefined;
}

/** Result of exclusion search for an inspector */
export interface InspectorExlcusionSearchMatchDto {
    /** The type of match found */
    matchType: InspectorExclusionMatchTypeEnum;
    /** The matched inspector */
    inspector: InspectorListDto | undefined;
    /** Action required based on the match and inspector's current exclusion status */
    actionNeeded: ExclusionActionNeededEnum;
    /** Date of status change provided by the customer */
    statusChangeDate: Date;
}

/** Request to search for inspectors based on customer exclusion spreadsheet */
export interface InspectorExclusionSearchRequestDto {
    /** Customer number to apply exclusions */
    customerNumber: number;
    /** Spreadsheet file data */
    fileData: string | undefined;
    /** The types of matches to find in the search */
    matchTypes: InspectorExclusionMatchTypeEnum[] | undefined;
}

/** Details to use in search of an inspector */
export interface InspectorExclusionsSearchDto {
    /** Inspector first name */
    firstName: string | undefined;
    /** Inspector last name */
    lastName: string | undefined;
    /** Customer number the search is being done for */
    customerId: number;
    /** Has the inspector been marked as eligible for cases (exclusion removed)? */
    eligible: boolean;
    /** Date of status change provided by the customer */
    statusChangeDate: Date;
}

/** Field rep eligible to be assigned case */
export interface InspectorForCase {
    /** Field rep Id */
    id: number;
    /** Field rep number */
    number: number;
    /** Field rep full name */
    fullName: string | undefined;
    /** Field rep employee id */
    employeeId: number | undefined;
    /** Field rep can be assigned cases */
    canBeAssignedCases: boolean;
    /** Field rep cost efficiency grade */
    costEfficiencyScore: number | undefined;
    /** Indicator that FR is not enabled for auto-assignment */
    disableAutoAssign: boolean;
    /** FR is a trainee */
    isTrainee: boolean;
    /** Date / IsAvailable / Reason combo to describe field rep availability due to travel rules, NOT considering calendar availability or unavailability, just travel rules by day */
    daysAvailability: InspectorForCaseAvailableDateReason[] | undefined;
}

/** Date / IsAvailable / Reason combo to describe field rep availability */
export interface InspectorForCaseAvailableDateReason {
    /** Days that this inspector is available
(currently this data is only provided from public InspectorsForCaseResponse GetInspectorsForCase(int controlIdNumber)
which takes a date range, and inspectors may be traveling during that range, meanining they might not be available certain days
in the request range */
    date: Date;
    /** True if the inspector is availble on this date */
    isAvailable: boolean;
    /** Location FR will be in on this date PRIMARY/SECONDARY */
    location: string | undefined;
    /** Where the inspector is coming from if they are covering this case with secondary coverage, null otherwise
Home or Travel (InspectorServiceTravelRuleStartType) */
    secondaryStartingLocation: string | undefined;
    /** Latitude for where the FR is coming from (home/travel) */
    latitude: number | undefined;
    /** Longitude for where the FR is coming from (home/travel) */
    longitude: number | undefined;
    /** Distance to case in miles from this field rep's home */
    distanceToCase: number | undefined;
}

/** Inspector Hiring Forecast Detail */
export interface InspectorHiringForecastDetailDto {
    /** Hiring Id  */
    id: number;
    /** Service Region Name */
    serviceRegion: ServiceRegionDto | undefined;
    /** Number of Employees needed to hire */
    deficit: number;
    /** Number of Employees needed to hire in local area */
    deficitLocal: number;
    /** Number of Trainees  */
    traineeCount: number;
    /** Deficit local with Trainee adjustment of 3 trainees equal 1 employee */
    deficitLocalTrainee: number;
    /** The assigned employee id (field development manager for now) */
    assignedToEmployee: EmployeeListDto | undefined;
    /** Status of Hiring Forecast */
    status: InspectorHiringForecastStatus;
    /** Created Date */
    createdDateTimeUtc: Date;
    /** Date of Last Update */
    updatedDateTimeUtc: Date;
    /** Ordering Trend */
    orderingTrend: number;
    /** How much the inspectors are being used */
    inspectorUtilization: number;
    /** Average wage of Inspector */
    rateOfPayOriginal: number | undefined;
    /** Rate of Pay rounded to nearest quarter */
    rateOfPay: number | undefined;
    /** Logistic Manager of that region */
    logisticsManager: string | undefined;
}

/** Service Region Id/Name Pairings */
export interface ServiceRegionSlim {
    /** Id */
    id: number;
    /** Service Region Name */
    name: string | undefined;
    /** State that the region resides in */
    stateAbbreviation: string | undefined;
}

export interface ServiceRegionDto extends ServiceRegionSlim {
    /** State that service region is associated with */
    state: StateDto | undefined;
    /** List of Counties associated to service region */
    countyList: CountyDto[] | undefined;
}

/** Refers to status field in InspectorHiringForecasts */
export enum InspectorHiringForecastStatus {
    Open = 1,
    InRecruiting = 2,
    Closed = 3,
}

/** Inspector Hiring Forecast History dto */
export interface InspectorHiringForecastHistoryDto {
    /** Primary key */
    id: number;
    /** Foreign key to InspectorHiringForecast */
    inspectorHiringForecastId: number;
    /** Created Date UTC */
    createdDateTimeUtc: Date;
    /** Deficit Count */
    deficit: number;
    /** Deficit Count Localized (handles traveling FR) */
    deficitLocal: number;
    /** Number of Trainees in the region */
    traineeCount: number;
    /** Deficit count local and trainee adjusted */
    deficitLocalTrainee: number;
    /** Ordering Trend */
    orderingTrend: number;
    /** How much the inspectors are being used */
    inspectorUtilization: number;
    /** Average wage of Inspector */
    rateOfPayOriginal: number | undefined;
    /** Average wage of Inspector rounded to nearest quarter */
    rateOfPay: number | undefined;
}

/** User to add a note to a Inspector Hiring Forecast record */
export interface InspectorHiringForecastNoteAdd {
    /** Inspector Hiring Forecast Id */
    inspectorHiringForecastId: number;
    /** Created By User Information */
    createdByInternetUserId: number;
    /** Comment that was made by the user */
    note: string;
}

/** Inspector Hiring Forecast Note */
export interface InspectorHiringForecastNoteDto {
    /** Note Id */
    id: number;
    /** Inspector Hiring Forecast Id */
    inspectorHiringForecastId: number;
    /** Created By User Information */
    createdByInternetUserNameInfo: InternetUserNameInfoDto | undefined;
    /** Comment that was made by the user */
    note: string | undefined;
    /** Date Time Note was created */
    createdDateTimeUtc: Date;
}

/** Used to update and Inspector Hiring Forecast */
export interface InspectorHiringForecastUpdateRequest {
    /** Inspector Hiring Forecast id */
    id: number;
    /** New Status */
    status: InspectorHiringForecastStatus;
    /** Assigned Field Development Manager Employee (for now :)) */
    assignedToEmployeeId: number;
}

/** Case Detail of Inspector Cases going to be paid */
export interface InspectorPaymentCase {
    /** Control Number */
    controlIdNumber: number;
    /** Inspector Number */
    inspectorNumber: string | undefined;
    /** Inspector Name */
    inspectorName: string | undefined;
    /** Payroll Id */
    payrollEmployeeId: string | undefined;
    /** Inspector state address */
    inspectorState: string | undefined;
    /** Case MAC */
    mac: number;
    /** Total Pay for Case */
    totalPay: number;
    /** Survey Type */
    surveyType: string | undefined;
    /** Date Submitted to QA from FR queue */
    submittedDateTime: Date | undefined;
    /** Date Inspected by FR */
    inspectedDateTime: Date | undefined;
    /** Miles Driven to get to the case */
    milesDriven: number;
    /** Site Hours */
    siteHours: number;
    /** Web Hours */
    webHours: number;
    /** Travel Hours */
    travelHours: number;
    /** From Admin Work Logs */
    administrativeHours: number | undefined;
    /** From Admin Work Logs */
    administrativeMiles: number | undefined;
}

/** Response of data and column definitions */
export interface InspectorPaymentCaseResponse {
    /** List of data */
    data: InspectorPaymentCase[] | undefined;
    /** File Name */
    fileName: string | undefined;
    /** Column Definitions */
    columnDefinitions: MGridColumnDefinition[] | undefined;
}

/** Details for an individual case to be included in the pay summary */
export interface InspectorPayPeriodCaseViewModel {
    /** Control number */
    controlIdNumber: number;
    /** Survey type */
    surveyClass: string | undefined;
    /** Survey city */
    surveyCity: string | undefined;
    /** Total estimated amount to be paid for individual case */
    mac: string | undefined;
    /** Total amount paid for individual case */
    caseCost: string | undefined;
    /** Date case was submitted to QA */
    submittedDate: Date | undefined;
    /** Minutes spent the case */
    minutes: string | undefined;
    /** Miles driven on the case */
    mileage: number | undefined;
}

/** Inspector Pay Period Summary Request */
export interface InspectorPayPeriodSummaryRequest {
    /** Ops Manager Internet User Id */
    operationsManagerInternetUserId: number;
    /** Ops Director Internet User Id */
    operationsDirectorInternetUserId: number;
    /** Field Development Manager Internet User Id */
    fieldDevelopmentManagerInternetUserId: number;
    /** Ops Director Internet User Id */
    isTrainee: boolean | undefined;
    /** The pay period to get the list of users  */
    payPeriodId: number;
    /** list of roles to limit the pay period */
    employeeRoleList: EmployeeRoleEnum[];
}

/** Inspector Payroll Summary */
export interface InspectorPayrollSummary {
    /** Inspector */
    inspector: InspectorListDto | undefined;
    /** inspector state */
    state: string | undefined;
    /** Payroll Id */
    payrollEmployeeID: string | undefined;
    /** hourly pay rate */
    hourlyPayRate: number | undefined;
    /** Is a team leader */
    isTeamLeader: boolean;
    /** team leader pay rate */
    teamLeaderPayRate: number | undefined;
    /** Production bonus */
    productionBonus: number;
    /** Production Hours */
    productionHours: number;
    /** Amount of Hours where Date inspected was outside the pay period */
    previousHours: number;
    /** Administrative hours */
    adminHours: number;
    /** Administrative team lead hours */
    adminTeamLeadHours: number;
    /** total hours */
    totalHours: number;
    /** Production mileage */
    productionMileage: number;
    /** Admin mileage */
    adminMileage: number;
    /** Total Mileage */
    totalMileage: number;
    /** Mileage Reimbursement dollars */
    totalMileageReimbursement: number;
    /** Effective Hourly Rate: ((HoursWorked * HourlyRateAgreed) + MacBonusPay) / HoursWorked */
    effectiveHourlyRate: number;
    /** If payroll has been approved for the user */
    isApproved: boolean;
    /** Supervisor to employee */
    supervisorName: string | undefined;
}

/** The full pay summary */
export interface InspectorPaySummaryViewModel {
    /** List of cases in the pay period to be summarized */
    payPeriodCases: InspectorPayPeriodCaseViewModel[] | undefined;
    /** CasePay + MileagePay */
    totalCaseCost: string | undefined;
    /** Total estimated amount to be paid to the inspector (Mueller Adjusted Cost) */
    totalMac: string | undefined;
    /** Amount paid in excess of estimated (excluding MileagePay) */
    macBonus: string | undefined;
    /** Total Hours accumulated for the inspector */
    totalHours: string | undefined;
    /** Total Mileage accumulated for the inspector */
    totalMileage: string | undefined;
    /** The Defines what Columns to display on the Client's grid */
    columns: ColumnViewModel[] | undefined;
}

/** Result from InspectorResultsProvider */
export interface InspectorQuicklistResult {
    /** Field rep number */
    inspectorNumber: number;
    /** EmployeeId, used for merging external data */
    employeeId: number;
    /** Field rep first and last name */
    inspectorName: string | undefined;
    /** Field rep home metropolitan statistical area */
    serviceRegion: string | undefined;
    /** Field rep home county */
    county: string | undefined;
    /** Field rep home state */
    state: string | undefined;
    /** Field director for field rep */
    fieldDirector: string | undefined;
    /** Field development manager for field rep */
    fieldDevelopmentManager: string | undefined;
    /** Operations (field, or logistics) manager for field rep */
    fieldOperationsManager: string | undefined;
    /** Has the field rep completed training */
    fieldRepIsTrainee: string | undefined;
    /** Total expected hours based on assigned case expected minutes */
    fieldHoursExpected: number;
    /** Count of assigned cases */
    casesAssigned: number;
    /** Count of assigned cases past due date */
    casesPastDue: number;
    /** Count of with a date inspected that haven't been submitted */
    casesInspectedNotSubmitted: number;
    /** Date field rep was hired */
    hireDate: Date | undefined;
    /** Date field rep completed training */
    trainingCompletedDate: Date | undefined;
    /** Field rep internet user id */
    internetUserId: number;
    /** Count of cases submitted to QA in the last 7 days */
    casesSubmittedToQa: number;
    /** Latest Training Note for Employee */
    lastNote: string | undefined;
    /** Guids for assigned phoenix files - used for merging external data */
    phoenixFiles: string[] | undefined;
    /** Total number of cases that have calls required */
    casesWithCallsCount: number;
    /** Total number of cases with overdue calls */
    callsPastDueCount: number;
    /** CallsPastDueCount / CasesWithCallsCount */
    callsPastDuePercent: number;
    /** Field Rep's last login date */
    lastLoginDate: Date | undefined;
    /** Employee status from payroll system */
    employeeStatus: string | undefined;
    /** Average days overdue of all open calls */
    averageDaysOverdue: number;
    /** FR available hours for the next 30 days */
    availableHours: number;
    /** Lender logistics manager */
    lenderLogisticsManager: string | undefined;
    /** Joining InspectorAdminWorkLogs ON InspectorId AND wt.Code IN ('CHECK_IN', 'NEW_HIRE_CHECK_IN') */
    lastCheckInDays: number | undefined;
    /** Date and content of last note (from InspectorAdminWorkLogs) */
    lastAdminWorkLog: string | undefined;
    /** Available Hours Compliant, Yes if FR is in compliance for the next 4 weeks */
    availableHoursCompliant: string | undefined;
    /** Number of support calls placed by this inspector in the last 7 days. Excludes coaching calls */
    supportCallsLast7Days: number;
}

/** Data model for an email indicating a new inspector has been assigned to an Appraisal case */
export interface InspectorReassignmentEmailDto {
    /** Addresses Email will be sent */
    toAddress: MailAddress[] | undefined;
    /** Carbon Copy Addresses Email will be sent */
    ccAddress: MailAddress[] | undefined;
    /** Name of Case's Lender */
    lenderName: string | undefined;
    /** Case's Loan Number */
    loanNumber: string | undefined;
    /** Cases's Status */
    status: string | undefined;
    /** Cases's Survey Type */
    reportType: string | undefined;
    /** Case's Broker */
    orderedBy: string | undefined;
    /** Case's Borrower */
    borrowerName: string | undefined;
    /** Cases's assigned Inspector */
    inspectorName: string | undefined;
    /** Date of Case's Appointment */
    appointmentDate: string | undefined;
    /** Time of Case's Appointment */
    appointmentTime: string | undefined;
}

/** Inspector Service Region Add Request */
export interface InspectorServiceRegionAddRequest {
    /** Inspector number */
    inspectorNumber: number;
    /** Link to county table id */
    countyId: number | undefined;
    /** Link to zip table id */
    postalId: number | undefined;
    /** Link to service region table id */
    serviceRegionId: number | undefined;
    /** Travel Rule Id that we are adding this region for */
    travelRuleId: number | undefined;
}

/** Inspector Service Region Change Request */
export interface InspectorServiceRegionChangeRequest {
    /** Link to county table id */
    countyId: number | undefined;
    /** Link to zip table id */
    postalId: number | undefined;
    /** Link to service region table id */
    serviceRegionId: number | undefined;
}

/** Add / Delete request for all regions at one time */
export interface InspectorServiceRegionUpdateRequest {
    /** List of add requests */
    addRequests: InspectorServiceRegionAddRequest[] | undefined;
    /** List of Delete request id's */
    deleteRequests: number[] | undefined;
    /** Inspector Number the changes are for */
    inspectorNumber: number;
}

/** Add Request for Travel Rules */
export interface InspectorServiceTravelRuleAddRequest {
    /** Inspector Number */
    inspectorNumber: number;
    /** Name of the Rule */
    ruleName: string | undefined;
    /** Starting Location Type (InspectorServiceTravelRuleStartType) */
    startingLocationType: string | undefined;
    /** Disable Auto Assign for Exterior Auto Assign */
    disableAutoAssign: boolean;
    /** Address */
    address: string | undefined;
    /** City */
    city: string | undefined;
    /** State */
    state: string | undefined;
    /** Postal Code */
    postalCode: string | undefined;
    /** Start Date */
    startDate: Date;
    /** End Date */
    endDate: Date | undefined;
    /** Repeat Every Unit (its value should be one of the values found in public static class RepeatUnit) */
    repeatEveryUnit: string | undefined;
    /** Repeat Amount */
    repeatAmount: number | undefined;
    /** Days of the week the event recurs on */
    recursOn: EmployeeCalendarRecurDays | undefined;
    /** A list of InspectorServiceRegionChangeRequest to set the regions to for this rule
Any regions not in this list will be deleted (for updates, not adds obviously), and regions in this list but not in the database will be added
Set to null if you dont want to change the service regions
If you pass an empty list, all the regions will be cleared */
    serviceRegions: InspectorServiceRegionChangeRequest[] | undefined;
}

/** Web response for Get Travel Rule Days by Inspector */
export interface InspectorServiceTravelRuleDayResponse {
    /** List of travel rules */
    travelRules: InspectorServiceTravelRuleResponse[] | undefined;
    /** List of days, linked to the rules returned */
    travelRuleDays: InspectorServiceTravelRuleDaySimple[] | undefined;
}

/** Web response for GetInspectorTravelRules */
export interface InspectorServiceTravelRuleResponse {
    /** Primary key */
    id: number;
    /** Inspector Number */
    inspectorNumber: number;
    /** Travel Rule Name */
    name: string | undefined;
    /** Starting Location Type (InspectorServiceTravelRuleStartType) */
    startingLocationType: string | undefined;
    /** Disable Auto Assign for Exterior Auto Assign */
    disableAutoAssign: boolean;
    /** Address */
    address: string | undefined;
    /** City */
    city: string | undefined;
    /** State */
    state: string | undefined;
    /** Postal Code */
    postalCode: string | undefined;
    /** Start Date of the rule */
    startDate: Date;
    /** End Date of the rule */
    endDate: Date | undefined;
    /** Recurs Mask */
    recursOn: EmployeeCalendarRecurDays | undefined;
    /** Repeat Every Unit (its value should be one of the values found in public static class RepeatUnit) */
    repeatEveryUnit: string | undefined;
    /** Repeat Amount */
    repeatAmount: number | undefined;
}

/** Links a day to a inspector service travel rule */
export interface InspectorServiceTravelRuleDaySimple {
    /** Date of Travel */
    travelDate: Date;
    /** Travel Rule Id */
    ruleId: number;
}

/** Inspector Service Travel Rule Delete Request */
export interface InspectorServiceTravelRuleDeleteRequest {
    /** Id of the rule */
    travelRuleId: number;
    /** Specifies what part of the event we are updating if it is a recurring event */
    updateType: CalendarUpdateEnum | undefined;
    /** What part of the recurring event to update if we are just updating one day, or this day and future events */
    dateToUpdate: Date | undefined;
}

/** Inspector Service Travel Rule Get Request */
export interface InspectorServiceTravelRuleGetRequest {
    /** InspectorNumber */
    inspectorNumber: number;
    /** Start Date of rules */
    startDate: Date | undefined;
    /** End date of rules */
    endDate: Date | undefined;
}

/** Are they starting at work or home */
export interface InspectorServiceTravelRuleStartType {
}

/** Add Request for Travel Rules */
export interface InspectorServiceTravelRuleUpdateRequest extends InspectorServiceTravelRuleAddRequest {
    /** Travel Rule Id */
    travelRuleId: number;
    /** Specifies what part of the event we are updating if it is a recurring event */
    updateType: CalendarUpdateEnum | undefined;
    /** What part of the recurring event to update if we are just updating one day, or this day and future events */
    dateToUpdate: Date;
}

/** Request parameters for retrieving which inspectors can handle a case. */
export interface InspectorsForCaseRequest {
    /** InpectorServiceTravelRules has a flag for if it should be included in exterior auto assign */
    considerExteriorAutoAssignFlag: boolean;
    /** Control ID number for the case or request */
    controlIdNumber: number;
    /** If Day is not used, you can pass a date range
to get availability across multiple days. */
    startDate: Date;
    /** End of the date range - if null we are just getting for one day, StartDay */
    endDate: Date | undefined;
}

/** Provides field reps that can be assigned a case or details on why no reps are available */
export interface InspectorsForCaseResponse {
    /** Field reps eligible to be assigned case */
    eligibleInspectors: InspectorForCase[] | undefined;
    /** Field reps with coverage for this case but not the correct designation */
    missingDesignationInspectors: InspectorForCase[] | undefined;
    /** Field reps with coverage for this case but have a customer exclusion for this customer */
    excludedInspectors: InspectorForCase[] | undefined;
    /** Failing Score mark */
    inspectorTimeEfficiencyFailingScore: number;
}

/** Specific "Inspectors" that are assigned cases that essentially stop if from being assigned to a real one. Most of the time for customer service to manually do something to the case before un-assigning it. */
export interface InspectorSpecificCodes {
}

/** Inspectors Time By day Summary */
export interface InspectorTimeByDaySummary {
    /** Pay Period Id */
    payPeriodId: number;
    /** User Id */
    internetUserId: number;
    /** Case Time (production) Log By Day */
    productionDailyHours: DailyTime | undefined;
    /** Non Production time by day */
    nonProductionDailyHours: DailyTime | undefined;
    /** Total Time Clock Day */
    dailyHoursTotal: DailyTime | undefined;
    /** Total Calendar Available Hours */
    calendarDailyHours: DailyTime | undefined;
    /** Calendar Hours Time Total */
    calendarHoursTotal: number;
    /** Non Production Time Total */
    nonProductionHoursTotal: number;
    /** Production Time Total */
    productionHoursTotal: number;
    /** Total Time */
    hoursTotal: number;
    /** Percentage of Production time based on total */
    productionEfficiency: number;
    /** Percentage of non Production time based on total */
    nonProductionEfficiency: number;
}

/** Model for Inspector Time Card Summary */
export interface InspectorTimeCardResponse {
    /** Pay Period Id */
    payPeriodId: number;
    /** User Id */
    internetUserId: number;
    /** Employee Name */
    employeeName: string | undefined;
    /** Inspector Number */
    inspectorNumber: number;
    /** Inspector State */
    inspectorState: string | undefined;
    /** Has time card been marked approved */
    isApproved: boolean;
    /** Detail of Approval of a pay period for a user (who and when) */
    approvalDetail: UserPayPeriodApprovalDto | undefined;
    /** Total hours for Time Card */
    hours: number;
    /** Score to be used for Grading */
    score: number | undefined;
    /** Expected Cost Total */
    expectedCostTotal: number;
    /** Expected Cost Total / Expected Revenue */
    expectedCostToRevenue: number | undefined;
    /** Actual Inspector Cost Efficiency */
    inspectorCostEfficiency: number | undefined;
    /** Total Cost */
    actualCostTotal: number;
    /** Total Cost / Expected Revenue */
    actualCostToRevenue: number | undefined;
    /** Failing Score mark */
    inspectorTimeEfficiencyFailingScore: number;
    /** Non Production Costs  */
    nonProductionCosts: number;
    /** Inspector is a trainee */
    isTrainee: boolean;
    /** (l.ExpectedRevenue * .55) - l.ActualTotalCost */
    fieldProductionCostDifference: number | undefined;
    /** Weeks employed since hire date */
    weeksEmployed: number;
    /** FHE submitted during pay period (field hours estimated) */
    submittedEstimatedHours: number;
    /** FHE assigned during pay period (field hours estimated) */
    assignedEstimatedHours: number;
    /** Last employee note */
    lastEmployeeNote: string | undefined;
    /** Last Employee Note Date */
    lastEmployeeNoteDate: Date | undefined;
    /** Expected revenue of cases completed (either actual or estimated if not billed yet) */
    expectedFieldServiceRevenue: number;
    /** Specialty Case Count */
    specialtyCasesCount: number;
    /** Specialty Case Overdue Count */
    specialtyCasesOverDueCount: number;
    /** Specialty Case Overdue Percent */
    specialtyCasesOverDuePercent: number | undefined;
    /** Appointment Case Count */
    appointmentCasesCount: number;
    /** Appointment Case Overdue Count */
    appointmentCasesOverDueCount: number;
    /** Appointment Case Overdue Percent */
    appointmentCasesOverDuePercent: number | undefined;
    /** Exterior Case Count */
    exteriorCasesCount: number;
    /** Exterior Case Overdue Count */
    exteriorCasesOverDueCount: number;
    /** Exterior Case Overdue Percent */
    exteriorCasesOverDuePercent: number | undefined;
    /** Days since Last Check in */
    lastCheckInDays: number | undefined;
    /** Admin Work Hours */
    adminWorkHours: number;
    /** Logistics Manager */
    logisticsManager: string | undefined;
}

/** This is the PayPeriod User Appproved dto */
export interface UserPayPeriodApprovalDto {
    /** Pay Period this was approved for */
    payPeriodId: number;
    /** User Id payperiod was approved for */
    internetUserId: number;
    /** User Name payperiod was approved for */
    internetUserName: string | undefined;
    /** Date Time it was approved */
    approvedDateTime: Date | undefined;
    /** Id of AppprovedByName */
    approvedInternetUserId: number;
    /** User who approved the payroll. */
    approvedByName: string | undefined;
}

/** Inspector Travel Log */
export interface InspectorTravelLogDto {
    /** Id for existing travel log */
    travelLogId: number | undefined;
    /** Travel Start Date */
    startDate: Date;
    /** Travel End Date */
    endDate: Date;
    /** Travel Loc Latitude */
    locationLatitude: number;
    /** Travel Loc Longitude */
    locationLongitude: number;
}

/** Past, present and future Inspector Travel Logs */
export interface InspectorTravelLogsDto {
    /** Inspector that is traveling */
    inspectorNumber: number;
    /** Upcoming travel for inspector */
    upcomingTravel: InspectorTravelLogDto[] | undefined;
    /** Active travel for inspector */
    activeTravel: InspectorTravelLogDto | undefined;
    /** Previous year of travel for Inspector */
    previousTravel: InspectorTravelLogDto[] | undefined;
}

/** Data transfer object for insurance order contact information */
export interface InsuranceOrderContactInfo extends ContactInfo {
    /** Role of the contact */
    role: string | undefined;
}

/** Request type for insurance web orders */
export interface InsuranceWebOrderRequest {
    /** Customer Number */
    customerNumber: number;
    /** Inspection type code */
    surveyTypeCode: string;
    /** Tracking Code */
    trackingCode: string | undefined;
    /** Order Code In */
    orderCodeIn: string | undefined;
    /** Case Mailing Address */
    mailingAddress: AddressInfo;
    /** Case Survey Address */
    surveyAddress: AddressInfo;
    /** Agent Info */
    agentInfo: AgentInfo | undefined;
    /** Supplement codes */
    supplements: string[] | undefined;
    /** Comments */
    comments: string | undefined;
    /** Uploaded attachment Guids */
    attachments: string[] | undefined;
    /** First day the case can be available for assignment */
    startDate: Date;
    /** Policy Number */
    policyNumber: string;
    /** Contact information for the insured */
    policyholderContactInfo: ContactInfo;
    /** Coverage In */
    coverageIn: number | undefined;
    /** Year Built */
    yearBuilt: number | undefined;
    /** Dwelling SqFt */
    sqFt: number | undefined;
    /** Business Type:  N or R */
    businessType: string | undefined;
    /** Policy effective date */
    effectiveDate: Date | undefined;
    /** Underwriter code to assign this case to */
    underwriterCode: string | undefined;
    /** Insurance specific contact info */
    contactInfo: WebOrderRoleContactInfo | undefined;
}

/** Request type for insurance web orders */
export interface InsuranceWebOrderRequest2 {
    /** Policy Number */
    policyNumber: string;
    /** Tracking Code */
    trackingCode: string | undefined;
    /** Customer Number */
    customerNumber: number;
    /** Inspection type code */
    surveyTypeCode: string;
    /** Case Mailing Address */
    mailingAddress: AddressInfo;
    /** Case Survey Address */
    surveyAddress: AddressInfo;
    /** Contact information for the insured */
    policyholderContactInfo: ContactInfo;
    /** Agent Info */
    agentInfo: AgentInfo | undefined;
    /** Coverage In */
    coverageIn: number | undefined;
    /** Year Built */
    yearBuilt: number | undefined;
    /** Dwelling SqFt */
    sqFt: number | undefined;
    /** Business Type:  N or R */
    businessType: string | undefined;
    /** First day the case can be available for assignment */
    startDate: Date;
    /** Policy effective date */
    effectiveDate: Date | undefined;
    /** Underwriter code to assign this case to */
    underwriterCode: string | undefined;
    /** Order Code In */
    orderCodeIn: string | undefined;
    /** Supplement codes */
    supplements: string[] | undefined;
    /** Comments */
    comments: string | undefined;
    /** Uploaded attachment Guids */
    attachments: string[] | undefined;
    /** Insurance specific contact info */
    contactInfo: WebOrderRoleContactInfo | undefined;
}

/** Create a new internet user file */
export interface InternetUserFileAddRequest {
    /** User Id */
    internetUserId: number;
    /** Type of file being uploaded */
    userFileType: InternetUserFileTypes;
    /** File to be uploaded  */
    fileStream: Stream | undefined;
    /** File name to be displayed to user */
    fileName: string;
}

/** User File Types */
export enum InternetUserFileTypes {
    Unknown = 0,
    AppraiserCountyProficiency = 1,
    All = -1,
}

/** Return content of a file */
export interface InternetUserFileContentDto {
    /** File Name */
    fileName: string | undefined;
    /** Content of Byte array */
    content: string | undefined;
}

/** Internet User File */
export interface InternetUserFileDto {
    /** Primary key */
    id: number;
    /** Internet User */
    internetUserId: number;
    /** Internet User File Type */
    userFileType: InternetUserFileTypeDto | undefined;
    /** Created Date */
    createdDate: Date;
    /** File Name */
    fileName: string | undefined;
    /** Url to view file */
    viewUrl: string | undefined;
    /** Url to download the file */
    downloadUrl: string | undefined;
}

/** Internet user file type */
export interface InternetUserFileTypeDto {
    /** Id */
    id: number;
    /** Name */
    name: string | undefined;
}

/** Get List of Files */
export interface InternetUserFileGetRequest {
    /** User Id */
    internetUserId: number;
    /** File Types */
    userFileType: InternetUserFileTypes;
}

/** internet user file update request */
export interface InternetUserFileUpdateRequest {
    /** Primary key */
    id: number;
    /** Type of file being uploaded */
    userFileType: InternetUserFileTypes;
    /** File to be uploaded  */
    fileStream: Stream | undefined;
    /** File Name */
    fileName: string;
}

/** Converts a InternetUserLoginStatisticsDto to be formatted for the React Site */
export interface InternetUserLoginStatisticsViewModel {
    lastLoginDate: Date | undefined;
    failedAttempts: string | undefined;
    countInLast7Days: string | undefined;
    countInLast14Days: string | undefined;
    countInLast30Days: string | undefined;
    countSunday: string | undefined;
    countMonday: string | undefined;
    countTuesday: string | undefined;
    countWednesday: string | undefined;
    countThursday: string | undefined;
    countFriday: string | undefined;
    countSaturday: string | undefined;
}

/** used as a detailed user return */
export interface InternetUserResponse {
    id: number;
    username: string | undefined;
    email: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    lastFirstName: string | undefined;
    firstLastName: string | undefined;
    failedAttempts: number;
    roleName: string | undefined;
    mustChangePassword: boolean;
    receivesEmailConfirmations: boolean;
    companyName: string | undefined;
    passwordChangedLastDate: Date | undefined;
    passwordChangeDays: number | undefined;
    isDisabled: boolean;
    isLockedOut: boolean;
    createDate: Date;
    modifyDate: Date;
    loginStatistics: InternetUserLoginStatisticsDto | undefined;
    userRights: InternetUserRightsDto[] | undefined;
    agencyCodes: AgencyCodesDto[] | undefined;
    hasUnderwriters: boolean | undefined;
    hasAgentCodes: boolean | undefined;
    customers: CustomerDto[] | undefined;
    hasAccountLimitations: boolean | undefined;
    canEditUser: boolean;
}

/** list of user rights */
export interface InternetUserRightsDto {
    /** Right */
    userRight: string | undefined;
    /** Is Enabled */
    isEnabled: boolean;
}

/** List of Internet User Roles */
export interface InternetUserRoles {
}

/** Entire Internet User View */
export interface InternetUserViewModel {
    /** Primary Key */
    id: number;
    /** Username */
    username: string | undefined;
    /** Users email for password resets, etc. */
    email: string | undefined;
    /** First Name */
    firstName: string | undefined;
    /** Last Name */
    lastName: string | undefined;
    /** Last and First name combined */
    lastFirstName: string | undefined;
    /** First and last combined */
    firstLastName: string | undefined;
    /** number of failed login attempts in a row */
    failedAttempts: number;
    /** Role Id */
    roleName: string | undefined;
    /** User must change there password */
    mustChangePassword: boolean;
    /** Do they receive email notifications when ordering a case on the website */
    receivesEmailConfirmations: boolean;
    /** Company they are associated with */
    companyName: string | undefined;
    /** Date last password was changed */
    passwordChangedLastDate: Date | undefined;
    /** Rule of days when they should change there password */
    passwordChangeDays: number | undefined;
    /** Is user disabled */
    isDisabled: boolean;
    /** Is user locked out */
    isLockedOut: boolean;
    /** Date record was created */
    createDate: Date;
    /** Date record was last modified */
    modifyDate: Date;
    /** login stats */
    loginStatistics: InternetUserLoginStatisticsViewModel | undefined;
    /** User Rights */
    userRights: InternetUserRightsDto[] | undefined;
    /** User has underwriter records */
    hasUnderwriters: boolean | undefined;
    /** is User Agent? */
    hasAgentCodes: boolean | undefined;
    /** list of agency codes */
    agencyCodes: AgencyCodesDto[] | undefined;
    /** list of Customers */
    customers: CustomerDto[] | undefined;
    /** Can the user edit information of internet user */
    canEditUser: boolean;
    /** does the user have account limitations? */
    hasAccountLimitations: boolean | undefined;
}

/** Thrown when a case status is invalid */
export interface InvalidCaseStatusException extends MuellerBusinessException {
}

/** An exception due to an invalid data mapping / transformation */
export interface InvalidDataMappingException extends MuellerBusinessException {
}

export interface IsExternalInit {
}

/** Is Feature on Request for a case */
export interface IsFeatureOnForCaseRequest {
    /** Case Id */
    controlIdNumber: number;
    /** Permission Type code */
    permissionTypeCode: string | undefined;
}

/** DTO for permission to close operations to keep case open and extend due date */
export interface KeepOpenWithExtensionDto {
    /** New due date for case */
    extendedDueDate: Date;
}

/** Key Value pair */
export interface KeyValueModel {
    /** The value identifier name */
    key: string;
    /** The value */
    value: any | undefined;
}

/** Get next Scheduling Assistant case request */
export interface LeaveSchedulingCaseRequest {
    /** Internet User Id */
    internetUserId: number;
    /** The SSO Token of the currently authenticated user */
    token: string | undefined;
    /** Control number passed from client */
    controlNumber: number;
    /** Time log working on a case */
    timeLog: CaseTimeLogAddDto | undefined;
}

/** The response for a request from a scheduling assistant to leave a case with no action. */
export interface LeaveSchedulingCaseResponse {
}

export interface LetterGrade {
    value: string | undefined;
}

/** Sketch living area measurements */
export interface LivingAreaMeasurementDto {
    /** Living area from the sketch, null if not available */
    sketchLivingAreaSqFt: number | undefined;
    /** Living area from public record source, null if not available */
    publicLivingAreaSqFt: number | undefined;
}

/** Log */
export interface Log {
    /** date */
    date: Date;
    /** code */
    code: string | undefined;
    /** email */
    email: any | undefined;
    /** description */
    description: string | undefined;
    /** reference */
    reference: any | undefined;
}

/** View Model for MultiFactor verification */
export interface LoginMultiFactorInitiateRequestDto {
    /** username */
    username: string;
    /** login token */
    token: string;
    /** MFA method */
    multiFactorMethod: string;
}

/** View Model for Multifactor Response */
export interface LoginMultiFactorResponseDto {
    /** Multifactor Result */
    result: ILoginMultiFactorVerifyResult | undefined;
    /** Profile of user logging in */
    profile: UserViewModel | undefined;
    /** Returns true if user's password has expired */
    mustChangePassword: boolean;
    /** Redirection instructions */
    redirect: RedirectResponseDto | undefined;
}

export interface ILoginMultiFactorVerifyResult {
    successIndicator: boolean;
    authenticationToken: string | undefined;
    rememberThisClientToken: string | undefined;
}

/** View Model representing a user that has logged in to the web api and been authenticated. */
export interface UserViewModel {
    /** Internet User Id */
    internetUserId: number;
    /** Login user name */
    username: string | undefined;
    /** Given name */
    firstName: string | undefined;
    /** Surname */
    lastName: string | undefined;
    /** Email Address */
    email: string | undefined;
    /** Authentication Token.  This is populated during the Login Controller action and returned to the front-end for using in future authenticated api calls. */
    token: string | undefined;
    /** User roles for permission checks. */
    roles: string[] | undefined;
    /** Return true if the user is an Appraiser. */
    isAppraiser: boolean;
    /** Return true if the user is a Manager among Appraisers */
    isAppraiserManager: boolean;
    /** Return true if the user is a Mortgage among Brokers */
    isMortgageBroker: boolean;
    /** Return true if the user is a Customer Service Agent */
    isCustomerService: boolean;
    /** Return true if the user is a Quality Assurance Agent */
    isQualityAssurance: boolean;
    /** Return true if the user is an ASR */
    isASR: boolean;
    /** The enabled rights that this user has */
    rights: string[] | undefined;
    /** The dashboard the user should be shown after logging in */
    dashboard: string | undefined;
    /** Mac Bonus */
    macBonus: string | undefined;
    /** True if the current user needs multi-factor setup */
    multiFactorSetupRequired: boolean;
}

/** Class to instruct the front end on redirect destinations */
export interface RedirectResponseDto {
    /** The destination url to redirect to */
    returnUrl: string | undefined;
}

/** View Model for MultiFactor verification */
export interface LoginMultiFactorVerifyRequestDto {
    /** The multifactor method name */
    multiFactorMethod: string;
    /** The intermediate token from the MFA initialize response */
    intermediateToken: string;
    /** The verification code that was sent to the user */
    verificationCode: string;
    /** Set to true if the user has requested that this client be remembered */
    rememberThisClientIndicator: boolean;
    /** A client supplied destination url path */
    returnUrl: string | undefined;
}

/** View Model for Login page */
export interface LoginViewModel {
    /** username */
    username: string;
    /** password */
    password: string;
    /** SSO token */
    sso: string | undefined;
    multiFactorRememberThisClientToken: string | undefined;
    /** A client supplied destination url path */
    returnUrl: string | undefined;
    /** Users local offset minutes to UTC at time of login */
    localOffsetMinutes: number;
}

/** ErrorLogs.dbo.LogTypeCodes */
export interface LogTypeCode extends TypeSafeEnum {
}

/** Define a UI Maintenance Card. */
export interface MaintenanceCard {
    /** The unique Id of the card */
    id: string | undefined;
    /** card name - not displayed */
    name: string | undefined;
    /** Which Card component to use. */
    component: string | undefined;
    /** User should redirect to the new url. */
    path: string | undefined;
    /** Title or name for the card */
    title: string | undefined;
    /** Sub Title or name for the card */
    subTitle: string | undefined;
    /** Displayed icon for the card */
    icon: string | undefined;
    /** Name of the action like button text or search label etc... */
    actionName: string | undefined;
}

export interface MaintenanceSection {
    id: string | undefined;
    title: string | undefined;
    maintenanceCards: MaintenanceCard[] | undefined;
}

/** Constants for Major Company codes. */
export interface MajorCompanyCodes {
}

/** Marks an export for retry */
export interface MarkExportForRetryByCaseRequest {
    /** The case control number */
    controlNumber: number;
    /** The export code to resend */
    exportCode: string | undefined;
}

/** Result of marking a case for export */
export interface MarkExportForRetryByCaseResponse {
    /** True if the export resend was handled */
    processed: boolean;
    /** True if a change occured for resend */
    actionTaken: boolean;
}

/** Parameters to mark a case reviewed */
export interface MarkReviewedDto {
    /** Case control number */
    controlIdNumber: number;
    /** Date case was underwriter reviewed */
    dateReviewed: Date | undefined;
    /** Underwriter name */
    reviewerName: string | undefined;
    /** Is Coverage A endorsed */
    hasCoverageAEndorsed: boolean;
    /** Coverage A endorsement amount */
    coverageAEndorsed: number | undefined;
}

/** Material */
export interface Material {
    /** Code */
    code: string | undefined;
    /** Amount */
    amount: number;
    /** Material Code */
    materialCode: string | undefined;
    /** Trimmed Code */
    trimmedCode: string | undefined;
}

/** Data item as structured by an MCard update */
export interface MCardDataItem extends KeyValueModel {
    /** The value that was present before the update */
    originalValue: string | undefined;
    /** An error message related to the value */
    error: string | undefined;
}

export interface MCardDataTypes {
}

/** Define a UI menu item. */
export interface MenuItem {
    /** The unique Id of the menu item */
    id: string | undefined;
    /** Optional Component - when set, this is the React Component to use. */
    component: string | undefined;
    /** Optional Path - when Component is not set, this is a local or remote path to a webpage.  User should redirect to the new url. */
    path: string | undefined;
    /** Displayed Title or name for the item */
    title: string | undefined;
    /** Displayed icon for the menu item */
    icon: string | undefined;
}

/** Encapsulates properties associated with an additional merge document */
export interface MergeDocument {
    /** Name of the file */
    fileName: string | undefined;
    /** Sort order within the final document */
    sortOrder: number;
    /** File needs to be retrieved and saved to the case file path */
    downloadRequired: boolean;
    /** File is temporary and needs to be cleaned up when printing is finished  */
    isTempFile: boolean;
}

/** Metadata */
export interface Metadata {
    /** photoMetadata */
    photoMetadata: Photometadata[] | undefined;
    /** formMetadata */
    formMetadata: Formmetadata[] | undefined;
    /** floorplanMetadata */
    floorplanMetadata: any[] | undefined;
    /** resourcesMetadata */
    resourcesMetadata: any[] | undefined;
    /** orderMetadata */
    orderMetadata: Ordermetadata[] | undefined;
    /** log */
    log: Log[] | undefined;
    /** workflowActions */
    workflowActions: Workflowaction[] | undefined;
    /** availableSupplements */
    availableSupplements: any[] | undefined;
    /** supplements */
    supplements: Supplement[] | undefined;
    /** voiceNotesMetadata */
    voiceNotesMetadata: any[] | undefined;
    /** textNotesMetadata */
    textNotesMetadata: any[] | undefined;
    /** drawingNotesMetadata */
    drawingNotesMetadata: any[] | undefined;
    /** rulesetMetadata */
    rulesetMetadata: any[] | undefined;
    /** moduleDefinitions */
    moduleDefinitions: any[] | undefined;
}

/** Photometadata */
export interface Photometadata {
    /** id */
    id: string;
    /** tag */
    tag: string | undefined;
    /** tags */
    tags: string[] | undefined;
    /** description */
    description: string | undefined;
    /** createdDate */
    createdDate: Date;
    /** imageWidth */
    imageWidth: number;
    /** imageHeight */
    imageHeight: number;
    /** latitude */
    latitude: number;
    /** longitude */
    longitude: number;
    /** altitude */
    altitude: number;
    /** hash */
    hash: any | undefined;
    /** links */
    links: string[] | undefined;
}

/** Ordermetadata */
export interface Ordermetadata {
    /** key */
    key: string | undefined;
    /** value */
    value: string | undefined;
    /** sortable */
    sortable: boolean;
    /** filterable */
    filterable: boolean;
    /** searchable */
    searchable: boolean;
}

/** Workflowaction */
export interface Workflowaction {
    /** title */
    title: string | undefined;
    /** url */
    url: string | undefined;
    /** confirm */
    confirm: boolean;
    /** validateForms */
    validateForms: boolean;
    /** requiresSync */
    requiresSync: boolean;
    /** requirePhotoTags */
    requirePhotoTags: boolean;
}

/** Supplement */
export interface Supplement {
    /** instanceId */
    instanceId: string | undefined;
    /** parentInstanceId */
    parentInstanceId: any | undefined;
    /** formType */
    formType: string | undefined;
    /** titleType */
    titleType: string | undefined;
    /** title */
    title: any | undefined;
    /** xmlFile */
    xmlFile: string | undefined;
    /** xpath */
    xpath: string | undefined;
    /** isHidden */
    isHidden: boolean;
}

/** Call state workflow step metadata tags */
export interface MetaDataTags {
}

/** County with metrics */
export interface MetricsByCounty_1 extends CountyDto {
    /** Metrics in this county */
    Metrics: T | undefined;
}

/** State with county level metrics */
export interface MetricsByStateCounty_1 extends StateDto {
    /** The counties in this state */
    Counties: T | undefined;
}

/** State with county level metrics */
export interface MetricsByStateCountyTabular_1 {
    /** The related state id */
    StateId: number;
    /** The related county id */
    CountyId: number;
    /** Metrics in this county */
    Metrics: T | undefined;
}

export enum MGridActionType {
    ACTION_MAP = 0,
    ACTION_DOWNLOAD = 1,
    ACTION_REFRESH = 2,
    ACTION_CONFIGURE = 3,
    ACTION_ADD = 4,
    ACTION_DELETE = 5,
    ACTION_EDIT = 6,
    ACTION_CANCEL = 7,
}

/** Class used for any MGrid Column Definitions passed from the back end */
export interface MGridColumnDefinitionFactory {
}

export enum MGridFilterType {
    FILTER_TYPE_NONE = 0,
    FILTER_TYPE_TEXT = 1,
    FILTER_TYPE_MULTI_SELECT = 2,
}

export interface MismoDesign {
    attachmentType: string | undefined;
    floors: string | undefined;
    hasLevel: string | undefined;
    description: string | undefined;
    attachmentTypeDisplayName: string | undefined;
}

export interface MismoGarage {
    garageCount: string | undefined;
    garageType: string | undefined;
    parkingCount: string | undefined;
    parkingType: string | undefined;
    description: string | undefined;
    carStorageAttachmentType1: string | undefined;
    carStorageAttachmentType2: string | undefined;
    carStorageCarCapacity1: string | undefined;
    carStorageCarCapacity2: string | undefined;
    carStorageType1: string | undefined;
    carStorageType2: string | undefined;
    drivewayType: string | undefined;
    drivewayCarCapacity: string | undefined;
}

/** List of distinct Molecule codes from Case Events */
export interface MoleculeCodes {
}

/** Move the case to the map (i.e. Unassigned status) */
export interface MoveToMapRequest {
    /** Control Number of the case. */
    controlNumbers: number[] | undefined;
    /** Time log working on a case */
    timeLog: CaseTimeLogAddDto | undefined;
}

/** The response for a request to move a case to the map */
export interface MoveToMapResponse {
}

/** Move the case to scheduling workflow */
export interface MoveToSchedulingRequest {
    /** Control Number of the case. */
    controlNumbers: number[] | undefined;
}

/** An exception to throw when a case is in the wrong status for the requested operation */
export interface MuellerInvalidCaseStatusException extends MuellerBusinessException {
}

export interface NewCaseForm {
    form: BaseForm | undefined;
    title: string | undefined;
    parent: BaseForm | undefined;
}

/** Notification Letter */
export interface NotificationLetterDto {
    /** Letter name */
    name: string | undefined;
    /** Letter code */
    code: string | undefined;
    /** Inactive date */
    inactiveDate: Date | undefined;
    /** Method code this letter is associated to */
    methodCode: string | undefined;
}

/** APT Notification Type Codes */
export interface NotificationMethodCodes {
}

/** Notification Type Code */
export interface NotificationTypeCodes {
}

/** Token returned from OAuth */
export interface OAuthToken {
    /** access token returned  */
    access_token: string | undefined;
    /** token type (bearer) */
    token_type: string | undefined;
    /** expires in (seconds) */
    expires_in: number;
    /** The date/time the token was issued at */
    tokenIssuedAt: Date;
    /** The date/time the token is going to expire at */
    tokenExpiresAt: Date;
}

/** Object Codes from CaseEvents table */
export interface ObjectCodes {
}

/** Add Satisfaction Survey Request */
export interface OnboardingSatisfactionSurveyAddRequest extends SatisfactionSurveyRequest {
    /** Support Call Id  */
    inspectorId: number;
    /** Control Number of the case being submitted */
    controlNumberSubmitted: number;
}

/** Onboarding Satisfaction Survey Response */
export interface OnboardingSatisfactionSurveyResponse extends SatisfactionSurveyResponse {
    /** Inspector Id */
    inspectorId: number;
    /** Inspector Name */
    inspectorName: string | undefined;
    /** Overall onboarding experience score (1-5) */
    onboardingExperienceScore: number;
    /** Did you complete the Viita course? */
    didYouCompleteViitaCourse: boolean | undefined;
    /** Was the Viita course helpful? */
    wasViitaCourseHelpful: boolean | undefined;
    /** What could be improved about the Viita course? */
    whatCouldBeImprovedAboutViitaCourse: string | undefined;
    /** Recruiter onboarding score (1-5) */
    recruiterOnboardingScore: number;
    /** Was the recruiter clear during the screening call? */
    wasRecruiterClearDuringScreeningCall: boolean | undefined;
    /** What was unclear during the screening call? */
    whatWasUnclearDuringScreeningCall: string | undefined;
    /** Did the recruiter provide helpful support during the screening call? */
    didRecruiterProvideHelpfulSupportDuringScreeningCall: boolean | undefined;
    /** Where did support break down during the screening call? */
    whereDidSupportBreakDownDuringScreeningCall: string | undefined;
    /** Did the recruiter resolve technical issues promptly? */
    didRecuiterResolveTechnicalIssuesPromptly: boolean | undefined;
    /** What support was not provided? */
    whatSupportWasNotProvided: string | undefined;
    /** Did onboarding paperwork make form completion easy? */
    didOnboardingPaperworkMakeFormCompletionEasy: boolean;
    /** What was confusing with onboarding paperwork? */
    whatWasConfusingWithOnboardingPaperwork: string | undefined;
    /** Were you able to log into systems without issue? */
    wereYouAbleToLogIntoSystemsWithoutIssue: boolean;
    /** Which systems caused trouble? */
    whichSystemsCausedTrouble: string | undefined;
    /** Manager onboarding support score (1-5) */
    managerOnboardingSupportScore: number;
    /** Did you meet with your manager within two days of hire? */
    didYouMeetWithManagerWithinTwoDaysOfHire: boolean;
    /** When did you first meet with your manager? */
    whenDidYouFirstMeetWithManager: string | undefined;
    /** Did orientation clarify expectations for your first day? */
    didOrientationClarifyExpectationsForFirstDay: boolean;
    /** What could have improved orientation? */
    whatCouldHaveImprovedOrientation: string | undefined;
    /** Did training materials help prepare for your first inspection? */
    didTrainingMaterialsHelpPrepareForFirstInspection: boolean | undefined;
    /** What could have been improved with training materials? */
    whatCouldHaveBeenImprovedWithTrainingMaterials: string | undefined;
    /** Were you provided a number for the field support hotline? */
    wereYouProvidedNumberForFieldSupportHotline: boolean | undefined;
    /** Did you feel supported by your manager during the first two weeks? */
    didYouFeelSupportedByYourManagerDuringFirstTwoWeeks: boolean;
    /** What support did you not receive? */
    whatSupportDidYouNotReceive: string | undefined;
    /** How long after the initial meeting did you complete an inspection?
Display Mapping in InitialInspectionTimeRange.cs */
    howLongAfterInitialMeetingDidYouCompleteAnInspection: string | undefined;
    /** What caused the delay? */
    whatCausedTheDelay: string | undefined;
    /** Did you feel confident before completing your first inspection? */
    didYouFeelConfidentBeforeCompletingYourFirstInspection: boolean;
    /** What made you feel unprepared? */
    whatMadeYouFeelUnprepared: string | undefined;
    /** Did you receive enough inspections in the first two weeks? */
    didYouReceiveEnoughInspectionsInFirstTwoWeeks: boolean | undefined;
    /** Did you let your manager know you needed more work? */
    didYouLetYourManagerKnowYouNeededMoreWork: string | undefined;
    /** Do you understand your job responsibilities today? */
    doYouUnderstandYourJobResponsibilitiesToday: boolean;
    /** What responsibilities could be clarified? */
    whatResponsibilitiesCouldBeClarified: string | undefined;
    /** Do you understand how your performance is measured? */
    doYouUnderstandHowYourPerformanceIsMeasured: boolean;
    /** What is unclear about performance expectations? */
    whatIsUnclearAboutPerformanceExpectations: string | undefined;
    /** Additional feedback for onboarding experience */
    additionaFeedbackForOnboardingExperience: string | undefined;
    /** Local creation date of the survey */
    dateCreated: Date;
    /** Local completion date of the survey */
    dateCompleted: Date | undefined;
}

/** Satisfaction Survey Request */
export interface OnboardingSatisfactionSurveyUpdateRequest extends SatisfactionSurveyRequest {
    /** Uuid */
    uid: string;
    /** Overall onboarding experience score (1-5) */
    onboardingExperienceScore: number;
    /** Did you complete the Viita course? */
    didYouCompleteViitaCourse: boolean | undefined;
    /** Was the Viita course helpful? */
    wasViitaCourseHelpful: boolean | undefined;
    /** What could be improved about the Viita course? */
    whatCouldBeImprovedAboutViitaCourse: string | undefined;
    /** Recruiter onboarding score (1-5) */
    recruiterOnboardingScore: number;
    /** Was the recruiter clear during the screening call? */
    wasRecruiterClearDuringScreeningCall: boolean | undefined;
    /** What was unclear during the screening call? */
    whatWasUnclearDuringScreeningCall: string | undefined;
    /** Did the recruiter provide helpful support during the screening call? */
    didRecruiterProvideHelpfulSupportDuringScreeningCall: boolean | undefined;
    /** Where did support break down during the screening call? */
    whereDidSupportBreakDownDuringScreeningCall: string | undefined;
    /** Did the recruiter resolve technical issues promptly? */
    didRecuiterResolveTechnicalIssuesPromptly: boolean | undefined;
    /** What support was not provided? */
    whatSupportWasNotProvided: string | undefined;
    /** Did onboarding paperwork make form completion easy? */
    didOnboardingPaperworkMakeFormCompletionEasy: boolean;
    /** What was confusing with onboarding paperwork? */
    whatWasConfusingWithOnboardingPaperwork: string | undefined;
    /** Were you able to log into systems without issue? */
    wereYouAbleToLogIntoSystemsWithoutIssue: boolean;
    /** Which systems caused trouble? */
    whichSystemsCausedTrouble: string | undefined;
    /** Manager onboarding support score (1-5) */
    managerOnboardingSupportScore: number;
    /** Did you meet with your manager within two days of hire? */
    didYouMeetWithManagerWithinTwoDaysOfHire: boolean;
    /** When did you first meet with your manager? */
    whenDidYouFirstMeetWithManager: string | undefined;
    /** Did orientation clarify expectations for your first day? */
    didOrientationClarifyExpectationsForFirstDay: boolean;
    /** What could have improved orientation? */
    whatCouldHaveImprovedOrientation: string | undefined;
    /** Did training materials help prepare for your first inspection? */
    didTrainingMaterialsHelpPrepareForFirstInspection: boolean | undefined;
    /** What could have been improved with training materials? */
    whatCouldHaveBeenImprovedWithTrainingMaterials: string | undefined;
    /** Were you provided a number for the field support hotline? */
    wereYouProvidedNumberForFieldSupportHotline: boolean | undefined;
    /** Did you feel supported by your manager during the first two weeks? */
    didYouFeelSupportedByYourManagerDuringFirstTwoWeeks: boolean;
    /** What support did you not receive? */
    whatSupportDidYouNotReceive: string | undefined;
    /** How long after the initial meeting did you complete an inspection?
Display Mapping in InitialInspectionTimeRange.cs */
    howLongAfterInitialMeetingDidYouCompleteAnInspection: number;
    /** What caused the delay? */
    whatCausedTheDelay: string | undefined;
    /** Did you feel confident before completing your first inspection? */
    didYouFeelConfidentBeforeCompletingYourFirstInspection: boolean;
    /** What made you feel unprepared? */
    whatMadeYouFeelUnprepared: string | undefined;
    /** Did you receive enough inspections in the first two weeks? */
    didYouReceiveEnoughInspectionsInFirstTwoWeeks: boolean | undefined;
    /** Did you let your manager know you needed more work? */
    didYouLetYourManagerKnowYouNeededMoreWork: string | undefined;
    /** Do you understand your job responsibilities today? */
    doYouUnderstandYourJobResponsibilitiesToday: boolean;
    /** What responsibilities could be clarified? */
    whatResponsibilitiesCouldBeClarified: string | undefined;
    /** Do you understand how your performance is measured? */
    doYouUnderstandHowYourPerformanceIsMeasured: boolean;
    /** What is unclear about performance expectations? */
    whatIsUnclearAboutPerformanceExpectations: string | undefined;
    /** Additional feedback for onboarding experience */
    additionaFeedbackForOnboardingExperience: string | undefined;
}

/** Operator constants */
export interface Operator {
}

/** Operator constants in lower case */
export interface OperatorLowerCase {
}

export interface OrderStatusCodes {
}

/** Status Code mapping name associated to order.  Element  and */
export interface OrderStatusMapping {
}

/** Status code Names associated to order.  Element */
export interface OrderStatusNames {
}

/** Freddie Mac Decision Response */
export interface ParseFreddieMacAppraisalDecisionResponse {
    /** The main message received */
    message: string | undefined;
    /** The rule categories received */
    messageCategories: FreddieMacAppraisalDecisionMessageCategory[] | undefined;
    /** Final export result */
    resultStatus: FreddieMacBaceResultStatus;
    /** Response saved to database */
    freddieMacBaceResponse: FreddieMacBaceResponseDto | undefined;
    /** Primary key in database */
    id: number;
}

/** BACE parsed decision result */
export interface ParseFreddieMacAppraisalDecisionResult_1 {
    /** The main message received */
    Message: string | undefined;
    /** The rule categories received */
    RuleCategories: T | undefined;
    /** Final export result */
    ResultStatus: FreddieMacBaceResultStatus;
}

/** Returns the definitions for the requirements of valid passwords */
export interface PasswordDefinitionModel {
    /** characters that satisfy the special character requirement in passwords */
    specialCharacters: string | undefined;
    /** minimum length of passwords */
    passwordMinLength: number;
}

/** Transaction Types associated with Case Payments */
export interface PaymentTransactionTypeCode {
}

/** Constants for PaymentType case attribute */
export interface PaymentType2 {
}

/** Any Employee user and correspending pay period infor */
export interface PayPeriodEmployeeDto {
    /** Pay Period Id */
    payPeriodId: number;
    /** User Id */
    internetUserId: number;
    /** Employee Name */
    employeeName: string | undefined;
    /** Payrate type */
    payrateType: PayrateTypeEnum;
    /** Is this Pay Periods Approved for this user */
    isApproved: boolean;
    /** Pay Periods Approval information for this user */
    approvalDetail: UserPayPeriodApprovalDto | undefined;
    /** Is this Pay Periods User missing Clock out. */
    isMissingClockInfo: boolean;
    /** Is the user currently clocked in now */
    isClockedInNow: boolean;
    /** Total minutes the user was clocked in */
    totalClockedInTimeMinutes: number | undefined;
    /** Total minutes logged to case time logs */
    totalCaseTimeLogTimeMinutes: number | undefined;
    /** Total expected minutes */
    totalAppraiserExpectedMinutes: number | undefined;
    /** Total time taken for appraisal work */
    totalAppraiserTimeMinutes: number | undefined;
    /** Appraiser efficiency score */
    appraiserTimeEfficiencyScore: number | undefined;
    /** Appraiser failing efficiency score */
    appraiserTimeEfficiencyFailingScore: number;
    /** True if any of the cases are not appraiser complete yet */
    anyIncompleteAppraiser: boolean;
    /** Total minutes of QA field review */
    totalFieldReviewTimeMinutes: number | undefined;
    /** Total minutes of QA2 valuation review */
    totalValuationReviewCaseTimeMinutes: number | undefined;
    /** Total minutes of QA field and valuation review */
    totalQAReviewTimeMinutes: number | undefined;
    /** Total minutes of expected QA field review */
    totalFieldReviewExpectedMinutes: number | undefined;
    /** Total minutes of expected QA2 valuation review */
    totalValuationReviewExpectedMinutes: number | undefined;
    /** Total minutes of expected QA field and valuation review */
    totalQAReviewExpectedMinutes: number | undefined;
    /** Overall QA Efficiency score */
    qaTimeEfficiencyScore: number | undefined;
    /** Overall QA Productivity score */
    qaProductivityScore: number | undefined;
    /** Total time clock rounded and totalled as would be reported to the payroll system */
    payrollClockInTimeHours: number | undefined;
    /** Total case time log rounded and totalled as would be reported to the payroll system */
    payrollCaseTimeLogsInHours: number | undefined;
    /** The total hours as would be exported to the payroll system */
    payrollTotalHours: number | undefined;
    /** True if the employee is in training */
    isTrainee: boolean;
    /** Appraiser Number associated to this employee */
    appraiserNumber: number | undefined;
    /** QA cost efficiency (expected minutes * standard qa rate) / (actual minutes * actual agent rate) */
    qaCostEfficiency: number | undefined;
    /** Percentage of successful audits */
    auditPercentage: number | undefined;
}

/** request for list of payperiods by supervisor and payperiod */
export interface PayPeriodEmployeeRequestDto {
    /** User that wants the list of employees for */
    supervisorInternetUserId: number;
    /** The payperiod to get the list of users  */
    payPeriodId: number;
    /** list of roles to limit the payperiod */
    employeeRoleList: EmployeeRoleEnum[];
}

/** used as the model to update close date on payperiod */
export interface PayPeriodUpdateDto {
    /** primary key */
    payPeriodId: number;
    /** close date. */
    closedDateTime: Date;
}

/** Pay Period View models */
export interface PayPeriodViewModel {
    /** Id (nPayPeriods_Id) */
    id: number;
    /** Work Type Code */
    fromDate: EdmDate;
    /** Work Type Name */
    toDate: EdmDate;
    /** Gives a full display if wanted. "[FromDate] to [ToDate]"
             */
    fromToDisplay: string | undefined;
    /** Date payroll is closed */
    closedDate: Date | undefined;
}

/** Date type for Edm.Date */
export interface EdmDate {
    /** Gets the year component of the date represented by this instance. */
    year: number;
    /** Gets the month component of the date represented by this instance. */
    month: number;
    /** Gets the day of the month represented by this instance. */
    day: number;
}

/** Payroll Execution Add request */
export interface PayrollExecutionAddRequest {
    /** Pay period Id */
    payPeriodId: number;
    /** User who wants to run payroll */
    internetUserId: number | undefined;
    /** Email address to send automated notifications back */
    email: string | undefined;
}

/** Payroll Execution */
export interface PayrollExecutionDto {
    /** Primary Key */
    id: number;
    /** Pay Period Id */
    payPeriodId: number;
    /** User who created record */
    internetUser: NameNumberDto | undefined;
    /** Created Date Time */
    createdDateTime: Date;
    /** Execution Start  */
    executeStartDateTime: Date | undefined;
    /** Execution Finish */
    executeFinishDateTime: Date | undefined;
    /** Notes */
    note: string | undefined;
    /** Did the execution result in an error or not */
    hadError: boolean;
    /** If Payroll can be exported */
    canExport: boolean;
    /** If Payroll can be Closed */
    canClose: boolean;
}

/** Update Payroll Execution request */
export interface PayrollExecutionUpdateRequest {
    /** Primary Key */
    id: number;
    /** Note */
    note: string | undefined;
}

/** Result when running the export */
export interface PayrollExportDto {
    /** Summary information to be refreshed */
    reviewResult: PayrollReviewDto | undefined;
    /** Payroll System data for export  */
    exportResult: UltimateIntegrationDto | undefined;
    /** Inspector Case List that was paid in the payroll */
    inspectorPaymentCaseList: InspectorPaymentCaseResponse | undefined;
    /** Appraiser Case List that was paid in the payroll */
    appraiserPaymentCaseList: AppraiserPaymentCaseResponse | undefined;
}

/** Result when running preview of payroll */
export interface PayrollReviewDto {
    /** Inspectors Payroll Summary  */
    inspectorsPayrollSummary: InspectorPayrollSummary[] | undefined;
    /** Appraiser Payroll Summary */
    appraisersPayrollSummary: AppraiserPayrollSummary[] | undefined;
    /** QA (Busops) payroll Summary */
    qaPayrollSummary: QaPayrollSummary[] | undefined;
    /** This will be used for any FR who had cases inspected outside the pay period */
    inspectorCaseLogDetail: InspectorCaseLogDetail[] | undefined;
    /** Subcontractor Pay Summary */
    inspectorContractorsPayrollSummary: InspectorContractorsPayrollSummary[] | undefined;
    /** Scheduling user Pay Summary */
    schedulingUsersPayPeriodSummary: SchedulingPayrollSummary[] | undefined;
}

/** QA (Busops) Payroll summary */
export interface QaPayrollSummary {
    /** Employee Id (from Employees table) */
    employeeId: number;
    /** Employee Role info */
    employeeRole: EmployeeRoleDto | undefined;
    /** Quality Assurance Employee info */
    qualityAssurance: NameNumberDto | undefined;
    /** Supervisor Name */
    supervisor: NameNumberDto | undefined;
    /** Has been reviewed and approved my supervisor */
    isApproved: boolean;
    /** Is missing a clock out */
    isMissingClockOut: boolean;
    /** Number of cases */
    casesCount: number;
    /** Hourly Rate at time of payroll run */
    hourlyRateAgreed: number;
    /** Production Hours */
    hoursProduction: number;
    /** Total Hours */
    hoursTotal: number;
    /** Production Percentage HoursProduction / HoursTotal */
    productionPercent: number;
    /** Current Cost of those hours worked */
    costCurrent: number;
    /** Cost of cases previously */
    costPrevious: number;
    /** Total Case Cost */
    costTotal: number;
    /** Deductions for case being returned  */
    returnedDeduction: number;
    /** Total Mac Amount of cases */
    macPay: number;
    /** Total Mac Bonus for the week */
    macBonusPay: number;
    /** Total Mac Bonus for the Bonus Weeks */
    macBonusPayRollup: number;
    /** Paid break minutes */
    paidBreakMinutes: number | undefined;
}

/** Scheduling Payroll Summary */
export interface SchedulingPayrollSummary {
    /** Scheduling user */
    user: NameNumberDto | undefined;
    /** Number of cases */
    casesCount: number;
    /** Hourly Rate at time of payroll run */
    hourlyRateAgreed: number;
    /** Hours worked for pay period */
    hoursWorked: number;
    /** Case Time Log Hours */
    productionHours: number;
    /** If the users time card has been approved for the pay period */
    isApproved: boolean;
    /** Is missing a clock out */
    isMissingClockInfo: boolean;
    /** Supervisor to Appraiser */
    supervisor: NameNumberDto | undefined;
    /** Number of minutes paid break */
    paidBreakMinutes: number | undefined;
}

/** Ultimate Files data */
export interface UltimateIntegrationDto {
    /** Employee Time Card */
    timeCard: TimeCardFile | undefined;
    /** Hourly Employee Bonus / reimbursement data */
    hourlyDollarCard: HourlyDollarFile | undefined;
    /** Contractor pay data */
    contractorDollarCard: ContractorDollarFile | undefined;
    /** Salaried Employee Bonus / reimbursement data */
    salariedDollarCard: SalariedDollarFile | undefined;
}

/** Column Layout Definition for Time Card Ultimate Exports */
export interface TimeCardFile {
    /** File Name */
    fileName: string | undefined;
    /** Columns for the time card definition */
    columnDefinitions: MGridColumnDefinition[] | undefined;
    /** Data for Export */
    data: UltimatePayrollTimeCardDto[] | undefined;
}

/** Payroll Time Card */
export interface UltimatePayrollTimeCardDto {
    /** Payroll Id */
    cardNumber: string | undefined;
    /** Date of hours */
    date: string | undefined;
    /** Employee Hours */
    hours: number;
    /** Pay Code */
    payCode: number;
    /** Job Type */
    job: string | undefined;
    /** Work Type */
    workType: string | undefined;
}

/** Hourly Employee File layout */
export interface SalariedDollarFile extends DollarFileDefinitionBase {
    /** File name */
    fileName: string | undefined;
    /** Data for Export */
    data: UltimatePayrollDollarDto[] | undefined;
}

/** Class representing individual comments by PNX control export-id */
export interface Pcrcommentary {
    /** PNX export-id */
    id: string | undefined;
    /** Label of changed field */
    label: string | undefined;
    /** Reason from Appraiser */
    reason: string | undefined;
    /** Commentary from Appraiser */
    commentary: string | undefined;
}

/** DTO for PcrCommentary */
export interface PcrCommentaryDto {
    /** PcrCommentary Array */
    pcrCommentary: Pcrcommentary[] | undefined;
}

/** Defines the data and display properties for a Phoenix control */
export interface PdfDisplayControl {
    /** Display text for the control */
    name: string | undefined;
    /** Control ID */
    id: string | undefined;
    /** Display value for the control */
    value: string | undefined;
    /** Display control type */
    type: PdfDisplayControlType;
    /** Additional properties defining how a control will be displayed */
    properties: PdfDisplayControlProperties | undefined;
    /** Nested display controls */
    children: PdfDisplayControl[] | undefined;
}

/** Type of display control */
export enum PdfDisplayControlType {
    Section = "Section",
    Table = "Table",
    TableCell = "TableCell",
    TextArea = "TextArea",
    SubSectionGroupFull = "SubSectionGroup-Full",
    SubSectionSingleFull = "SubSectionSingle-Full",
    SubSection = "SubSection",
    Label = "Label",
    HTML = "HTML",
}

/** Additional properties defining how a control will be displayed */
export interface PdfDisplayControlProperties {
    /** Don't render the control if no value */
    hide: boolean;
    /** Don't render the control if no value */
    hideNullOrEmpty: boolean;
    /** Parse the value into "Yes" or "No" in the display */
    parseAsBoolean: boolean;
    /** Invert boolean values */
    invertBoolean: boolean;
    /** Prints a control as a form input rather than a label */
    editable: boolean;
}

/** Defines controls to display in the PDF for a Phoenix form */
export interface PdfDisplayDefinition {
    /** Name of the form */
    name: string | undefined;
    /** Name of the form */
    formName: string | undefined;
    /** Phoenix form definition ID */
    linkedFormId: string;
    /** Display controls for this form */
    displayControls: PdfDisplayControl[] | undefined;
}

/** Represents the data transfer object for retrieving PDF export settings. */
export interface PDFExportSettingsDto {
    /** Customer Number of the PDF export settings. */
    customerNumber: number;
    /** The start date of the PDF export settings. */
    startDate: Date;
    /** The date when the PDF export settings became inactive, if applicable. */
    inactiveDate: Date | undefined;
    /** Indicates whether local folder storage is enabled. */
    localFolderEnabled: boolean;
    /** The destination path for exported PDFs. */
    destinationPath: string | undefined;
    /** The file template name used for export. */
    fileTemplateName: string;
    /** Indicates whether PGP encryption is enabled. */
    pgpEnabled: boolean;
    /** The sender identifier for PGP encryption. */
    pgpEncryptSender: string | undefined;
    /** The sender identifier's password */
    pgpEncryptSenderPassword: string | undefined;
    /** The recipient identifier for PGP encryption. */
    pgpEncryptRecipient: string | undefined;
    /** Indicates whether FTP upload is enabled. */
    ftpEnabled: boolean;
    /** The FTP server to upload files to. */
    ftpUploadToServer: string | undefined;
    /** The path on the FTP server where files should be uploaded. */
    ftpUploadToPath: string | undefined;
    /** The username for FTP authentication. */
    ftpUploadToUsername: string | undefined;
    /** The password for FTP authentication. */
    ftpUploadToPassword: string | undefined;
    /** Indicates whether passive mode is used for FTP upload. */
    ftpUploadToUsePassive: boolean;
    /** Indicates whether SSL is enabled for FTP upload. */
    ftpEnableSSL: boolean;
    /** The name of a custom processing class. */
    customClass: string | undefined;
}

/** Represents the fields available for PDF export settings. */
export interface PDFExportSettingsFields {
    /** List of Fields */
    fields: string[] | undefined;
}

/** Keys used in RTF file generation */
export interface PdfLetterTemplateKeys {
    /** Current date */
    date: string | undefined;
    /** Insured Name */
    insuredName: string | undefined;
    /** Contact Name */
    contactName: string | undefined;
    /** Contact Phone */
    contactPhone: string | undefined;
    /** Contact Email */
    contactEmail: string | undefined;
    /** Mailing Address1 */
    mailingAddress1: string | undefined;
    /** Mailing City State Zip */
    mailingCityStateZip: string | undefined;
    /** Policy Number */
    policyNumber: string | undefined;
    /** Recommendations */
    recommendations: string | undefined;
    /** Recommendations Table */
    recommendationsTable: string | undefined;
    /** Survey Address 1 */
    surveyAddress1: string | undefined;
    /** Survey City State Zip */
    surveyCityStateZip: string | undefined;
    /** Survey Date Unformatted */
    surveyDateUnformatted: string | undefined;
    /** Survey Date Formatted */
    surveyDateFormatted: string | undefined;
    /** Agency Name */
    agencyName: string | undefined;
    /** Agency Phone Number */
    agencyPhoneNumber: string | undefined;
    /** Agency Email */
    agencyEmail: string | undefined;
    /** Agency Code */
    agencyCode: string | undefined;
    /** Agents Address */
    agentsAddress: string | undefined;
    /** Agents City */
    agentsCity: string | undefined;
    /** Agents State */
    agentsState: string | undefined;
    /** Agents City State Zip */
    agentsCityStateZip: string | undefined;
    /** Location Building */
    locationBuilding: string | undefined;
    /** Underwriter Name */
    underwriterName: string | undefined;
    /** Underwriter Code */
    underwriterCode: string | undefined;
    /** Insured Home Phone */
    insuredHomePhone: string | undefined;
    /** Insured Email */
    insuredEmail: string | undefined;
    /** Control Number */
    controlNumber: string | undefined;
    /** Inspector Name */
    inspectorName: string | undefined;
    /** Tracking Number */
    trackingNumber: string | undefined;
    /** Order Code In */
    orderCodeIn: string | undefined;
    /** Year the inspection was completed */
    yearInspected: string | undefined;
    /** Month the inspection was completed */
    monthInspected: string | undefined;
    /** Day the inspection was completed */
    dayInspected: string | undefined;
    /** Recommendation number */
    recommendationNumber: string | undefined;
    /** Recommendation level */
    recommendationLevel: string | undefined;
    /** Recommendation name */
    recommendationName: string | undefined;
    /** Recommendation text */
    recommendationText: string | undefined;
    /** An HTML block that defines a set of recommendations grouped by level */
    levelGroupTemplate: string | undefined;
    /** An HTML block that defines a single recommendation */
    recommendationTemplate: string | undefined;
    /** Completed Date Formatted */
    completedDateFormatted: string | undefined;
}

/** Response from PhoenixServices indicating whether case is PDF ready */
export interface PdfReadyResponse {
    /** Indicates if PDF ready */
    isPhoenixPdfReady: boolean;
    /** Forms that are not PDF ready */
    formsNotPdfReady: string[] | undefined;
}

/** DTO for requesting permission to close */
export interface PermissionToCloseDto {
    /** Where to sent the email */
    to: string | undefined;
    /** CC on email */
    cc: string | undefined;
    /** Body for email. Body templates are now providing base text which can be edited */
    body: string | undefined;
}

/** UW submitted denial of permission to extend */
export interface PermissionToExtendDeny {
    /** Submitted detail from UW */
    detail: string | undefined;
}

/** Fields for starting the permission to extend process */
export interface PermissionToExtendStart {
    /** Where to sent the email */
    to: string | undefined;
    /** CC on email */
    cc: string | undefined;
    /** Body for email. Body templates are now providing base text which can be edited */
    body: string | undefined;
}

export interface PhoenixBundle {
    controlIdNumber: number;
    pnxForms: PhoenixCaseForm[] | undefined;
}

/** Classes that model the Phoenix data export JSON */
export interface PhoenixExportData {
    /** Phoenix controls collection */
    controls: PhoenixExportDataPoint[] | undefined;
    /** Phoenix repeats collection */
    repeats: PhoenixExportDataRepeat[] | undefined;
}

/** A phoenix data point */
export interface PhoenixExportDataPoint {
    /** The data point id */
    id: string | undefined;
    /** The value */
    value: string | undefined;
    attributes: PhoenixExportDataPointAttribute[] | undefined;
    /** id split into individual values by the pipe | delimiter */
    ids: string[] | undefined;
}

/** A Phoenix data attribute */
export interface PhoenixExportDataPointAttribute {
    /** The key */
    key: string | undefined;
    /** The value */
    value: string | undefined;
}

/** Phoenix repeat data export structure */
export interface PhoenixExportDataRepeat {
    /** identifier */
    id: string | undefined;
    /** Attributes of this repeat */
    attributes: PhoenixExportDataPointAttribute[] | undefined;
    /** Data in this repeat */
    groups: PhoenixExportData[] | undefined;
}

/** PhoenixFile */
export interface PhoenixFile {
    /** RowKey */
    rowKey: string | undefined;
    /** PartitionKey */
    partitionKey: string | undefined;
    /** metadata */
    metadata: Metadata | undefined;
    /** features */
    features: Features | undefined;
    /** applicationData */
    applicationData: Applicationdata | undefined;
    /** localSyncVersion */
    localSyncVersion: any | undefined;
    /** mapPinColor */
    mapPinColor: any | undefined;
    /** title */
    title: string | undefined;
    /** subtitle */
    subtitle: string | undefined;
    /** LocationKey */
    locationKey: string | undefined;
    /** modifiedByEmail */
    modifiedByEmail: any | undefined;
    /** modifiedByDate */
    modifiedByDate: Date;
    /** syncDate */
    syncDate: Date;
    /** dataModifiedByDate */
    dataModifiedByDate: Date;
    /** sketchModifiedByDate */
    sketchModifiedByDate: Date;
    /** address1 */
    address1: string | undefined;
    /** address2 */
    address2: any | undefined;
    /** city */
    city: string | undefined;
    /** state */
    state: string | undefined;
    /** postal */
    postal: string | undefined;
    /** country */
    country: string | undefined;
    /** tzDatabaseId */
    tzDatabaseId: any | undefined;
    /** locale */
    locale: string | undefined;
    /** latitude */
    latitude: number;
    /** longitude */
    longitude: number;
    /** photos */
    photos: string[] | undefined;
    /** forms */
    forms: string[] | undefined;
    /** tags */
    tags: string[] | undefined;
    /** miscResources */
    miscResources: any[] | undefined;
    /** voiceNotes */
    voiceNotes: any[] | undefined;
    /** drawingNotes */
    drawingNotes: any[] | undefined;
    /** textNotes */
    textNotes: any[] | undefined;
    /** schemaVersion */
    schemaVersion: any | undefined;
    /** paid */
    paid: boolean;
    /** revision */
    revision: number;
    /** starred */
    starred: boolean;
    /** Timestamp */
    timestamp: Date;
}

export interface PhoenixFile2 {
    photos: string[] | undefined;
    forms: string[] | undefined;
    tags: string[] | undefined;
    miscResources: string[] | undefined;
    schemaVersion: string | undefined;
    timestamp: Date;
    rowKey: string | undefined;
    partitionKey: string | undefined;
    revision: number;
    title: string | undefined;
    locationKey: string | undefined;
    modifiedByEmail: string | undefined;
    modifiedByDate: Date;
    syncDate: Date;
    dataModifiedByDate: Date;
    sketchModifiedByDate: Date;
}

/** Represents a single item in the Phoenix Forms Designer list */
export interface PhoenixFormListItem {
    /** Form Name (availform, else phoenixform) */
    name: string | undefined;
    /** PhoenixAnywhere form category */
    category: string | undefined;
    /** PhoenixAnywhere form description */
    description: string | undefined;
    /** PhoenixAnywhere form last modified date */
    modifiedDate: Date | undefined;
    /** Form last modified by user */
    modifiedBy: string | undefined;
    /** Last publish (promote) date */
    publishDate: Date | undefined;
    /** Form volume of completed cases in the last 30 days */
    volume30: number;
    /** Availforms Date Inactive */
    inactiveDate: Date | undefined;
    /** AvailForm Id */
    availFormId: number | undefined;
    /** Phoenix Form Id */
    phoenixFormId: string | undefined;
    /** List of content codes that the form references */
    contentCodesReferenced: string[] | undefined;
}

/** Details for a Phoenix Form */
export interface PhoenixFormDetail extends PhoenixFormListItem {
    /** Availform Notes */
    notes: string | undefined;
    /** Linked PDF definitions */
    phoenixPdfDefinitionIds: string[] | undefined;
    /** Expected field minutes for the form */
    expectedFieldMinutes: number;
    /** Expected call center minutes for the form */
    expectedCallCenterMinutes: number;
    /** Expected QA minutes for the form */
    expectedQaMinutes: number;
    /** Usage details for the form, such as customer number, survey type, and inactive dates */
    usageDetails: FormUsageDetail[] | undefined;
    /** True if the form can be previewed publicly */
    publicPreviewEnabled: boolean;
}

/** Model for editing Phoenix Forms Designer details */
export interface PhoenixFormDetailEdit {
    /** PhoenixAnywhere form category */
    category: string | undefined;
    /** Indicates if the category has changed */
    categoryChanged: boolean;
    /** PhoenixAnywhere form description */
    description: string | undefined;
    /** Indicates if the description has changed */
    descriptionChanged: boolean;
    /** Availforms Date Inactive */
    inactiveDate: Date | undefined;
    /** Indicates if the inactive date has changed */
    inactiveDateChanged: boolean;
    /** Availform Notes */
    notes: string | undefined;
    /** Indicates if the notes have changed */
    notesChanged: boolean;
}

/** Model for phoenix related data */
export interface PhoenixIntegrationData {
    /** The data model for a Phoenix case */
    payload: string | undefined;
}

export interface PhoenixValidationResults {
    success: boolean;
    messages: string[] | undefined;
    formValidationResults: FormValidationResult[] | undefined;
}

/** Phone Support Call Add Request */
export interface PhoneSupportCallAddRequest {
    /** Support Role of use who called in */
    supportedForRoleId: number;
    /** Caller name */
    supportedCallerName: string;
    /** Support Employee Id */
    supportedEmployeeId: number | undefined;
    /** Support Category */
    phoneSupportCategoryId: number;
    /** Notes */
    notes: string | undefined;
    /** If true we will set the complete date upon saving */
    isCompleted: boolean;
    /** Start of call (local time zone of call receiver */
    startUtcDateTime: Date;
    /** End of call (local time zone of call receiver) */
    completeUtcDateTime: Date;
    /** Date time offset in minutes */
    timeZoneOffsetMinutes: number;
}

/** Add a new case to a phone support call */
export interface PhoneSupportCallCaseAddRequest {
    /** Phone Support Call Id */
    phoneSupportCallId: number;
    /** Control Id Number */
    controlIdNumber: number;
    /** Notes */
    notes: string | undefined;
}

/** Phone Support Call Case Dto */
export interface PhoneSupportCallCaseDto {
    /** Primary key */
    id: number;
    /** Control Id Number */
    controlIdNumber: number;
    /** Policy Number of case */
    policyNumber: string | undefined;
    /** Customer Information */
    customerInfo: CustomerInfo | undefined;
    /** Notes */
    notes: string | undefined;
}

/** Update request for Phone Support Call Cases */
export interface PhoneSupportCallCaseUpdateRequest {
    /** primary key */
    id: number;
    /** Control Id Number */
    controlIdNumber: number;
    /** Note */
    notes: string | undefined;
}

/** Phone Support Call Dto */
export interface PhoneSupportCallDetailDto {
    /** Primary key */
    id: number;
    /** Supported for role */
    supportedForRole: RoleDto | undefined;
    /** Name of user being supported */
    supportedCallerName: string | undefined;
    /** Supported Employee  */
    supportedEmployee: EmployeeListDto | undefined;
    /** User who supported */
    supportUser: InternetUserListDto | undefined;
    /** Category */
    phoneSupportCategory: PhoneSupportCategoryDto | undefined;
    /** Date Call was created utc */
    startUtcDateTime: Date;
    /** Date call was completed utc */
    completeUtcDateTime: Date | undefined;
    /** Date Call was created local time */
    startLocalDateTime: Date | undefined;
    /** Date Call was completed local time */
    completeLocalDateTime: Date | undefined;
    /** Notes */
    notes: string | undefined;
    /** Time in minutes of how long the call took from start to complete */
    timeMinutes: number;
}

/** Phone Category dto */
export interface PhoneSupportCategoryDto {
    /** Primary Key */
    id: number;
    /** Code */
    code: string | undefined;
    /** Name */
    name: string | undefined;
}

/** Used for getting list of phone support calls */
export interface PhoneSupportCallListDto {
    /** Primary key */
    id: number;
    /** Name of user being supported */
    supportedCallerName: string | undefined;
    /** User who supported */
    supportUser: InternetUserListDto | undefined;
    /** Date Call was created (converted from utc to system local) */
    startDateTime: Date;
    /** Notes */
    notes: string | undefined;
    /** Time in minutes of how long the call took from start to complete */
    timeMinutes: number;
}

/** phone Support update request */
export interface PhoneSupportCallUpdateRequest extends PhoneSupportCallAddRequest {
    /** Primary key */
    id: number;
}

/** Phone Support Categories */
export interface PhoneSupportCategoryCodes {
}

/** Constants for Photo Analysis Type codes. */
export interface PhotoAnalysisResultTypeCodes {
}

/** Configuration settings for photo analysis in the application. */
export interface PhotoAnalysisSettings {
    /** Indicates if photo analysis is enabled based on current configuration settings.
Enabling photo analysis is dependent on other settings such as image quality score,
comprehensive person detection, and the requirement of a specific form on the case. */
    analysisEnabled: boolean;
    /** Indicates whether a specific form is required on the case for enabling photo analysis.
When set to true, photo analysis will only be enabled if the required form is present in the case. */
    requireFormOnCase: boolean;
    /** Debris detection enabled */
    enableDebrisDetection: boolean;
    /** Object detection enabled */
    enableObjectDetection: boolean;
    /** Determines whether the condition score is enabled for photo analysis.
The condition score evaluates specific conditions of the photo which may impact the analysis outcome. */
    enableConditionScore: boolean;
    /** Specifies whether image quality scoring is enabled within the photo analysis configuration.
When enabled, it activates the feature that evaluates and scores the quality of the images. */
    enableQualityScore: boolean;
    /** Determines whether the image quality score analysis feature is enabled.
This setting is checked along with other configuration settings to activate photo analysis. */
    enableImageQualityScore: boolean;
    /** Defines the threshold score at which an image is considered blurry during the photo analysis.
Images scoring below this threshold are deemed to be of insufficient quality. */
    blurryImageThresholdScore: number;
    /** Specifies whether comprehensive person detection within photo analysis is enabled.
Comprehensive person detection involves advanced techniques to detect individuals
more accurately within images, which may include face detection and recognition,
identifying multiple people, and assessing pose and features for better analytical results. */
    enableComprehensivePersonDetection: boolean;
    /** Determines whether finish detection is enabled in the photo analysis process.
Finish detection is a feature used to identify the completion state of a photo analysis. */
    enableFinishDetection: boolean;
    /** Specifies whether roof material detection is enabled in the photo analysis process. */
    enableRoofMaterialDetection: boolean;
    /** Photo Analysis Types that are enabled  */
    enabledModels: string[] | undefined;
    /** Detached Structure Classifier enabled */
    enableDetachedStructure: boolean;
    /** Dwelling Style Detection enabled */
    enableDwellingStyleDetection: boolean;
    /** Exterior Wall Detection enabled */
    enableExteriorWallsDetection: boolean;
    /** Roof Style Detection enabled */
    enableRoofStyleDetection: boolean;
}

export interface PhotoTag {
    id: number | undefined;
    tagName: string | undefined;
    tagNameDisplayOrder: number | undefined;
    inactiveDate: Date | undefined;
    isRequired: boolean | undefined;
    customerId: number | undefined;
    surveyTypeId: number | undefined;
    isHazard: boolean | undefined;
    tagLongName: string | undefined;
    customer: Customer | undefined;
    surveyType: SurveyType | undefined;
}

export interface PhotoTagViewModel {
    tagName: string | undefined;
}

/** Control Number of the case which had a photo uploaded */
export interface PhotoUploadLogRequest {
    /** ControlIdNumber */
    controlIdNumber: string | undefined;
}

/** JSON data for service boundary */
export interface PolygonServiceBoundary {
    /** Geometry type */
    type: string | undefined;
    /** Drawn by user or from county geometry */
    mode: string | undefined;
    /** Geometry coordinates for polygons */
    coordinates: number[][][] | undefined;
}

/** File types populated by the AiReadyEnvCreateRequestFileLocator */
export enum PopulateEnvRequestFileTypes {
    None = 0,
    All = 2,
    PropertyConditionInspectionReport = 4,
    ComparablesMap = 8,
    Sketches = 16,
    AppraiserSignature = 32,
    ComparableSalePhotos = 64,
    ComparableListingPhotos = 128,
    SubjectFrontViewPhoto = 256,
    SubjectRearViewPhoto = 512,
    SubjectStreetViewPhoto = 1024,
    SubjectAdditionalPhotos = 2048,
    MarketTrendCharts = 4096,
    InvoiceXml = 8192,
    UadXml = 16384,
    AppraiserLicense = 32768,
}

/** Preferred appt. status codes */
export interface PreferredAppointmentStatus {
}

/** Primary Structure Cost */
export interface PrimaryStructureCost extends Cost {
    /** Total Replacement Cost */
    totalReplacementCost: number;
    /** Current Coverage Percent Of IRC Specified */
    currentCoveragePercentOfIRCSpecified: boolean;
    /** Current Coverage Percent Of IRC */
    currentCoveragePercentOfIRC: number;
    /** Labor Cost */
    laborCost: number;
    /** Material Cost */
    materialCost: number;
    /** Equipment Cost */
    equipmentCost: number;
    /** Historical Depreciation Specified */
    historicalDepreciationSpecified: boolean;
    /** Historical Depreciation */
    historicalDepreciation: number;
    /** RC Less Historical Depreciation Specified */
    rcLessHistoricalDepreciationSpecified: boolean;
    /** RC Less Historical Depreciation */
    rcLessHistoricalDepreciation: number;
    /** Policy Exclusions */
    policyExclusions: number;
}

/** Primary Structure Non Standardized Cost */
export interface PrimaryStructureNonStandardizedCost extends PrimaryStructureCost {
    /** Architect Fee */
    architectFee: number;
    /** Debris Removal */
    debrisRemoval: number;
    /** General Contractor Overhead */
    generalContractorOverhead: number;
    /** General Contractor Profit */
    generalContractorProfit: number;
}

/** Primary Structure Standardized Cost */
export interface PrimaryStructureStandardizedCost extends PrimaryStructureCost {
    /** Finished Floor Area Specified */
    finishedFloorAreaSpecified: boolean;
    /** Finished Floor Area */
    finishedFloorArea: number;
    /** Total Floor Area Specified */
    totalFloorAreaSpecified: boolean;
    /** Total Floor Area */
    totalFloorArea: number;
    /** Debris Removal */
    debrisRemoval: number;
    /** Subtotal After Debris Removal */
    subtotalAfterDebrisRemoval: number;
    /** Permits And Architects Plans Including General Conditions */
    permitsAndArchitectsPlansIncludingGeneralConditions: number;
    /** Overhead And Profit */
    overheadAndProfit: number;
    /** Labor Material And Supplies */
    laborMaterialAndSupplies: number;
}

/** Constants used to generate PDF parts */
export interface PrintPdfPartTypeNames {
}

/** Private Notes form */
export interface PrivateNotes {
    /** Wrappable Id - used by the Frontend to load the right React component */
    wrappableId: string | undefined;
    /** Control id number for post back */
    controlNumber: number;
    /** Private Notes text */
    notes: string | undefined;
    /** Private Notes text */
    isReadOnly: boolean;
}

/** Export progress updates */
export interface ProgressChangedDto {
    /** Percentage complete */
    progressPercentage: number;
    /** Progress Message */
    message: string | undefined;
}

export interface PropertyRightsAttribute extends Attribute2 {
}

/** API Models for Propmix */
export interface PropmixSso {
    propmixSsoUrl: string | undefined;
    /** Propmix order id number. */
    orderId: string | undefined;
    /** Propmix username is set to Mueller's email address */
    username: string | undefined;
    /** Control ID Number */
    controlNumber: number;
    /** Propmix or other Error message */
    message: string | undefined;
    /** truth! */
    success: boolean;
    /** The returned user access token */
    userAccessToken: string | undefined;
}

export interface PublicPropertyRecord {
    siteAddress: string | undefined;
    siteCity: string | undefined;
    siteState: string | undefined;
    siteZip: string | undefined;
    yearBuilt: string | undefined;
    buildingArea: number | undefined;
    numberOfStories: string | undefined;
    numberOfUnits: number | undefined;
    baths: number | undefined;
    bedrooms: number | undefined;
    pdfPath: string | undefined;
    /** Flag to indicate whether or not to show Sketch Discrepancy info in the card. */
    discrepancyEnabled: boolean;
    /** Tax record confirmation statuses from PhoenixIntegration.BusinessLogic.Workflow.ImportSketchInteractive */
    discrepancyStatus: string | undefined;
    /** Explanation for a discrepancy between tax records and sketch square footage (if it was required) */
    discrepancyExplanation: string | undefined;
    /** Calculated square footage of phoenix sketch */
    sketchSqFt: number;
}

/** Respose for viewing audit results on Qa Timelog screen */
export interface QaAgentAuditResultResponse {
    /** ControlIdNumber of the case */
    controlIdNumber: number;
    /** Survey type of the case */
    surveyType: string | undefined;
    /** Survey address */
    address: string | undefined;
    /** Customer Info */
    customerInfo: CustomerInfo | undefined;
    /** Date the case was completed */
    completedDate: Date | undefined;
    /** Date the case was audited */
    auditDate: Date;
    /** NAme of the user that performed the audit */
    auditorName: string | undefined;
    /** The audit failed (issues were noted) */
    auditFail: boolean;
    /** Display string of the audit results */
    result: string | undefined;
}

/** QA User Audit Percentage Tiers */
export interface QAAuditPercentageOptions {
}

/** Dto for a QA User's Audit Percentage */
export interface QAAuditPercentageUserDto {
    /** Internet User Id of the QA User */
    internetUserId: number;
    /** Audit Percentage of the QA User */
    auditPercentage: number;
    /** Rejection Audit Percentage of the QA User */
    auditPercentageOptions: number[] | undefined;
}

/** Constants and static methods for QA Audit Risk Tiers */
export interface QaAuditRiskTiers {
}

/** Web Service Response for QaCaseAuditController.RetrieveAuditDetermination */
export interface QaCaseAuditDeterminationResponse {
    /** A flag to indicate an audit was completed. */
    auditRequired: boolean;
    /** Date the audit was created */
    auditRequiredDeterminationDate: Date;
    /** Case Audit Required for Inspector */
    auditRequiredForInspector: boolean;
    /** Case Audit Required for Customer */
    auditRequiredForCustomer: boolean;
    /** Case Audit Required for QA Agent */
    auditRequiredForQaAgent: boolean;
}

/** Web Service Response for QaCaseAuditController.Retrieve */
export interface QaCaseAuditRetrieveResponse extends CaseAuditCreateRequest {
    /** A flag to indicate an audit was completed. */
    auditCompleted: boolean;
    /** Date the audit was created */
    auditDate: Date | undefined;
    /** Name of the internet user that created the audit */
    auditorName: string | undefined;
    /** Name of the internet user that is/was the subject of the audit */
    qaAgentName: string | undefined;
    /** Director of the QA Agent */
    qaAgentDirector: string | undefined;
    /** Manager of the QA Agent */
    qaAgentManager: string | undefined;
    /** Case expected QA minutes */
    expectedMinutes: number;
    /** QA Time on the case */
    actualMinutes: number;
    /** QA Agent Completed Audit Feedback */
    auditFeedbackCompleted: boolean;
    /** Date QA Agent Completed Audit Feedback */
    auditFeedbackDate: Date;
    /** QA Agent Agrees with Audit Findings */
    qaAgentAgrees: boolean;
    /** QA Agent has Requested Training */
    qaAgentTrainingRequested: boolean;
    /** QA Agent Comments on Audit */
    qaAgentFeedbackComments: string | undefined;
}

/** Used to add/update */
export interface QaCompletedCaseUpdateRequest {
    /** Case Id */
    controlIdNumber: number;
    /** Users local offset in minutes compared to UTC */
    localOffsetMinutes: number;
    /** User who completed the case */
    internetUserId: number;
    /** Date case was completed in UTC time */
    completedDateUtc: Date | undefined;
}

/** Details for an individual case to be included in the pay summary */
export interface QAPayrollCaseResponse {
    /** Control number */
    controlIdNumber: number;
    /** Survey Type */
    surveyType: string | undefined;
    /** Base amount to be paid to the QA Agent (Mueller Anticipated Cost) */
    mac: number;
    /** Amount deducted from MacTotal for having a customer service incident returned (rejected) */
    returnedDeduction: number;
    /** All costs already paid to the QA Agent for the case */
    costPrevious: number;
    /** All cost in current payperiod NOT paid to the QA Agent for the case. */
    costCurrent: number;
    /** All time that is allocated to this payperiod */
    timeCurrent: number;
    /** Total amount paid for individual case (CostPrevious + CostCurrent) */
    costTotal: number;
    /** The calculated MacBonus on the case */
    macBonus: number;
    /** The potential MacBonus on the case */
    macBonusPotential: number;
    /** This is the available amount of remaining MAC bonus for the case */
    macRemaining: number;
}

/** The full pay summary */
export interface QAPayrollSummaryResponse {
    /** Pay Period */
    payPeriod: PayPeriodDto | undefined;
    /** Total estimated amount to be paid to the QA Agent (Average Rate x Estimated Minutes)) */
    macTotal: number;
    /** Total Production hours of cases in pay period */
    productionHours: number;
    /** Total hours worked based on Time Card */
    totalHoursWorked: number;
    /** Total Mac Bonus for the pay period */
    macBonus: number;
}

/** QA Performance Entry */
export interface QAPerformance {
    /** Row Type */
    rowType: QAPerformanceRowType;
    /** Date of the thing */
    date: Date;
    /** Control Id number associated with the row, only set if there is only one number */
    controlIdNumber: number | undefined;
    /** Control Number(s) associated with the row (or n/a) */
    controlIdNumberForDisplay: string | undefined;
    /** Customer Name and Number */
    customerNameNumber: string | undefined;
    /** Survey Type */
    surveyType: string | undefined;
    /** Details */
    details: string | undefined;
    /** Case Time Log Work Type Code */
    caseTimeLogWorkTypeCode: string | undefined;
    /** Case Time Log Work Type Name */
    caseTimeLogWorkTypeName: string | undefined;
    /** Expected Minutes */
    expectedMinutes: number;
}

/** QA Performance Row Type */
export enum QAPerformanceRowType {
    PhoneSupport = 1,
    ProductionTimeLog = 2,
    ClockIn = 3,
    ClockOut = 4,
}

/** Qa Queue Types */
export interface QaQueueType {
}

/** Dto for a QA User's Rejection Audit Percentage */
export interface QARejectionAuditPercentageUserDto {
    /** Internet User Id of the QA User */
    internetUserId: number;
    /** Rejection Audit Percentage of the QA User */
    rejectionAuditPercentage: number;
    /** List of available rejection audit percentages */
    rejectionAuditPercentageOptions: number[] | undefined;
}

/** QA resolution codes constants for values in the cResolution column of MuellerHomeOwner.dbo.QAQueue */
export interface QaResolutionCode {
}

/** QA Time By Day Summary */
export interface QATimeByDaySummary {
    /** Pay Period Id */
    payPeriodId: number;
    /** User Id */
    internetUserId: number;
    /** Total Time Clock Day */
    timeClockDailyHours: DailyTime | undefined;
    /** Total Expected hours (qa cases, audits, Phone support */
    expectedTotalDailyHours: DailyTime | undefined;
    /** QA Hours Expected of Completed cases */
    expectedCaseCompletedDailyHours: DailyTime | undefined;
    /** QA Hours expected phone support */
    expectedAuditDailyHours: DailyTime | undefined;
    /** QA Hours expected phone support */
    expectedPhoneSupportDailyHours: DailyTime | undefined;
    /** Time efficiency percentage by day (Expected Hours/Clock In Hours %) */
    timeEfficiencyDaily: DailyPercent | undefined;
    /** Audit Score Percent (Audits Passed / Audits total  %) */
    auditDailyEfficiency: AuditDailyPercent | undefined;
    /** Total Calendar Available Hours */
    calendarDailyHours: DailyTime | undefined;
    /** Calendar Hours Time Total */
    calendarHoursTotal: number;
    /** Total Time Clock Time */
    timeClockHoursTotal: number;
    /** QA Hours Expected of Completed cases */
    expectedTotalHours: number;
    /** QA Hours Expected of Completed cases */
    expectedCaseCompletedTotalHours: number;
    /** QA Hours expected phone support */
    expectedAuditTotalHours: number;
    /** QA Hours expected phone support */
    expectedPhoneSupportTotalHours: number;
    /** Time efficiency percentage by day (Expected Hours/Clock In Hours %) */
    timeEfficiencyTotal: number;
    /** Audit Score Percent (Audits Passed / Audits total  %) */
    auditTotalEfficiency: AuditTotalPercent | undefined;
}

/** QA Timecard filter options for Active/Inactive users. */
export enum QaTimecardActiveUserFilterOptions {
    OnlyActive = 1,
    OnlyInactive = 2,
}

/** Quality Assurance Pay Period Summary response */
export interface QaTimeCardResponse {
    /** Employee list  */
    employeeList: QaTimeCardResponseDetail[] | undefined;
    /** Total */
    totals: QaTimeCardResponseDetail | undefined;
}

/** Quality Assurance Pay Period Summary request */
export interface QaTimeCardResponseDetail {
    /** Pay Period Id */
    payPeriodId: number;
    /** User Id */
    internetUserId: number;
    /** Employee Id */
    employeeId: number;
    /** Employee Name */
    employeeName: NameNumberDto | undefined;
    /** Employee's hourly rate */
    hourlyPayRate: number;
    /** Is this Pay Periods Approved for this user */
    isApproved: boolean;
    /** Pay Periods Approval information for this user */
    approvalDetail: UserPayPeriodApprovalDto | undefined;
    /** Is this Pay Periods User missing Clock out. */
    isMissingClockInfo: boolean;
    /** Is the user currently clocked in now */
    isClockedInNow: boolean;
    /** Total minutes the user was clocked in */
    clockedInTimeMinutes: number;
    /** Total minutes of QA field review */
    totalExpectedMinutes: number;
    /** Actual Cost (clock in hours * pay rate) */
    actualCost: number;
    /** QA Review Expected Minutes */
    qaReviewExpectedMinutes: number;
    /** Audit Expected Minutes */
    auditExpectedMinutes: number;
    /** Phone Support Expected Minutes */
    phoneSupportExpectedMinutes: number;
    /** Total time clock rounded and totalled as would be reported to the payroll system */
    payrollClockInTimeHours: number;
    /** Expected cost */
    expectedCost: number;
    /** True if the employee is in training */
    isTrainee: boolean;
    /** How many weeks employed they are. */
    weeksEmployed: number;
    /** Cost Difference (ExpectedCost - ActualCost) rounded to 2 */
    costDifference: number;
    /** Cost Efficiency (ExpectedCost / ActualCost) rounded to 2 */
    costEfficiency: number;
    /** Time Efficiency (TotalExpectedMinutes / ClockedInTimeMinutes) rounded to 2 */
    timeEfficiency: number;
    /** Percentage of successful audits */
    auditPercentage30: AuditTotalPercent | undefined;
    /** Percentage of successful audits */
    auditPercentage: AuditTotalPercent | undefined;
    /** Percentage of successful audits */
    rejectionAuditPercentage: AuditTotalPercent | undefined;
    /** Percentage of successful audits */
    rejectionAuditPercentage30: AuditTotalPercent | undefined;
    /** Percentage of rejection/completed cases over the last 30 days */
    rejectionPercentage: RejectionTotalPercent | undefined;
    /** Supervisor Name */
    supervisorName: string | undefined;
    /** Director Name */
    directorName: string | undefined;
    /** Employment Type */
    employmentType: string | undefined;
    /** Days Since Last Check In */
    daysSinceLastCheckIn: number | undefined;
    /** Phone Support Call Note of last check in */
    lastCheckInNote: string | undefined;
    /** Employee Role */
    employeeRole: EmployeeRoleDto | undefined;
    /** Employee status */
    activeStatus: string | undefined;
    /** Overall pass or fail based on Tenure, clock in hours, cost eff%, and Audit 7 */
    grade: string | undefined;
    /** Total Available hours in the pay period */
    availableHours: number;
}

/** Audit Percent */
export interface RejectionTotalPercent {
    /** Rejections count */
    rejectionCount: number;
    /** Total Rejections + Completions  */
    totalCount: number;
    /** Total Rejections percent */
    amount: number;
}

/** Filter options for QA Timecard Trainees */
export enum QaTimecardTraineeFilterOptions {
    OnlyTrainees = 1,
    ExcludeTrainees = 2,
}

export interface QualityAssuranceAgentList {
    /** login id */
    internetUserId: number | undefined;
    /** Name */
    name: string | undefined;
    /** Address of QA agent */
    address: string | undefined;
    /** City of QA agent */
    city: string | undefined;
    /** State of QA agent */
    state: string | undefined;
    /** Postal Code of QA agent */
    postalCode: string | undefined;
    /** Phone number of QA agent */
    homePhone: string | undefined;
    /** Email address of QA agent */
    emailAddress: string | undefined;
    /** Payroll Id of QA agent */
    payrollEmployeeId: string | undefined;
    /** Hire Date of QA agent */
    hireDate: Date | undefined;
    /** Supervisor of QA agent */
    supervisorName: string | undefined;
    /** Team Name of QA agent */
    teamName: string | undefined;
    /** Audit Percentage of QA agent */
    auditPercentage: number;
    /** Rejection Audit Percentage */
    rejectionsAuditPercentage: number;
}

/** Result from InspectorResultsProvider */
export interface QualityAssuranceAgentResult {
    /** QA Agent payroll id */
    payrollId: string | undefined;
    /** Internet User id */
    internetUserId: number | undefined;
    /** EmployeeId, used for merging external data */
    employeeId: number | undefined;
    /** Coaching call has date and detail */
    lastCoachingCall: string | undefined;
    /** QA Agent first and last name */
    qaAgentName: string | undefined;
    /** QA Agent home state */
    state: string | undefined;
    /** QA Manager for QA Agent */
    qaManager: string | undefined;
    /** QA Director for QA Agent */
    qaDirector: string | undefined;
    /** Whether employee is currently clocked in */
    employeeStatus: string | undefined;
    /** QA Agent is a trainee */
    isTrainee: boolean;
    /** Employment Type */
    employmentType: string | undefined;
    /** Date QA Agent was hired */
    hireDate: Date | undefined;
    /** Date QA Agent started */
    startDate: Date | undefined;
    /** Years, months, and days worked */
    tenure: number | undefined;
    /** QA Agent's last login date */
    lastLoginDate: Date | undefined;
    /** The text contents of the last note */
    lastNote: string | undefined;
    /** The date/time the note was last edited */
    lastModifiedDateUtc: Date | undefined;
    /** Number of cases completed in last 7 days */
    numberOfCasesCompleted: number | undefined;
    /** QA hours expected */
    hoursExpected: number | undefined;
    /** Actual clock in hours last 7 days */
    clockInHours: number | undefined;
    /** Cost efficiency last 7 days */
    costEfficiency: number | undefined;
    /** Audit percentage in last 7 days */
    auditPercentage: number | undefined;
    /** Audit percentage in last 30 days */
    auditPercentageLastMonth: number | undefined;
    /** QA available hours for the next 30 days */
    availableHours: number;
}

/** Result class for QualityAssuranceAuditRiskResultProvider */
export interface QualityAssuranceAuditRiskResult {
    /** Control number */
    controlIDNumber: number;
    /** policy number */
    policyNumber: string | undefined;
    /** survey address */
    address: string | undefined;
    /** survey address city */
    city: string | undefined;
    /** survey address state */
    state: string | undefined;
    /** survey address zip code */
    zip: string | undefined;
    /** customer number */
    customerNumber: number | undefined;
    /** customer name */
    customerName: string | undefined;
    /** customer name and number combined */
    customerNameNumber: string | undefined;
    /** date completed */
    dateCompleted: Date | undefined;
    /** inspection type name */
    inspectionType: string | undefined;
    /** grid row type */
    resultGridRowType: string | undefined;
    /** assigned agent */
    agent: string | undefined;
    /** QA director */
    qaDirector: string | undefined;
    /** QA manager */
    qaManager: string | undefined;
    /** Coverage A In */
    coverageAIn: number | undefined;
    /** The name of the Field QA agent */
    fieldQaAgent: string | undefined;
    /** Case Audit Risk Score */
    riskScore: number;
    /** Case Audit Risk Tier */
    riskTier: string | undefined;
}

/** Result class for QualityAssuranceAuditComplianceResultProvider */
export interface QualityAssuranceAuditComplianceResult extends QualityAssuranceAuditRiskResult {
    /** Date the Audit was completed */
    auditDate: Date;
    /** Name of the Auditor */
    auditorName: string | undefined;
    /** Audit result display */
    auditResults: string | undefined;
    /** Auditee Feedback Results */
    feedbackResults: string | undefined;
    /** Auditee Feedback Comments */
    feedbackComments: string | undefined;
    /** Auditee Requests Training */
    trainingRequested: string | undefined;
    /** Audit Comments */
    comments: string | undefined;
    /** Date when Pre-Release Completed */
    preReleaseDate: Date | undefined;
    /** Gets or sets the tenure of the field representative employee in weeks. */
    fieldRepEmployeeTenureInWeeks: number | undefined;
    /** Gets or sets the tenure of the QA employee in weeks. */
    qaEmployeeTenureInWeeks: number | undefined;
}

/** Quicklist result for QA Insurance Case Audits */
export interface QualityAssuranceAuditRequiredQuicklistResult {
    /** Control number */
    controlIDNumber: number;
    /** customer name and number combined */
    customerNameNumber: string | undefined;
    /** inspection type name */
    surveyType: string | undefined;
    /** QA director */
    qaDirector: string | undefined;
    /** QA manager */
    qaManager: string | undefined;
    /** QA Auditee Agent assigned */
    qaAuditeeAssigned: string | undefined;
    /** QA Audit Agent assigned */
    qaAuditorAssigned: string | undefined;
    /** case due date */
    dueDate: Date | undefined;
    /** time in pre-release */
    timeInPreRelease: string | undefined;
    /** grid row type */
    resultGridRowType: string | undefined;
}

/** Result class for QualityAssuranceAuditReviewResultProvider */
export interface QualityAssuranceAuditReviewResult {
    /** Control number */
    controlIDNumber: number;
    /** Customer name and number combined */
    customerNameNumber: string | undefined;
    /** Inspection (survey) type name */
    inspectionType: string | undefined;
    /** Date the Audit was completed */
    auditDate: Date;
    /** Audit result display */
    auditResults: string | undefined;
    /** Audit comments */
    auditComments: string | undefined;
    /** Row Type for Quicklist */
    resultGridRowType: string | undefined;
}

/** Quicklist result for QA Insurance  cases */
export interface QualityAssuranceInsuranceActiveQuicklistResult {
    /** Control number */
    controlIDNumber: number;
    /** policy number */
    policyNumber: string | undefined;
    /** survey address */
    address: string | undefined;
    /** survey address city */
    city: string | undefined;
    /** survey address state */
    state: string | undefined;
    /** survey address zip code */
    zip: string | undefined;
    /** customer number */
    customerNumber: number | undefined;
    /** customer name */
    customerName: string | undefined;
    /** customer name and number combined */
    customerNameNumber: string | undefined;
    /** date received */
    dateReceived: Date | undefined;
    /** date entered */
    dateEntered: Date | undefined;
    /** date completed */
    dateCompleted: Date | undefined;
    /** date reviewed by underwriter */
    reviewedDate: Date | undefined;
    /** case due date */
    dueDate: Date | undefined;
    /** inspection type name */
    inspectionType: string | undefined;
    /** date returned to field rep */
    dateReturned: Date | undefined;
    /** case field status */
    webStatus: string | undefined;
    /** grid row type */
    resultGridRowType: string | undefined;
    /** the last case note */
    lastNote: CellViewModelOfCaseNoteViewModel | undefined;
    /** time in field service QA */
    timeInFSQA: string | undefined;
    /** assigned agent */
    agent: string | undefined;
    /** Mueller @ Home created */
    atHomeCreated: string | undefined;
    /** Mueller @ Home ready */
    atHomeReady: string | undefined;
    /** QA director */
    qaDirector: string | undefined;
    /** Coverage A In */
    coverageAIn: number | undefined;
    /** The name of the Field QA agent */
    fieldQaAgent: string | undefined;
    /** Field Rep Due Date */
    frDueDate: Date;
    /** FR Assigned */
    frAssigned: string | undefined;
    /** FR Email */
    frEmail: string | undefined;
}

/** Quicklist result for QA Insurance cases */
export interface QualityAssuranceQuicklistResult {
    /** Order Code In */
    orderCodeIn: string | undefined;
    /** Control number */
    controlIDNumber: number;
    /** policy number */
    policyNumber: string | undefined;
    /** survey address */
    address: string | undefined;
    /** survey address city */
    city: string | undefined;
    /** survey address state */
    state: string | undefined;
    /** survey address zip code */
    zip: string | undefined;
    /** policy holder name */
    policyholderName: string | undefined;
    /** customer number */
    customerNumber: number | undefined;
    /** customer name */
    customerName: string | undefined;
    /** customer name and number combined */
    customerNameNumber: string | undefined;
    /** date received */
    dateReceived: Date | undefined;
    /** date entered */
    dateEntered: Date | undefined;
    /** date completed */
    dateCompleted: Date | undefined;
    /** date reviewed by underwriter */
    reviewedDate: Date | undefined;
    /** case due date */
    dueDate: Date | undefined;
    /** field survey appointment date */
    appointmentDate: Date | undefined;
    /** inspection type name */
    inspectionType: string | undefined;
    /** original inspection type name */
    originalSurveyType: string | undefined;
    /** field rep */
    frAssigned: string | undefined;
    /** date returned to field rep */
    dateReturned: Date | undefined;
    /** customer tracking number */
    trackingNumber: string | undefined;
    /** case field status */
    webStatus: string | undefined;
    /** grid row type */
    resultGridRowType: string | undefined;
    /** appointment date and time */
    appointmentDateTime: Date | undefined;
    /** appointment contact date */
    contactMadeOnDate: Date | undefined;
    /** appointment contact person */
    contactPerson: string | undefined;
    /** appointment contact effort */
    contactEffortResult: string | undefined;
    /** the last case note */
    lastNote: CellViewModelOfCaseNoteViewModel | undefined;
    /** time assigned to the field rep */
    timeUnassignedFieldRep: string | undefined;
    /** time assigned waiting for contact efforts */
    timeAssignedWithNoContactEfforts: string | undefined;
    /** time since appt was scheduled */
    timeSinceScheduledAppointment: string | undefined;
    /** time since appt was schedued */
    timeSinceScheduledAppointmentRaw: string | undefined;
    /** time in field QA */
    timeInQA1: string | undefined;
    /** time in field service QA */
    timeInFSQA: string | undefined;
    /** assigned agent */
    agent: string | undefined;
    /** field rep director */
    fieldDirector: string | undefined;
    /** field coordinator */
    fieldLevelCoordinator: string | undefined;
    /** Lender logistics manager */
    lenderLogisticsManager: string | undefined;
    /** date assigned to field rep */
    dateAssigned: Date | undefined;
    /** policyholder preferred appointment date */
    preferredAppointmentDate: Date | undefined;
    /** Mueller @ Home created */
    atHomeCreated: string | undefined;
    /** Mueller @ Home ready */
    atHomeReady: string | undefined;
    /** QA director */
    qaDirector: string | undefined;
    /** Underwriter code */
    underwriterCode: string | undefined;
    /** QA agent assigned */
    qaAgent: string | undefined;
    /** QA Queue id */
    qaQueueId: number;
    /** Is the case a rush */
    isRush: string | undefined;
    /** Coverage A In */
    coverageAIn: number | undefined;
    /** The name of the Field QA agent */
    fieldQaAgent: string | undefined;
    /** FR Email */
    frEmail: string | undefined;
    /** FR Hire Date */
    frHireDate: Date | undefined;
    /** Auto QA  */
    autoQA: string | undefined;
    /** Customer Type Code */
    customerTypeCode: string | undefined;
    /** Count of Major Hazards */
    majorHazardCount: number;
    /** Count of Minor Hazards */
    minorHazardCount: number;
    /** Survey Remarks */
    surveyRemarks: string | undefined;
    /** Inspector has Training Completed Date */
    fieldRepIsTrainee: boolean;
    /** Insurance to Value Percent */
    percentToValue: number | undefined;
    /** Inspector Error Percentage */
    fieldRepErrorRate: number | undefined;
    /** Last Resolution Note from the QA Queue */
    lastQANote: string | undefined;
    /** On Hold Status */
    isOnHold: boolean;
    /** Indicates if a case is in the Audit Queue */
    preRelease: boolean;
    /** Time since added to the Pre-Release queue */
    timeInPreRelease: string | undefined;
    /** Status of CubiCasa scan for case */
    cubiCasaStatus: string | undefined;
    /** Amount of time that the CubiCasa scan has been in waiting status */
    timeInWaitingCubiCasaStatus: string | undefined;
    /** Amount of days case is on hold */
    daysOnHold: number;
    /** QA Manager for case */
    qaManager: string | undefined;
    /** Amount of time that case has been assigned to the current QA Agent */
    timeAssignedQaQueue: string | undefined;
}

/** Request to unassign cases from qa agent(s) */
export interface QualityAssuranceUnassignRequest {
    /** Cases to assign to qa agents */
    controlIdNumbers: number[] | undefined;
}

/** Queue Entry dto */
export interface QueueEntryDto {
    /** ControlIdNumber */
    controlIdNumber: number;
    /** Queue Type */
    queueTypeCode: string | undefined;
    /** Date Taken */
    takenDate: Date | undefined;
}

export interface QueueNewCaseRequest {
    controlIdNumber: number;
    queueType: QueueTypeEnum;
    rankOverride: number | undefined;
    queueToRemove: QueueTypeEnum | undefined;
}

/** QA Queue Type codes */
export interface QueueTypeCodes {
}

/** Queue Entry Queue Types */
export interface QueueTypes {
}

export interface QuickFilterKeys {
}

/** Customization for client behavior on quick list types. */
export interface QuickListClientConfiguration {
    /** Indication on whether rows can be selected to take bulk actions. */
    hasSelectableRows: boolean;
}

export interface QuickListCountViewModel {
    /** QuickList Id */
    id: number;
    /** the Count of records. */
    recordCount: number;
    /** Date of the last calculation. */
    asOfDate: Date;
}

/** Quick List Filter Rule */
export interface QuickListFilter {
    /** filter identifier */
    term: string | undefined;
    /** Displayable title for the Filter */
    title: string[] | undefined;
    /** Machine readable filter key */
    code: string | undefined;
    /** Optional Id for filtering to a user or appraiser. */
    id: string | undefined;
    /** Operator for the filter - == > >= etc. */
    operator: string | undefined;
    /** Value to be searched for based on the Operator
Syntax is Term + Operator + Operand. */
    operand: string | undefined;
    /** And Or joiner between Filter expressions */
    combiner: string | undefined;
}

export interface QuickListFilterField {
    /** Meat friendly name. */
    name: string | undefined;
    /** Data friendly name. */
    key: string | undefined;
    /** Use 'all' or provide a list of operators. */
    operators: string | undefined;
    /** Use 'text' or 'date' or 'else' */
    inputType: string | undefined;
    /** Quick filter key that is mapped to this key */
    quickFilterKey: string | undefined;
}

export interface QuickListFilterLogic {
}

/** Used by the Update Quick List Grouper. */
export interface QuickListGroupUpdateViewModel {
    /** Database Id */
    id: number;
    /** Title */
    name: string | undefined;
    /** Group the lists by business unit, tbd */
    group: string | undefined;
    /** Allow the user to change the Sort Order. */
    sortOrder: number;
}

export interface QuickListGroupViewModel {
    /** Name and description */
    id: number;
    /** Readable Code that can be used as a parameter. */
    groupCode: string | undefined;
    /** A sporty name that can be used in a dropdown list. */
    name: string | undefined;
}

/** Data for a live instance of a QuickList. */
export interface QuickListItemViewModel {
    /** Database Id */
    id: number;
    /** Title */
    name: string | undefined;
    /** QuickList code identifier */
    quickListCode: string | undefined;
    /** Template Code identifier */
    templateCode: string | undefined;
    /** Group the lists by business unit, tbd */
    group: string | undefined;
    /** Allow the user to change the Sort Order. */
    sortOrder: number;
    /** QuickList user provided description */
    description: string | undefined;
    /** Json code for the filters that may have been applied. */
    filter: QuickListFilterLogic | undefined;
    /** Json code for the filters that may have been applied. */
    filterCode: string | undefined;
    /** List of the selected column names. */
    columnKeys: string | undefined;
    columns: MGridColumnDefinition[] | undefined;
    /** Underlying template */
    template: QuickListTemplateViewModel | undefined;
    /** Underlying Count if it was qureied */
    count: QuickListCountViewModel | undefined;
    /** Underlying Results. */
    result: QuickListResultModel | undefined;
    /** Determines if the quick list is editable */
    isEditable: boolean;
    /** Whether or not the quick list is shared by user id with this user (not by right) */
    isSharedWithThisUser: boolean;
    /** Stores if the quick list was made with simple mode */
    isSimpleList: boolean;
    /** For shared quick lists
when you get a quicklist by guid you can get any list
we need to let the front end know if the user already has the quicklist or not so it can alert them accordingly */
    doesSignedInUserHaveAccess: boolean;
}

export interface QuickListTemplateViewModel {
    /** Name and description */
    id: number;
    /** Readable Code that can be used as a parameter. */
    templateCode: string | undefined;
    /** A sporty name that can be used in a dropdown list. */
    name: string | undefined;
    /** Specifies if the list was made in simple mode or not */
    isSimpleList: boolean;
    /** Master list of columns available to the users of this template. */
    columns: MGridColumnDefinition[] | undefined;
    /** New Quick Lists will start out with these columns selected. */
    defaultColumnKeys: string[] | undefined;
    /** Master list of columns available to the users of this template. */
    filterFields: QuickListFilterField[] | undefined;
    /** Client configuration properties for the quick list type/template. */
    clientConfiguration: QuickListClientConfiguration | undefined;
    /** Quick list requires a filter to refine the result. Should be enabled by default */
    filterRequired: boolean;
}

/** The result model being returned back to the front end. */
export interface QuickListResultModel {
    /** Quick List Id */
    id: number;
    /** Name of the Template */
    code: QuickListTemplateCode;
    /** Date the query was run. */
    asOfDate: Date;
    /** Grid Definitions */
    columns: MGridColumnDefinition[] | undefined;
}

/** Template code for quick lists */
export enum QuickListTemplateCode {
    Invalid = 0,
    AppraisalCases = 1,
    InsuranceCases = 2,
    CustomerInsuranceCases = 3,
    CustomerAppraisalCases = 4,
    HomeownerOpenIncidents = 5,
    CustomerReviewQueue = 6,
    BrokerFeedback = 7,
    BrokerCases = 8,
    InspectorHiringForecastsOpen = 9,
    CaseFeedback = 10,
    AppraiserQueue = 11,
    QualityAssuanceInsurance = 12,
    QualityAssuranceInsuranceActivity = 13,
    AppraisalAssignmentApproval = 14,
    CaseExportWithApi = 15,
    SchedulingAssistant = 16,
    QualityAssuranceAuditRisk = 17,
    QualityAssuranceAuditCompliance = 18,
    Inspector = 19,
    QualityAssuranceAuditReview = 20,
    QualityAssuranceRequireAudit = 21,
    QualityAssuranceAgent = 22,
    InsuranceCasesNewCustomer = 23,
    CaseFollowUp = 24,
    Appraiser = 25,
    CustomerSatisfactionSurvey = 26,
}

export interface QuickListQueryModel {
    id: string | undefined;
    rules: QuickListRule[] | undefined;
    combinator: string | undefined;
}

export interface QuickListRule {
    id: string | undefined;
    field: string | undefined;
    value: string | undefined;
    operator: string | undefined;
}

/** Interface for different quick list Models */
export interface QuickListResultModel_1 extends QuickListResultModel {
    /** List of results */
    Data: T | undefined;
}

export interface QuickListResultViewModel {
    /** QuickList Id */
    id: number;
    /** Name of the Template */
    code: string | undefined;
    data: any[] | undefined;
    /** Date the query was run. */
    asOfDate: Date;
    /** Flag for the front-end. */
    isFetching: boolean;
    columns: MGridColumnDefinition[] | undefined;
    /** This should only be emitted in Debug/Test */
    sql: string | undefined;
    /** List of users that this list is shared with */
    sharedWithInternetUsers: number[] | undefined;
}

export interface QuickListUpdateViewModel {
    /** Database Id */
    id: number;
    /** Title */
    name: string | undefined;
    /** QuickList code identifier */
    quickListCode: string | undefined;
    /** Template Code identifier */
    templateCode: string | undefined;
    /** Group the lists by business unit, tbd */
    group: string | undefined;
    /** Allow the user to change the Sort Order. */
    sortOrder: number;
    /** QuickList user provided description */
    description: string | undefined;
    /** Json code for the filters that may have been applied. */
    filterCode: string | undefined;
    /** List of the selected column names. */
    columnKeys: string[] | undefined;
    /** Stores what mode the quick list was made in */
    isSimpleList: boolean;
}

/** Represents a request to raise a case event. */
export interface RaiseCaseEventRequest {
    /** Gets or sets the control ID number associated with the case event. */
    controlIdNumber: number;
    /** Gets or sets the optional object ID related to the case event. */
    objectId: number | undefined;
    /** Gets or sets the optional creation date of the case event. */
    createDate: Date | undefined;
    /** Gets or sets the type of case event being raised. */
    caseEvent: CaseEventConstant | undefined;
}

/** Rct Calc Adjustment */
export interface RctCalcAdjustment {
    /** Name */
    name: string | undefined;
    /** Include For Valuation */
    includeForValuation: boolean;
    /** Percentage */
    percentage: number;
    /** Cap */
    cap: number;
}

/** Constant names for MSB RCT calculation adjustments. */
export interface RctCalcAdjustmentNames {
}

/** Rct calc adjustments */
export interface RctCalcAdjustments {
    /** Wage type specified */
    wageTypeSpecified: boolean;
    /** Wage type code */
    wageTypeCode: string | undefined;
    /** Depreciation choice specified */
    depreciationChoiceSpecified: boolean;
    /** Depreciation choice code */
    depreciationChoiceCode: string | undefined;
    /** Depreciation percentage specified */
    depreciationPercentageSpecified: boolean;
    /** Depreciation percentage */
    depreciationPercentage: number;
    /** Depreciation age specified */
    depreciationAgeSpecified: boolean;
    /** Depreciation age */
    depreciationAge: number;
    /** General percentage specified */
    generalPercentageSpecified: boolean;
    /** General percentage */
    generalPercentage: number;
    /** Exclude excavation specified */
    excludeExcavationSpecified: boolean;
    /** Exclude excavation */
    excludeExcavation: boolean;
    /** Adjustments */
    adjustments: RctCalcAdjustment[] | undefined;
}

/** RCT calc floor to floor height */
export interface RCTCalcFloorToFloorHeight {
    /** Height */
    height: number;
    /** Percentage */
    percentage: number;
}

/** Represent a calc data file stored in the case file path */
export interface RctCalcInformation {
    /** The Name of this replacement cost estimate */
    name: string | undefined;
    /** Style code */
    styleCode: string | undefined;
    /** Number of families */
    numberOfFamilies: number | undefined;
    /** Use fractional story height */
    useFractionalStoryHeight: boolean;
    /** Site access code */
    siteAccessCode: string | undefined;
    /** The wings on this calc */
    sections: RctCalcWing[] | undefined;
    /** The structure wide materials */
    materials: RCTCalcMaterial[] | undefined;
    /** Additional materials sent to MSB for the replacement cost estimate */
    additionalCalculationMaterials: RCTCalcMaterial[] | undefined;
    /** The structure wide special items */
    specialItems: RCTCalcSpecialItem[] | undefined;
    /** Calculation adjustments */
    adjustments: RctCalcAdjustments | undefined;
    /** The most recent calculation results */
    replacementCostEstimate: RctCalcResults | undefined;
    /** The Record ID from MSB */
    msbRecordId: number | undefined;
    /** The Record Version from MSB */
    msbVersionId: number | undefined;
    /** Comments about the replacement cost estimate */
    comments: string | undefined;
    /** The date/time this calculation was last modified */
    lastModified: Date;
}

/** Rct calc wing */
export interface RctCalcWing {
    /** Id */
    id: string | undefined;
    /** Name */
    name: string | undefined;
    /** Living area */
    livingArea: number;
    /** Living area lower level */
    livingAreaLowerLevel: number;
    /** Year built */
    yearBuilt: number;
    /** Number of stories */
    noOfStories: number;
    /** Construction type code */
    constructionTypeCode: string | undefined;
    /** Living area entry method code */
    livingAreaEntryMethodCode: string | undefined;
    /** Perimeter choice code */
    perimeterChoiceCode: string | undefined;
    /** Section shape code */
    sectionShapeCode: string | undefined;
    /** Additional materials sent to MSB for the replacement cost estimate */
    additionalCalculationMaterials: RCTCalcMaterial[] | undefined;
    /** Measured perimeter */
    measuredPerimeter: number;
    /** Materials */
    materials: RCTCalcMaterial[] | undefined;
    /** Floor to floor heights */
    floorToFloorHeights: RCTCalcFloorToFloorHeight[] | undefined;
}

/** RCT calc material */
export interface RCTCalcMaterial {
    /** Material code */
    materialCode: string | undefined;
    /** Amount */
    amount: number;
    /** Is dummy material */
    isDummyMaterial: boolean;
    /** Is default material */
    isDefaultMaterial: boolean;
}

/** RCT calc special item */
export interface RCTCalcSpecialItem {
    /** Description */
    description: string | undefined;
    /** Comment */
    comment: string | undefined;
    /** Quantity */
    quantity: number;
    /** Unit of measure code */
    unitOfMeasureCode: string | undefined;
    /** Coverage type code */
    coverageTypeCode: string | undefined;
    /** Building system location code */
    buildingSystemLocationCode: string | undefined;
    /** Equipment cost */
    equipmentCost: number;
    /** Labor cost */
    laborCost: number;
    /** Material cost */
    materialCost: number;
}

/** Rct Calc Results */
export interface RctCalcResults {
    /** Calculation errors */
    calculationErrors: string[] | undefined;
    /** Results header */
    resultsHeader: ResultsHeader | undefined;
    /** Fit commit date */
    fitCommitDate: Date | undefined;
}

/** Results header */
export interface ResultsHeader {
    /** Cost Data Version Date */
    costDataVersionDate: Date;
    /** Calc Date */
    calcDate: Date;
    /** Record Id */
    recordId: number;
    /** Version Id */
    versionId: number;
    /** Data Source */
    dataSource: string | undefined;
    /** Primary Structure Cost */
    primaryStructureCost: PrimaryStructureCost | undefined;
    /** Detached Structure Cost */
    detachedStructureCost: DetachedStructureCost | undefined;
    /** Building System Cost */
    buildingSystemCost: BuildingSystemCost[] | undefined;
    /** Sections */
    sections: SectionResult[] | undefined;
    /** Materials */
    materials: Material[] | undefined;
    /** The original response received */
    sourceResultsSerializedXml: string | undefined;
}

/** Section Result */
export interface SectionResult {
    /** Number */
    number: number;
    /** Materials */
    materials: Material[] | undefined;
}

/** RCT High Value Material Sub System Codes */
export interface RctHighValueMaterialSubSystemCodes {
}

/** Unit of measure names used in RCT calculations. */
export interface RctHighValueUnitOfMeasureNames {
}

/** RCT Material List Ids */
export enum RCTMaterialListId {
    EXTERIOR_WALLS = 1,
    ROOFING = 2,
    ATTACHED_STRUCTURES = 3,
    DETACHED_STRUCTURES = 4,
    SPECIAL_ITEMS = 5,
    PARTITIONS = 6,
    WALL_COVERINGS = 7,
    CEILINGS = 8,
    FLOORING = 9,
    INTERIOR_ITEMS = 10,
    HVAC = 11,
    MISC_SYSTEMS = 12,
    ROOF_STYLE_SLOPE = 13,
    DOORS = 14,
    BATHROOMS = 15,
    KITCHENS = 16,
}

/** Constants for RCT Material List values. */
export interface RctMaterialListValues {
}

export interface ReactivateAppraiserDto {
    /** Appraiser id */
    appraiserId: number;
    /** Date they are active */
    activeDate: Date;
}

/** Export IDs for data fields in the recommendation form. */
export interface RecommendationExportIds {
}

/** Represents the PhoenixServices and PhoenixIntegration recommendation result response */
export interface RecommendationResult {
    name: string | undefined;
    category: string | undefined;
    /** Recommendation level */
    categories: string[] | undefined;
    /** Recommendation level */
    level: string | undefined;
    /** Recommendation text */
    recommendation: string | undefined;
    /** Location description */
    location: string | undefined;
    /** If "Other" recommendation name, provides a description */
    userprovidedname: string | undefined;
    /** Datafield ID, if the rec is generated in the form (optional) */
    datafieldid: string | undefined;
    /** Count of this recommendation identified in form */
    count: number;
    /** Identifying tag */
    tag: string | undefined;
    /** ID of the linked photo */
    photoIds: string[] | undefined;
    /** Index of the form repeat */
    formIndex: number | undefined;
}

export interface RecommendationsCategory {
    category: RecommendationsCategory[] | undefined;
    name: string | undefined;
    majorcompany: string | undefined;
    rectext: string | undefined;
}

export interface RecommendationSettings {
    categories: RecommendationsCategory[] | undefined;
}

/** Used as Multi polygon areas for mapping */
export interface RegionMultiPolygon {
    /** Type of Polygon */
    type: string | undefined;
    /** list of coordinates */
    coordinates: number[][][][] | undefined;
}

/** Used as polygon areas for mapping */
export interface RegionPolygon {
    /** Type of Polygon */
    type: string | undefined;
    /** What mode of points this is (county, draw) */
    mode: string | undefined;
    /** list of coordinates */
    coordinates: number[][][] | undefined;
}

/** Request to reject a case from a QA rep to the field */
export interface RejectCaseRequest {
    /** Control number for the case */
    controlIdNumber: number;
    /** QA Queue Id */
    qaQueueId: number | undefined;
    /** QA Queue Type Id */
    qaQueueTypeId: number | undefined;
    /** Rejection Notes associated with the rejection */
    rejectionNotes: string;
    /** Flag on whether or not the QA reps manager should be CC'd on the rejection */
    sendCopyToManager: boolean;
    /** User Id of the QA Rep */
    internetUserId: number;
    /** Time log working on a case */
    timeLog: CaseTimeLogAddDto | undefined;
    /** Local offset minutes */
    localOffsetMinutes: number;
    /** Indicates the request was sent using the "return to inspector" button in case actions */
    isCaseActionsRequest: boolean;
}

/** Result of request to reject case to the field. */
export interface RejectCaseResponse {
    /** Rejection was not successful, see ValidationMessage for details */
    isInvalid: boolean;
    /** Validation message */
    validationMessage: string | undefined;
}

/** Case Link Response */
export interface RelatedCaseResponse {
    /** Related Case Control Number */
    controlIdNumber: number;
    /** Policy number of linked case */
    policyNumber: string | undefined;
    /** Policy Holder Name */
    policyHolderName: string | undefined;
    /** Inspection Address */
    inspectionAddress: AssignmentAddress | undefined;
    /** Field Rep Assigned (if applicable) */
    inspectorAssigned: number | undefined;
    /** Name of Field Rep Assigned (if applicable) */
    inspectorAssignedName: string | undefined;
    /** Insurance Status */
    insuranceStatus: string | undefined;
    /** Field inspection appointment date */
    fieldAppointmentDate: Date | undefined;
    /** Survey Type */
    surveyType: string | undefined;
}

/** used to remove a users rights */
export interface RemoveInternetUserRightDto {
    internetUserId: number;
    rightNames: string[] | undefined;
}

/** Request for removing a survey type nofication */
export interface RemoveSurveyTypeNotificationRequest {
    /** Customer Number */
    customerNumber: number;
    /** Survey Type Code */
    surveyTypeCode: string | undefined;
    /** Notification Type Code */
    notificationTypeCode: string | undefined;
}

/** Status defines for updating the case header Status fields (Primary and/or SecondaryStatus. */
export interface RepeatUnit {
}

/** Report Group names that show up in reporting.mueller-inc.com */
export interface ReportGroupNames {
}

/** Representing a report type for the broker web order */
export interface ReportType {
    /** Inspection Type Name */
    reportName: string | undefined;
    /** Inspection Type Code */
    reportCode: string | undefined;
    /** List of payment methods available for this survey type */
    availablePaymentTypes: PaymentType[] | undefined;
}

export interface RequiredMemberAttribute extends Attribute2 {
}

/** Request to re-send a case notification. */
export interface ReSendNotificationRequest {
    /** Control number of the notification to Re-Send */
    controlIdNumber: number;
    /** Code of the notification to Re-Send */
    code: string | undefined;
}

/** View for Reseting a user's password Gets called when you fill out form in page that was link in forgot-password email */
export interface ResetPasswordViewModel {
    token: string;
    /** new password */
    password: string;
}

/** Response Action */
export interface ResponseActionDto {
    /** Response action value */
    id: ResponseActionEnum;
    /** Response Name */
    name: string | undefined;
}

/** Response Action */
export enum ResponseActionEnum {
    Approved = 1,
    Modified = 2,
    Denied = 3,
}

/** Parameters to look up the UCDP settings */
export interface RetrieveUCDPSettingsRequestDto {
    /** Case control number */
    controlNumber: number;
}

/** UCDP settings response object */
export interface RetrieveUCDPSettingsResponseDto {
    /** Fannie Mae Institution Id */
    fnmInstitutionId: string | undefined;
    /** Fannie Mae Seller Number */
    fnmSellerNumber: string | undefined;
    /** Freddie Mac Identification Number */
    freIdentificationNumber: string | undefined;
    /** Business Unit Number */
    businessUnitNumber: string | undefined;
    /** UCDP customer feature is enabled */
    isEnabled: boolean;
    /** The survey type codes that should have UCDP preview run */
    previewEnabledSurveyTypeCodes: string[] | undefined;
    /** The survey type codes that should have UCDP submit run */
    submitEnabledSurveyTypeCodes: string[] | undefined;
}

/** Right DTO for use by the API BL */
export interface RightDto {
    /** Name of Right */
    name: string | undefined;
    /** Id of Right */
    id: number;
    /** Description of Right */
    description: string | undefined;
    /** Ids of all Roles this Right is enabled on */
    enabledRoleIds: number[] | undefined;
    /** Ids of all Roles this Right is disabled on */
    disabledRoleIds: number[] | undefined;
}

/** List of Right Names */
export interface RightNames {
}

export interface RightViewModel {
    name: string | undefined;
    id: number;
    description: string | undefined;
    enabledRoleIds: number[] | undefined;
    disabledRoleIds: number[] | undefined;
}

/** Datamodel defining a role right key pair */
export interface RoleIdRightIdPairDto {
    /** the role id */
    roleId: number;
    /** the right id */
    rightId: number;
}

/** RoleRights DTO for use by the API BL */
export interface RoleRightsDto {
    /** Array of Dtos for all the ROles */
    roles: RoleDto[] | undefined;
    /** Array of Dtos for all Rights */
    rights: RightDto[] | undefined;
}

/** DTO for sending data from Controller to Business Logic */
export interface RoleRightsEditDto {
    /** Array of RoleId RightId Paisr  */
    roleIdRightIdPairs: RoleIdRightIdPairDto[] | undefined;
    /** Enabled or Disabled Role Rights */
    lValue: boolean;
}

export interface RoleRightsViewModel {
    roles: RoleViewModel[] | undefined;
    permissions: RightViewModel[] | undefined;
}

export interface RoleViewModel {
    name: string | undefined;
    id: number;
    enabledRightIds: number[] | undefined;
    disabledRightIds: number[] | undefined;
}

/** Keys used in RTF file generation */
export interface RtfTemplateKeys {
    /** Current date */
    date: string | undefined;
    /** Insured Name */
    insuredName: string | undefined;
    /** Contact Name */
    contactName: string | undefined;
    /** Contact Phone */
    contactPhone: string | undefined;
    /** Contact Email */
    contactEmail: string | undefined;
    /** Mailing Address1 */
    mailingAddress1: string | undefined;
    /** Mailing City State Zip */
    mailingCityStateZip: string | undefined;
    /** Policy Number */
    policyNumber: string | undefined;
    /** Recommendations */
    recommendations: string | undefined;
    /** Recommendations Table */
    recommendationsTable: string | undefined;
    /** Survey Address 1 */
    surveyAddress1: string | undefined;
    /** Survey City State Zip */
    surveyCityStateZip: string | undefined;
    /** Survey Date Unformatted */
    surveyDateUnformatted: string | undefined;
    /** Survey Date Formatted */
    surveyDateFormatted: string | undefined;
    /** Agency Name */
    agencyName: string | undefined;
    /** Agency Phone Number */
    agencyPhoneNumber: string | undefined;
    /** Agency Email */
    agencyEmail: string | undefined;
    /** Agency Code */
    agencyCode: string | undefined;
    /** Agents Address */
    agentsAddress: string | undefined;
    /** Agents City */
    agentsCity: string | undefined;
    /** Agents State */
    agentsState: string | undefined;
    /** Agents City State Zip */
    agentsCityStateZip: string | undefined;
    /** Location Building */
    locationBuilding: string | undefined;
    /** Underwriter Name */
    underwriterName: string | undefined;
    /** Underwriter Code */
    underwriterCode: string | undefined;
    /** Insured Home Phone */
    insuredHomePhone: string | undefined;
    /** Insured Email */
    insuredEmail: string | undefined;
    /** Control Number */
    controlNumber: string | undefined;
    /** Inspector Name */
    inspectorName: string | undefined;
    /** Tracking Number */
    trackingNumber: string | undefined;
    /** Order Code In */
    orderCodeIn: string | undefined;
    /** Year the inspection was completed */
    yearInspected: string | undefined;
    /** Month the inspection was completed */
    monthInspected: string | undefined;
    /** Day the inspection was completed */
    dayInspected: string | undefined;
    /** Completed Date Formatted */
    completedDateFormatted: string | undefined;
    /** Recommendation number */
    recommendationNumber: string | undefined;
    /** Recommendation level */
    recommendationLevel: string | undefined;
    /** Recommendation name */
    recommendationName: string | undefined;
    /** Recommendation text */
    recommendationText: string | undefined;
    /** An HTML block that defines a set of recommendations grouped by level */
    levelGroupTemplate: string | undefined;
    /** An HTML block that defines a single recommendation */
    recommendationTemplate: string | undefined;
}

/** QA Performance Entry */
export interface SAPerformance {
    /** Row Type */
    rowType: SAPerformanceRowType;
    /** Date of the thing */
    date: Date;
    /** Control Id number associated with the row, only set if there is only one number */
    controlIdNumber: number | undefined;
    /** Control Number(s) associated with the row (or n/a) */
    controlIdNumberForDisplay: string | undefined;
    /** Customer Name and Number */
    customerNameNumber: string | undefined;
    /** Survey Type */
    surveyType: string | undefined;
    /** Details */
    details: string | undefined;
    /** Expected Minutes */
    expectedMinutes: number;
}

/** QA Performance Row Type */
export enum SAPerformanceRowType {
    CaseScheduled = 1,
    CaseSubmittedToQA = 2,
    ClockIn = 3,
    ClockOut = 4,
    CustomerServiceNote = 5,
    ProductionTimeLog = 6,
    CoachingCall = 7,
    WebOrder = 8,
}

/** Used to save test results */
export interface SaveResultsRequest {
    /** Course Name */
    courseName: string;
    /** Employee Email that took course */
    employeeEmail: string;
    /** What the score was on the test */
    score: number;
    /** If the user passed or not on the course */
    status: string;
    /** amount of time user took to take the course */
    durationMinutes: number | undefined;
    /** Location of saved test results if applicable */
    fileName: string | undefined;
}

/** Result model from FieldServicesCaseResultProvider */
export interface SchedulingAssistantQuicklistResult {
    /** Case control number */
    controlIDNumber: number;
    /** Policy Number */
    policyNumber: string | undefined;
    /** Survey address */
    address: string | undefined;
    /** Survey city */
    city: string | undefined;
    /** Survey state abbreviation */
    state: string | undefined;
    /** Survey Zip code */
    zip: string | undefined;
    /** Survey Count */
    county: string | undefined;
    /** Policyholder name */
    policyholderName: string | undefined;
    /** Customer Name and Number */
    customerNameNumber: string | undefined;
    /** Date received */
    dateReceived: Date | undefined;
    /** Date entered */
    dateEntered: Date | undefined;
    /** Due Date */
    dueDate: Date | undefined;
    /** Inspection Type */
    inspectionType: string | undefined;
    /** Inspector days till due */
    inspectorDaysDue: number | undefined;
    /** Grid row type? */
    resultGridRowType: string | undefined;
    /** Appointment contact made date */
    contactMadeOnDate: Date | undefined;
    /** Appointment contact person */
    contactPerson: string | undefined;
    /** Appointment contact effort result */
    contactEffortResult: string | undefined;
    /** Last case note */
    lastNote: CellViewModelOfCaseNoteViewModel | undefined;
    /** Agent name */
    agent: string | undefined;
    /** Field director */
    fieldDirector: string | undefined;
    /** Field level coordinator */
    fieldLevelCoordinator: string | undefined;
    /** Lender logistics manager */
    lenderLogisticsManager: string | undefined;
    /** Mueller At Home ready */
    atHomeReady: string | undefined;
    /** Case is rush */
    isRush: boolean;
    /** Customer Type Code */
    customerTypeCode: string | undefined;
    /** Assigned to in the Field Scheduling Queue */
    assignedInQueue: string | undefined;
    /** Queue rank */
    queueRank: string | undefined;
    /** Due date of the next contact */
    nextContactDue: Date | undefined;
    /** Name of the next contact step */
    nextContactStep: string | undefined;
    /** Phoenix File Id */
    phoenixFileId: string;
    /** Customer Experience Manager */
    customerExperienceManager: string | undefined;
    /** Customer Experience Director */
    customerExperienceDirector: string | undefined;
}

/** Scheduling time by day */
export interface SchedulingTimeByDaySummary {
    /** Pay Period Id */
    payPeriodId: number;
    /** User Id */
    internetUserId: number;
    /** Total Time Clock Day */
    timeClockDailyHours: DailyTime | undefined;
    /** Actual case time log  */
    actualHours: DailyTime | undefined;
    /** Total Expected Hours of all cases submitted and scheduled */
    expectedHours: DailyTime | undefined;
    /** Expected hours of SA Scheduled "Completed" cases */
    scheduledExpectedHours: DailyTime | undefined;
    /** Expected hours of SA Submitted to QA "Completed" cases */
    submittedExpectedHours: DailyTime | undefined;
    /** Expected hours of SA Customer Service "Completed" incidents */
    incidentExpectedHours: DailyTime | undefined;
    /** Expected hours of Coaching calls */
    coachingCallExpectedHours: DailyTime | undefined;
    /** Expected hours of user manually ordering a case */
    webOrderExpectedHours: DailyTime | undefined;
    /** Expected hours of additional required calls made */
    additionalCallExpectedHours: DailyTime | undefined;
    /** Total Time Clock Time */
    timeClockHoursTotal: number;
    /** Actual case time log  */
    actualHoursTotal: number;
    /** Total Expected Hours of all cases submitted and scheduled */
    expectedHoursTotal: number;
    /** Total Expected hours of SA Scheduled "Completed" cases */
    scheduledExpectedHoursTotal: number;
    /** Total Expected hours of SA Submitted to QA "Completed" cases */
    submittedExpectedHoursTotal: number;
    /** Total Expected hours of SA Customer Service "Completed" incidents */
    incidentExpectedHoursTotal: number;
    /** Total Expected hours of SA Customer Service manually order a case */
    webOrderExpectedHoursTotal: number;
    /** Total expected hours of coaching calls */
    coachingCallExpectedHoursTotal: number;
    /** Total expected hours of additional required calls made */
    additionalCallExpectedHoursTotal: number;
    /** Count of SA Submitted to QA Completed cases */
    submittedCount: DailyAmountOfInteger | undefined;
    /** Total Count of SA Submitted to QA Completed cases */
    submittedCountTotal: number;
    /** Count of SA Scheduled Completed cases */
    scheduledCount: DailyAmountOfDecimal | undefined;
    /** Total Count of SA Scheduled Completed cases */
    scheduledCountTotal: number;
    /** Count of SA Customer Service Completed incidents */
    incidentCount: DailyAmountOfInteger | undefined;
    /** Total Count of SA Customer Service Completed incidents */
    incidentCountTotal: number;
}

/** Scheduling Time Card response */
export interface SchedulingTimeCardDetail {
    /** Pay Period id */
    payPeriodId: number;
    /** Employee Id */
    employeeId: number;
    /** User Id */
    internetUserId: number;
    /** Employee Name */
    employeeName: NameNumberDto | undefined;
    /** Employee's hourly rate */
    hourlyPayRate: number;
    /** Is this Pay Periods Approved for this user */
    isApproved: boolean;
    /** Pay Periods Approval information for this user */
    approvalDetail: UserPayPeriodApprovalDto | undefined;
    /** Is this Pay Periods User missing Clock out. */
    isMissingClockInfo: boolean;
    /** Is the user currently clocked in now */
    isClockedInNow: boolean;
    /** Total minutes the user was clocked in */
    clockedInTimeMinutes: number;
    /** Total time clock rounded and totalled as would be reported to the payroll system */
    payrollClockInTimeHours: number;
    /** Actual hours from case time logs */
    productionHours: number;
    /** Production Cost (ProductionHours * HourlyPayRate) */
    productionCost: number;
    /** Payroll Cost (HourlyPayRate * PayrollClockInTimeHours) */
    payrollCost: number;
    /** How many weeks employed they are. */
    weeksEmployed: number;
    /** Expected hours of SA Submitted to QA "Completed" cases */
    submittedExpectedHours: number;
    /** Expected hours of SA Scheduled "Completed" cases */
    scheduledExpectedHours: number;
    /** Expected hours of SA Customer Service "Completed" incidents */
    incidentExpectedHours: number;
    /** Expected hours of coaching calls */
    coachingExpectedHours: number;
    /** Expected hours of Additional Calls */
    additionalCallsExpectedHours: number;
    /** Expected hours of SA All "Completed" cases/incidents */
    expectedHours: number;
    /** Count of SA Customer Service "Completed" incidents */
    incidentCount: number;
    /** Expected cost of SA "Completed" cases */
    expectedCost: number;
    /** Incident Expected Cost */
    incidentExpectedCost: number;
    /** ExpectedCost - ProductionCost */
    costDifference: number;
    /** ExpectedCost / ProductionCost  */
    costEfficiency: number;
    /** ExpectedHours / (ClockedInTimeMinutes / 60)  */
    timeEfficiency: number;
    /** Body of most recent row in EmployeeNotes table */
    lastEmployeeNote: string | undefined;
    /** UTC date of most recent row in EmployeeNotes table */
    lastEmployeeNoteDate: Date | undefined;
    /** Manually entered orders on the web */
    webOrderExpectedHours: number;
    /** Total number of appointments completed in this pay period */
    appointmentsCompleted: number;
    /** Total number of appointments completed on time in this pay period */
    appointmentsCompletedOnTime: number;
    /** Percent of appointments completed on time in this pay period */
    percentAppointmentsCompletedOnTime: number;
    /** Total number of hours spent on calls receiving credit */
    callHours: number;
    /** Total number of appointments scheduled in this pay period */
    appointmentsScheduled: number;
    /** Total number of appointments completed using top 5 */
    top5Appointments: number;
    /** The percentage of the top 5 appointments relative to the total appointments */
    percentTop5Appointments: number;
    /** Total available hours in the pay period */
    availableHours: number;
}

/** Scheduling Time Card Response */
export interface SchedulingTimeCardResponse {
    /** Employee list  */
    employeeList: SchedulingTimeCardDetail[] | undefined;
    /** Total */
    totals: SchedulingTimeCardDetail | undefined;
}

export interface ScorecardMetric {
    actual: string | undefined;
    score: string | undefined;
    name: string | undefined;
}

export interface ScorecardMetricNames {
}

export interface SearchResultDto {
    /** List of display columns to show with the results. */
    columns: MGridColumnDefinition[] | undefined;
    /** List of items to be returned */
    rows: CaseResult[] | undefined;
}

export interface SearchResultMGridViewModel {
    columns: MGridColumnDefinition[] | undefined;
    rows: any[] | undefined;
}

export interface SearchResultOptionsDto {
    rowType: string | undefined;
    title: string | undefined;
    description: string | undefined;
    warning: string | undefined;
}

/** Request to assign a case in the QA queue */
export interface SendCaseRequest {
    /** Control number for case */
    controlIdNumber: number;
    /** QA Queue Id  */
    qaQueueId: number;
    /** QA Queue Type Id */
    qaQueueTypeId: number;
    /** Notes indicating the reason the case was sent or assigned */
    notes: string | undefined;
    /** Internet user Id of the user sending or assigning the case */
    requestorInternetUserId: number;
    /** Internet user ID of the user to send or assign the case to */
    assignToInternetUserId: number;
    /** Time log working on a case */
    timeLog: CaseTimeLogAddDto | undefined;
    /** The result of the action being taken on the case */
    resolutionCode: string | undefined;
}

/** Result of request to send a case to another user in the QA queue */
export interface SendCaseResponse {
}

/** Request to assign a case */
export interface SendSchedulingCaseRequest {
    /** Control number for case */
    controlIdNumber: number;
    /** Notes indicating the reason the case was sent or assigned */
    notes: string;
    /** Internet User Id of the user sending the case.  */
    fromInternetUserId: number;
    /** Internet user ID of the user to send or assign the case to */
    assignToInternetUserId: number;
    /** Time log working on a case */
    timeLog: CaseTimeLogAddDto | undefined;
}

/** Result of request to send a case to another user */
export interface SendSchedulingCaseResponse {
}

export interface ServiceException extends Exception {
}

/** DTO class for Service Exception */
export interface ServiceExceptionDto {
    /** Display friendly error details */
    errors: ServiceExceptionErrorDto[] | undefined;
}

/** DTO class for Service Exception */
export interface ServiceExceptionDetailedDto extends ServiceExceptionDto {
    /** The full exception stack trace */
    fullStackTrace: string | undefined;
}

/** Details of the service exception */
export interface ServiceExceptionErrorDto {
    /** User friendly message */
    message: string | undefined;
    /** Error code */
    code: number;
}

export interface ServiceRegionAddRequest {
    /** Service Region Name */
    name: string | undefined;
    /** Service Region Type */
    type: ServiceRegionTypeEnum;
}

/** Service Region Types */
export enum ServiceRegionTypeEnum {
    Inspector = 1,
}

/** Update request */
export interface ServiceRegionUpdateRequest {
    /** Primary Id */
    id: number;
    /** Service Region Name */
    name: string | undefined;
}

export interface SetsRequiredMembersAttribute extends Attribute2 {
}

/** SignalR Hub Name constants */
export interface SignalrHubNames {
}

/** Basic extendable response class */
export interface SimpleResponse {
    /** Response has an error */
    error: boolean;
    /** List of error messages */
    errorMessages: string[] | undefined;
}

/** Stack Code Setting dto */
export interface StackCodeSettingDto {
    /** Code */
    code: string | undefined;
    /** Name */
    name: string | undefined;
}

/** An export sequence request */
export interface StartExportSequenceRequest {
    /** Export sequence request */
    exportRequests: StartExportRequest[] | undefined;
}

/** Start Timer Result */
export interface StartTimerResult {
    /** Id */
    id: number;
    /** Successful or not */
    success: boolean;
    /** String Message if Success = False */
    message: string | undefined;
    /** Amount of seconds the front end will need to ping back to say "still working on it" */
    pingRateSeconds: number;
}

export interface StateRequestDto {
    /** List of State abbreviations */
    stateAbbrevation: string[] | undefined;
    /** Pull back county boundaries if true
We dont always pull them back because theyre huge */
    includeBoundaries: boolean;
}

export interface StateViewModel {
    id: number;
    stateName: string | undefined;
    stateAbbreviation: string | undefined;
}

/** Options for storing an attachment in azure */
export interface StoreAttachmentOptions {
    /** The date/time this attachment should expire at */
    expiresAtUtc: Date;
    /** Sub folder under the main container (not required) */
    subFolder: string | undefined;
    /** The filename to store */
    fileName: string | undefined;
    /** The file content type / MIME type */
    contentType: string | undefined;
}

/** Generic structure to package stream data with an arbitrary metadata object */
export interface StreamWithMetadata_1 {
    /** Data */
    Data: Stream | undefined;
    /** Metadata */
    Metadata: T | undefined;
}

/** Used to submit a deduction request for a customer service incident that was the QA Agent fault */
export interface SubmitReturnedCaseRequest {
    /** Case Id */
    controlIdNumber: number;
    /** QA Agent Internet User Id */
    qaInternetUserId: number;
}

/** Submit to QA Request */
export interface SubmitToQaRequest {
    /** Case Id */
    controlIdNumber: number;
}

/** Employee supervisor not found */
export interface SupervisorEmployeeNotFoundException extends MuellerBusinessException {
}

/** Add Satisfaction Survey Request */
export interface SupportLineSatisfactionSurveyAddRequest extends SatisfactionSurveyRequest {
    /** Support Call Id  */
    phoneSupportCallId: number;
    /** The employee Id of the supported user */
    supportedEmployeeId: number;
}

/** Satisfaction Survey Response */
export interface SupportLineSatisfactionSurveyResponse extends SatisfactionSurveyResponse {
    /** Support Call Id */
    supportCallId: number;
    /** Name of the Support Line Rep. at time of survey */
    supportName: string | undefined;
    /** Name of the Support Line Caller at time of survey */
    supportedName: string | undefined;
    /** Overall Satisfaction (1 - 5, 5 being best) with support */
    supportSatisfactionScore: number;
    /** Overall Satisfaction (1 - 5, 5 being best) with support understanding and working to resolve the issue */
    supportUnderstoodAndWorkedToResolveScore: number;
    /** Overall Satisfaction (1 - 5, 5 being best) with post-call confidence in the resolution */
    postCallConfidenceScore: number;
    /** Overall Satisfaction (0 - 1, yes or no) with the issue being fully resolved */
    issueFullyResolvedScore: number;
    /** Survey text repsonse */
    issueFullyResolvedComments: string | undefined;
    /** Survey text repsonse */
    isThereAnythingSupportCouldHaveDoneBetter: string | undefined;
    /** Survey text repsonse */
    additionaFeedbackOnCall: string | undefined;
    /** Local Creation Date of the Survey */
    dateCreated: Date;
    /** Date Completed */
    dateCompleted: Date | undefined;
}

/** Satisfaction Survey Request */
export interface SupportLineSatisfactionSurveyUpdateRequest extends SatisfactionSurveyRequest {
    /** WorkItemId of the surveyed case */
    uid: string;
    /** Overall Satisfaction (1 - 5, 5 being best) with support */
    supportSatisfactionScore: number;
    /** Overall Satisfaction (1 - 5, 5 being best) with support understanding and working to resolve the issue */
    supportUnderstoodAndWorkedToResolveScore: number;
    /** Overall Satisfaction (1 - 5, 5 being best) with post-call confidence in the resolution */
    postCallConfidenceScore: number;
    /** Overall Satisfaction (1 - 5, 5 being best) with the issue being fully resolved */
    issueFullyResolvedScore: number;
    /** Survey text repsonse */
    issueFullyResolvedComments: string | undefined;
    /** Survey text repsonse */
    isThereAnythingSupportCouldHaveDoneBetter: string | undefined;
    /** Survey text repsonse */
    additionaFeedbackOnCall: string | undefined;
}

/** InspectionTypesT.InspectionTypeClass */
export interface SurveyTypeClass {
}

/** Survey (inspection) Type codes */
export interface SurveyTypeCodes {
}

/** Survey Type Group codes */
export interface SurveyTypeGroupCodes {
}

/** Task Job SignalR Hub Message model */
export interface TaskJobMessage {
    /** Case control number */
    controlNumber: number;
    /** Event date/time */
    createDateUtc: Date;
    /** Task job conversation handle UUID */
    conversationHandleUuid: string | undefined;
    /** Task job name */
    taskJobName: string | undefined;
    /** Message content (used to set EventType if using CaseEventHub) */
    message: string | undefined;
}

/** Parameters to terminate an appraiser */
export interface TerminateAppraiserDto {
    /** Appraiser id */
    appraiserId: number;
    terminatedDate: Date;
}

/** Mueller Tiers */
export interface TierCodes {
}

/** Topic markdown response */
export interface TopicMarkdownResponse {
    /** Topic ID */
    topicId: string;
    /** Markdown */
    markdown: string | undefined;
}

/** Topic markup preview response */
export interface TopicMarkupPreviewResponse {
    /** Markup preview */
    markup: string | undefined;
}

/** Touch Type Codes */
export interface TouchTypeCodes {
}

/** Touch Type */
export enum TouchTypeEnum {
    FR_ACCEPTED = 1,
    RCVD_FROM_WEB = 2,
    RCVD_FROM_IMPORT = 3,
    RCVD_FROM_FAX_DATA_ENTRY = 4,
    ASSIGNED = 5,
    FR_RETURNED_CASE_BECAUSE = 6,
    FR_HAS_PROBLEM = 7,
    FR_ADDS_PHOTO = 8,
    FR_FILLS_OUT_FORM = 9,
    FR_COMPLETES = 10,
    IN_CALC = 11,
    REJECTED_BY_QA = 12,
    IN_QA = 13,
    IN_BILLING = 14,
    SENT_TO_CUST_VIA_WEB = 15,
    SENT_TO_CUST_VIA_EXPORT = 16,
    SENT_TO_CUST_VIA_HARDCOPY = 17,
    IN_DIRECTIONS = 18,
    ATC_INSURED_BY_MUELLER = 19,
    ATC_AGENT_BY_MUELLER = 20,
    ATC_CUST_BY_MUELLER = 21,
    ATC_INSURED_BY_FR = 22,
    ATC_AGENT_BY_FR = 23,
    FR_APPT_UNABLE = 25,
    FR_CASE_PHONE_LOOKUP = 26,
    FR_DIRECTORY_ASSISTANCE = 27,
    FR_WASTO_FIND_THE_STREET = 28,
    FR_DIRECTIONS_PO = 29,
    FR_FOUND_HOUSE_NUMS = 30,
    FR_STOP_AT_HOUSE_NUMBER = 31,
    FR_ATT_TO_CONTACT_INSURED = 32,
    FR_MINOR_AT_HOME = 33,
    FR_RECEIVED_REFUSAL = 34,
    FR_RECEIVED_REFUSAL_FROM = 35,
    FR_FLAT_RETURNED_BECAUSE = 36,
    FR_COULD_NOT_ACCESS = 37,
    RETURN_NOTES = 38,
    NO_APPT_EXT_ONLY = 39,
    FR_CASE_WARNING = 40,
    FR_CASE_PULLED = 41,
    EXTENSION_PENDING = 42,
    CONV_CLOSEOUT = 43,
    FR_CASE_RETURNED_REASSIGN = 44,
    EXTENSION_APPROVED = 45,
    EXTENSION_MODIFIED = 46,
    EXTENSION_DENIED = 47,
    RCT_UPLOADED_TO_MSB_XNET = 48,
    CALL_CENTER_STARTED = 49,
    CALL_CENTER_FINISHED = 50,
    POLICYHOLDER_STARTED = 51,
    POLICYHOLDER_FINISHED = 52,
    AGENT_STARTED = 53,
    AGENT_FINISHED = 54,
    CASE_CONVERTED_INT_SUPP = 55,
    CASE_FORM_CHANGED = 56,
    RCT_MERGED_FROM_MSB_FILE = 57,
    M2_EVENT = 58,
    CASE_RE_ORDERED_ONLINE = 59,
    CASE_CHANGED = 60,
    CHANGED_CUST = 61,
    BILLING_CHANGED = 62,
    DATE_CHANGED = 63,
    CASE_FILE_ATTACH = 64,
    POLICYHOLDER_EMAIL_SENT = 65,
    AUTOMATED_SYSTEM_ERROR = 66,
    UW_ASSIGNED_TO_CASE = 67,
    DUEDATE_CHANGED = 68,
    UW_ACTIONS_CLEARED = 69,
    APPRAISALSCOPE_UPLOADED = 70,
    APPRAISALSCOPE_IMPORTED = 71,
    MOBILE_NOTIFICATION = 72,
    ASSIGNED_APPRAISAL = 73,
    CAPTURE_PAYMENT = 74,
    PRE_CHARGE_AUTH_EMAIL = 75,
    BILLED_CHARGE_EMAIL = 76,
    QA_SWITCH_FULL_VIEW = 77,
    VOID_PAYMENT = 78,
    BROKER_UPLOAD_DOCUMENT = 79,
    BROKER_ORDER_NO_UPLOAD = 80,
    PNX_WORKFLOW = 81,
    CALLBACK_REMINDER_QUEUED = 82,
    CALLBACK_EXPIRED_QUEUED = 83,
    BORROWER_PAYMENT_REQUEST = 84,
    BORROWER_PAYMENT_CONFIRM = 85,
    BORROWER_INITIAL_REMINDER = 86,
    PAYMENT_EXPIRED_EMAIL = 87,
    ORDER_PAYMENT_AUTHORIZED = 88,
    REOPENED_CASE = 89,
    COMPARABLE_UPDATED = 90,
    NOTIFICATION_RESENT = 91,
    CASE_EMAIL_SENT = 92,
    FS_AUTO_QA = 93,
    CASE_FORM_DATA_TRANSFER = 94,
    ETA_CHANGED = 95,
    AVAIL_APPR_ON_ASSIGN = 96,
    APPRAISAL_PORT_MSG_SENT = 97,
    BORROWER_BROKER_EMAIL = 98,
    APPOINTMENT_CHANGE = 99,
    APPRAISAL_PORT_MSG_RCVD = 101,
    CASE_RETURNED_TO_FR = 102,
    QUEUE_RANK_MOVED = 103,
    NOTIFY_RESEND_CANCELLED = 104,
    AGENT_EMAIL_ASSIGNED_CASE = 105,
    AUTO_ASSIGNED = 106,
    AUTO_ASSIGNMENT_FAILED = 107,
    SA_ASSIGNED_CASE = 108,
}

/** String constants for touch type notes and note components */
export interface TouchTypeNoteContants {
}

/** Mueller Training and Demo Accounts */
export interface TrainingAndDemoAccounts {
}

export interface TrendCharts {
    defaultCharts: ChartImage[] | undefined;
    axisCharts: ChartImage[] | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnum_1 extends TypeSafeEnum {
}

/** Constants for Photo Analysis Type codes. */
export interface UnderwriterActionCodes {
}

/** Used to insert a new underwriter */
export interface UnderwriterAddRequest {
    /** Major company it's associated with */
    majorCompanyId: number;
    /** InternetUserId it's associated with */
    internetUserId: number;
    /** First Name */
    firstName: string | undefined;
    /** Last Name */
    lastName: string | undefined;
    /** Email */
    email: string | undefined;
    /** Unique Code within this major company (will be generated if not supplied)
             */
    code: string | undefined;
}

/** Request to assign cases to underwriter */
export interface UnderwriterAssignRequest {
    /** Underwriter code */
    code: string | undefined;
    /** Cases to assign to udnerwriter */
    controlIdNumbers: number[] | undefined;
}

/** Listing model for underwriters */
export interface UnderwriterListViewModel {
    /** The Underwriter record id */
    id: number;
    /** The major company info */
    majorCompany: MajorCompanyDto | undefined;
    /** Underwriter code */
    underwriterCode: string | undefined;
    /** Underwriter first name */
    underwriterFirstName: string | undefined;
    /** Underwriter last name */
    underwriterLastName: string | undefined;
    /** Email address */
    emailAddress: string | undefined;
    /** FirstName LastName (Code) */
    displayName: string | undefined;
}

/** Viewmodel for next case to be reviewed */
export interface UnderwriterNextCaseViewModel {
    /** Case Control Number */
    controlIdNumber: number;
    /** True if the user's queue is empty */
    isEmpty: boolean;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfUnderwriterPermissionToClose extends TypeSafeEnum {
}

/** Underwriter Permission To Close Process */
export interface UnderwriterPermissionToClose extends TypeSafeEnumOfUnderwriterPermissionToClose {
}

/** Webpage display information */
export interface UnderwriterPermissionToClosePageInformation {
    /** If not null, the webpage will display this message and the rest of the 
properties will be defaulted */
    errorMessage: string | undefined;
    controlIdNumber: number;
    daysUntilClosed: number;
    policyNumber: string | undefined;
    customerInfo: string | undefined;
    reportType: string | undefined;
    surveyAddress: Address | undefined;
    dueDate: Date;
    policyholderName: Name | undefined;
    homePhone: string | undefined;
    workPhone: string | undefined;
    email: string | undefined;
    agentName: string | undefined;
    agentCode: string | undefined;
    agentPhone: string | undefined;
    agentEmail: string | undefined;
    specialAttentionNotes: string | undefined;
    callLogs: CallLog[] | undefined;
    /** A list of phone numbers already on the case, digits only, no formatting */
    existingPhoneNumbers: string[] | undefined;
    /** A flag to indicate that the UW user did select the keep open option on this case already */
    didAlreadySelectKeepOpen: boolean;
    /** A flag to indicate that the UW user did select the keep open with extension option on this case already */
    didAlreadySelectKeepOpenWithExtension: boolean;
    /** A flag to indicate that the UW user did select the try again option on this case already */
    didAlreadySelectTryAgain: boolean;
    /** CS phone number to display */
    muellerPhoneNumber: string | undefined;
    /** Customer is set up to hold closeouts open until due date with customer feature 'HOLD_CLOSEOUT_UNTIL_DUE' */
    holdCloseoutUntilDue: boolean;
    /** If the customer had the 'HOLD_CLOSEOUT_UNTIL_DUE' feature enabled and 'HOLD_CLOSEOUT_UNTIL_DUE_ALLOW_DUE_EXTENSION' set to true,
this indicates the max number of days the UW is allowed to extend the due date. If zero, this feature setting is not enabled. */
    maximumDueDateExtensionDays: number;
}

/** Defines an email body */
export interface UnderwriterPermissionToCloseTemplate {
    /** Key */
    key: string | undefined;
    /** Lines of the email body */
    lines: string[] | undefined;
}

/** Underwriter permission to close email template */
export interface UnderwriterPermissionToCloseTemplates {
    /** To email address */
    to: string | undefined;
    /** CC email address */
    cc: string | undefined;
    /** Email body */
    emailBodies: UnderwriterPermissionToCloseTemplate[] | undefined;
}

/** Extension to TypeSafeEnum that allows parsing from string */
export interface TypeSafeEnumOfUnderwriterPermissionToExtend extends TypeSafeEnum {
}

/** Underwriter Permission To Extend Process */
export interface UnderwriterPermissionToExtend extends TypeSafeEnumOfUnderwriterPermissionToExtend {
}

/** Webpage display information */
export interface UnderwriterPermissionToExtendPageInformation {
    /** If not null, the webpage will display this message and the rest of the 
properties will be defaulted */
    errorMessage: string | undefined;
    /** ControlIdNumber */
    controlIdNumber: number;
    /** Number of days remaining before auto-extended */
    daysUntilExtended: number;
    /** AppointmentDate */
    appointmentDate: Date;
    /** Due date if the case extension is approved */
    extendedDueDate: Date;
    /** PolicyNumber */
    policyNumber: string | undefined;
    /** Customer Name (Customer Number) */
    customerInfo: string | undefined;
    /** Survey type */
    reportType: string | undefined;
    /** SurveyAddress */
    surveyAddress: Address | undefined;
    /** Case DueDate */
    dueDate: Date;
    /** PolicyholderName */
    policyholderName: Name | undefined;
    /** Policyholder Email */
    email: string | undefined;
    /** AgentName */
    agentName: string | undefined;
    /** AgentCode */
    agentCode: string | undefined;
    /** AgentPhone */
    agentPhone: string | undefined;
    /** AgentEmail */
    agentEmail: string | undefined;
    /** SA notes */
    specialAttentionNotes: string | undefined;
    /** Case contact efforts */
    callLogs: CallLog[] | undefined;
}

/** Defines the default text of an email body */
export interface UnderwriterPermissionToExtendTemplate {
    /** Body templates */
    bodyTemplates: UnderwriterPermissionToExtendTemplateBody[] | undefined;
    /** Email "To" field */
    to: string | undefined;
    /** Email "CC" field */
    cc: string | undefined;
}

/** Email body templates */
export interface UnderwriterPermissionToExtendTemplateBody {
    /** Key */
    key: string | undefined;
    /** Lines of the email body */
    lines: string[] | undefined;
}

/** Request to unassign cases from underwriter(s) */
export interface UnderwriterUnassignRequest {
    /** Cases to assign to underwriter */
    controlIdNumbers: number[] | undefined;
}

/** Request to update an Underwriter */
export interface UnderwriterUpdateRequest {
    /** Underwriter id */
    id: number;
    /** Underwriter code */
    code: string | undefined;
    /** Underwriter email */
    email: string | undefined;
    /** Major company ID associated with Underwriter */
    majorCompanyId: number;
}

/** Request to update appointment note */
export interface UpdateAppointmentNoteRequest {
    /** Appointment id to update */
    appointmentId: number;
    /** Updated note */
    appointmentNote: string | undefined;
}

/** Update Case User Event Watches Request */
export interface UpdateCaseWatchesRequest {
    /** Control number */
    controlNumber: number;
    /** Internet user ID */
    internetUserId: number;
    /** Enable case event type IDs */
    enableCaseEventIds: number[] | undefined;
    /** Disable case event type IDs */
    disableCaseEventIds: number[] | undefined;
}

/** Case Mileage Details */
export interface UpdateInspectorCaseMileageDto {
    /** Case Id */
    controlIdNumber: number;
    /** Miles Inspector entered to get to the case */
    mileageActual: number;
}

/** Model for Estimate and Actual Minutes detail */
export interface UpdateInspectorCaseTimeDto {
    /** Control Number for the case */
    controlIdNumber: number;
    /** Drive Time Minutes */
    driveTimeMinutes: number;
    /** Site Time Minutes */
    siteTimeMinutes: number;
    /** Web write up Minutes */
    webTimeMinutes: number;
}

/** used to update a users roles */
export interface UpdateInternetUserRoleDto {
    internetUserId: number;
    role: string | undefined;
    resetUserRights: boolean;
}

export interface UpdateRecommendationsResult {
    /** Recommendations to add */
    additions: RecommendationResult[] | undefined;
    /** Recommendations to remove */
    removals: RecommendationResult[] | undefined;
    /** Errors thrown when trying to retrieve/apply recommendation updates */
    errors: string[] | undefined;
}

/** Request for updating a notification to a survey type */
export interface UpdateSurveyTypeNotificationRequest extends AddSurveyTypeNotificationRequest {
    /** Original type code in case this was changed as part of the update */
    originalNotificationTypeCode: string | undefined;
}

/** Update User Dto */
export interface UpdateUserDto {
    username: string | undefined;
    company: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    email: string | undefined;
    receivesEmailConfirmations: boolean;
    roleName: string | undefined;
    isDisabled: boolean;
    isLockedOut: boolean;
    mustChangePassword: boolean;
    forcedPassword: string | undefined;
}

/** Request to update user watches */
export interface UpdateUserWatchRequest {
    /** Internet user ID */
    internetUserId: number;
    /** Enable case event type IDs */
    enableCaseEventIds: number[] | undefined;
    /** Disable case event type IDs */
    disableCaseEventIds: number[] | undefined;
}

/** used as a detailed user return */
export interface UserInformationRequestDto {
    internetUserId: number;
}

/** Basic list of Appraiser. */
export interface UserListViewModel {
    /** Internet User Id */
    id: number;
    /** Appraiser First and Last Name combined */
    firstLastName: string | undefined;
}

/** Update Model for a user that has authenticated with the site and wishes to update their profile. */
export interface UserProfileUpdateModel {
    /** Given name */
    firstName: string;
    /** Surname */
    lastName: string;
}

/** View Model representing a user that has logged in to the web api and been authenticated. */
export interface UserProfileViewModel {
    roles: string[] | undefined;
    /** Login user name */
    username: string | undefined;
    /** Given name */
    firstName: string;
    /** Surname */
    lastName: string;
    /** Email Address */
    email: string;
    /** Authentication Token.  This is populated during the Login Controller action and returned to the front-end for using in future authenticated api calls. */
    token: string | undefined;
}

/** Dto to Request if right is enabled */
export interface UserRightEnabledRequest {
    /** User id */
    internetUserId: number;
    /** Right Name  */
    rightName: string | undefined;
}

/** This is the list of users by a pay period */
export interface UsersByTimeLogListDto {
    /** InternetUserId */
    internetUserId: number;
    /** First and Last Name */
    firstLastName: string | undefined;
}

/** Watches for a user */
export interface UserWatchDto {
    /** Name */
    name: string | undefined;
    /** Code */
    code: string | undefined;
    /** Case event type ID */
    caseEventTypeId: number;
    /** Watch is enabled */
    enabled: boolean;
    /** Watch is for an inspection event */
    isInspectionWatch: boolean;
    /** Watch is for an appraisal event */
    isAppraisalWatch: boolean;
}

export interface ValidationAttribute extends Attribute2 {
    requiresValidationContext: boolean;
    errorMessage: string | undefined;
    errorMessageResourceName: string | undefined;
    errorMessageResourceType: string | undefined;
}

/** Extension to System.ComponentModel.DataAnnotations that allows validation to drill down into class properties on a model without requiring custom validators. */
export interface ValidateObjectAttribute extends ValidationAttribute {
}

/** Validation Issues displayer. */
export interface ValidationIssues {
    /** Wrappable Id - used by the Frontend to load the right React component */
    wrappableId: string | undefined;
    /** Control id number for post back */
    controlNumber: number;
    /** Private Notes text */
    validationIssuesJson: string | undefined;
    /** Private Notes text */
    isReadOnly: boolean;
}

/** View Model for Veros Preview Results. */
export interface ValidationIssuesViewModel {
    previewStatus: VerosStatus;
    previewResult: VerosPreviewResultViewModel | undefined;
    ucdpStatus: VerosStatus;
    ucdpResult: VerosSubmitResultViewModel | undefined;
}

export enum VerosStatus {
    NotApplicable = 0,
    NoRequests = 1,
    ChangedSinceLastRequest = 2,
    PendingResult = 3,
    HasResult = 4,
}

/** Veros Preview web view model. */
export interface VerosPreviewResultViewModel {
    id: number;
    controlIdNumber: number;
    verosPathwayGuid: string | undefined;
    requestVerosStatus: string | undefined;
    resultVerosStatus: string | undefined;
    resultReceivedDate: Date | undefined;
    readOnly: boolean;
    items: VerosResultItemViewModel[] | undefined;
}

/** Single item of a result from the Preview. */
export interface VerosResultItemViewModel {
    id: number;
    verosRequestId: number;
    verosResultTypeId: number;
    verosSeverityId: number;
    severity: string | undefined;
    resultCode: string | undefined;
    resultMessage: string | undefined;
    formSection: string | undefined;
    formField: string | undefined;
    propertyAffected: string | undefined;
    dataPoint: string | undefined;
    anticipatedVerosOverrideTypeId: number | undefined;
    selectedVerosOverrideTypeId: number | undefined;
    selectedOverrideComment: string | undefined;
    resolvedDate: Date | undefined;
    choices: VerosOverrideChoice[] | undefined;
}

export interface VerosOverrideChoice {
    id: number;
    verosResultTypeId: number;
    resultCode: string | undefined;
    overrideCode: string | undefined;
    name: string | undefined;
    description: string | undefined;
    commentRequired: boolean;
}

export interface VerosSubmitResultViewModel {
    id: number;
    controlIdNumber: number;
    verosPathwayGuid: string | undefined;
    requestVerosStatus: string | undefined;
    resultVerosStatus: string | undefined;
    resultReceivedDate: Date | undefined;
    items: VerosResultItemViewModel[] | undefined;
}

/** Enum to classify which Validation the Validation Status belongs to. */
export enum ValidationModule {
    PhoenixForms = 0,
    VerosPreview = 1,
    UcdpSubmit = 2,
    QaRejections = 3,
    FileManager = 4,
    GaarPreview = 5,
}

/** This is the story of a Validation service. */
export interface ValidationServiceStatus {
    /** Which validation module is this. */
    module: ValidationModule;
    /** What is the current status of this? */
    status: ValidationStatus;
    /** Number of Errors - 0 is good, not 0 is bad. */
    errorCount: number;
    /** What do we call this thing? */
    name: string | undefined;
    /** How do we explain it? */
    message: string | undefined;
}

/** Determines the status of a specific Validaton Service. */
export enum ValidationStatus {
    NoIssuse = 0,
    HasIssues = 1,
    DoesNotExistYet = 2,
    InProcess = 3,
    NotApplicable = -1,
}

/** Single item of a result from the Preview. */
export interface VerosPreviewResultItemViewModel {
    id: number;
    verosPreviewRequestId: number;
    verosResultTypeId: number;
    verosSeverityId: number;
    severity: string | undefined;
    resultCode: string | undefined;
    resultMessage: string | undefined;
    formSection: string | undefined;
    formField: string | undefined;
    propertyAffected: string | undefined;
    dataPoint: string | undefined;
    anticipatedVerosOverrideTypeId: number | undefined;
    selectedVerosOverrideTypeId: number | undefined;
    selectedOverrideComment: string | undefined;
    resolvedDate: Date | undefined;
    choices: VerosOverrideChoice[] | undefined;
}

/** View model used by the UCDP Submittal form in the Classic ASP QA site. */
export interface VerosSubmitResultAspViewModel {
    hasUnresolvedItems: boolean;
    /** Did the request fail? */
    requestFailed: boolean;
    /** Is the request still processing? */
    requestInProgress: boolean;
    /** The result issue items */
    items: VerosSubmitResultItemAspViewModel[] | undefined;
    /** Veros status name */
    requestVerosStatusName: string | undefined;
    /** Veros result status code */
    resultVerosStatusCode: string | undefined;
    /** Veros result status name */
    resultVerosStatusName: string | undefined;
    /** Date the result was received */
    resultReceivedDate: Date | undefined;
    /** The Veros unique id */
    verosPathwayGuid: string | undefined;
    /** The last time the status was updated */
    lastPolledDate: Date | undefined;
    /** The date/time the request was created */
    createDate: Date;
    /** The case control number */
    controlIdNumber: number;
    /** The Veros submittal request id */
    id: number;
    /** The initial period to wait before checking the status */
    pollingIntervalSecondsInitial: number;
    /** The follow up delay to check status */
    pollingIntervalSecondsSubsequent: number;
}

/** View model used by the UCDP Submittal form in the Classic ASP QA site. */
export interface VerosSubmitResultItemAspViewModel {
    /** Id for the submit result item */
    id: number;
    /** Form field */
    formField: string | undefined;
    /** Form section */
    formSection: string | undefined;
    /** Data point */
    dataPoint: string | undefined;
    /** The UCDP result code
             */
    resultCode: string | undefined;
    /** Result message */
    resultMessage: string | undefined;
    /** Override comment */
    selectedOverrideComment: string | undefined;
    /** The date this issue was resolved on */
    resolvedDate: Date | undefined;
    /** Override type code */
    selectedVerosOverrideTypeCode: string | undefined;
    /** Override type name */
    selectedVerosOverrideTypeName: string | undefined;
    /** Veros Result Type Code */
    verosResultTypeCode: string | undefined;
    /** Veros Result Type Name */
    verosResultTypeName: string | undefined;
    /** Veros Severity Type Code */
    verosSeverityTypeCode: string | undefined;
    /** Veros Severity Type Name */
    verosSeverityTypeName: string | undefined;
}

export interface ViewRightsAttribute extends RightsAttribute {
}

/** Data model for an email indicated a Waiver has been denied */
export interface WaiverDeniedEmailDto {
    /** Addresses Email will be sent */
    toAddress: MailAddress[] | undefined;
    /** Carbon Copy Addresses Email will be sent */
    ccAddress: MailAddress[] | undefined;
    /** Name of Case's Lender */
    lenderName: string | undefined;
    /** Case's Loan Number */
    loanNumber: string | undefined;
    /** Cases's Status */
    status: string | undefined;
    /** Cases's Survey Type */
    reportType: string | undefined;
    /** Case's Broker */
    orderedBy: string | undefined;
    /** Case's Borrower */
    borrowerName: string | undefined;
}

/** Constants for waiver exports */
export interface WaiverExportConstants {
}

/** Represents a case that was ordered */
export interface WebOrderCase {
    /** ControlIdNumber */
    controlIdNumber: number;
    /** Address1 + Address2 */
    address: string | undefined;
}

/** Posted data for Cancelling a Checkout. */
export interface WebOrderCheckoutCancel {
    /** Encrypted url freindly token. */
    token: string | undefined;
    /** Decoded control number */
    controlNumber: number;
    /** User should provide a reason for cancelling the checkout. */
    reason: string | undefined;
}

/** Posted data when saving a checkout with credit card payment. */
export interface WebOrderCheckoutSave {
    /** Encrypted url freindly token. */
    token: string;
    /** Credit card payment information. */
    billing: CreditCardBillingInfo;
}

/** Web order constants */
export interface WebOrderConstants {
}

/** Insurance order specific details */
export interface WebOrderInsuranceDetail {
    /** Policy Number */
    policyNumber: string;
    /** Business Type:  N or R */
    businessType: string | undefined;
    /** Policy effective date */
    effectiveDate: Date | undefined;
    /** Underwriter code to assign this case to */
    underwriterCode: string | undefined;
    /** Contact information for the insured */
    policyholderContactInfo: ContactInfo;
    /** Coverage In */
    coverageIn: number | undefined;
    /** Year Built */
    yearBuilt: number | undefined;
    /** Dwelling SqFt */
    sqFt: number | undefined;
}

/** Appraisal order specific details */
export interface WebOrderLenderDetail {
    /** The broker agent code? */
    brokerAgent: string | undefined;
    /** Broker agent a correspondent broker */
    isCorrespondent: boolean;
    /** Details about the loan */
    loan: LoanInfo;
    /** The lender transaction type */
    transactionType: string;
    /** Details about the borrower */
    borrower: BrokerOrderContactInfo;
}

/** Web order details (Homeowner Insurance and Lender) */
export interface WebOrderRequest extends WebOrderRequestBase {
    /** Tracking Code */
    trackingCode: string | undefined;
    /** Case Survey Address */
    surveyAddress: AddressInfo;
    /** Supplement codes */
    supplements: string[] | undefined;
    /** Notes regarding repairs that need to be documented */
    repairNotes: string | undefined;
    /** User selected FRE API for order */
    useFreApi: boolean;
    /** User selected FNMA API for order */
    useFnmaApi: boolean;
    /** Insurance related details */
    insuranceDetail: WebOrderInsuranceDetail | undefined;
    /** Appraisal related details */
    lenderDetail: WebOrderLenderDetail | undefined;
}

/** Case handling feature settings */
export interface WebOrderSettingsCaseHandlingFeatures {
    /** DU ID is required */
    desktopUnderwriterIdRequired: boolean;
    /** Mueller@Home allowed */
    muellerAtHomeAllowed: boolean;
    /** Is an appointment required */
    isAppointmentRequired: boolean;
    /** Loan Prospector ID is required */
    loanProspectorIdRequired: boolean;
    /** Is the Freddie Mac Case File ID required  */
    freddieMacCaseFileIdRequired: boolean;
    /** Show DU ID and Loan Prospector ID fields even if this isn't an appraisal (needed for FNMA export) */
    showAppraisalIdFields: boolean;
    /** Account uses customer feature to show expected price even if retail billing is not available */
    showExpectedPrice: boolean;
    /** Display and make required the repair notes field */
    repairNotesRequired: boolean;
    /** Account has both FNMA and FRE integrations and user can choose which one to use (for 1004 Hybrid/70H only) */
    showAppraisalApiChoice: boolean;
}

/** Settings for the combined web ordering page */
export interface WebOrderSettingsRequest {
    /** The customer account number */
    customerNumber: number;
    /** The survey type id */
    surveyTypeId: number;
}

/** Settings for the the combined order page */
export interface WebOrderSettingsResponse {
    /** The order page layout to use */
    orderingPageLayoutType: string | undefined;
    /** The order page terminology type */
    terminologyType: string | undefined;
    /** What payment types are allowed */
    availablePaymentTypes: PaymentType[] | undefined;
    /** Is batch ordering allowed */
    batchOrderingAllowed: boolean;
    /** The batch ordering template url */
    batchOrderingTemplateUrl: string | undefined;
    /** Additional case handling feature settings */
    caseHandlingFeatures: WebOrderSettingsCaseHandlingFeatures | undefined;
    /** List of available supplements by survey type */
    supplements: AvailFormDto[] | undefined;
}

/** Status of WebOrder */
export interface WebOrderStatusResponse {
    /** True if the import is still running */
    finished: boolean;
    /** True if not running and in a failed status code */
    failed: boolean;
    /** Summary of import errors and scrubs */
    messages: string[] | undefined;
    /** Count of records that were attempted to be imported */
    recordCount: number | undefined;
    /** Count of errors on import */
    errorCount: number | undefined;
    /** Batch id that the customer can send to IT for reference if things fail */
    batchId: string | undefined;
    /** List of cases in the import batch */
    cases: WebOrderCase[] | undefined;
}

/** Web Order Validators */
export interface WebOrderValidators {
}

export enum WidgetQueryMetricScores {
    A = 0,
    B = 1,
    C = 2,
    D = 3,
    F = 4,
}

export interface WidgetQueryMetricViewModel {
    value: string | undefined;
    label: string | undefined;
    category: string | undefined;
    score: string | undefined;
}

export interface WidgetQueryResponse {
    data: DataContainer | undefined;
    errorMessage: string | undefined;
    stackTrace: string | undefined;
    success: boolean;
}

export interface WidgetQueryResponseViewModel {
    data: WidgetQueryMetricViewModel[] | undefined;
}

/** Static functions to help determine what status comes next and all that. */
export interface WorkflowStatusHelper {
}

/** ImportOperations WorkItem import request */
export interface WorkItemImportRequest {
    /** WorkItem to import */
    workItem: WorkItem | undefined;
    /** Attachments to include (LookupKeys from WebOrderPendingAttachments) or null if there are no attachments */
    attachments: string[] | undefined;
}

export interface WorkItem {
    customerCode: string | undefined;
    accountNumber: number;
    orderedByUser: string | undefined;
    order: Order2 | undefined;
    imported: boolean;
    reportTypeCode: string | undefined;
    id: string;
    controlNumber: number;
    programCode: string | undefined;
}

export interface Order2 {
    trackingCode: string | undefined;
    orderCodeIn: string | undefined;
    reportType: string | undefined;
    businessType: BusinessType2 | undefined;
    expeditedService: boolean;
    startDate: Date | undefined;
    agent: Agency | undefined;
    underwriter: Underwriter2 | undefined;
    notes: string | undefined;
    supplements: string[] | undefined;
    orderSpecificInformation: OrderSpecificInformation[] | undefined;
    additionalInformation: AdditionalInformationBase[] | undefined;
    directionsToSurveyAddress: string | undefined;
    policy: Policy | undefined;
    insured: Insured | undefined;
}

export enum BusinessType2 {
    Renewal = 0,
    New = 1,
    Unknown = -1,
}

export interface Agency {
    code: string | undefined;
    name: string | undefined;
    email: string | undefined;
    mailingAddress: Address2 | undefined;
    phone: string | undefined;
    fax: string | undefined;
    groupCode: string | undefined;
}

export interface Address2 {
    streetAddress1: string | undefined;
    streetAddress2: string | undefined;
    city: string | undefined;
    state: string | undefined;
    postalCode: string | undefined;
}

export interface Underwriter2 {
    code: string | undefined;
    name: string | undefined;
    email: string | undefined;
    address: Address2 | undefined;
    phone: string | undefined;
    fax: string | undefined;
    phoneExtension: string | undefined;
}

export interface OrderSpecificInformation {
    key: string | undefined;
    value: string | undefined;
}

export interface AdditionalInformationBase {
}

export interface RctInformation extends AdditionalInformationBase {
    yearBuilt: number;
    livingArea: number;
    style: string | undefined;
    stories: number;
    numberOfFamilies: string | undefined;
    materials: RctMaterial[] | undefined;
}

export interface RctMaterial {
    materialCode: string | undefined;
    amount: number;
}

export interface AutomotivePolicyInformation extends AdditionalInformationBase {
    vehicles: Vehicle[] | undefined;
    driver: Driver[] | undefined;
}

export interface Vehicle {
    vehicleIdentificationNumber: string | undefined;
    garagingAddress: Address2 | undefined;
    year: number;
    make: string | undefined;
    model: string | undefined;
    annualMilesDriven: number;
}

export interface Driver {
    fullName: string | undefined;
    dateOfBirth: Date;
}

export interface Policy {
    effectiveDate: Date | undefined;
    policyNumber: string | undefined;
    typeCode: string | undefined;
    coverageAIn: number | undefined;
    address: Address2 | undefined;
}

export interface Insured {
    firstName: string | undefined;
    fullName: string | undefined;
    lastName: string | undefined;
    phone1: string | undefined;
    phone2: string | undefined;
    address: Address2 | undefined;
}

/** Response class after queueing a work item import */
export interface WorkItemImportResponse {
    /** Id of the queued import */
    importQueueId: number;
}

/** Zip Code transformation object */
export interface ZipCodeDto {
    /** Id */
    id: number;
    /** Zip Code */
    zipCode: string | undefined;
    /** City */
    city: string | undefined;
    /** State */
    state: string | undefined;
    /** State Abbreviation */
    stateAbbreviation: string | undefined;
    /** County Id */
    countyId: number | undefined;
    /** County */
    county: string | undefined;
    /** Latitude */
    latitude: number;
    /** Longitude */
    longitude: number;
    /** Boundary JSON */
    boundary: string | undefined;
}
